var _regeneratorRuntime = require("/usr/src/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/usr/src/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _taggedTemplateLiteral = require("/usr/src/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _slicedToArray = require("/usr/src/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/slicedToArray");

var _objectWithoutProperties = require("/usr/src/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _defineProperty = require("/usr/src/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/defineProperty");

var _objectSpread = require("/usr/src/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/objectSpread2");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11;

(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('classnames'), require('moment'), require('prop-types'), require('react'), require('react-collapse'), require('styled-components'), require('react-datepicker'), require('rc-slider'), require('react-virtualized'), require('react-notifications-component'), require('@fortawesome/fontawesome-svg-core'), require('@fortawesome/free-solid-svg-icons'), require('react-imask'), require('@fortawesome/react-fontawesome'), require('react-modal'), require('react-dom'), require('react-dates/initialize'), require('react-dates')) : typeof define === 'function' && define.amd ? define(['exports', 'classnames', 'moment', 'prop-types', 'react', 'react-collapse', 'styled-components', 'react-datepicker', 'rc-slider', 'react-virtualized', 'react-notifications-component', '@fortawesome/fontawesome-svg-core', '@fortawesome/free-solid-svg-icons', 'react-imask', '@fortawesome/react-fontawesome', 'react-modal', 'react-dom', 'react-dates/initialize', 'react-dates'], factory) : (global = global || self, factory(global['ibe-components'] = {}, global.classNames, global.moment, global.PropTypes, global.React, global.Collapse, global.styled, global.DatePicker$1, global.Slider, global.reactVirtualized, global.ReactNotification, global.fontawesomeSvgCore, global.freeSolidSvgIcons, global.reactImask, global.reactFontawesome, global.ReactModal, global.ReactDOM, null, global.reactDates));
})(this, function (exports, classNames, moment, PropTypes, React, Collapse, styled, DatePicker$1, Slider, reactVirtualized, ReactNotification, fontawesomeSvgCore, freeSolidSvgIcons, reactImask, reactFontawesome, ReactModal, ReactDOM, initialize, reactDates) {
  'use strict';

  var _PropTypes__default$s, _definitions;

  classNames = classNames && Object.prototype.hasOwnProperty.call(classNames, 'default') ? classNames['default'] : classNames;
  moment = moment && Object.prototype.hasOwnProperty.call(moment, 'default') ? moment['default'] : moment;
  var PropTypes__default = 'default' in PropTypes ? PropTypes['default'] : PropTypes;
  var React__default = 'default' in React ? React['default'] : React;
  Collapse = Collapse && Object.prototype.hasOwnProperty.call(Collapse, 'default') ? Collapse['default'] : Collapse;
  styled = styled && Object.prototype.hasOwnProperty.call(styled, 'default') ? styled['default'] : styled;
  DatePicker$1 = DatePicker$1 && Object.prototype.hasOwnProperty.call(DatePicker$1, 'default') ? DatePicker$1['default'] : DatePicker$1;
  var Slider__default = 'default' in Slider ? Slider['default'] : Slider;
  var ReactNotification__default = 'default' in ReactNotification ? ReactNotification['default'] : ReactNotification;
  ReactModal = ReactModal && Object.prototype.hasOwnProperty.call(ReactModal, 'default') ? ReactModal['default'] : ReactModal;
  ReactDOM = ReactDOM && Object.prototype.hasOwnProperty.call(ReactDOM, 'default') ? ReactDOM['default'] : ReactDOM;

  function styleInject(css, ref) {
    if (ref === void 0) ref = {};
    var insertAt = ref.insertAt;

    if (!css || typeof document === 'undefined') {
      return;
    }

    var head = document.head || document.getElementsByTagName('head')[0];
    var style = document.createElement('style');
    style.type = 'text/css';

    if (insertAt === 'top') {
      if (head.firstChild) {
        head.insertBefore(style, head.firstChild);
      } else {
        head.appendChild(style);
      }
    } else {
      head.appendChild(style);
    }

    if (style.styleSheet) {
      style.styleSheet.cssText = css;
    } else {
      style.appendChild(document.createTextNode(css));
    }
  }

  var css_248z = "@font-face {\n  font-family: \"Source Sans Pro\", sans-serif;\n  src: url(\"../fonts/SourceSansPro-Regular.ttf\") format(\"opentype\");\n}";
  styleInject(css_248z);
  var css_248z$1 = ".accrualLogList-container .accrualLog-container {\n  border-top: 1px solid #000000;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  min-height: 70px;\n}\n.accrualLogList-container .date-wrapper {\n  font-size: 16px;\n  line-height: 150%;\n}\n.accrualLogList-container .description-wrapper span {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 16px;\n}\n.accrualLogList-container .right-content-wrapper {\n  font-size: 16px;\n  line-height: 16px;\n}\n.accrualLogList-container .loyalty-style {\n  font-size: 12px !important;\n}";
  styleInject(css_248z$1);
  var css_248z$2 = ".ticket-price-container {\n  display: flex;\n  flex-direction: row;\n}\n.ticket-price-container .currency-style {\n  font-weight: 600;\n  font-size: 20px;\n  line-height: 25px;\n  color: #000000;\n}\n.ticket-price-container .loyalty-style {\n  color: #000000;\n  font-size: 20px;\n  font-weight: 600;\n  padding-left: 3px;\n}\n\n.defaultPrice {\n  color: #000000;\n  font-weight: 600;\n  font-size: 50px;\n  letter-spacing: -0.03em;\n}\n\n.loyaltyPrice {\n  color: #ff9800;\n  font-family: \"Source Sans Pro\", sans-serif;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 100%;\n}\n\n.negativePrice {\n  color: #ff4040;\n}\n\n@media only screen and (max-width: 365px) {\n  .loyaltyPrice {\n    font-size: 16px;\n  }\n}";
  styleInject(css_248z$2);
  var FLIGHT_TYPE = 1;
  var BUS_TYPE = 2;
  var BLACK_CAR_TYPE = 3;
  var EXPRESS_TYPE = 4;
  var EXPRESS_HOME_TYPE = 5;

  function numberWithCommas() {
    var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  function priceFormat(amount, currency) {
    var decimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2;
    var ceil = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    var floor = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    var hideCurrency = arguments.length > 5 ? arguments[5] : undefined;
    var formatedAmount = Number(amount).toFixed(decimals);

    if (ceil) {
      formatedAmount = Math.ceil(Number(amount));
    } else if (floor) {
      formatedAmount = Math.floor(Number(amount));
    }

    console.log(formatedAmount);
    var formatedPointsAmount = numberWithCommas(formatedAmount);

    switch (hideCurrency || currency) {
      case "USD":
        return "$".concat(formatedAmount);

      case "PTS":
        return "".concat(formatedPointsAmount, " Miles");

      case "hide":
        return formatedPointsAmount;

      default:
        return "$".concat(formatedAmount);
    }
  }

  var isBlackCarAirline = function isBlackCarAirline(segment) {
    return segment.service_type === BLACK_CAR_TYPE;
  };

  var isExpressAirline = function isExpressAirline(segment) {
    return segment.service_type === EXPRESS_TYPE;
  };

  var isExpressHomeAirline = function isExpressHomeAirline(segment) {
    return segment.service_type === EXPRESS_HOME_TYPE;
  };

  var parseSegment = function parseSegment(segment) {
    var airline = segment.airline;

    if (typeof airline === "object") {
      airline = segment.airline.iata;
    }

    var parsedFlightNumber = segment.flight_no || segment.flight_number;

    if (parsedFlightNumber.substring(0, 1).match(/^[A-Za-z]+$/)) {
      airline = parsedFlightNumber.substring(0, 2);
      parsedFlightNumber = parsedFlightNumber.substring(2);
    }

    return _objectSpread(_objectSpread({}, segment), {}, {
      airlineCode: airline,
      parsedFlightNumber: parsedFlightNumber,
      airlineName: segment.airline_name || (segment.airline || {}).name
    });
  };

  var isBlackCar = function isBlackCar() {
    var segments = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return !!segments.find(function (segment) {
      return isBlackCarAirline(segment);
    });
  };

  var isExpress = function isExpress() {
    var segments = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return !!segments.find(function (segment) {
      return isExpressAirline(segment);
    });
  };

  var isExpressHome = function isExpressHome() {
    var segments = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return !!segments.find(function (segment) {
      return isExpressHomeAirline(segment);
    });
  };

  var containsFlight = function containsFlight() {
    var segments = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return !!segments.find(function (segment) {
      return segment.service_type === FLIGHT_TYPE;
    });
  };

  var containsBus = function containsBus() {
    var segments = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return !!segments.find(function (segment) {
      return segment.service_type === BUS_TYPE;
    });
  };

  var preloadImage = function preloadImage(url) {
    if (typeof window === "undefined") {
      return;
    }

    var img = new Image();
    img.src = url;
  };

  var Price = function Price(_ref) {
    var amount = _ref.amount,
        currency = _ref.currency,
        decimals = _ref.decimals,
        ceil = _ref.ceil,
        floor = _ref.floor,
        loyaltyStyle = _ref.loyaltyStyle,
        presign = _ref.presign,
        hideCurrency = _ref.hideCurrency,
        negativeStyle = _ref.negativeStyle,
        useLoyalty = _ref.useLoyalty,
        showDecimals = _ref.showDecimals;
    var currencies = priceFormat(amount, currency, decimals, ceil, floor, "hide");
    var priceStyle = classNames("defaultPrice", {
      loyaltyPrice: loyaltyStyle,
      negativePrice: negativeStyle
    }); // const showDecimals = parseFloat(currencies).toFixed(0) < parseFloat(currencies)

    var displayAmount = showDecimals ? currencies : parseFloat(currencies).toFixed(0);
    displayAmount = currency && currency.toLowerCase() === "pts" ? amount : displayAmount; // Hides the currency sign if Loyalty Points are selected

    useLoyalty ? hideCurrency = useLoyalty : null;
    return /*#__PURE__*/React__default.createElement("div", {
      className: "ticket-price-container"
    }, hideCurrency ? null : /*#__PURE__*/React__default.createElement("div", {
      className: "currency-style"
    }, "$"), /*#__PURE__*/React__default.createElement("div", {
      className: priceStyle
    }, displayAmount), useLoyalty ? /*#__PURE__*/React__default.createElement("div", {
      className: "loyalty-style"
    }, "m") : null);
  };

  Price.propTypes = {
    amount: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.number]),
    currency: PropTypes__default.string.isRequired,
    decimals: PropTypes__default.number,
    loyaltyStyle: PropTypes__default.bool,
    presign: PropTypes__default.string,
    hideCurrency: PropTypes__default.bool,
    ceil: PropTypes__default.bool,
    floor: PropTypes__default.bool,
    negativeStyle: PropTypes__default.bool
  };
  Price.defaultProps = {
    amount: "0",
    hideCurrency: false,
    decimals: 2,
    loyaltyStyle: false,
    presign: "",
    negativeStyle: false,
    ceil: false,
    floor: false,
    showDecimals: true
  };
  var css_248z$3 = ".tagLabel-container {\n  display: flex;\n  padding: 0 10px;\n  color: #3c3835;\n  border-radius: 3px;\n  font-size: 12px;\n  width: max-content;\n  line-height: 20px;\n}\n.tagLabel-container.inf {\n  background-color: #e5e5e5;\n}\n.tagLabel-container.C {\n  background-color: #bbebff;\n}\n.tagLabel-container.LL {\n  background-color: #fab500;\n  color: #3c3835;\n}\n.tagLabel-container.M {\n  background-color: #b0eadb;\n}\n.tagLabel-container.W {\n  background-color: #b0eadb;\n}\n.tagLabel-container.t {\n  background-color: transparent;\n  border: 1px solid #cdccc8;\n}\n.tagLabel-container.LLT {\n  background-color: transparent;\n  border: 1px solid #fab500;\n}\n.tagLabel-container.F {\n  background-color: #c7beff;\n}\n.tagLabel-container.LLP {\n  background-color: #fab500;\n}\n.tagLabel-container.LLS {\n  background-color: #3c3835;\n  color: #fab500;\n}\n.tagLabel-container.BC {\n  background-color: #3c3835;\n  color: #fff;\n}\n.tagLabel-container.BCT {\n  background-color: transparent;\n  border: 1px solid #3c3835;\n  color: #3c3835;\n}\n.tagLabel-container.RED {\n  background-color: #ff4040;\n  color: #fff;\n}\n.tagLabel-container.GREEN {\n  background-color: #00c08b;\n  color: #fff;\n}\n\n.firstTagLabel {\n  border-top-right-radius: 0px;\n  border-bottom-right-radius: 0px;\n}\n\n.lastTagLabel {\n  border-top-left-radius: 0px;\n  border-bottom-left-radius: 0px;\n}\n\n.middleTagLabel {\n  border-radius: 0px;\n}\n\n.tagLabel-isContainer {\n  padding: 3px 6px !important;\n}\n\n.tagLabel-center {\n  justify-content: center;\n}";
  styleInject(css_248z$3);

  var TagLabel = function TagLabel(_ref) {
    var _classNames;

    var content = _ref.content,
        type = _ref.type,
        margin = _ref.margin,
        onClick = _ref.onClick,
        className = _ref.className,
        container = _ref.container,
        center = _ref.center,
        width = _ref.width;
    var tagLabelClass = classNames("tagLabel-container", (_classNames = {}, _defineProperty(_classNames, type, type), _defineProperty(_classNames, "tagLabel-isContainer", container), _defineProperty(_classNames, "tagLabel-center", center), _classNames));
    var style = {
      margin: margin
    };

    if (width) {
      style.width = width;
    }

    return /*#__PURE__*/React__default.createElement("div", {
      style: style,
      className: "".concat(tagLabelClass, " ").concat(className),
      onClick: onClick
    }, content);
  };

  TagLabel.propTypes = {
    content: PropTypes__default.string,
    type: PropTypes__default.oneOf(["inf", // "info",
    "C", // "business",
    "t", // "transparent",
    "M", // "economy",
    "W", // premium economy
    "LL", // "landline",
    "LLT", // "landlineTransparent",
    "F", // "firstClass",
    "LLP", // landline primary
    "LLS", // landline secondary
    "BC", // landline black
    "BCT", // landline black transparent
    "RED", // landline red
    "GREEN" // landline green
    ]),
    margin: PropTypes__default.string,
    onClick: PropTypes__default.func,
    className: PropTypes__default.string,
    container: PropTypes__default.bool,
    center: PropTypes__default.bool,
    width: PropTypes__default.number
  };
  TagLabel.defaultProps = {
    container: false,
    content: "",
    type: "info",
    margin: "",
    onClick: function onClick() {},
    className: "",
    center: false,
    width: undefined
  };

  var AccrualLogList = function AccrualLogList(_ref) {
    var accrualList = _ref.accrualList;
    var accrualLogListClass = classNames("accrualLogList-container");

    var isNegative = function isNegative(price) {
      if (Number(price) < 0) {
        return true;
      }

      return false;
    };

    return /*#__PURE__*/React__default.createElement("div", {
      className: accrualLogListClass
    }, accrualList.map(function (_ref2) {
      var item = _ref2.points_id;
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
        className: "accrualLog-container"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "left-content-container"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "date-wrapper"
      }, moment(item.created).format("dddd, MMMM D")), /*#__PURE__*/React__default.createElement("div", {
        className: "description-wrapper"
      }, /*#__PURE__*/React__default.createElement("span", null, item.transaction_type, "\xA0"), "".concat(item.additional_details))), /*#__PURE__*/React__default.createElement("div", {
        className: "right-content-wrapper"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: ""
      }, /*#__PURE__*/React__default.createElement(TagLabel, {
        type: "t",
        content: /*#__PURE__*/React__default.createElement(React__default.Fragment, null, !isNegative(item.points) && /*#__PURE__*/React__default.createElement("span", null, "+"), /*#__PURE__*/React__default.createElement(Price, {
          amount: item.points,
          currency: "PTS",
          useLoyalty: true
        }))
      })))));
    }));
  };

  AccrualLogList.propTypes = {
    accrualList: PropTypes__default.instanceOf(Array)
  };
  AccrualLogList.defaultProps = {
    accrualList: []
  };

  function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };
    return _extends.apply(this, arguments);
  }

  var css_248z$4 = ".svgRight {\n  position: absolute;\n  right: 5px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 15px;\n  height: 15px;\n}\n\n.svgLeft {\n  position: absolute;\n  left: 10px;\n  top: 50%;\n  transform: translateY(-50%);\n}\n\nbutton {\n  cursor: pointer;\n}\n\nbutton:active {\n  outline: none;\n  border: none;\n}\n\nbutton:focus {\n  outline: 0;\n}\n\n.disabled-button {\n  opacity: 0.6;\n  pointer-events: none;\n}\n.disabled-button button {\n  cursor: unset;\n}\n\n.button-default button {\n  font-family: \"Source Sans Pro\", sans-serif;\n  font-style: normal;\n  font-weight: 600;\n  font-size: 18px;\n  border-radius: 6px;\n  min-width: 140px;\n  min-height: 40px;\n  position: relative;\n}\n\n.regular button {\n  border: 1px solid black;\n  padding: 0 20px;\n  background: white;\n  color: #3c3835;\n}\n\n.regular:not(.disabled-button) button:hover,\n.regular.hover button {\n  border: 1px solid #ff9800;\n}\n\n.primary button {\n  border: none;\n  text-align: center;\n  padding: 0 35px;\n  background: #3c3835;\n  color: #fab500;\n  transition: all 0.3s ease;\n}\n.primary button svg {\n  transition: all 0.3s ease;\n  fill: #fab500;\n}\n\n.primary:not(.disabled-button) button:hover,\n.primary.hover button {\n  background: #fab500;\n  color: #3c3835;\n}\n.primary:not(.disabled-button) button:hover svg,\n.primary.hover button svg {\n  fill: #3c3835;\n}\n\n.secondary button {\n  border: none;\n  padding: 0 35px;\n  text-align: center;\n  background: #fab500;\n  color: #3c3835;\n  transition: all 0.3s ease;\n}\n.secondary button svg {\n  fill: #3c3835;\n}\n\n.secondary:not(.disabled-button) button:hover,\n.secondary.hover button {\n  background: #ff9800;\n  border: none;\n}\n\n.destructive button {\n  padding: 0 20px;\n  background: #ff4040;\n  color: white;\n  border: none;\n}\n\n.destructive:not(.disabled-button) button:hover,\n.destructive.hover button {\n  background: white;\n  color: #ff4040;\n  border: 1px solid #ff4040;\n}\n\n.disabled button {\n  border: none;\n  padding: 0 20px;\n  background: #e5e5e5;\n  color: #cdccc8;\n}\n\n@media only screen and (max-width: 365px) {\n  .svgRight {\n    width: 16px;\n    height: 16px;\n  }\n  .secondary button {\n    font-size: 14px;\n    padding: 0 10px;\n  }\n}\n@media only screen and (max-width: 450px) {\n  .secondary button {\n    font-size: 14px;\n    padding: 0 10px;\n  }\n  .primary button {\n    margin: 4px 0;\n  }\n}";
  styleInject(css_248z$4);

  var Button = function Button(_ref) {
    var _classNames2;

    var onClick = _ref.onClick,
        className = _ref.className,
        fullWidth = _ref.fullWidth,
        type = _ref.type,
        icon = _ref.icon,
        children = _ref.children,
        margin = _ref.margin,
        buttonType = _ref.buttonType,
        disabled = _ref.disabled,
        rest = _objectWithoutProperties(_ref, ["onClick", "className", "fullWidth", "type", "icon", "children", "margin", "buttonType", "disabled"]);

    var buttonClass = classNames("".concat(type, " button-default"), (_classNames2 = {}, _defineProperty(_classNames2, className, className), _defineProperty(_classNames2, "disabled-button", disabled), _classNames2));
    return /*#__PURE__*/React__default.createElement("div", {
      style: fullWidth ? {
        width: "100%",
        margin: margin
      } : {
        margin: margin
      },
      className: buttonClass
    }, /*#__PURE__*/React__default.createElement("button", _extends({
      disabled: disabled,
      type: buttonType,
      style: fullWidth ? {
        width: "100%"
      } : {},
      onClick: onClick
    }, rest), children, icon));
  };

  Button.propTypes = {
    onClick: PropTypes__default.func.isRequired,
    className: PropTypes__default.string,
    fullWidth: PropTypes__default.bool,
    type: PropTypes__default.oneOf(["regular", "primary", "secondary", "destructive", "disabled"]),
    icon: PropTypes__default.element,
    children: PropTypes__default.oneOfType([PropTypes__default.element, PropTypes__default.string]),
    margin: PropTypes__default.string,
    buttonType: PropTypes__default.oneOf(["button", "submit"]),
    disabled: PropTypes__default.bool
  };
  Button.defaultProps = {
    className: "",
    disabled: false,
    fullWidth: false,
    type: "regular",
    icon: null,
    children: null,
    margin: "0",
    buttonType: "button"
  };
  var css_248z$5 = "";
  styleInject(css_248z$5);
  var css_248z$6 = ".collapsiblebutton-toggle-icon {\n  display: flex;\n  align-items: center;\n}\n.collapsiblebutton-toggle-icon .svgRight {\n  position: inherit;\n  right: 0;\n  top: 0;\n  transform: inherit;\n  margin-top: 3px;\n}\n\n.collapsiblebutton-toggle-right {\n  display: flex;\n}\n.collapsiblebutton-toggle-right.right-information-wrapper {\n  display: flex;\n  flex-direction: row;\n}\n\n.collapsiblebutton-toogle-wrapper {\n  display: flex;\n  justify-content: space-between;\n  padding: 10px 0;\n  cursor: pointer;\n  border-bottom: 1px solid #3c3835;\n  outline: none;\n}\n\n.collapsiblebutton-name {\n  display: flex;\n  align-items: center;\n}\n\n.collapsiblebutton-left {\n  margin-right: 10px;\n}\n\n@media only screen and (max-width: 540px) {\n  .collapsiblebutton-toggle-right {\n    flex-direction: column;\n  }\n}";
  styleInject(css_248z$6);
  var css_248z$7 = ".noAbsolute {\n  position: relative;\n  transform: none;\n  top: 0;\n  right: 0;\n}\n\n.icon-cursor-pointer {\n  cursor: pointer;\n}";
  styleInject(css_248z$7);
  var icons = "/media/70a824bbd698a366.svg";

  var Icon = function Icon(_ref) {
    var _classNames3;

    var align = _ref.align,
        width = _ref.width,
        height = _ref.height,
        error = _ref.error,
        name = _ref.name,
        viewBox = _ref.viewBox,
        className = _ref.className,
        noAbsolute = _ref.noAbsolute,
        onClick = _ref.onClick,
        children = _ref.children,
        withoutProps = _ref.withoutProps,
        margin = _ref.margin,
        style = _ref.style,
        rest = _objectWithoutProperties(_ref, ["align", "width", "height", "error", "name", "viewBox", "className", "noAbsolute", "onClick", "children", "withoutProps", "margin", "style"]);

    var position = align && align === "left" ? "svgLeft" : "svgRight"; // If align props is left, assign a svgLeft class and else.
    // const isError = error ? "#FF4040" : ""

    var iconClass = classNames("", (_classNames3 = {}, _defineProperty(_classNames3, position, !noAbsolute), _defineProperty(_classNames3, className, className), _defineProperty(_classNames3, "noAbsolute", noAbsolute), _defineProperty(_classNames3, "icon-cursor-pointer", name === "closeButtonIcon" || name === "copyIcon"), _classNames3));
    return /*#__PURE__*/React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      onClick: onClick,
      className: iconClass,
      width: width,
      height: height,
      viewBox: !withoutProps && viewBox,
      style: _objectSpread({
        margin: margin
      }, style)
    }, rest), /*#__PURE__*/React__default.createElement("use", {
      xlinkHref: "".concat(icons, "#").concat(name)
    }));
  };

  Icon.propTypes = {
    onClick: PropTypes__default.func,
    align: PropTypes__default.string,
    width: PropTypes__default.string,
    height: PropTypes__default.string,
    error: PropTypes__default.bool,
    name: PropTypes__default.string,
    viewBox: PropTypes__default.string,
    className: PropTypes__default.string,
    noAbsolute: PropTypes__default.bool,
    children: PropTypes__default.element,
    withoutProps: PropTypes__default.bool,
    margin: PropTypes__default.string,
    style: PropTypes__default.instanceOf(Object)
  };
  Icon.defaultProps = {
    onClick: undefined,
    align: "",
    width: "24",
    height: "24",
    error: false,
    name: "",
    viewBox: "0 0 24 24",
    className: "",
    noAbsolute: false,
    children: null,
    withoutProps: false,
    margin: null,
    style: {}
  };

  var CollapsibleButton = function CollapsibleButton(_ref) {
    var title = _ref.title,
        children = _ref.children,
        rightContent = _ref.rightContent,
        open = _ref.open,
        toggle = _ref.toggle,
        leftToggleIcon = _ref.leftToggleIcon,
        defaultCloseIcon = _ref.defaultCloseIcon,
        defaultOpenIcon = _ref.defaultOpenIcon,
        defaultCloseIconViewBox = _ref.defaultCloseIconViewBox,
        defaultOpenIconViewBox = _ref.defaultOpenIconViewBox,
        onWork = _ref.onWork,
        className = _ref.className;
    var collapsibleButtonClass = classNames("collapsiblebutton-toggle-right", className);

    var _React$useState = React.useState(false),
        _React$useState2 = _slicedToArray(_React$useState, 2),
        openMenu = _React$useState2[0],
        setOpenMenu = _React$useState2[1];

    var controlledOpenMenu = open || openMenu;

    var toogleMenu = function toogleMenu() {
      if (toggle) {
        toggle();
      } else {
        setOpenMenu(!openMenu);
      }
    };

    return /*#__PURE__*/React__default.createElement("div", {
      className: "collapsiblebutton-wrapper"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "collapsiblebutton-toogle-wrapper",
      onClick: toogleMenu
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "collapsiblebutton-name"
    }, leftToggleIcon && /*#__PURE__*/React__default.createElement("div", {
      className: "collapsiblebutton-toggle-icon collapsiblebutton-left"
    }, controlledOpenMenu ? /*#__PURE__*/React__default.createElement(Icon, {
      name: defaultCloseIcon,
      viewBox: defaultCloseIconViewBox
    }) : /*#__PURE__*/React__default.createElement(Icon, {
      name: defaultOpenIcon,
      viewBox: defaultOpenIconViewBox
    })), title), /*#__PURE__*/React__default.createElement("div", {
      className: collapsibleButtonClass
    }, rightContent, !leftToggleIcon && /*#__PURE__*/React__default.createElement("div", {
      className: "collapsiblebutton-toggle-icon"
    }, controlledOpenMenu ? /*#__PURE__*/React__default.createElement(Icon, {
      name: defaultCloseIcon,
      viewBox: defaultCloseIconViewBox
    }) : /*#__PURE__*/React__default.createElement(Icon, {
      name: defaultOpenIcon,
      viewBox: defaultOpenIconViewBox
    })))), /*#__PURE__*/React__default.createElement(Collapse, {
      onWork: onWork,
      isOpened: controlledOpenMenu,
      initialStyle: controlledOpenMenu ? {
        height: "auto",
        overflow: "initial"
      } : {
        height: "0px",
        overflow: "hidden"
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "collapsiblebutton-content-container"
    }, children)));
  };

  CollapsibleButton.propTypes = {
    children: PropTypes__default.element.isRequired,
    title: PropTypes__default.element.isRequired,
    rightContent: PropTypes__default.element,
    open: PropTypes__default.bool,
    toggle: PropTypes__default.func,
    leftToggleIcon: PropTypes__default.bool,
    defaultOpenIcon: PropTypes__default.string,
    defaultCloseIcon: PropTypes__default.string,
    defaultCloseIconViewBox: PropTypes__default.string,
    defaultOpenIconViewBox: PropTypes__default.string,
    onWork: PropTypes__default.func,
    className: PropTypes__default.string
  };
  CollapsibleButton.defaultProps = {
    rightContent: /*#__PURE__*/React__default.createElement(React__default.Fragment, null),
    open: false,
    toggle: undefined,
    leftToggleIcon: false,
    defaultOpenIcon: "counter_increase",
    defaultCloseIcon: "counter_decrease",
    defaultOpenIconViewBox: "0 0 24 24",
    defaultCloseIconViewBox: "0 0 24 24",
    onWork: function onWork() {},
    className: ""
  };
  var css_248z$8 = "";
  styleInject(css_248z$8);

  var FormatedTitle = function FormatedTitle(_ref) {
    var text = _ref.text,
        checkBox = _ref.checkBox;
    var titleClass = classNames("formated-title", {
      "checkbox-title": checkBox
    });
    return /*#__PURE__*/React__default.createElement("span", {
      className: titleClass
    }, text);
  };

  FormatedTitle.propTypes = {
    text: PropTypes__default.string.isRequired,
    checkBox: PropTypes__default.bool
  };
  FormatedTitle.defaultProps = {
    checkBox: false
  };
  var LABEL_POSITION = {
    BEFORE: "before",
    AFTER: "after"
  };

  var noop = function noop() {
    return false;
  };

  var DEFAULT_SHARED_PROPS = {
    labelPosition: LABEL_POSITION.AFTER,
    disabled: false,
    className: "",
    onChange: noop,
    selected: undefined,
    margin: "10px 0",
    titleText: ""
  };
  var radioButtonCheckedImage = "/media/21f4c7b0de1039ba.svg";
  var radioButtonUnCheckedImage = "/media/f1570b8e3fefb020.svg";

  var _React__default$creat = /*#__PURE__*/React__default.createContext(),
      Provider = _React__default$creat.Provider,
      Consumer = _React__default$creat.Consumer;

  var RadioButton = function RadioButton(_ref) {
    var id = _ref.id,
        value = _ref.value,
        children = _ref.children,
        buttonDisabled = _ref.disabled,
        buttonClassName = _ref.className,
        buttonLabelPosition = _ref.labelPosition,
        margin = _ref.margin;
    return /*#__PURE__*/React__default.createElement(Consumer, null, function (_ref2) {
      var selected = _ref2.selected,
          onChange = _ref2.onChange,
          name = _ref2.name,
          groupDisabled = _ref2.disabled,
          groupClassName = _ref2.className,
          groupLabelPosition = _ref2.labelPosition;
      var className = classNames(groupClassName, buttonClassName);
      var isBefore = buttonLabelPosition !== DEFAULT_SHARED_PROPS.labelPosition || groupLabelPosition !== DEFAULT_SHARED_PROPS.labelPosition;
      var disabled = buttonDisabled || groupDisabled;
      var radioProps = {
        disabled: disabled,
        id: id,
        value: value || id,
        name: name,
        onChange: onChange
      };
      if (selected) radioProps.checked = selected === id;
      var radio = /*#__PURE__*/React__default.createElement(Container, null, /*#__PURE__*/React__default.createElement(Input, _extends({
        type: "radio"
      }, radioProps)), /*#__PURE__*/React__default.createElement(Span, null));

      var _ref5 = isBefore ? [children, radio] : [radio, children],
          _ref6 = _slicedToArray(_ref5, 2),
          first = _ref6[0],
          second = _ref6[1];

      return /*#__PURE__*/React__default.createElement(RadioLabel, _extends({}, className && {
        className: className
      }, {
        disabled: disabled,
        style: {
          margin: margin
        }
      }), first, second);
    });
  };

  RadioButton.propTypes = {
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    labelPosition: PropTypes.oneOf(Object.values(LABEL_POSITION)),
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    disabled: PropTypes.bool,
    children: PropTypes.node,
    className: PropTypes.string,
    margin: PropTypes.string
  };
  RadioButton.defaultProps = DEFAULT_SHARED_PROPS;
  var Input = styled.input(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  cursor: pointer;\n  line-height: 20px;\n  font-size: 14px;\n  display: none;\n"])));
  var Span = styled.span(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: relative;\n  display: inline-block;\n  box-sizing: border-box;\n  width: 24px;\n  height: 24px;\n  -webkit-tap-highlight-color: transparent;\n  background: url(", ") center center no-repeat;\n  margin-right: 10px;\n  input[type=\"radio\"]:checked + & {\n    background: url(", ") center center no-repeat;\n  }\n"])), radioButtonUnCheckedImage, radioButtonCheckedImage);
  var Container = styled.label(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral([""])));
  var RadioLabel = styled.label(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  font-family: \"Source Sans Pro\", sans-serif;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 16px;\n  line-height: 130%;\n  color: #3c3835;\n"])));
  Provider.displayName = "RadioGroupProvider";

  var RadioGroup = function RadioGroup(props) {
    var titleText = props.titleText,
        children = props.children;
    return /*#__PURE__*/React__default.createElement("div", null, titleText && /*#__PURE__*/React__default.createElement(Span$1, null, titleText), /*#__PURE__*/React__default.createElement(Provider, {
      value: props
    }, children));
  };

  RadioGroup.propTypes = {
    children: PropTypes__default.element.isRequired,
    titleText: PropTypes__default.string
  };
  RadioGroup.defaultProps = DEFAULT_SHARED_PROPS;
  var Span$1 = styled.span(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  font-family: \"Source Sans Pro\", sans-serif;\n  color: #ff9800;\n  font-size: 18px;\n  line-height: 18px;\n  border-bottom: 1px solid #cdccc8;\n  display: block;\n  margin: 15px 0 10px 0;\n  padding-bottom: 10px;\n"])));

  var CabinTypeFilter = function CabinTypeFilter(_ref) {
    var cabinTypes = _ref.cabinTypes,
        onCabinTypeChange = _ref.onCabinTypeChange;
    return /*#__PURE__*/React__default.createElement(CollapsibleButton, {
      title: /*#__PURE__*/React__default.createElement(FormatedTitle, {
        text: "Cabin Type"
      }),
      defaultOpenIcon: "chevron_down",
      defaultCloseIcon: "chevron_up"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "collapsible-wrapper"
    }, /*#__PURE__*/React__default.createElement(RadioGroup, {
      selected: cabinTypes,
      onChange: onCabinTypeChange
    }, /*#__PURE__*/React__default.createElement(RadioButton, {
      id: "M"
    }, /*#__PURE__*/React__default.createElement(TagLabel, {
      content: "Economy",
      type: "M"
    })), /*#__PURE__*/React__default.createElement(RadioButton, {
      id: "W"
    }, /*#__PURE__*/React__default.createElement(TagLabel, {
      content: "Premium Economy",
      type: "M"
    })), /*#__PURE__*/React__default.createElement(RadioButton, {
      id: "C"
    }, /*#__PURE__*/React__default.createElement(TagLabel, {
      content: "Business",
      type: "C"
    })), /*#__PURE__*/React__default.createElement(RadioButton, {
      id: "F"
    }, /*#__PURE__*/React__default.createElement(TagLabel, {
      content: "First Class",
      type: "F"
    })))));
  };

  CabinTypeFilter.propTypes = {
    cabinTypes: PropTypes__default.string.isRequired,
    onCabinTypeChange: PropTypes__default.func.isRequired
  };
  var css_248z$9 = "";
  styleInject(css_248z$9);

  var CheckBox = function CheckBox(_ref) {
    var checked = _ref.checked,
        onChange = _ref.onChange,
        value = _ref.value,
        disabled = _ref.disabled,
        margin = _ref.margin;

    var _React$useState3 = React.useState(checked),
        _React$useState4 = _slicedToArray(_React$useState3, 2),
        isChecked = _React$useState4[0],
        setChecked = _React$useState4[1];

    var handleChange = function handleChange(e) {
      if (disabled) return;
      setChecked(e.currentTarget.checked);
      onChange(e);
    };

    return /*#__PURE__*/React__default.createElement(Container$1, {
      margin: margin
    }, /*#__PURE__*/React__default.createElement(Label, null, /*#__PURE__*/React__default.createElement(Input$1, {
      type: "checkbox",
      checked: isChecked,
      onChange: handleChange,
      name: value
    }), /*#__PURE__*/React__default.createElement(Span$2, null)), /*#__PURE__*/React__default.createElement(InputText, null, value));
  };

  CheckBox.propTypes = {
    checked: PropTypes__default.bool,
    onChange: PropTypes__default.func,
    value: PropTypes__default.string.isRequired,
    margin: PropTypes__default.string,
    disabled: PropTypes__default.bool
  };
  CheckBox.defaultProps = {
    checked: false,
    onChange: function onChange() {
      return null;
    },
    disabled: false,
    margin: "0"
  };
  var Container$1 = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  font-family: \"Source Sans Pro\", sans-serif;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 16px;\n  line-height: 120%;\n  color: #3c3835;\n  margin: ", ";\n"])), function (props) {
    return props.margin;
  });
  var InputText = styled.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  margin-left: 1rem;\n  display: flex;\n  align-self: flex-start;\n"])));
  var Span$2 = styled.span(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n"])));
  var Input$1 = styled.input(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  position: absolute;\n  opacity: 1;\n"])));
  var Label = styled.label(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  position: relative;\n  height: 20px;\n  width: 20px;\n  display: flex;\n  align-self: flex-start;\n\n  & ", " {\n    position: absolute;\n    opacity: 0;\n    cursor: pointer;\n  }\n  & ", " {\n    position: absolute;\n    top: 0px;\n    left: 0px;\n    height: 20px;\n    width: 20px;\n    background-color: transparent;\n    border-radius: 3px;\n    transition: all 0.1s ease-out;\n    border: 3px solid #3c3835;\n  }\n  & ", ":checked ~ ", " {\n    background-color: #3c3835;\n    border-radius: 3px;\n    -webkit-transform: rotate(0deg) scale(1);\n    -ms-transform: rotate(0deg) scale(1);\n    transform: rotate(0deg) scale(1);\n    opacity: 1;\n    border: 3px solid #3c3835;\n  }\n  & ", "::after {\n    position: absolute;\n    content: \"\";\n    left: 8px;\n    top: 8px;\n    height: 0px;\n    width: 0px;\n    border-radius: 3px;\n    border: solid #3c3835;\n    border-width: 0 3px 3px 0;\n    -webkit-transform: rotate(0deg) scale(0);\n    -ms-transform: rotate(0deg) scale(0);\n    transform: rotate(0deg) scale(0);\n    opacity: 1;\n    transition: all 0.1s ease-out;\n  }\n\n  & ", ":checked ~ ", "::after {\n    -webkit-transform: rotate(45deg) scale(1);\n    -ms-transform: rotate(45deg) scale(1);\n    transform: rotate(45deg) scale(1);\n    opacity: 1;\n    left: 3px;\n    top: -3px;\n    width: 5px;\n    height: 12px;\n    border: solid white;\n    border-width: 0 3px 3px 0;\n    background-color: transparent;\n    border-radius: 0;\n  }\n"])), Input$1, Span$2, Input$1, Span$2, Span$2, Input$1, Span$2);

  var CarrierFilter = function CarrierFilter(_ref) {
    var airlineFilter = _ref.airlineFilter,
        onAirlineFilterChange = _ref.onAirlineFilterChange;
    return /*#__PURE__*/React__default.createElement(CollapsibleButton, {
      title: /*#__PURE__*/React__default.createElement(FormatedTitle, {
        text: "Preferred Carriers"
      }),
      defaultOpenIcon: "chevron_down",
      defaultCloseIcon: "chevron_up"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "collapsible-wrapper"
    }, airlineFilter.map(function (airline, index) {
      return /*#__PURE__*/React__default.createElement(CheckBox, {
        margin: "0px 0px 10px 0px",
        value: airline.name,
        checked: airline.checked,
        onChange: function onChange(e) {
          onAirlineFilterChange(e, index);
        }
      });
    })));
  };

  CarrierFilter.propTypes = {
    airlineFilter: PropTypes__default.instanceOf(Array).isRequired,
    onAirlineFilterChange: PropTypes__default.func.isRequired
  };
  var css_248z$a = "";
  styleInject(css_248z$a);

  var ClearFilter = function ClearFilter(_ref) {
    var text = _ref.text,
        onClick = _ref.onClick;
    return /*#__PURE__*/React__default.createElement("div", {
      className: "clear-filter"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "text"
    }, text), /*#__PURE__*/React__default.createElement("div", {
      className: "buttonX"
    }, /*#__PURE__*/React__default.createElement(Icon, {
      name: "closeIcon",
      noAbsolute: true,
      onClick: onClick
    })));
  };

  ClearFilter.propTypes = {
    text: PropTypes__default.string.isRequired,
    onClick: PropTypes__default.func.isRequired
  };
  var css_248z$b = "";
  styleInject(css_248z$b);

  var ConnectingAirportFilter = function ConnectingAirportFilter(_ref) {
    var connectingAirports = _ref.connectingAirports,
        onConnectingAirportsChange = _ref.onConnectingAirportsChange;
    return /*#__PURE__*/React__default.createElement(CollapsibleButton, {
      title: /*#__PURE__*/React__default.createElement(FormatedTitle, {
        text: "Connecting Airports"
      }),
      defaultOpenIcon: "chevron_down",
      defaultCloseIcon: "chevron_up"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "collapsible-wrapper"
    }, connectingAirports.map(function (airport, index) {
      return /*#__PURE__*/React__default.createElement(CheckBox, {
        margin: "0px 0px 10px 0px",
        value: airport.name,
        checked: airport.checked,
        onChange: function onChange(e) {
          onConnectingAirportsChange(e, index);
        }
      });
    })));
  };

  ConnectingAirportFilter.propTypes = {
    connectingAirports: PropTypes__default.instanceOf(Array).isRequired,
    onConnectingAirportsChange: PropTypes__default.func.isRequired
  };
  var css_248z$c = ".react-datepicker-popper[data-placement^=\"bottom\"] .react-datepicker__triangle,\n.react-datepicker-popper[data-placement^=\"top\"] .react-datepicker__triangle,\n.react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-read-view--down-arrow,\n.react-datepicker__month-year-read-view--down-arrow {\n  margin-left: -8px;\n  position: absolute;\n}\n\n.react-datepicker-popper[data-placement^=\"bottom\"] .react-datepicker__triangle,\n.react-datepicker-popper[data-placement^=\"top\"] .react-datepicker__triangle,\n.react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-read-view--down-arrow,\n.react-datepicker__month-year-read-view--down-arrow,\n.react-datepicker-popper[data-placement^=\"bottom\"] .react-datepicker__triangle::before,\n.react-datepicker-popper[data-placement^=\"top\"] .react-datepicker__triangle::before,\n.react-datepicker__year-read-view--down-arrow::before,\n.react-datepicker__month-read-view--down-arrow::before,\n.react-datepicker__month-year-read-view--down-arrow::before {\n  box-sizing: content-box;\n  position: absolute;\n  border: 8px solid transparent;\n  height: 0;\n  width: 1px;\n}\n\n.react-datepicker-popper[data-placement^=\"bottom\"] .react-datepicker__triangle::before,\n.react-datepicker-popper[data-placement^=\"top\"] .react-datepicker__triangle::before,\n.react-datepicker__year-read-view--down-arrow::before,\n.react-datepicker__month-read-view--down-arrow::before,\n.react-datepicker__month-year-read-view--down-arrow::before {\n  content: \"\";\n  z-index: -1;\n  border-width: 8px;\n  left: -8px;\n  border-bottom-color: #aeaeae;\n}\n\n.react-datepicker-popper[data-placement^=\"bottom\"] .react-datepicker__triangle {\n  top: 0;\n  margin-top: -8px;\n}\n\n.react-datepicker-popper[data-placement^=\"bottom\"] .react-datepicker__triangle,\n.react-datepicker-popper[data-placement^=\"bottom\"] .react-datepicker__triangle::before {\n  border-top: none;\n  border-bottom-color: #f0f0f0;\n}\n\n.react-datepicker-popper[data-placement^=\"bottom\"] .react-datepicker__triangle::before {\n  top: -1px;\n  border-bottom-color: #aeaeae;\n}\n\n.react-datepicker-popper[data-placement^=\"top\"] .react-datepicker__triangle,\n.react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-read-view--down-arrow,\n.react-datepicker__month-year-read-view--down-arrow {\n  bottom: 0;\n  margin-bottom: -8px;\n}\n\n.react-datepicker-popper[data-placement^=\"top\"] .react-datepicker__triangle,\n.react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-read-view--down-arrow,\n.react-datepicker__month-year-read-view--down-arrow,\n.react-datepicker-popper[data-placement^=\"top\"] .react-datepicker__triangle::before,\n.react-datepicker__year-read-view--down-arrow::before,\n.react-datepicker__month-read-view--down-arrow::before,\n.react-datepicker__month-year-read-view--down-arrow::before {\n  border-bottom: none;\n  border-top-color: #fff;\n}\n\n.react-datepicker-popper[data-placement^=\"top\"] .react-datepicker__triangle::before,\n.react-datepicker__year-read-view--down-arrow::before,\n.react-datepicker__month-read-view--down-arrow::before,\n.react-datepicker__month-year-read-view--down-arrow::before {\n  bottom: -1px;\n  border-top-color: #aeaeae;\n}\n\n.react-datepicker-wrapper {\n  display: inline-block;\n  padding: 0;\n  border: 0;\n}\n\n.react-datepicker {\n  font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  font-size: 0.8rem;\n  background-color: #fff;\n  color: #000;\n  border: 1px solid #aeaeae;\n  border-radius: 0.3rem;\n  display: inline-block;\n  position: relative;\n}\n\n.react-datepicker--time-only .react-datepicker__triangle {\n  left: 35px;\n}\n\n.react-datepicker--time-only .react-datepicker__time-container {\n  border-left: 0;\n}\n\n.react-datepicker--time-only .react-datepicker__time {\n  border-radius: 0.3rem;\n}\n\n.react-datepicker--time-only .react-datepicker__time-box {\n  border-radius: 0.3rem;\n}\n\n.react-datepicker__triangle {\n  position: absolute;\n  left: 50px;\n}\n\n.react-datepicker-popper {\n  z-index: 1;\n}\n\n.react-datepicker-popper[data-placement^=\"bottom\"] {\n  margin-top: 10px;\n}\n\n.react-datepicker-popper[data-placement=\"bottom-end\"] .react-datepicker__triangle,\n.react-datepicker-popper[data-placement=\"top-end\"] .react-datepicker__triangle {\n  left: auto;\n  right: 50px;\n}\n\n.react-datepicker-popper[data-placement^=\"top\"] {\n  margin-bottom: 10px;\n}\n\n.react-datepicker-popper[data-placement^=\"right\"] {\n  margin-left: 8px;\n}\n\n.react-datepicker-popper[data-placement^=\"right\"] .react-datepicker__triangle {\n  left: auto;\n  right: 42px;\n}\n\n.react-datepicker-popper[data-placement^=\"left\"] {\n  margin-right: 8px;\n}\n\n.react-datepicker-popper[data-placement^=\"left\"] .react-datepicker__triangle {\n  left: 42px;\n  right: auto;\n}\n\n.react-datepicker__header {\n  text-align: center;\n  background-color: #f0f0f0;\n  border-bottom: 1px solid #aeaeae;\n  border-top-left-radius: 0.3rem;\n  border-top-right-radius: 0.3rem;\n  padding-top: 8px;\n  position: relative;\n}\n\n.react-datepicker__header--time {\n  padding-bottom: 8px;\n  padding-left: 5px;\n  padding-right: 5px;\n}\n\n.react-datepicker__year-dropdown-container--select,\n.react-datepicker__month-dropdown-container--select,\n.react-datepicker__month-year-dropdown-container--select,\n.react-datepicker__year-dropdown-container--scroll,\n.react-datepicker__month-dropdown-container--scroll,\n.react-datepicker__month-year-dropdown-container--scroll {\n  display: inline-block;\n  margin: 0 2px;\n}\n\n.react-datepicker__current-month,\n.react-datepicker-time__header,\n.react-datepicker-year-header {\n  margin-top: 0;\n  color: #000;\n  font-weight: bold;\n  font-size: 0.944rem;\n}\n\n.react-datepicker-time__header {\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n}\n\n.react-datepicker__navigation {\n  background: none;\n  line-height: 1.7rem;\n  text-align: center;\n  cursor: pointer;\n  position: absolute;\n  top: 10px;\n  width: 0;\n  padding: 0;\n  border: 0.45rem solid transparent;\n  z-index: 1;\n  height: 10px;\n  width: 10px;\n  text-indent: -999em;\n  overflow: hidden;\n}\n\n.react-datepicker__navigation--previous {\n  left: 10px;\n  border-right-color: #ccc;\n  width: 14.38px;\n  height: 14.38px;\n}\n\n.react-datepicker__navigation--previous:hover {\n  border-right-color: #b3b3b3;\n}\n\n.react-datepicker__navigation--previous--disabled,\n.react-datepicker__navigation--previous--disabled:hover {\n  border-right-color: #e6e6e6;\n  cursor: default;\n}\n\n.react-datepicker__navigation--next {\n  right: 10px;\n  border-left-color: #ccc;\n  width: 14.38px;\n  height: 14.38px;\n}\n\n.react-datepicker__navigation--next--with-time:not(.react-datepicker__navigation--next--with-today-button) {\n  right: 80px;\n}\n\n.react-datepicker__navigation--next:hover {\n  border-left-color: #b3b3b3;\n}\n\n.react-datepicker__navigation--next--disabled,\n.react-datepicker__navigation--next--disabled:hover {\n  border-left-color: #e6e6e6;\n  cursor: default;\n}\n\n.react-datepicker__navigation--years {\n  position: relative;\n  top: 0;\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.react-datepicker__navigation--years-previous {\n  top: 4px;\n  border-top-color: #ccc;\n}\n\n.react-datepicker__navigation--years-previous:hover {\n  border-top-color: #b3b3b3;\n}\n\n.react-datepicker__navigation--years-upcoming {\n  top: -4px;\n  border-bottom-color: #ccc;\n}\n\n.react-datepicker__navigation--years-upcoming:hover {\n  border-bottom-color: #b3b3b3;\n}\n\n.react-datepicker__month-container {\n  float: left;\n}\n\n.react-datepicker__month {\n  margin: 0.4rem;\n  text-align: center;\n}\n\n.react-datepicker__month .react-datepicker__month-text,\n.react-datepicker__month .react-datepicker__quarter-text {\n  display: inline-block;\n  width: 4rem;\n  margin: 2px;\n}\n\n.react-datepicker__input-time-container {\n  clear: both;\n  width: 100%;\n  float: left;\n  margin: 5px 0 10px 15px;\n  text-align: left;\n}\n\n.react-datepicker__input-time-container .react-datepicker-time__caption {\n  display: inline-block;\n}\n\n.react-datepicker__input-time-container .react-datepicker-time__input-container {\n  display: inline-block;\n}\n\n.react-datepicker__input-time-container\n  .react-datepicker-time__input-container\n  .react-datepicker-time__input {\n  display: inline-block;\n  margin-left: 10px;\n}\n\n.react-datepicker__input-time-container\n  .react-datepicker-time__input-container\n  .react-datepicker-time__input\n  input {\n  width: 85px;\n}\n\n.react-datepicker__input-time-container\n  .react-datepicker-time__input-container\n  .react-datepicker-time__input\n  input[type=\"time\"]::-webkit-inner-spin-button,\n.react-datepicker__input-time-container\n  .react-datepicker-time__input-container\n  .react-datepicker-time__input\n  input[type=\"time\"]::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n.react-datepicker__input-time-container\n  .react-datepicker-time__input-container\n  .react-datepicker-time__input\n  input[type=\"time\"] {\n  -moz-appearance: textfield;\n}\n\n.react-datepicker__input-time-container\n  .react-datepicker-time__input-container\n  .react-datepicker-time__delimiter {\n  margin-left: 5px;\n  display: inline-block;\n}\n\n.react-datepicker__time-container {\n  float: right;\n  border-left: 1px solid #aeaeae;\n  width: 85px;\n}\n\n.react-datepicker__time-container--with-today-button {\n  display: inline;\n  border: 1px solid #aeaeae;\n  border-radius: 0.3rem;\n  position: absolute;\n  right: -72px;\n  top: 0;\n}\n\n.react-datepicker__time-container .react-datepicker__time {\n  position: relative;\n  background: white;\n}\n\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box {\n  width: 85px;\n  overflow-x: hidden;\n  margin: 0 auto;\n  text-align: center;\n}\n\n.react-datepicker__time-container\n  .react-datepicker__time\n  .react-datepicker__time-box\n  ul.react-datepicker__time-list {\n  list-style: none;\n  margin: 0;\n  height: calc(195px + (1.7rem / 2));\n  overflow-y: scroll;\n  padding-right: 0px;\n  padding-left: 0px;\n  width: 100%;\n  box-sizing: content-box;\n}\n\n.react-datepicker__time-container\n  .react-datepicker__time\n  .react-datepicker__time-box\n  ul.react-datepicker__time-list\n  li.react-datepicker__time-list-item {\n  height: 30px;\n  padding: 5px 10px;\n  white-space: nowrap;\n}\n\n.react-datepicker__time-container\n  .react-datepicker__time\n  .react-datepicker__time-box\n  ul.react-datepicker__time-list\n  li.react-datepicker__time-list-item:hover {\n  cursor: pointer;\n  background-color: #f0f0f0;\n}\n\n.react-datepicker__time-container\n  .react-datepicker__time\n  .react-datepicker__time-box\n  ul.react-datepicker__time-list\n  li.react-datepicker__time-list-item--selected {\n  background-color: #216ba5;\n  color: white;\n  font-weight: bold;\n}\n\n.react-datepicker__time-container\n  .react-datepicker__time\n  .react-datepicker__time-box\n  ul.react-datepicker__time-list\n  li.react-datepicker__time-list-item--selected:hover {\n  background-color: #216ba5;\n}\n\n.react-datepicker__time-container\n  .react-datepicker__time\n  .react-datepicker__time-box\n  ul.react-datepicker__time-list\n  li.react-datepicker__time-list-item--disabled {\n  color: #ccc;\n}\n\n.react-datepicker__time-container\n  .react-datepicker__time\n  .react-datepicker__time-box\n  ul.react-datepicker__time-list\n  li.react-datepicker__time-list-item--disabled:hover {\n  cursor: default;\n  background-color: transparent;\n}\n\n.react-datepicker__week-number {\n  color: #ccc;\n  display: inline-block;\n  width: 1.7rem;\n  line-height: 1.7rem;\n  text-align: center;\n  margin: 0.166rem;\n}\n\n.react-datepicker__week-number.react-datepicker__week-number--clickable {\n  cursor: pointer;\n}\n\n.react-datepicker__week-number.react-datepicker__week-number--clickable:hover {\n  border-radius: 0.3rem;\n  background-color: #f0f0f0;\n}\n\n.react-datepicker__day-names,\n.react-datepicker__week {\n  white-space: nowrap;\n}\n\n.react-datepicker__day-name,\n.react-datepicker__day,\n.react-datepicker__time-name {\n  color: #000;\n  display: inline-block;\n  width: 1.7rem;\n  line-height: 1.7rem;\n  text-align: center;\n  margin: 0.166rem;\n}\n\n.react-datepicker__month--selected,\n.react-datepicker__month--in-selecting-range,\n.react-datepicker__month--in-range,\n.react-datepicker__quarter--selected,\n.react-datepicker__quarter--in-selecting-range,\n.react-datepicker__quarter--in-range {\n  border-radius: 0.3rem;\n  background-color: #216ba5;\n  color: #fff;\n}\n\n.react-datepicker__month--selected:hover,\n.react-datepicker__month--in-selecting-range:hover,\n.react-datepicker__month--in-range:hover,\n.react-datepicker__quarter--selected:hover,\n.react-datepicker__quarter--in-selecting-range:hover,\n.react-datepicker__quarter--in-range:hover {\n  background-color: #1d5d90;\n}\n\n.react-datepicker__month--disabled,\n.react-datepicker__quarter--disabled {\n  color: #ccc;\n  pointer-events: none;\n}\n\n.react-datepicker__month--disabled:hover,\n.react-datepicker__quarter--disabled:hover {\n  cursor: default;\n  background-color: transparent;\n}\n\n.react-datepicker__day,\n.react-datepicker__month-text,\n.react-datepicker__quarter-text {\n  cursor: pointer;\n}\n\n.react-datepicker__day:hover,\n.react-datepicker__month-text:hover,\n.react-datepicker__quarter-text:hover {\n  border-radius: 0.3rem;\n  background-color: #f0f0f0;\n}\n\n.react-datepicker__day--today,\n.react-datepicker__month-text--today,\n.react-datepicker__quarter-text--today {\n  font-weight: bold;\n}\n\n.react-datepicker__day--highlighted,\n.react-datepicker__month-text--highlighted,\n.react-datepicker__quarter-text--highlighted {\n  border-radius: 0.3rem;\n  background-color: #3dcc4a;\n  color: #fff;\n}\n\n.react-datepicker__day--highlighted:hover,\n.react-datepicker__month-text--highlighted:hover,\n.react-datepicker__quarter-text--highlighted:hover {\n  background-color: #32be3f;\n}\n\n.react-datepicker__day--highlighted-custom-1,\n.react-datepicker__month-text--highlighted-custom-1,\n.react-datepicker__quarter-text--highlighted-custom-1 {\n  color: magenta;\n}\n\n.react-datepicker__day--highlighted-custom-2,\n.react-datepicker__month-text--highlighted-custom-2,\n.react-datepicker__quarter-text--highlighted-custom-2 {\n  color: green;\n}\n\n.react-datepicker__day--selected,\n.react-datepicker__day--in-selecting-range,\n.react-datepicker__day--in-range,\n.react-datepicker__month-text--selected,\n.react-datepicker__month-text--in-selecting-range,\n.react-datepicker__month-text--in-range,\n.react-datepicker__quarter-text--selected,\n.react-datepicker__quarter-text--in-selecting-range,\n.react-datepicker__quarter-text--in-range {\n  border-radius: 0.3rem;\n  background-color: #216ba5;\n  color: #fff;\n}\n\n.react-datepicker__day--selected:hover,\n.react-datepicker__day--in-selecting-range:hover,\n.react-datepicker__day--in-range:hover,\n.react-datepicker__month-text--selected:hover,\n.react-datepicker__month-text--in-selecting-range:hover,\n.react-datepicker__month-text--in-range:hover,\n.react-datepicker__quarter-text--selected:hover,\n.react-datepicker__quarter-text--in-selecting-range:hover,\n.react-datepicker__quarter-text--in-range:hover {\n  background-color: #1d5d90;\n}\n\n.react-datepicker__day--keyboard-selected,\n.react-datepicker__month-text--keyboard-selected,\n.react-datepicker__quarter-text--keyboard-selected {\n  border-radius: 0.3rem;\n  background-color: #2a87d0;\n  color: #fff;\n}\n\n.react-datepicker__day--keyboard-selected:hover,\n.react-datepicker__month-text--keyboard-selected:hover,\n.react-datepicker__quarter-text--keyboard-selected:hover {\n  background-color: #1d5d90;\n}\n\n.react-datepicker__day--in-selecting-range,\n.react-datepicker__month-text--in-selecting-range,\n.react-datepicker__quarter-text--in-selecting-range {\n  background-color: rgba(33, 107, 165, 0.5);\n}\n\n.react-datepicker__month--selecting-range .react-datepicker__day--in-range,\n.react-datepicker__month--selecting-range .react-datepicker__month-text--in-range,\n.react-datepicker__month--selecting-range .react-datepicker__quarter-text--in-range {\n  background-color: #f0f0f0;\n  color: #000;\n}\n\n.react-datepicker__day--disabled,\n.react-datepicker__month-text--disabled,\n.react-datepicker__quarter-text--disabled {\n  cursor: default;\n  color: #ccc;\n}\n\n.react-datepicker__day--disabled:hover,\n.react-datepicker__month-text--disabled:hover,\n.react-datepicker__quarter-text--disabled:hover {\n  background-color: transparent;\n}\n\n.react-datepicker__month-text.react-datepicker__month--selected:hover,\n.react-datepicker__month-text.react-datepicker__month--in-range:hover,\n.react-datepicker__month-text.react-datepicker__quarter--selected:hover,\n.react-datepicker__month-text.react-datepicker__quarter--in-range:hover,\n.react-datepicker__quarter-text.react-datepicker__month--selected:hover,\n.react-datepicker__quarter-text.react-datepicker__month--in-range:hover,\n.react-datepicker__quarter-text.react-datepicker__quarter--selected:hover,\n.react-datepicker__quarter-text.react-datepicker__quarter--in-range:hover {\n  background-color: #216ba5;\n}\n\n.react-datepicker__month-text:hover,\n.react-datepicker__quarter-text:hover {\n  background-color: #f0f0f0;\n}\n\n.react-datepicker__input-container {\n  position: relative;\n  display: inline-block;\n  width: 100%;\n}\n\n.react-datepicker__year-read-view,\n.react-datepicker__month-read-view,\n.react-datepicker__month-year-read-view {\n  border: 1px solid transparent;\n  border-radius: 0.3rem;\n}\n\n.react-datepicker__year-read-view:hover,\n.react-datepicker__month-read-view:hover,\n.react-datepicker__month-year-read-view:hover {\n  cursor: pointer;\n}\n\n.react-datepicker__year-read-view:hover .react-datepicker__year-read-view--down-arrow,\n.react-datepicker__year-read-view:hover .react-datepicker__month-read-view--down-arrow,\n.react-datepicker__month-read-view:hover .react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-read-view:hover .react-datepicker__month-read-view--down-arrow,\n.react-datepicker__month-year-read-view:hover .react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-year-read-view:hover .react-datepicker__month-read-view--down-arrow {\n  border-top-color: #b3b3b3;\n}\n\n.react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-read-view--down-arrow,\n.react-datepicker__month-year-read-view--down-arrow {\n  border-top-color: #ccc;\n  float: right;\n  margin-left: 20px;\n  top: 8px;\n  position: relative;\n  border-width: 0.45rem;\n}\n\n.react-datepicker__year-dropdown,\n.react-datepicker__month-dropdown,\n.react-datepicker__month-year-dropdown {\n  background-color: #f0f0f0;\n  position: absolute;\n  width: 50%;\n  left: 25%;\n  top: 30px;\n  z-index: 1;\n  text-align: center;\n  border-radius: 0.3rem;\n  border: 1px solid #aeaeae;\n}\n\n.react-datepicker__year-dropdown:hover,\n.react-datepicker__month-dropdown:hover,\n.react-datepicker__month-year-dropdown:hover {\n  cursor: pointer;\n}\n\n.react-datepicker__year-dropdown--scrollable,\n.react-datepicker__month-dropdown--scrollable,\n.react-datepicker__month-year-dropdown--scrollable {\n  height: 150px;\n  overflow-y: scroll;\n}\n\n.react-datepicker__year-option,\n.react-datepicker__month-option,\n.react-datepicker__month-year-option {\n  line-height: 20px;\n  width: 100%;\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.react-datepicker__year-option:first-of-type,\n.react-datepicker__month-option:first-of-type,\n.react-datepicker__month-year-option:first-of-type {\n  border-top-left-radius: 0.3rem;\n  border-top-right-radius: 0.3rem;\n}\n\n.react-datepicker__year-option:last-of-type,\n.react-datepicker__month-option:last-of-type,\n.react-datepicker__month-year-option:last-of-type {\n  -webkit-user-select: none;\n  user-select: none;\n  border-bottom-left-radius: 0.3rem;\n  border-bottom-right-radius: 0.3rem;\n}\n\n.react-datepicker__year-option:hover,\n.react-datepicker__month-option:hover,\n.react-datepicker__month-year-option:hover {\n  background-color: #ccc;\n}\n\n.react-datepicker__year-option:hover .react-datepicker__navigation--years-upcoming,\n.react-datepicker__month-option:hover .react-datepicker__navigation--years-upcoming,\n.react-datepicker__month-year-option:hover .react-datepicker__navigation--years-upcoming {\n  border-bottom-color: #b3b3b3;\n}\n\n.react-datepicker__year-option:hover .react-datepicker__navigation--years-previous,\n.react-datepicker__month-option:hover .react-datepicker__navigation--years-previous,\n.react-datepicker__month-year-option:hover .react-datepicker__navigation--years-previous {\n  border-top-color: #b3b3b3;\n}\n\n.react-datepicker__year-option--selected,\n.react-datepicker__month-option--selected,\n.react-datepicker__month-year-option--selected {\n  position: absolute;\n  left: 15px;\n}\n\n.react-datepicker__close-icon {\n  cursor: pointer;\n  background-color: transparent;\n  border: 0;\n  outline: 0;\n  padding: 0px 6px 0px 0px;\n  position: absolute;\n  top: 0;\n  right: 0;\n  height: 100%;\n  display: table-cell;\n  vertical-align: middle;\n}\n\n.react-datepicker__close-icon::after {\n  cursor: pointer;\n  background-color: #216ba5;\n  color: #fff;\n  border-radius: 50%;\n  height: 16px;\n  width: 16px;\n  padding: 2px;\n  font-size: 12px;\n  line-height: 1;\n  text-align: center;\n  display: table-cell;\n  vertical-align: middle;\n  content: \"\\00d7\";\n}\n\n.react-datepicker__today-button {\n  background: #f0f0f0;\n  border-top: 1px solid #aeaeae;\n  cursor: pointer;\n  text-align: center;\n  font-weight: bold;\n  padding: 5px 0;\n  clear: left;\n}\n\n.react-datepicker__portal {\n  position: fixed;\n  width: 100vw;\n  height: 100vh;\n  background-color: rgba(0, 0, 0, 0.8);\n  left: 0;\n  top: 0;\n  justify-content: center;\n  align-items: center;\n  display: flex;\n  z-index: 2147483647;\n}\n\n.react-datepicker__portal .react-datepicker__day-name,\n.react-datepicker__portal .react-datepicker__day,\n.react-datepicker__portal .react-datepicker__time-name {\n  width: 3rem;\n  line-height: 3rem;\n}\n\n@media (max-width: 400px), (max-height: 550px) {\n  .react-datepicker__portal .react-datepicker__day-name,\n  .react-datepicker__portal .react-datepicker__day,\n  .react-datepicker__portal .react-datepicker__time-name {\n    width: 2rem;\n    line-height: 2rem;\n  }\n}\n\n.react-datepicker__portal .react-datepicker__current-month,\n.react-datepicker__portal .react-datepicker-time__header {\n  font-size: 1.44rem;\n}\n\n.react-datepicker__portal .react-datepicker__navigation {\n  border: 0.81rem solid transparent;\n}\n\n.react-datepicker__portal .react-datepicker__navigation--previous {\n  border-right-color: #ccc;\n}\n\n.react-datepicker__portal .react-datepicker__navigation--previous:hover {\n  border-right-color: #b3b3b3;\n}\n\n.react-datepicker__portal .react-datepicker__navigation--previous--disabled,\n.react-datepicker__portal .react-datepicker__navigation--previous--disabled:hover {\n  border-right-color: #e6e6e6;\n  cursor: default;\n}\n\n.react-datepicker__portal .react-datepicker__navigation--next {\n  border-left-color: #ccc;\n}\n\n.react-datepicker__portal .react-datepicker__navigation--next:hover {\n  border-left-color: #b3b3b3;\n}\n\n.react-datepicker__portal .react-datepicker__navigation--next--disabled,\n.react-datepicker__portal .react-datepicker__navigation--next--disabled:hover {\n  border-left-color: #e6e6e6;\n  cursor: default;\n}\n";
  styleInject(css_248z$c);
  var css_248z$d = ".dropdowndatepicker-wrapper {\n  min-width: 140px;\n  position: relative;\n  margin-top: 20px;\n}\n\n.react-datepicker-wrapper {\n  width: 100%;\n}\n\n.dropdowndatepicker-wrapper.dropdowndatepicker-error input {\n  border-color: #ff4040;\n  color: #ff4040;\n}\n\n.dropdowndatepicker-wrapper input {\n  width: 100%;\n}\n\n.dropdowndatepicker-wrapper input:focus {\n  outline: none;\n  border-color: #3c3835;\n}\n\n.react-datepicker__input-container {\n  position: relative;\n  font-family: \"Source Sans Pro\", sans-serif;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 18px;\n  line-height: 23px;\n  align-items: center;\n}\n\n.react-datepicker__input-container input {\n  position: relative;\n  display: flex;\n  align-items: center;\n  min-height: 40px;\n  border: 1px solid #cdccc8;\n  color: #3c3835;\n  box-sizing: border-box;\n  border-radius: 6px;\n  padding: 0 20px;\n  font-family: \"Source Sans Pro\", sans-serif;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 18px;\n  line-height: 23px;\n}\n\n.react-datepicker__header {\n  background: white;\n  border: none;\n}\n\n.react-datepicker__current-month,\n.react-datepicker-time__header,\n.react-datepicker-year-header {\n  font-family: \"Source Sans Pro\", sans-serif;\n  font-style: normal;\n  font-weight: 600;\n  font-size: 20px;\n  line-height: 100%;\n  text-align: center;\n  color: #000000;\n  margin-bottom: 20px;\n}\n\n.react-datepicker__day-name,\n.react-datepicker__day,\n.react-datepicker__time-name {\n  width: 33px;\n}\n\n.react-datepicker__day-name {\n  margin-top: 10px;\n  font-family: \"Source Sans Pro\", sans-serif;\n  font-style: normal;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 18px;\n  color: #000000;\n  padding: 0px 5px;\n}\n\n.react-datepicker__day {\n  font-family: \"Source Sans Pro\", sans-serif;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 18px;\n  line-height: 23px;\n  text-align: center;\n  color: #000000;\n  border: none;\n  padding: 5px;\n}\n\n.react-datepicker__day--selected,\n.react-datepicker__day--in-selecting-range,\n.react-datepicker__day--in-range,\n.react-datepicker__month-text--selected,\n.react-datepicker__month-text--in-selecting-range,\n.react-datepicker__month-text--in-range,\n.react-datepicker__quarter-text--selected,\n.react-datepicker__quarter-text--in-selecting-range,\n.react-datepicker__quarter-text--in-range,\n.react-datepicker__day--keyboard-selected,\n.react-datepicker__month-text--keyboard-selected,\n.react-datepicker__quarter-text--keyboard-selected {\n  background: #3c3835;\n  color: #fab500;\n  font-weight: 600;\n  font-size: 18px;\n  border-radius: 0px;\n}\n\n.react-datepicker__day--disabled {\n  color: #cdccc8;\n  pointer-events: none;\n}\n\n.react-datepicker__day:hover {\n  background: #fab500;\n  border-radius: 0px;\n}\n\n.react-datepicker-popper {\n  box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.15);\n  border-radius: 6px;\n  z-index: 100;\n  background-color: #fff;\n  top: 0px;\n  left: 0px;\n  transform: translate3d(0px, 40px, 0px) !important;\n  margin-top: 10px;\n  margin-bottom: 0;\n}\n\n.react-datepicker {\n  border: 0;\n}\n\n.react-datepicker__month-select {\n  background-color: #fff;\n  color: #3c3835;\n  border: none;\n}\n\n.react-datepicker__year-select {\n  background-color: #fff;\n  color: #3c3835;\n  border: none;\n}\n\n.react-datepicker__current-month,\n.react-datepicker-time__header,\n.react-datepicker-year-header {\n  display: none;\n}\n\n.react-datepicker__navigation {\n  top: 15px;\n}";
  styleInject(css_248z$d);
  var css_248z$e = ".fieldlabel-wrapper {\n  position: absolute;\n  top: -5px;\n  text-transform: uppercase;\n  left: 10px;\n  padding: 0 5px;\n  background-color: white;\n  color: #3c3835;\n  font-family: \"Source Sans Pro\", sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 8.5px;\n  line-height: 10px;\n  letter-spacing: 0.05em;\n  display: flex;\n  align-items: center;\n  text-align: center;\n  text-transform: uppercase;\n  z-index: 1;\n}\n\n.fieldlabel-error {\n  color: #ff4040;\n}\n\n.mandatory-star {\n  color: #fab500;\n}\n\n@media only screen and (max-width: 400px) {\n  .fieldlabel-wrapper {\n    padding: 0px 5px !important;\n    font-size: 10px;\n    left: 15px;\n  }\n}";
  styleInject(css_248z$e);

  var FieldLabel = function FieldLabel(_ref) {
    var error = _ref.error,
        labelText = _ref.labelText,
        mandatory = _ref.mandatory;
    var fieldlabelClass = classNames("fieldlabel-wrapper", {
      "fieldlabel-error": error
    });
    return /*#__PURE__*/React__default.createElement("label", {
      className: fieldlabelClass
    }, labelText, mandatory && /*#__PURE__*/React__default.createElement("span", {
      className: "mandatory-star"
    }, "\xA0*"));
  };

  FieldLabel.propTypes = {
    error: PropTypes__default.bool,
    labelText: PropTypes__default.string,
    mandatory: PropTypes__default.bool
  };
  FieldLabel.defaultProps = {
    error: false,
    labelText: "",
    mandatory: false
  };

  var DropDownDatePicker = function DropDownDatePicker(_ref) {
    var labelText = _ref.labelText,
        fullWidth = _ref.fullWidth,
        onDateChange = _ref.onDateChange,
        mandatory = _ref.mandatory,
        value = _ref.value,
        error = _ref.error,
        margin = _ref.margin,
        maxDate = _ref.maxDate,
        minDate = _ref.minDate,
        tabIndex = _ref.tabIndex,
        onYearChange = _ref.onYearChange;
    var dropdowndatepickerClass = classNames("dropdowndatepicker-wrapper", {
      "dropdowndatepicker-error": error
    });

    var _React$useState5 = React.useState(null),
        _React$useState6 = _slicedToArray(_React$useState5, 2),
        date = _React$useState6[0],
        setSelectedDate = _React$useState6[1];

    var controlledDate = value ? new Date(value) : date;

    var setDate = function setDate(dateParam) {
      if (onDateChange) {
        onDateChange(dateParam);
      } else {
        setSelectedDate(dateParam);
      }
    };

    return /*#__PURE__*/React__default.createElement("div", {
      className: dropdowndatepickerClass,
      style: fullWidth ? {
        width: "100%",
        margin: margin
      } : {
        margin: margin
      }
    }, /*#__PURE__*/React__default.createElement(FieldLabel, {
      labelText: labelText,
      mandatory: mandatory,
      error: error
    }), /*#__PURE__*/React__default.createElement(DatePicker$1, {
      tabIndex: tabIndex,
      maxDate: maxDate,
      minDate: minDate,
      selected: controlledDate,
      onChange: setDate,
      peekNextMonth: true,
      showMonthDropdown: true,
      showYearDropdown: true,
      dropdownMode: "select",
      showPopperArrow: false,
      dateFormat: "dd MMM yyyy",
      disabledKeyboardNavigation: true,
      onYearChange: onYearChange
    }));
  };

  DropDownDatePicker.propTypes = {
    labelText: PropTypes__default.string,
    onDateChange: PropTypes__default.func,
    fullWidth: PropTypes__default.bool,
    mandatory: PropTypes__default.bool,
    value: PropTypes__default.bool,
    error: PropTypes__default.bool,
    margin: PropTypes__default.string,
    maxDate: PropTypes__default.string,
    minDate: PropTypes__default.string,
    tabIndex: PropTypes__default.number,
    onYearChange: PropTypes__default.func
  };
  DropDownDatePicker.defaultProps = {
    labelText: "",
    onDateChange: undefined,
    fullWidth: false,
    mandatory: false,
    value: undefined,
    error: false,
    margin: "0 0 20px 0",
    maxDate: undefined,
    minDate: undefined,
    tabIndex: undefined,
    onYearChange: function onYearChange() {}
  };
  var css_248z$f = ".dropdownmenu-wrapper {\n  min-width: 140px;\n  position: relative;\n  font-family: \"Source Sans Pro\", sans-serif;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 18px;\n  line-height: 23px;\n  align-items: center;\n}\n\n.dropdownmenu-header:focus {\n  outline: none;\n}\n\n.dropdownmenu-header {\n  position: relative;\n  display: flex;\n  align-items: center;\n  min-height: 40px;\n  border: 1px solid #cdccc8;\n  color: #3c3835;\n  box-sizing: border-box;\n  border-radius: 6px;\n  padding: 0 10px;\n}\n\n.dropdownmenu-header-focused {\n  border-color: #3c3835;\n  outline: none;\n}\n\n.dropdownmenu-header-error {\n  border-color: #ff4040;\n  color: #ff4040;\n}\n\n.dropdownmenu-content {\n  margin-top: 10px;\n  font-size: 16px;\n  line-height: 20px;\n  box-sizing: border-box;\n  position: absolute;\n  width: 100%;\n  background-color: #f9f9f9;\n  min-width: 160px;\n  z-index: 2;\n  background: #ffffff;\n  box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.15);\n  border-radius: 6px;\n  max-height: 300px;\n  overflow: auto;\n}\n\n.dropdownmenu-content-row {\n  display: block;\n  padding: 10px 20px;\n}\n\n.dropdownmenu-content-row:hover {\n  background: #f5f5f5;\n}\n\n@media only screen and (max-width: 400px) {\n  .dropdownmenu-wrapper {\n    font-size: 16px;\n  }\n}";
  styleInject(css_248z$f);

  function useOnClickOutside(ref, handler) {
    React.useEffect(function () {
      var listener = function listener(event) {
        // Do nothing if clicking ref's element or descendent elements
        if (!ref.current || ref.current.contains(event.target)) {
          return;
        }

        handler(event);
      };

      document.addEventListener("mousedown", listener);
      document.addEventListener("touchstart", listener);
      return function () {
        document.removeEventListener("mousedown", listener);
        document.removeEventListener("touchstart", listener);
      };
    }, [ref, handler]);
  }

  function useRoveFocus(locationList, state, changeState) {
    var operationOnIndex = function operationOnIndex(direction) {
      if (!locationList.length) {
        return;
      }

      var cityIndex = state.cityIndex,
          airportIndex = state.airportIndex;

      if (direction) {
        // down arrow
        if (cityIndex === -1 || ((locationList[cityIndex] || []).airports || []).length - 1 === airportIndex && cityIndex !== locationList.length - 1) {
          changeState({
            // If all last airports are in selected city
            cityIndex: cityIndex + 1,
            // If next city has only one airport, airportIndex will be 0, if not -1
            airportIndex: ((locationList[cityIndex + 1] || []).airports || []).length === 1 ? 0 : -1
          });
        } else if (((locationList[cityIndex] || []).airports || []).length - 1 > airportIndex) {
          // if is selected city and has more airports
          changeState({
            airportIndex: airportIndex + 1
          });
        }

        return;
      } // up arrow


      if ((airportIndex === -1 || airportIndex === 0 && ((locationList[cityIndex] || []).airports || []).length === 1) && cityIndex > 0) {
        // If is city with one airport or if is first airport in city
        changeState({
          cityIndex: cityIndex - 1,
          // If previous city has only one airport, airportIndex will be 0, if not - airportIndex will be his last airport (length-1)
          airportIndex: ((locationList[cityIndex - 1] || []).airports || []).length === 1 ? 0 : ((locationList[cityIndex - 1] || []).airports || []).length - 1
        });
      } else if (airportIndex >= 0) {
        // if is selected city and has more airports
        changeState({
          airportIndex: airportIndex - 1
        });
      }
    };

    var handleKeyDown = React.useCallback(function (e) {
      if (e.key === "ArrowDown") {
        e.preventDefault();
        operationOnIndex(true); // down
      } else if (e.key === "ArrowUp") {
        // Up arrow
        e.preventDefault();
        operationOnIndex(false); // up
      }
    }, [operationOnIndex]);
    React.useEffect(function () {
      document.addEventListener("keydown", handleKeyDown, false);
      return function () {
        document.removeEventListener("keydown", handleKeyDown, false);
      };
    }, [handleKeyDown]);
  }

  var DropdownMenu = function DropdownMenu(_ref) {
    var labelText = _ref.labelText,
        error = _ref.error,
        mandatory = _ref.mandatory,
        content = _ref.content,
        value = _ref.value,
        open = _ref.open,
        toggle = _ref.toggle,
        onSelect = _ref.onSelect,
        margin = _ref.margin,
        children = _ref.children,
        tabIndex = _ref.tabIndex;

    var _React$useState7 = React.useState(false),
        _React$useState8 = _slicedToArray(_React$useState7, 2),
        showDropDownContent = _React$useState8[0],
        setShowDropDownContent = _React$useState8[1];

    var controlledDropDownContent = open || showDropDownContent;

    var changeShowDropDownContent = function changeShowDropDownContent(isOpen) {
      if (toggle) {
        toggle(isOpen);
      } else {
        setShowDropDownContent(isOpen);
      }
    };

    var toogleDropDownContent = function toogleDropDownContent() {
      changeShowDropDownContent(!controlledDropDownContent);
    };

    var ref = React.useRef();
    useOnClickOutside(ref, function () {
      return changeShowDropDownContent(false);
    });
    var dropDownMenuHeader = classNames("dropdownmenu-header", {
      "dropdownmenu-header-error": error,
      "dropdownmenu-header-focused": controlledDropDownContent
    });
    var dropDownMenuContent = classNames("dropdownmenu-content");
    return /*#__PURE__*/React__default.createElement("div", {
      className: "dropdownmenu-wrapper",
      ref: ref,
      style: {
        margin: margin
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      className: dropDownMenuHeader,
      tabIndex: tabIndex,
      onClick: toogleDropDownContent
    }, value, /*#__PURE__*/React__default.createElement(FieldLabel, {
      error: error,
      labelText: labelText,
      mandatory: mandatory
    }), /*#__PURE__*/React__default.createElement(Icon, {
      name: controlledDropDownContent ? "chevron_up" : "chevron_down",
      error: error
    })), controlledDropDownContent && /*#__PURE__*/React__default.createElement("div", {
      className: dropDownMenuContent
    }, children, content.map(function (singleRow) {
      return /*#__PURE__*/React__default.createElement("div", {
        key: singleRow,
        className: "dropdownmenu-content-row",
        onClick: function onClick() {
          onSelect(singleRow[0]);
          toogleDropDownContent();
        }
      }, singleRow[1]);
    })));
  };

  DropdownMenu.propTypes = {
    labelText: PropTypes__default.string,
    open: PropTypes__default.bool,
    toggle: PropTypes__default.func,
    children: PropTypes__default.element,
    error: PropTypes__default.bool,
    mandatory: PropTypes__default.bool,
    content: PropTypes__default.instanceOf(Array),
    value: PropTypes__default.any,
    onSelect: PropTypes__default.func.isRequired,
    margin: PropTypes__default.string,
    tabIndex: PropTypes__default.number
  };
  DropdownMenu.defaultProps = {
    labelText: "",
    open: false,
    toggle: undefined,
    children: null,
    content: [],
    error: false,
    mandatory: false,
    margin: "0 0 20px 0",
    tabIndex: undefined,
    onSelect: function onSelect() {}
  };
  var css_248z$g = ".emptyState-container {\n  text-align: center;\n  border-radius: 6px;\n  background-color: #fff;\n  padding: 20px;\n  font-size: 14px;\n}\n.emptyState-container p {\n  color: #696d6f;\n}\n@media screen and (max-width: 1112px) {\n  .emptyState-container p {\n    color: #000;\n  }\n}\n@media screen and (max-width: 1112px) {\n  .emptyState-container img {\n    max-width: 114px;\n  }\n}";
  styleInject(css_248z$g);

  var EmptyState = function EmptyState(_ref) {
    var type = _ref.type,
        onClickText = _ref.onClickText;
    var emptyStateClass = classNames("emptyState-container");
    var content = React.useMemo(function () {
      var data = {
        title: "We couldn't find any available routes for your selections",
        text: "Please edit your search."
      };

      switch (type) {
        case "search":
          data.title = "We couldn't find any available routes for your selections";
          data.text = "Please edit your search.";
          break;

        case "mytrips":
          data.title = "You have no trips";
          data.text = "Please go and book one.";
          break;
      }

      return data;
    }, [type]);
    return /*#__PURE__*/React__default.createElement("div", {
      className: emptyStateClass
    }, /*#__PURE__*/React__default.createElement("h4", null, content.title), /*#__PURE__*/React__default.createElement("p", null, content.text), /*#__PURE__*/React__default.createElement("img", {
      width: "114",
      height: "130",
      src: "data:image/png;base64,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"
    }), /*#__PURE__*/React__default.createElement("h4", {
      style: {
        fontWeight: "600",
        fontSize: "22px",
        lineHeight: "30px"
      }
    }, "Need personal assistance?"), /*#__PURE__*/React__default.createElement("p", null, "Contact customer support at info@landline.com or call +1 888 428 1149."));
  };

  EmptyState.propTypes = {
    type: PropTypes__default.oneOf(["search"]),
    onClickText: PropTypes__default.func
  };
  EmptyState.defaultProps = {
    type: "search",
    onClickText: null
  };
  var css_248z$h = ".IncrementerInput-wrapper {\n  position: relative;\n  border: 1px solid #cdccc8;\n  box-sizing: border-box;\n  border-radius: 6px;\n}\n.IncrementerInput-wrapper .IncrementerLabelAlignMiddle, .IncrementerInput-wrapper .IncrementerLabelAlignLeft {\n  position: absolute;\n  font-family: \"Source Sans Pro\", sans-serif;\n  font-style: normal;\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 15px;\n  text-transform: uppercase;\n  background: #fff;\n  padding: 1px 10px;\n}\n.IncrementerInput-wrapper .counter-container {\n  display: grid;\n  background: #fff;\n  grid-template-columns: 40px 1fr 40px;\n  grid-column-gap: 10px;\n  height: 44px;\n  align-items: center;\n  justify-items: center;\n  line-height: inherit;\n}\n.IncrementerInput-wrapper .counter-container .count-wrapper {\n  font-family: \"Source Sans Pro\", sans-serif;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 18px;\n  color: #3c3835;\n}\n.IncrementerInput-wrapper .counter-container .count-decrease-wrapper {\n  display: flex;\n}\n.IncrementerInput-wrapper .counter-container .count-decrease-wrapper .svgRight {\n  position: inherit;\n  right: 0;\n  top: 0;\n  transform: inherit;\n  margin-top: 3px;\n}\n.IncrementerInput-wrapper .counter-container .count-increase-wrapper {\n  display: flex;\n}\n.IncrementerInput-wrapper .counter-container .count-increase-wrapper .svgRight {\n  position: inherit;\n  right: 0;\n  top: 0;\n  transform: inherit;\n  margin-top: 3px;\n}\n.IncrementerInput-wrapper .IncrementerLabelAlignLeft {\n  top: -8px;\n  left: 20px;\n}\n.IncrementerInput-wrapper .IncrementerLabelAlignMiddle {\n  left: 50%;\n  transform: translateX(-50%);\n  width: max-content;\n}\n.IncrementerInput-wrapper .IncrementerLabelAlignRight {\n  left: 100%;\n  transform: translateX(-100%);\n  transform: translateX(-90px);\n}";
  styleInject(css_248z$h);

  var IncrementerInput = function IncrementerInput(_ref) {
    var onIncrementChange = _ref.onIncrementChange,
        incrementNumber = _ref.incrementNumber,
        label = _ref.label,
        incrementStep = _ref.incrementStep,
        counterLimit = _ref.counterLimit,
        labelAlign = _ref.labelAlign,
        counterMin = _ref.counterMin;

    var _React$useState9 = React.useState(incrementNumber),
        _React$useState10 = _slicedToArray(_React$useState9, 2),
        numberToIncrement = _React$useState10[0],
        setNumberToIncrement = _React$useState10[1];

    var IncrementerInputClass = classNames("IncrementerInput-wrapper");
    var IncrementerLabelAlign = classNames("IncrementerLabelAlignLeft", {
      IncrementerLabelAlignMiddle: labelAlign === "middle",
      IncrementerLabelAlignRight: labelAlign === "right"
    });

    var updateCounter = function updateCounter(count) {
      if (count >= counterMin && count <= counterLimit) {
        setNumberToIncrement(count);
        onIncrementChange(count);
      }
    };

    return /*#__PURE__*/React__default.createElement("div", {
      className: IncrementerInputClass
    }, /*#__PURE__*/React__default.createElement("div", {
      className: IncrementerLabelAlign
    }, label), /*#__PURE__*/React__default.createElement("div", {
      className: "counter-container"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "count-decrease-wrapper",
      onClick: function onClick() {
        return updateCounter(numberToIncrement - incrementStep);
      }
    }, /*#__PURE__*/React__default.createElement(Icon, {
      name: "counter_decrease"
    })), /*#__PURE__*/React__default.createElement("div", {
      className: "count-wrapper"
    }, numberToIncrement), /*#__PURE__*/React__default.createElement("div", {
      className: "count-increase-wrapper",
      onClick: function onClick() {
        return updateCounter(numberToIncrement + incrementStep);
      }
    }, /*#__PURE__*/React__default.createElement(Icon, {
      name: "counter_increase"
    }))));
  };

  IncrementerInput.propTypes = {
    incrementNumber: PropTypes__default.number,
    incrementStep: PropTypes__default.number,
    counterLimit: PropTypes__default.number,
    onIncrementChange: PropTypes__default.func,
    label: PropTypes__default.string,
    labelAlign: PropTypes__default.string,
    counterMin: PropTypes__default.number
  };
  IncrementerInput.defaultProps = {
    incrementNumber: 1,
    incrementStep: 1,
    counterLimit: 9,
    counterMin: 1,
    onIncrementChange: function onIncrementChange() {},
    label: "",
    labelAlign: ""
  };
  var css_248z$i = ".inputPreview-wrapper {\n  border-bottom: 1px solid #e5e5e5;\n  display: flex;\n  justify-content: space-between;\n}\n\n.inputPreview-left-container {\n  display: flex;\n  flex-flow: column nowrap;\n}\n\n.inputPreview-right-container {\n  display: flex;\n  flex-flow: column nowrap;\n}\n\n.inputPreview-title {\n  display: flex;\n  height: 20px;\n  align-items: center;\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 15px;\n  margin-top: 10px;\n}\n\n.inputPreview-value {\n  display: flex;\n  height: 40px;\n  align-items: center;\n  font-weight: normal;\n  font-size: 16px;\n  line-height: 150%;\n  color: #696d6f;\n  padding-bottom: 10px;\n}\n\n.inputPreview-right-title {\n  display: flex;\n  height: 20px;\n  align-items: center;\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 15px;\n  margin-top: 10px;\n  color: #ff9800;\n  justify-content: flex-end;\n}\n\n.inputPreview-right-value {\n  display: flex;\n  height: 40px;\n  align-items: center;\n  font-weight: normal;\n  font-size: 16px;\n  line-height: 150%;\n  color: #696d6f;\n  padding-bottom: 10px;\n  justify-content: right;\n}";
  styleInject(css_248z$i);

  var InputPreview = function InputPreview(_ref) {
    var title = _ref.title,
        value = _ref.value,
        rightTitle = _ref.rightTitle,
        rightValue = _ref.rightValue;
    return /*#__PURE__*/React__default.createElement("div", {
      className: "inputPreview-wrapper"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "inputPreview-left-container"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "inputPreview-title"
    }, title), /*#__PURE__*/React__default.createElement("div", {
      className: "inputPreview-value"
    }, value)), /*#__PURE__*/React__default.createElement("div", {
      className: "inputPreview-right-container"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "inputPreview-right-title"
    }, rightTitle), /*#__PURE__*/React__default.createElement("div", {
      className: "inputPreview-right-value"
    }, rightValue)));
  };

  InputPreview.propTypes = {
    title: PropTypes__default.string.isRequired,
    value: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.element]).isRequired,
    rightTitle: PropTypes__default.string,
    rightValue: PropTypes__default.string
  };
  InputPreview.defaultProps = {
    rightTitle: "",
    rightValue: null
  };
  var css_248z$j = ".rc-slider-tooltip-content {\n  display: block;\n  visibility: unset;\n}\n\n.rc-slider-tooltip-arrow {\n  border-top-color: #f5f5f5 !important;\n}\n\n.rc-slider-tooltip-inner {\n  padding: 5px !important;\n  font-size: 14px !important;\n  display: flex;\n  height: auto !important;\n  justify-content: center;\n  align-items: center;\n  background-color: #f5f5f5 !important;\n  color: #3c3835 !important;\n}\n\n.layover-container {\n  display: flex;\n  flex-direction: column;\n}\n.layover-container .text {\n  margin: 16px 0px;\n}\n.layover-container.collapsible-wrapper {\n  padding: 0px !important;\n}\n.layover-container .rc-slider-container {\n  margin: 50px 0px;\n  padding: 0px 20px;\n}\n.layover-container .rc-slider-handle {\n  box-shadow: 0px 2px 8px 2px rgba(0, 0, 0, 0.1);\n}\n\n.rc-slider-mark + div + div .rc-slider-tooltip-placement-top {\n  top: 23px !important;\n}\n.rc-slider-mark + div + div .rc-slider-tooltip-placement-top .rc-slider-tooltip-arrow {\n  transform: rotate(180deg);\n  top: 0;\n}";
  styleInject(css_248z$j);
  var dotStyle = {
    height: 20,
    width: 20,
    backgroundColor: "rgba(60, 56, 53, 1)",
    border: "none",
    marginTop: -8
  };
  /* eslint-disable no-undef */

  var toDateFormatString = function toDateFormatString(date) {
    var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "MM/DD/YYYY";
    return moment(date).format(format);
  };

  var toTimeFormatString = function toTimeFormatString(date) {
    var displayFormat = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "hh:mm a";
    var inputFormat = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "HH:mm:ss";
    return moment(date, inputFormat).format(displayFormat);
  };

  var getDurationTime = function getDurationTime(durationTime) {
    var momentTime = moment(durationTime, "HH:mm:ss");

    if (!momentTime.isValid()) {
      return false;
    }

    if (momentTime.minutes() === 0) {
      return momentTime.format("H[h]");
    }

    return momentTime.format("H[h] m[m]");
  };

  var getDurationTimeFromSeconds = function getDurationTimeFromSeconds(durationTime) {
    return moment.utc(durationTime * 1000).format("H[h] m[m]");
  };

  var momentFormat = "YYYY/MM/DD HH:mm";

  var dateMask = function dateMask(maskType) {
    if (maskType === "time") {
      return {
        mask: Date,
        pattern: momentFormat,
        lazy: false,
        min: new Date(1910, 0, 1),
        max: new Date(2030, 0, 1),
        format: function format(date) {
          return moment(date).format(momentFormat);
        },
        parse: function parse(str) {
          return moment(str, momentFormat);
        },
        blocks: {
          YYYY: {
            mask: IMask.MaskedRange,
            from: 1970,
            to: 2030
          },
          MM: {
            mask: IMask.MaskedRange,
            from: 1,
            to: 12
          },
          DD: {
            mask: IMask.MaskedRange,
            from: 1,
            to: 31
          },
          HH: {
            mask: IMask.MaskedRange,
            from: 0,
            to: 23
          },
          mm: {
            mask: IMask.MaskedRange,
            from: 0,
            to: 59
          }
        }
      };
    }

    return {};
  };

  var createSliderWithTooltip = Slider__default.createSliderWithTooltip;
  var Range = createSliderWithTooltip(Slider__default.Range);

  var LayoverFilter = function LayoverFilter(_ref) {
    var maxLayover = _ref.maxLayover,
        onLayoverTimeChange = _ref.onLayoverTimeChange,
        transportType = _ref.transportType;
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(CollapsibleButton, {
      title: /*#__PURE__*/React__default.createElement(FormatedTitle, {
        text: transportType === "bus" ? "Bus to Airline connection time" : "Airline connection time"
      }),
      defaultOpenIcon: "chevron_down",
      defaultCloseIcon: "chevron_up"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "layover-container collapsible-wrapper"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "text"
    }, "Length of layover"), /*#__PURE__*/React__default.createElement("div", {
      className: "rc-slider-container"
    }, /*#__PURE__*/React__default.createElement(Range, {
      tipProps: {
        visible: true,
        placement: "top"
      },
      tipFormatter: getDurationTimeFromSeconds,
      min: 3600,
      max: 86359,
      step: 100,
      value: maxLayover,
      onChange: onLayoverTimeChange,
      trackStyle: [{
        backgroundColor: "#FAB500"
      }, {
        backgroundColor: "#FAB500"
      }],
      handleStyle: dotStyle
    })))));
  };

  LayoverFilter.propTypes = {
    maxLayover: PropTypes__default.number.isRequired,
    transportType: PropTypes__default.string.isRequired,
    onLayoverTimeChange: PropTypes__default.func.isRequired
  };
  var css_248z$k = "@media screen and (max-width: 450px) {\n  .legconnection-wrapper {\n    font-size: 13px;\n  }\n  .middleConnectionPointText {\n    margin-right: -9px !important;\n  }\n}\n.legconnection-container {\n  display: flex;\n  flex: 1;\n  flex-flow: column;\n  padding-bottom: 20px;\n}\n@media screen and (max-width: 1112px) {\n  .legconnection-container {\n    padding-bottom: 20px;\n  }\n}\n.legconnection-container .default-opacity {\n  opacity: 0.2;\n}\n.legconnection-container .header {\n  margin-bottom: 24px;\n  display: flex;\n  flex-direction: column;\n}\n.legconnection-container .header .connection-time-container {\n  margin-top: 8px;\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 15px;\n  display: flex;\n}\n.legconnection-container .header .connection-time-container:not(.ticket-connection-time) {\n  justify-content: center;\n}\n.legconnection-container .header .connection-time-container .connection-time-wrapper {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-basis: 140px;\n  background-color: #fff;\n  border-bottom-left-radius: 2px;\n  border-bottom-right-radius: 2px;\n  height: 24px;\n  border: 1px solid #e5e5e5;\n  font-weight: 600;\n  font-size: 12px;\n}\n.legconnection-container .header .connection-time-container .connection-time-wrapper span {\n  color: #999999;\n}\n.legconnection-container .header .title-wrapper {\n  display: flex;\n}\n.legconnection-container .header .title-wrapper:not(.ticket-select-leg-connection-title) {\n  border-top: 1px solid #cdccc8;\n  justify-content: center;\n}\n.legconnection-container .header .title-wrapper:not(.ticket-select-leg-connection-title) .connection-time-container {\n  justify-content: center;\n}\n.legconnection-container .header .title-wrapper .title {\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 15px;\n  display: flex;\n  flex-basis: 140px;\n  justify-content: center;\n  align-items: center;\n  border-bottom-left-radius: 2px;\n  border-bottom-right-radius: 2px;\n  height: 24px;\n}\n.legconnection-container .header .title-wrapper .bus {\n  background-color: #fab500;\n}\n.legconnection-container .header .title-wrapper .blackCar {\n  background-color: #3c3835;\n  color: #fff;\n}\n.legconnection-container .legconnection-content-container {\n  display: flex;\n  flex: 1;\n  align-items: flex-start;\n  gap: 10px;\n  padding-top: 20px;\n}\n.legconnection-container .icon-align svg {\n  top: -3px;\n}\n.legconnection-container .connection-point {\n  box-sizing: border-box;\n  width: 16px;\n  height: 16px;\n}\n.legconnection-container .connection-wrapper {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n}\n.legconnection-container .connection-points-container {\n  display: flex;\n  flex: 1;\n  align-items: flex-end;\n}\n.legconnection-container .icon {\n  display: flex;\n  align-items: center;\n}\n.legconnection-container .icon svg {\n  top: -7px;\n}\n.legconnection-container .icon.icon-motorcoach svg {\n  top: 0;\n  height: 8px;\n  transform: scale(3);\n}\n.legconnection-container .line {\n  border-top: 1px solid #d9d9d9;\n  width: 100%;\n  margin: 0 10px;\n  margin-bottom: 1px;\n}\n.legconnection-container .opacity-point {\n  opacity: 1;\n}\n.legconnection-container .connection-info-wrapper {\n  display: flex;\n  flex-direction: column;\n  color: #999999;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 16px;\n}\n.legconnection-container .connection-info-wrapper .connectionPointText-container {\n  margin-top: 5px;\n  display: flex;\n  justify-content: space-between;\n}\n.legconnection-container .connection-info-wrapper .middleConnectionPointText {\n  margin-right: -11px;\n  text-align: center;\n  position: relative;\n}\n.legconnection-container .connection-info-wrapper .otherSegmentsContainer {\n  display: flex;\n  justify-content: flex-end;\n}\n.legconnection-container .connection-info-wrapper .connectionPointText {\n  display: flex;\n  flex-flow: column;\n  align-items: flex-end;\n}\n.legconnection-container .connection-info-wrapper .connectionPointText .cityCode {\n  max-width: 108px;\n  text-align: right;\n  display: flex;\n  flex-direction: column;\n  line-height: 18px;\n}\n@media screen and (max-width: 830px) {\n  .legconnection-container .connection-info-wrapper .connectionPointText .cityCode .cityName {\n    display: none;\n  }\n}\n.legconnection-container .connection-info-wrapper .connectionPointTextLeft {\n  align-items: flex-start;\n}\n.legconnection-container .connection-info-wrapper .connectionPointTextLeft .cityCode {\n  text-align: left;\n}\n@media screen and (max-width: 600px) {\n  .legconnection-container .connection-info-wrapper .connectionPointText .cityCode {\n    max-width: 200px;\n  }\n}\n@media screen and (max-width: 490px) {\n  .legconnection-container .connection-info-wrapper .connectionPointText .cityCode {\n    max-width: 95px;\n  }\n}\n.legconnection-container .connection-info-wrapper .connectionPointTextRight {\n  align-items: flex-end;\n}\n.legconnection-container .connection-info-wrapper .connectionPointTextRight .date-wrapper {\n  text-align: right;\n}\n\n@media only screen and (min-width: 440px) {\n  .legconnection-container .header .title-wrapper:not(.ticket-select-leg-connection-title) {\n    min-width: 400px;\n  }\n}\n.time-wrapper {\n  font-weight: 600;\n  font-size: 18px;\n  line-height: 16px;\n}\n\n.date-wrapper {\n  line-height: 26px;\n}\n@media screen and (max-width: 780px) {\n  .date-wrapper {\n    max-width: 100px;\n  }\n}\n\n.connection-line-container {\n  display: flex;\n  flex-grow: 1;\n  align-items: center;\n  margin-bottom: -2px;\n}\n\n.layover-wrapper {\n  display: flex;\n  align-items: center;\n  position: relative;\n  padding: 0 20px;\n}\n.layover-wrapper .layover-container {\n  display: flex;\n  flex-direction: row;\n  margin-top: 2px;\n}\n.layover-wrapper .line {\n  width: 5px;\n  margin: 0 5px;\n  align-self: center;\n}\n.layover-wrapper .layover-duration {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  opacity: 0.7;\n}\n.layover-wrapper svg {\n  margin-right: 2px;\n}\n.layover-wrapper span {\n  display: flex;\n  line-height: 13px;\n  font-size: 14px;\n}\n\n.mobile-connection-line-container {\n  display: none;\n}\n\n@media screen and (max-width: 819px) {\n  .mobile-connection-line-container {\n    display: flex;\n    width: 100%;\n    flex: 1;\n    align-self: center;\n  }\n  .mobile-connection-line-container .line {\n    border-top-color: #000;\n  }\n  .connection-line-container {\n    display: none !important;\n  }\n  .connectionPointText .cityName {\n    display: none;\n  }\n}\n.segment-date {\n  display: none;\n}\n@media screen and (max-width: 414px) {\n  .segment-date {\n    display: block;\n    font-family: \"Source Sans Pro\";\n    font-style: normal;\n    font-weight: 600;\n    font-size: 18px;\n    line-height: 16px;\n    /* identical to box height, or 89% */\n    color: #000000;\n    margin-bottom: 15px;\n  }\n}";
  styleInject(css_248z$k);

  var TimeLabel = function TimeLabel(_ref) {
    var time = _ref.time,
        myTrips = _ref.myTrips;
    return /*#__PURE__*/React__default.createElement("div", {
      className: "time-wrapper"
    }, toTimeFormatString(time, "hh:mma", myTrips ? "HH:mm" : "hh:mm:ss"));
  };

  var DateLabel = function DateLabel(_ref2) {
    var date = _ref2.date;
    return /*#__PURE__*/React__default.createElement("div", {
      className: "date-wrapper"
    }, toDateFormatString(date, "dddd, MMMM DD"));
  };

  var expressCar = "/media/d6a1fe229cbff010.png";

  var BusIcon = function BusIcon() {
    return /*#__PURE__*/React__default.createElement(Icon, {
      className: "icon-motorcoach",
      name: "bus",
      width: "30",
      height: "30",
      withoutProps: true,
      noAbsolute: true
    });
  };

  var BlackCarIcon = function BlackCarIcon() {
    return /*#__PURE__*/React__default.createElement(Icon, {
      name: "blackCar",
      className: "icon-black-car",
      width: "33",
      height: "30",
      withoutProps: true,
      noAbsolute: true
    });
  };

  var AirplaneIcon = function AirplaneIcon() {
    return /*#__PURE__*/React__default.createElement(Icon, {
      withoutProps: true,
      noAbsolute: true,
      className: "icon-airplane",
      name: "newAirplane",
      height: "30",
      width: "30"
    });
  };

  var ExpressIcon = function ExpressIcon() {
    return (
      /*#__PURE__*/
      // <Icon
      //   style={{ top: 0 }}
      //   className="icon-express"
      //   noAbsolute
      //   withoutProps
      //   name="express"
      //   height="10"
      //   width="27"
      // />
      React__default.createElement("img", {
        src: expressCar,
        style: {
          height: "14px",
          width: "27px",
          top: "0"
        },
        className: "icon-express"
      })
    );
  };

  var TimeIcon = function TimeIcon() {
    return /*#__PURE__*/React__default.createElement(Icon, {
      name: "clock",
      width: "10",
      height: "10",
      noAbsolute: true,
      withoutProps: true
    });
  };

  var WifiIcon = function WifiIcon() {
    return /*#__PURE__*/React__default.createElement(Icon, {
      name: "wifi-trip",
      width: "20",
      height: "20",
      noAbsolute: true,
      withoutProps: true
    });
  };

  var LuggageIcon = function LuggageIcon() {
    return /*#__PURE__*/React__default.createElement(Icon, {
      name: "luggage-trip",
      width: "20",
      height: "20",
      noAbsolute: true,
      withoutProps: true
    });
  };

  var BathroomIcon = function BathroomIcon() {
    return /*#__PURE__*/React__default.createElement(Icon, {
      name: "bathroom-trip",
      width: "20",
      height: "20",
      noAbsolute: true,
      withoutProps: true
    });
  };

  var WheelchairIcon = function WheelchairIcon() {
    return /*#__PURE__*/React__default.createElement("img", {
      src: "https://content.landline.com/wp-content/uploads/2023/09/wheelchair-icon.png",
      style: {
        width: "20px",
        height: "20px"
      },
      className: "wheelchair-trip"
    });
  };

  var ConnectionPointText = function ConnectionPointText(_ref) {
    var time = _ref.time,
        date = _ref.date,
        cityCode = _ref.cityCode,
        cityName = _ref.cityName,
        align = _ref.align,
        isSelected = _ref.isSelected,
        showLegConnectionDate = _ref.showLegConnectionDate,
        myTrips = _ref.myTrips,
        showLegConnectionTime = _ref.showLegConnectionTime,
        showFullCityNames = _ref.showFullCityNames;
    var connectionPointTextClass = classNames("connectionPointText default-opacity", {
      connectionPointTextRight: align === "right",
      connectionPointTextLeft: align === "left",
      "opacity-point": isSelected
    });
    return /*#__PURE__*/React__default.createElement("div", {
      className: connectionPointTextClass
    }, showLegConnectionDate && /*#__PURE__*/React__default.createElement(DateLabel, {
      date: date
    }), /*#__PURE__*/React__default.createElement("div", {
      className: "cityCode"
    }, showFullCityNames && /*#__PURE__*/React__default.createElement("span", {
      className: "cityName"
    }, cityName, ","), " ", /*#__PURE__*/React__default.createElement("span", {
      className: "cityNameShort"
    }, cityCode)));
  };

  ConnectionPointText.propTypes = {
    time: PropTypes__default.string,
    cityCode: PropTypes__default.string,
    cityName: PropTypes__default.string,
    align: PropTypes__default.string,
    isSelected: PropTypes__default.bool,
    date: PropTypes__default.string,
    showLegConnectionDate: PropTypes__default.bool,
    showLegConnectionTime: PropTypes__default.bool,
    showFullCityNames: PropTypes__default.bool,
    myTrips: PropTypes__default.bool
  };
  ConnectionPointText.defaultProps = {
    time: "",
    cityCode: "",
    cityName: "",
    align: "",
    isSelected: false,
    date: "",
    showLegConnectionDate: false,
    showLegConnectionTime: true,
    showFullCityNames: true,
    myTrips: false
  };

  var LayoverLabel = function LayoverLabel(_ref2) {
    var duration = _ref2.duration;
    var durationTime = getDurationTime(duration);
    return /*#__PURE__*/React__default.createElement("div", {
      className: "layover-wrapper"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "layover-container"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "layover-duration"
    }, /*#__PURE__*/React__default.createElement(TimeIcon, null), /*#__PURE__*/React__default.createElement("span", {
      "aria-label": "Layover duration: ".concat(durationTime)
    }, durationTime))));
  };

  var MiddleConnectionPointText = function MiddleConnectionPointText(_ref3) {
    var code = _ref3.code,
        duration = _ref3.duration,
        isSelected = _ref3.isSelected,
        showMiddleConnectionPointText = _ref3.showMiddleConnectionPointText,
        showLayoverTimes = _ref3.showLayoverTimes;
    var middleConnectionPointTextClass = classNames("middleConnectionPointText default-opacity", {
      "opacity-point": isSelected
    });
    return /*#__PURE__*/React__default.createElement("div", {
      className: middleConnectionPointTextClass
    }, /*#__PURE__*/React__default.createElement("div", null, code));
  };

  MiddleConnectionPointText.propTypes = {
    code: PropTypes__default.string,
    duration: PropTypes__default.string,
    isSelected: PropTypes__default.bool,
    showMiddleConnectionPointText: PropTypes__default.bool.isRequired,
    showLayoverTimes: PropTypes__default.bool
  };
  MiddleConnectionPointText.defaultProps = {
    code: "",
    duration: "",
    isSelected: false,
    showLayoverTimes: true
  };

  var getTransportIcon = function getTransportIcon(segment) {
    if (isBlackCar([segment])) {
      return /*#__PURE__*/React__default.createElement(BlackCarIcon, null);
    }

    if (isExpress([segment]) || isExpressHome([segment])) {
      return /*#__PURE__*/React__default.createElement(ExpressIcon, null);
    }

    if (containsBus([segment])) {
      return /*#__PURE__*/React__default.createElement(BusIcon, null);
    }

    return /*#__PURE__*/React__default.createElement(AirplaneIcon, null);
  };

  var LegConnection = function LegConnection(_ref) {
    var segments = _ref.segments,
        selectedCodes = _ref.selectedCodes,
        layoverTimes = _ref.layoverTimes,
        showLegConnectionDate = _ref.showLegConnectionDate,
        myTrips = _ref.myTrips,
        ticketSelect = _ref.ticketSelect,
        totalTripTime = _ref.totalTripTime,
        showLegConnectionTime = _ref.showLegConnectionTime,
        showLayoverTimes = _ref.showLayoverTimes,
        showFullCityNames = _ref.showFullCityNames,
        showHeader = _ref.showHeader;
    var legConnectionClass = classNames("legconnection-container");
    return /*#__PURE__*/React__default.createElement("div", {
      className: legConnectionClass
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "legconnection-content-container"
    }, segments.map(function (segment, index) {
      var onLastSegment = segments.length - 1 === index;
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Connection, {
        key: "".concat(segment.airline, "-").concat(segment.departure_time, "-").concat(segment.flight_no),
        selectedCodes: selectedCodes,
        segment: segment,
        index: index,
        layoverTimes: layoverTimes,
        segmentsLength: segments.length,
        showLegConnectionDate: showLegConnectionDate,
        showLegConnectionTime: showLegConnectionTime,
        myTrips: myTrips,
        showFullCityNames: showFullCityNames,
        showLayoverTimes: showLayoverTimes
      }), !onLastSegment ? /*#__PURE__*/React__default.createElement(LayoverLabel, {
        duration: layoverTimes[index]
      }) : null);
    })));
  };

  LegConnection.propTypes = {
    segments: PropTypes__default.instanceOf(Array).isRequired,
    selectedCodes: PropTypes__default.instanceOf(Array),
    layoverTimes: PropTypes__default.instanceOf(Array),
    showLegConnectionDate: PropTypes__default.bool,
    showLegConnectionTime: PropTypes__default.bool,
    myTrips: PropTypes__default.bool,
    ticketSelect: PropTypes__default.bool,
    totalTripTime: PropTypes__default.string,
    showFullCityNames: PropTypes__default.bool,
    showLayoverTimes: PropTypes__default.bool,
    showHeader: PropTypes__default.bool
  };
  LegConnection.defaultProps = {
    selectedCodes: [],
    layoverTimes: [],
    showLegConnectionDate: false,
    showLegConnectionTime: true,
    myTrips: false,
    ticketSelect: false,
    totalTripTime: undefined,
    showFullCityNames: true,
    showLayoverTimes: true,
    showHeader: true
  };

  var Connection = function Connection(_ref2) {
    var segment = _ref2.segment,
        index = _ref2.index,
        segmentsLength = _ref2.segmentsLength,
        selectedCodes = _ref2.selectedCodes,
        layoverTimes = _ref2.layoverTimes,
        showLegConnectionDate = _ref2.showLegConnectionDate,
        myTrips = _ref2.myTrips,
        showLegConnectionTime = _ref2.showLegConnectionTime,
        showLayoverTimes = _ref2.showLayoverTimes,
        showFullCityNames = _ref2.showFullCityNames;
    var connectionWrapperClass = classNames("connection-wrapper");
    var isDepartSelected = selectedCodes.length === 0 || selectedCodes.includes(segment.departure_code || segment.depart.iata);
    var isArriveSelected = selectedCodes.includes(segment.arrival_code || segment.arrive.iata);
    var iconClass = classNames("icon default-opacity", {
      "opacity-point": isDepartSelected,
      "icon-shuttle": segment.service_type === 4,
      "icon-motorcoach": segment.service_type === 2
    });
    return /*#__PURE__*/React__default.createElement("div", {
      className: connectionWrapperClass
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "segment-date"
    }, moment(segment.departure_date).format("MM/DD/yyyy")), /*#__PURE__*/React__default.createElement("div", {
      className: "connection-points-container"
    }, /*#__PURE__*/React__default.createElement(TimeLabel, {
      time: segment.departure_time,
      myTrips: myTrips
    }), /*#__PURE__*/React__default.createElement("div", {
      className: "mobile-connection-line-container"
    }, /*#__PURE__*/React__default.createElement(Line, {
      isSelected: isDepartSelected
    })), /*#__PURE__*/React__default.createElement("div", {
      className: "connection-line-container"
    }, /*#__PURE__*/React__default.createElement(Line, {
      isSelected: isDepartSelected
    }), /*#__PURE__*/React__default.createElement("div", {
      className: "".concat(iconClass, " mid-connection"),
      style: {
        position: "relative"
      }
    }, getTransportIcon(segment), /*#__PURE__*/React__default.createElement("div", {
      style: {
        fontWeight: 400,
        fontSize: "12px",
        lineHeight: "15px",
        position: "absolute",
        bottom: "-25px",
        left: "-115%",
        whiteSpace: "nowrap"
      }
    }, "Trip Duration: ", getDurationTime(segment.duration))), /*#__PURE__*/React__default.createElement(Line, {
      isSelected: isDepartSelected
    })), /*#__PURE__*/React__default.createElement(TimeLabel, {
      time: segment.arrival_time,
      myTrips: myTrips
    })), /*#__PURE__*/React__default.createElement("div", {
      className: "connection-info-wrapper"
    }, /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
      className: "connectionPointText-container"
    }, /*#__PURE__*/React__default.createElement(ConnectionPointText, {
      date: segment.departure_date,
      showLegConnectionDate: showLegConnectionDate,
      align: "left",
      cityCode: segment.departure_code || segment.depart.iata,
      cityName: segment.departure || segment.depart.city,
      time: segment.departure_time,
      isSelected: isDepartSelected,
      myTrips: myTrips,
      showLegConnectionTime: showLegConnectionTime,
      showFullCityNames: showFullCityNames
    }), /*#__PURE__*/React__default.createElement(ConnectionPointText, {
      date: segment.arrival_date,
      showLegConnectionDate: showLegConnectionDate,
      cityCode: segment.arrival_code || segment.arrive.iata,
      cityName: segment.arrival || segment.arrive.city,
      time: segment.arrival_time,
      align: "right",
      isSelected: isDepartSelected || isArriveSelected,
      myTrips: myTrips,
      showLegConnectionTime: showLegConnectionTime,
      showFullCityNames: showFullCityNames
    })))));
  };

  Connection.propTypes = {
    index: PropTypes__default.number,
    segmentsLength: PropTypes__default.number,
    selectedCodes: PropTypes__default.string,
    segment: PropTypes__default.instanceOf(Object).isRequired,
    layoverTimes: PropTypes__default.instanceOf(Array),
    showLegConnectionDate: PropTypes__default.bool,
    showLegConnectionTime: PropTypes__default.bool,
    myTrips: PropTypes__default.bool,
    showFullCityNames: PropTypes__default.bool,
    showLayoverTimes: PropTypes__default.bool
  };
  Connection.defaultProps = {
    index: 0,
    segmentsLength: 0,
    selectedCodes: "",
    layoverTimes: [],
    showLegConnectionDate: false,
    showLegConnectionTime: true,
    myTrips: false,
    showFullCityNames: true,
    showLayoverTimes: true
  };

  var Line = function Line(_ref3) {
    var isSelected = _ref3.isSelected;
    var lineClass = classNames("line default-opacity", {
      "opacity-point": isSelected
    });
    return /*#__PURE__*/React__default.createElement("div", {
      className: lineClass
    });
  };

  Line.propTypes = {
    isSelected: PropTypes__default.bool
  };
  Line.defaultProps = {
    isSelected: false
  };

  var Title = function Title(_ref4) {
    var type = _ref4.type,
        text = _ref4.text;
    var titleClass = classNames("title", _defineProperty({}, type, type));
    return /*#__PURE__*/React__default.createElement("div", {
      className: titleClass
    }, text);
  };

  Title.propTypes = {
    type: PropTypes__default.oneOf(["bus", "blackCar"]).isRequired,
    text: PropTypes__default.string.isRequired
  };
  var css_248z$l = ".legconnectionvertical-wrapper {\n  width: 100%;\n  border-bottom: 1px solid rgba(60, 56, 53, 0.15);\n  padding: 20px 0px;\n}\n.legconnectionvertical-wrapper .legConnection-content-container {\n  margin-left: 20px;\n}\n.legconnectionvertical-wrapper .dateWrapper {\n  font-size: 12px;\n  line-height: 16px;\n  display: flex;\n  align-items: center;\n  color: #696d6f;\n  padding-right: 20px;\n  border-bottom: 1px solid rgba(60, 56, 53, 0.22);\n  margin-bottom: 20px;\n}\n.legconnectionvertical-wrapper .additional-wrapper {\n  width: 100%;\n}\n.legconnectionvertical-wrapper .additional-wrapper .layoverWrapper {\n  display: flex;\n}\n.legconnectionvertical-wrapper .additional-wrapper .classInfoWrapper {\n  display: flex;\n  align-items: center;\n}\n.legconnectionvertical-wrapper .additional-wrapper .tripInfoWrapper {\n  display: flex;\n  align-items: center;\n  padding: 5px 0;\n}\n.legconnectionvertical-wrapper .additional-wrapper .tripInfoWrapper .iconWrapper {\n  flex-basis: 30px;\n  display: flex;\n  justify-content: center;\n  flex-shrink: 0;\n}\n.legconnectionvertical-wrapper .additional-wrapper .tripInfoWrapper .tripInfoTags {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n}\n.legconnectionvertical-wrapper .additional-wrapper .points-wrapper {\n  flex-basis: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n}\n.legconnectionvertical-wrapper .additional-wrapper .first-point {\n  flex-flow: column;\n  padding-top: 10px;\n}\n.legconnectionvertical-wrapper .additional-wrapper .fillLine {\n  border-left: 1px solid #3c3835;\n  height: 100%;\n}\n.legconnectionvertical-wrapper .additional-wrapper .grid-container {\n  display: flex;\n  height: 34px;\n}\n.legconnectionvertical-wrapper .dots-point-item {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n.legconnectionvertical-wrapper .dots-point-item .dot-point {\n  border: 1px solid #3c3835;\n  box-sizing: border-box;\n  background-color: #fff;\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  z-index: 100;\n}\n.legconnectionvertical-wrapper .line-wrapper {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  height: 29px;\n}\n.legconnectionvertical-wrapper .line-wrapper .line {\n  border-left: 1px solid #3c3835;\n  height: 100%;\n}\n.legconnectionvertical-wrapper .line-wrapper .bottom-line {\n  border-left: 1px solid #3c3835;\n  height: 100%;\n}\n.legconnectionvertical-wrapper .legconnectionvertical-end-dot {\n  display: flex;\n  line-height: normal;\n  align-items: center;\n}\n.legconnectionvertical-wrapper .legconnectionvertical-end-dot .end-dot-container {\n  display: flex;\n  justify-content: center;\n  width: 30px;\n}\n.legconnectionvertical-wrapper .legconnectionvertical-end-dot .end-dot {\n  border: 1px solid #3c3835;\n  box-sizing: border-box;\n  background-color: #fff;\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  z-index: 100;\n}\n.legconnectionvertical-wrapper .timeWrapper {\n  font-family: \"Source Sans Pro\", sans-serif;\n  font-style: normal;\n  font-weight: bold;\n  font-size: 16px;\n  line-height: 16px;\n  display: flex;\n  align-items: center;\n  color: #3c3835;\n  flex-shrink: 0;\n}\n.legconnectionvertical-wrapper .legConnection-vertical-grid-item {\n  display: flex;\n  flex: 1;\n  justify-content: space-between;\n  align-self: center;\n}\n.legconnectionvertical-wrapper .legConnection-vertical-grid-item .date-name-container {\n  display: flex;\n  flex: 1;\n  justify-content: space-between;\n}\n.legconnectionvertical-wrapper .legConnection-vertical-grid-item .name-wrapper {\n  font-family: \"Source Sans Pro\", sans-serif;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 14px;\n  line-height: 16px;\n  display: flex;\n  align-items: center;\n  color: #3c3835;\n}\n.legconnectionvertical-wrapper .connectedPointWrapper {\n  display: flex;\n  position: relative;\n}\n.legconnectionvertical-wrapper .connectedPointWrapper .cityCodeContainer {\n  width: max-content;\n  height: 30px;\n  position: absolute;\n  left: 29px;\n  top: -50%;\n}\n.legconnectionvertical-wrapper .connectedPointWrapper .iconContainer {\n  flex-basis: 30px;\n  display: flex;\n  justify-content: center;\n  flex-shrink: 0;\n  height: 34px;\n}\n.legconnectionvertical-wrapper .leftFixedWidth {\n  width: 100px;\n  display: flex;\n  flex-shrink: 0;\n  align-content: center;\n  justify-content: flex-end;\n}\n.legconnectionvertical-wrapper .leftFixedWidth .orangeFont {\n  margin-right: 15px;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 16px;\n  color: #ff9800;\n}\n.legconnectionvertical-wrapper .leftFixedWidth .layoverTimeContainer {\n  position: relative;\n}\n.legconnectionvertical-wrapper .leftFixedWidth .layoverTime-wrapper {\n  position: absolute;\n  display: flex;\n  flex-wrap: nowrap;\n  justify-content: flex-end;\n  right: 0;\n  transform: translateY(50%);\n}\n.legconnectionvertical-wrapper .leftFixedWidth .layoverTime-wrapper .layoverTime {\n  display: flex;\n  align-items: center;\n}\n.legconnectionvertical-wrapper .leftFixedWidth .layoverTime-wrapper .layoverTime svg {\n  padding-right: 3px;\n}\n.legconnectionvertical-wrapper .leftFixedWidth .lowerDepartTime {\n  margin-top: 22px;\n}\n.legconnectionvertical-wrapper .leftFixedWidth .upperArrivalTime {\n  margin-top: -4px;\n}\n.legconnectionvertical-wrapper .leftFixedWidth .daysDiffrence {\n  display: flex;\n  justify-content: flex-end;\n  flex-shrink: 0;\n  width: 115px;\n  align-items: center;\n}";
  styleInject(css_248z$l);
  var css_248z$m = ".tagLabelGroup-wrapper {\n  display: flex;\n  flex-wrap: wrap;\n}";
  styleInject(css_248z$m);

  var TagLabelGroup = function TagLabelGroup(_ref) {
    var labels = _ref.labels;
    var tagLabelGroupClass = classNames("tagLabelGroup-wrapper");

    var getClassName = function getClassName(tagLabelIndex) {
      if (tagLabelIndex === labels.length - 1) {
        return "lastTagLabel";
      }

      if (tagLabelIndex === 0) {
        return "firstTagLabel";
      }

      return "middleTagLabel";
    };

    return /*#__PURE__*/React__default.createElement("div", {
      className: tagLabelGroupClass
    }, labels.map(function (label, index) {
      return /*#__PURE__*/React__default.createElement(TagLabel, {
        className: getClassName(index),
        content: label.text,
        type: label.type
      });
    }));
  };

  TagLabelGroup.propTypes = {
    labels: PropTypes__default.instanceOf(Array)
  };
  TagLabelGroup.defaultProps = {
    labels: []
  };

  var LegConnectionVertical = function LegConnectionVertical(_ref) {
    var segments = _ref.segments,
        layoverTimes = _ref.layoverTimes,
        inputDateFormat = _ref.inputDateFormat;
    var legconnectionverticalClass = classNames("legconnectionvertical-wrapper");
    var additionalInfoGrid = classNames("grid-container", {});

    var isLast = function isLast(index) {
      if (index === segments.length - 1) {
        return true;
      }

      return false;
    };

    var isFirst = function isFirst(index) {
      if (index === 0) {
        return true;
      }

      return false;
    };

    var isDayAfter = function isDayAfter(startDate, endDate) {
      var startDateMoment = moment(startDate, "YYYY-MM-DD");
      var endDateMoment = moment(endDate, "YYYY-MM-DD");
      return endDateMoment.diff(startDateMoment, "days");
    };

    var getAirlineIcon = function getAirlineIcon(segment) {
      if (containsFlight([segment])) {
        return /*#__PURE__*/React__default.createElement(Icon, {
          noAbsolute: true,
          name: "airplane",
          height: "12",
          width: "12",
          withoutProps: true
        });
      }

      if (isExpress([segment])) {
        return /*#__PURE__*/React__default.createElement(Icon, {
          noAbsolute: true,
          withoutProps: true,
          name: "express",
          height: "10",
          width: "27"
        });
      }

      if (isBlackCar([segment])) {
        return /*#__PURE__*/React__default.createElement(Icon, {
          noAbsolute: true,
          name: "blackCar",
          width: "33",
          height: "30",
          withoutProps: true
        });
      }

      return /*#__PURE__*/React__default.createElement(Icon, {
        noAbsolute: true,
        name: "bus",
        height: "30",
        width: "30",
        withoutProps: true
      });
    };

    var getAirlineTagLabel = function getAirlineTagLabel(segment) {
      var parsedSegment = parseSegment(segment);

      if (containsFlight([segment])) {
        var classBands = [{
          text: parsedSegment.airlineName,
          type: "t"
        }, {
          text: "".concat(parsedSegment.airlineCode, " - ").concat(parsedSegment.parsedFlightNumber),
          type: "t"
        }];

        if (segment.tickets) {
          classBands.push({
            text: "".concat(segment.tickets[0].classband.name),
            type: "".concat(segment.tickets[0].classband.code)
          });
        }

        return /*#__PURE__*/React__default.createElement(TagLabelGroup, {
          labels: classBands
        });
      }

      if (isBlackCar([segment])) {
        return /*#__PURE__*/React__default.createElement(TagLabelGroup, {
          labels: [{
            text: "Landline",
            type: "BC"
          }, {
            text: "Select",
            type: "BCT"
          }]
        });
      }

      return /*#__PURE__*/React__default.createElement(TagLabelGroup, {
        labels: [{
          text: "Landline",
          type: "LL"
        }, {
          text: "".concat(parsedSegment.airlineCode).concat(parsedSegment.parsedFlightNumber),
          type: "LLT"
        }]
      });
    };

    var departArriveLegDateDifferenceLast = isDayAfter(segments[segments.length - 1].departure_date, segments[segments.length - 1].arrival_date);
    return /*#__PURE__*/React__default.createElement("div", {
      className: legconnectionverticalClass
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "dateWrapper"
    }, moment("".concat(segments[0].departure_date, "T").concat(segments[0].departure_time), inputDateFormat).format("dddd, MMMM DD, YYYY")), /*#__PURE__*/React__default.createElement("div", {
      className: "legConnection-content-container"
    }, segments.map(function (item, index) {
      var departArriveLegDateDifference = isDayAfter(item.departure_date, item.arrival_date);
      var betweenDepartAndArriveLegDateDifference = 0;

      if (!isFirst(index)) {
        betweenDepartAndArriveLegDateDifference = isDayAfter(segments[index - 1].arrival_date, item.departure_date);
      }

      return /*#__PURE__*/React__default.createElement("div", {
        className: "additional-wrapper",
        key: item.departure
      }, /*#__PURE__*/React__default.createElement("div", {
        className: additionalInfoGrid
      }, isFirst(index) ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
        className: "leftFixedWidth"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "timeWrapper"
      }, moment("".concat(item.departure_date, "T").concat(item.departure_time), inputDateFormat).format("hh:mm a"))), /*#__PURE__*/React__default.createElement("div", {
        className: "points-wrapper first-point"
      }, /*#__PURE__*/React__default.createElement(StartPoint, null), /*#__PURE__*/React__default.createElement("div", {
        className: "fillLine"
      })), /*#__PURE__*/React__default.createElement("div", {
        className: "legConnection-vertical-grid-item"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "date-name-container"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "name-wrapper"
      }, "".concat(item.departure || item.depart.city, ", ").concat(item.departure_code || item.depart.iata))))) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
        className: "leftFixedWidth"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "lowerDepartTime daysDiffrence"
      }, betweenDepartAndArriveLegDateDifference > 0 && /*#__PURE__*/React__default.createElement("span", {
        className: "orangeFont"
      }, "+", betweenDepartAndArriveLegDateDifference, " Day"), /*#__PURE__*/React__default.createElement("span", {
        className: "timeWrapper"
      }, moment("".concat(item.departure_date, "T").concat(item.departure_time), inputDateFormat).format("hh:mm a")))), /*#__PURE__*/React__default.createElement("div", {
        className: "connectedPointWrapper"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "iconContainer lastIcon"
      }, /*#__PURE__*/React__default.createElement(Icon, {
        name: "LegConnectionLowerConnectionPoint",
        noAbsolute: true,
        width: "15",
        height: "35",
        withoutProps: true
      })), /*#__PURE__*/React__default.createElement("div", {
        className: "cityCodeContainer"
      }, "".concat(item.departure || item.depart.city, ", ").concat(item.departure_code || item.depart.iata))))), /*#__PURE__*/React__default.createElement("div", {
        className: "classInfoWrapper"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "leftFixedWidth"
      }), /*#__PURE__*/React__default.createElement("div", {
        className: "points-wrapper"
      }, /*#__PURE__*/React__default.createElement(Line$1, null))), /*#__PURE__*/React__default.createElement("div", {
        className: "tripInfoWrapper"
      }, /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
        className: "leftFixedWidth"
      }, /*#__PURE__*/React__default.createElement(TagLabel, {
        content: item.duration
      })), /*#__PURE__*/React__default.createElement("div", {
        className: "iconWrapper"
      }, getAirlineIcon(item)), /*#__PURE__*/React__default.createElement("div", {
        className: "tripInfoTags"
      }, getAirlineTagLabel(item)))), /*#__PURE__*/React__default.createElement("div", {
        className: "layoverWrapper"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "leftFixedWidth"
      }), /*#__PURE__*/React__default.createElement("div", {
        className: "points-wrapper"
      }, /*#__PURE__*/React__default.createElement(Line$1, {
        isBottomLine: true
      }))), !isLast(index) && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
        className: "connectedPointWrapper"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "leftFixedWidth"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "layoverTimeContainer"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "upperArrivalTime daysDiffrence"
      }, departArriveLegDateDifference > 0 && /*#__PURE__*/React__default.createElement("span", {
        className: "orangeFont"
      }, "+", departArriveLegDateDifference, " Day"), /*#__PURE__*/React__default.createElement("span", {
        className: "timeWrapper"
      }, moment("".concat(item.arrival_date, "T").concat(item.arrival_time), inputDateFormat).format("hh:mm a"))), /*#__PURE__*/React__default.createElement("div", {
        className: "layoverTime-wrapper"
      }, item.airline !== "" && /*#__PURE__*/React__default.createElement(TagLabel, {
        content: /*#__PURE__*/React__default.createElement("div", {
          className: "layoverTime"
        }, /*#__PURE__*/React__default.createElement(Icon, {
          name: "clock",
          width: "10",
          height: "10",
          noAbsolute: true,
          withoutProps: true
        }), getDurationTime(layoverTimes[index]), " layover"),
        type: "t"
      })))), /*#__PURE__*/React__default.createElement("div", {
        className: "iconContainer"
      }, /*#__PURE__*/React__default.createElement(Icon, {
        name: "LegConnectionUpperConnectionPoint",
        noAbsolute: true,
        width: "15",
        height: "35",
        withoutProps: true
      })), /*#__PURE__*/React__default.createElement("div", {
        className: ""
      }))));
    }), /*#__PURE__*/React__default.createElement("div", {
      className: "legconnectionvertical-end-dot"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "leftFixedWidth"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "daysDiffrence"
    }, departArriveLegDateDifferenceLast > 0 && /*#__PURE__*/React__default.createElement("span", {
      className: "orangeFont"
    }, "+", departArriveLegDateDifferenceLast, " Day")), /*#__PURE__*/React__default.createElement("div", {
      className: "timeWrapper"
    }, moment("".concat(segments[segments.length - 1].arrival_date, "T").concat(segments[segments.length - 1].arrival_time), inputDateFormat).format("hh:mm a"))), /*#__PURE__*/React__default.createElement("div", {
      className: "end-dot-container"
    }, /*#__PURE__*/React__default.createElement(Icon, {
      name: "LegConnectionDot",
      height: "20",
      width: "20",
      noAbsolute: true,
      withoutProps: true
    })), /*#__PURE__*/React__default.createElement("div", {
      className: "legConnection-vertical-grid-item"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "date-name-container"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "name-wrapper"
    }, "".concat(segments[segments.length - 1].arrival || segments[segments.length - 1].arrive.city, ", ").concat(segments[segments.length - 1].arrival_code || segments[segments.length - 1].arrive.iata)))))));
  };

  LegConnectionVertical.propTypes = {
    segments: PropTypes__default.instanceOf(Array),
    layoverTimes: PropTypes__default.instanceOf(Array),
    inputDateFormat: PropTypes__default.string
  };
  LegConnectionVertical.defaultProps = {
    segments: [],
    layoverTimes: [],
    inputDateFormat: undefined
  };

  var StartPoint = function StartPoint() {
    return /*#__PURE__*/React__default.createElement("div", {
      className: "dots-point-item"
    }, /*#__PURE__*/React__default.createElement(Icon, {
      name: "LegConnectionDot",
      noAbsolute: true,
      withoutProps: true,
      height: "20",
      width: "20"
    }), /*#__PURE__*/React__default.createElement("div", {
      className: "bottom-bar"
    }));
  };

  var Line$1 = function Line$1(_ref2) {
    var isBottomLine = _ref2.isBottomLine;
    return /*#__PURE__*/React__default.createElement("div", {
      className: "line-wrapper"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: isBottomLine ? "bottom-line" : "line"
    }));
  };

  Line$1.propTypes = {
    isBottomLine: PropTypes__default.bool
  };
  Line$1.defaultProps = {
    isBottomLine: false
  };
  var css_248z$n = ".listOfSuccessReferrals-wrapper .inputPreview-wrapper {\n  display: flex;\n  flex-direction: column;\n}\n.listOfSuccessReferrals-wrapper .inputPreview-up-container {\n  display: flex;\n  justify-content: space-between;\n  height: 40px;\n  border-bottom: 1px solid #e5e5e5;\n}\n.listOfSuccessReferrals-wrapper .inputPreview-down-container {\n  display: flex;\n  justify-content: space-between;\n  height: 40px;\n  border-bottom: 1px solid #3c3835;\n}\n.listOfSuccessReferrals-wrapper .inputPreview-title {\n  font-style: normal;\n  font-weight: normal;\n  font-size: 18px;\n  line-height: 100%;\n}\n.listOfSuccessReferrals-wrapper .inputPreview-right-title {\n  font-style: normal;\n  font-weight: normal;\n  font-size: 18px;\n  line-height: 100%;\n}\n.listOfSuccessReferrals-wrapper .inputPreview-value {\n  font-style: normal;\n  font-weight: normal;\n  font-size: 14px;\n  line-height: 100%;\n  color: #3c3835;\n  padding: 0px;\n}\n.listOfSuccessReferrals-wrapper .inputPreview-right-value {\n  font-style: normal;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 100%;\n  padding: 0px;\n}\n\n.referrals-table {\n  width: 100%;\n}";
  styleInject(css_248z$n);

  var ListOfSuccessReferrals = function ListOfSuccessReferrals(_ref) {
    var referralList = _ref.referralList; // const listOfSuccessReferralsClass = classNames("listOfSuccessReferrals-wrapper")

    return (
      /*#__PURE__*/
      // <div className={listOfSuccessReferralsClass}>
      //   {referralList.map(referral => (
      //     <div className="inputPreview-wrapper">
      //       <div className="inputPreview-up-container">
      //         <div className="inputPreview-title">
      //           {moment(referral.created).format("dddd, MMMM D")}
      //         </div>
      //         <div className="inputPreview-right-title">
      //           +
      //           <Price amount={referral.accrual_miles} currency="PTS" decimals={0} />
      //         </div>
      //       </div>
      //       <div className="inputPreview-down-container">
      //         <div className="inputPreview-value">{referral.user_name}</div>
      //         <div className="inputPreview-right-value">{referral.user_email}</div>
      //       </div>
      //     </div>
      //   ))}
      // </div>
      React__default.createElement("table", {
        className: "referrals-table"
      }, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", null, "Referee Email"), /*#__PURE__*/React__default.createElement("th", null, "Trip Completed"), /*#__PURE__*/React__default.createElement("th", null, "Award")), referralList.map(function (referral) {
        return /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, referral.email), /*#__PURE__*/React__default.createElement("td", null, referral.completed ? "Yes" : "No"), /*#__PURE__*/React__default.createElement("td", null, referral.award ? "$" + referral.award : "TBD"));
      }))
    );
  };

  ListOfSuccessReferrals.propTypes = {
    referralList: PropTypes__default.instanceOf(Array)
  };
  ListOfSuccessReferrals.defaultProps = {
    referralList: []
  };
  var css_248z$o = ".spinner {\n  margin: 10px auto;\n  width: 100px;\n  height: 100px;\n  text-align: center;\n  font-size: 10px;\n}\n\n.spinner-image {\n  width: inherit;\n  height: inherit;\n}\n\n.loading-height {\n  height: calc(100vh - 115px - 270px);\n}\n\n.loading-wrapper {\n  display: flex;\n  flex-flow: column nowrap;\n  justify-content: center;\n  margin: 0px;\n}\n.loading-wrapper .isTop {\n  height: calc(100vh - 75px - 270px);\n}\n\n.loading-text {\n  text-align: center;\n  font-weight: bold;\n  font-size: 100%;\n  color: #333;\n  width: 100px;\n  margin: 0 auto;\n  padding: 20px;\n}";
  styleInject(css_248z$o);
  var loadingImage = "/media/bbfbda2e4c8b1aab.gif";

  var Loading = function Loading(_ref) {
    var isTop = _ref.isTop,
        message = _ref.message,
        showMessage = _ref.showMessage,
        small = _ref.small,
        src = _ref.src;
    var loadingClass = classNames("loading-wrapper", {
      isTop: isTop,
      "loading-height": !small
    });
    return /*#__PURE__*/React__default.createElement("div", {
      className: loadingClass
    }, showMessage && /*#__PURE__*/React__default.createElement("div", {
      className: "loading-text"
    }, message), /*#__PURE__*/React__default.createElement("div", {
      className: "spinner"
    }, /*#__PURE__*/React__default.createElement("img", {
      className: "spinner-image",
      type: "image/gif",
      src: src,
      alt: "landline-loading"
    })));
  };

  Loading.propTypes = {
    isTop: PropTypes__default.bool,
    message: PropTypes__default.string,
    showMessage: PropTypes__default.bool,
    small: PropTypes__default.bool,
    src: PropTypes__default.string
  };
  Loading.defaultProps = {
    isTop: false,
    message: "Loading...",
    showMessage: true,
    small: false,
    src: loadingImage
  };
  var css_248z$p = "";
  styleInject(css_248z$p);
  var hiddenCityCodes = ["DLT", "MKT", "MNS", "MSP", "STC"];
  var MSP = "MSP";
  var MKT = "MKT";
  var css_248z$q = ".locationRow-container {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: 10px 20px;\n  border-bottom: 1px solid #e5e5e5;\n}\n.locationRow-container:hover {\n  background-color: #f5f5f5;\n}\n.locationRow-container.indent {\n  padding-left: 50px;\n}\n.locationRow-container .location-text-container {\n  display: flex;\n  flex-direction: column;\n}\n.locationRow-container .location-text-container .location-description {\n  color: #fab500;\n}\n.locationRow-container:focus {\n  background-color: #f5f5f5;\n  outline: none;\n}";
  styleInject(css_248z$q);

  var LocationRow = function LocationRow(_ref) {
    var title = _ref.title,
        icon = _ref.icon,
        indent = _ref.indent,
        onClick = _ref.onClick,
        focus = _ref.focus,
        stringToBold = _ref.stringToBold,
        style = _ref.style;
    var locationRowClass = classNames("locationRow-container", {
      indent: indent
    });
    var ref = React.useRef(null);
    React.useEffect(function () {
      if (focus) {
        // Move element into view when it is focused
        ref.current.focus();
      }
    }, [focus]);

    var boldString = function boldString(text, value) {
      var newValue = value;
      newValue = newValue.replace("(", "");
      newValue = newValue.replace(")", "");
      var strRegExp = new RegExp(newValue, "gi");
      return text.replace(strRegExp, function (match) {
        return "<b>".concat(match, "</b>");
      });
    };

    return /*#__PURE__*/React__default.createElement("div", {
      className: locationRowClass,
      onClick: onClick,
      onKeyDown: function onKeyDown(e) {
        if (e.key === "Enter") {
          onClick();
        }
      } // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
      ,
      tabIndex: focus ? 0 : -1,
      ref: ref,
      style: style
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "icon-wrapper"
    }, /*#__PURE__*/React__default.createElement(Icon, {
      withoutProps: true,
      name: icon,
      width: "40",
      height: "40",
      noAbsolute: true
    })), /*#__PURE__*/React__default.createElement("div", {
      className: "location-text-container"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "location-title",
      dangerouslySetInnerHTML: {
        __html: boldString(title, stringToBold)
      }
    })));
  };

  LocationRow.propTypes = {
    title: PropTypes__default.string,
    icon: PropTypes__default.string,
    indent: PropTypes__default.bool,
    onClick: PropTypes__default.func,
    focus: PropTypes__default.bool,
    stringToBold: PropTypes__default.string
  };
  LocationRow.defaultProps = {
    title: "",
    icon: "",
    indent: false,
    onClick: function onClick() {},
    focus: false,
    stringToBold: ""
  };

  var LocationPickerRowRenderer = function LocationPickerRowRenderer(_ref) {
    var key = _ref.key,
        index = _ref.index,
        style = _ref.style,
        parent = _ref.parent,
        locationList = _ref.locationList,
        way = _ref.way,
        cache = _ref.cache,
        onPlaceSelect = _ref.onPlaceSelect,
        setInputFieldSet = _ref.setInputFieldSet,
        toggleLocationListOpen = _ref.toggleLocationListOpen,
        focusState = _ref.focusState,
        setFocusState = _ref.setFocusState,
        toInputRef = _ref.toInputRef,
        stringToBold = _ref.stringToBold;
    var city = React.useMemo(function () {
      return locationList[index];
    }, [locationList, index]);
    var getRowData = React.useCallback(function (dataObject, cityValue) {
      var parserData = {
        city_code: dataObject.city_code || dataObject.CityCode,
        city_name: dataObject.city_name || dataObject.AirportName,
        operator: dataObject.operator
      };
      var tempCityData = {
        code: parserData.city_code,
        name: parserData.city_name,
        operator: parserData.operator
      };

      if (way === "dep_from") {
        tempCityData.city_from = cityValue;
      } else {
        tempCityData.city_to = cityValue;
      }

      return tempCityData;
    }, [way]);
    var cityData = React.useMemo(function () {
      return getRowData(city, true);
    }, [city.city_code, city.city_name, city.operator, way]);
    var cityName = React.useMemo(function () {
      var tempCityName = city.city_name;

      if (!hiddenCityCodes.includes(cityData.code)) {
        tempCityName += " (All airports, ".concat(cityData.code, ")");
      } else {
        tempCityName += " (All airports)";
      }

      if (!city.city_region_searchable) {
        tempCityName = city.city_name;
      }

      return tempCityName;
    }, [city.city_name, cityData.code]);
    var selectRow = React.useCallback(function (data) {
      onPlaceSelect(way, data);
      setInputFieldSet(way, data);
      toggleLocationListOpen(false);

      if (way === "dep_from") {
        toInputRef.current.element.focus();
      }
    }, [way]);
    useRoveFocus(locationList, focusState, setFocusState);
    var cityIndexState = focusState.cityIndex,
        airportIndexState = focusState.airportIndex;

    var locationRowFocus = function locationRowFocus(field, airportIndex) {
      if (field === "city") {
        if (cityIndexState === index && airportIndexState === -1) {
          return true;
        }
      } else if (cityIndexState === index && airportIndexState === airportIndex) {
        return true;
      }

      return undefined;
    };

    return /*#__PURE__*/React__default.createElement(reactVirtualized.CellMeasurer, {
      key: key,
      cache: cache,
      parent: parent,
      columnIndex: 0,
      rowIndex: index
    }, /*#__PURE__*/React__default.createElement("div", {
      style: style
    }, city.airports.length > 1 && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(LocationRow, {
      icon: "search-city",
      title: cityName,
      focus: locationRowFocus("city"),
      onClick: function onClick() {
        if (!city.city_region_searchable) {
          return;
        }

        var parsedCityData = _objectSpread(_objectSpread({}, cityData), {}, {
          all_airports: true
        });

        selectRow(parsedCityData);
      },
      stringToBold: stringToBold,
      style: !city.city_region_searchable ? {
        cursor: "default"
      } : null
    })), /*#__PURE__*/React__default.createElement("div", {
      className: "locationRows-container"
    }, city.airports.map(function (airport, airportIndex) {
      var airportData = getRowData(airport, false);
      var title = "".concat(airportData.name, " (").concat(airportData.code, ")");
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(LocationRow, {
        key: title,
        icon: "search-airplane",
        title: title,
        indent: city.airports.length > 1,
        focus: locationRowFocus("airport", airportIndex),
        onClick: function onClick() {
          selectRow(airportData);
        },
        stringToBold: stringToBold
      }));
    }))));
  };

  LocationPickerRowRenderer.propTypes = {
    key: PropTypes__default.string.isRequired,
    index: PropTypes__default.number.isRequired,
    style: PropTypes__default.instanceOf(Object),
    parent: PropTypes__default.instanceOf(Object).isRequired,
    locationList: PropTypes__default.instanceOf(Array).isRequired,
    way: PropTypes__default.string.isRequired,
    cache: PropTypes__default.instanceOf(Object).isRequired,
    onPlaceSelect: PropTypes__default.func.isRequired,
    toggleLocationListOpen: PropTypes__default.func.isRequired,
    setInputFieldSet: PropTypes__default.func.isRequired,
    focusState: PropTypes__default.shape({
      cityIndex: PropTypes__default.number,
      airportIndex: PropTypes__default.number
    }).isRequired,
    setFocusState: PropTypes__default.func.isRequired,
    toInputRef: PropTypes__default.instanceOf(Object),
    stringToBold: PropTypes__default.string
  };
  LocationPickerRowRenderer.defaultProps = {
    style: {},
    toInputRef: {},
    stringToBold: ""
  };
  var LocationPickerRowRenderer$1 = /*#__PURE__*/React__default.memo(LocationPickerRowRenderer);
  var css_248z$r = ".loyaltyPointsBalance-wrapper {\n  font-family: \"Source Sans Pro\", sans-serif;\n}\n.loyaltyPointsBalance-wrapper .defaultPrice {\n  font-size: 24px !important;\n}\n\n.loyaltyPointsBalance-points-earned {\n  display: flex;\n  border-top: 1px solid #3c3835;\n  border-bottom: 1px solid #3c3835;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 18px;\n  line-height: 100%;\n  padding: 10px 0;\n  justify-content: space-between;\n  color: #3c3835;\n}\n\n.loyaltyPointsBalance-points-earned-number {\n  color: #ff9800;\n  display: flex;\n}\n.loyaltyPointsBalance-points-earned-number .loyalty-style {\n  display: flex;\n  align-items: flex-end;\n  padding-top: 2px;\n  font-size: 14px !important;\n}\n\n.loyaltyPointsBalance-points-balance-number .loyalty-style {\n  font-size: 14px !important;\n}\n\n.loyaltyPointsBalance-points-balance {\n  display: flex;\n  flex-direction: column;\n  font-style: normal;\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 150%;\n  color: #3c3835;\n}\n\n.loyaltyPointsBalance-points-balance-single-row {\n  display: flex;\n  justify-content: space-between;\n  padding: 8px 0;\n}\n.loyaltyPointsBalance-points-balance-single-row .defaultPrice {\n  font-size: 24px !important;\n}\n\n.loyaltyPointsBalance-points-balance-new-points-single-row {\n  display: flex;\n  justify-content: space-between;\n  border-bottom: 1px solid #e5e5e5;\n  padding: 8px 0;\n}\n\n.loyaltyPointsBalance-points-balance-current-point-single-row {\n  font-style: normal;\n  font-weight: normal;\n  display: flex;\n  justify-content: space-between;\n  padding: 8px 0;\n}\n\n.loyaltyPointsBalance-points-total {\n  border-top: 1px solid #3c3835;\n  font-style: normal;\n  font-weight: 600;\n  font-size: 20px;\n  line-height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.loyaltyPointsBalance-points-total-single-row {\n  display: flex;\n  justify-content: space-between;\n  padding: 10px 0;\n}";
  styleInject(css_248z$r);

  var LoyaltyPointsBalance = function LoyaltyPointsBalance(_ref) {
    var pointsToBuy = _ref.pointsToBuy,
        currentPoints = _ref.currentPoints,
        fees = _ref.fees,
        taxes = _ref.taxes,
        currency = _ref.currency,
        showOnlyPoints = _ref.showOnlyPoints,
        isChanged = _ref.isChanged;
    var loyaltyPointsBalanceClass = classNames("loyaltyPointsBalance-wrapper");
    return /*#__PURE__*/React__default.createElement("div", {
      className: loyaltyPointsBalanceClass
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "loyaltyPointsBalance-points-earned"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "loyaltyPointsBalance-points-earned-text"
    }, "MileMarker Miles"), /*#__PURE__*/React__default.createElement("div", {
      className: "loyaltyPointsBalance-points-earned-number"
    }, "+", /*#__PURE__*/React__default.createElement(Price, {
      amount: pointsToBuy,
      decimals: 0,
      currency: "PTS",
      loyaltyStyle: true,
      useLoyalty: true
    }))), /*#__PURE__*/React__default.createElement("div", {
      className: "loyaltyPointsBalance-points-balance"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "loyaltyPointsBalance-points-balance-current-point-single-row"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "loyaltyPointsBalance-points-balance-text"
    }, "Current Mile balance"), /*#__PURE__*/React__default.createElement("div", {
      className: "loyaltyPointsBalance-points-balance-number"
    }, /*#__PURE__*/React__default.createElement(Price, {
      amount: currentPoints,
      decimals: 0,
      currency: "PTS",
      loyaltyStyle: true,
      useLoyalty: true
    }))), /*#__PURE__*/React__default.createElement("div", {
      className: "loyaltyPointsBalance-points-balance-new-points-single-row"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "loyaltyPointsBalance-points-balance-text"
    }, "New Mile balance"), /*#__PURE__*/React__default.createElement("div", {
      className: "loyaltyPointsBalance-points-balance-number"
    }, /*#__PURE__*/React__default.createElement(Price, {
      amount: Number(currentPoints) + Number(pointsToBuy),
      decimals: 0,
      currency: "PTS",
      loyaltyStyle: true,
      useLoyalty: true
    }))), !showOnlyPoints && /*#__PURE__*/React__default.createElement("div", {
      className: "loyaltyPointsBalance-points-balance-single-row"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "loyaltyPointsBalance-points-balance-text"
    }, "Fees"), /*#__PURE__*/React__default.createElement("div", {
      className: "loyaltyPointsBalance-points-balance-number"
    }, isChanged ? "Please calculate " : /*#__PURE__*/React__default.createElement(Price, {
      amount: fees,
      currency: currency
    }))), !showOnlyPoints && /*#__PURE__*/React__default.createElement("div", {
      className: "loyaltyPointsBalance-points-balance-single-row"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "loyaltyPointsBalance-points-balance-text"
    }, "Taxes"), /*#__PURE__*/React__default.createElement("div", {
      className: "loyaltyPointsBalance-points-balance-number"
    }, isChanged ? "Please calculate" : /*#__PURE__*/React__default.createElement(Price, {
      amount: taxes,
      currency: currency
    })))), !showOnlyPoints && /*#__PURE__*/React__default.createElement("div", {
      className: "loyaltyPointsBalance-points-total"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "loyaltyPointsBalance-points-total-single-row"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "loyaltyPointsBalance-points-total-text"
    }, "Total"), /*#__PURE__*/React__default.createElement("div", {
      className: "loyaltyPointsBalance-points-total-number"
    }, isChanged ? "Please calculate" : /*#__PURE__*/React__default.createElement(Price, {
      amount: (Number(fees) + Number(taxes)).toFixed(2),
      currency: currency
    })))));
  };

  LoyaltyPointsBalance.propTypes = {
    pointsToBuy: PropTypes__default.string,
    currentPoints: PropTypes__default.string,
    fees: PropTypes__default.string,
    taxes: PropTypes__default.string,
    currency: PropTypes__default.string,
    showOnlyPoints: PropTypes__default.bool,
    isChanged: PropTypes__default.bool
  };
  LoyaltyPointsBalance.defaultProps = {
    pointsToBuy: "",
    currentPoints: "",
    fees: "",
    taxes: "",
    currency: "USD",
    showOnlyPoints: "",
    isChanged: false
  };
  var css_248z$s = ".loyaltyprofile-wrapper {\n  width: 100%;\n}\n.loyaltyprofile-wrapper .wallet-container {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  grid-column-gap: 10px;\n  grid-template-rows: 40px;\n  border-top: 1px solid #CDCCC8;\n}\n.loyaltyprofile-wrapper .wallet-container .text-item {\n  font-family: \"Source Sans Pro\", sans-serif;\n  font-style: normal;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 100%;\n  display: flex;\n  align-items: center;\n  color: #3C3835;\n}\n.loyaltyprofile-wrapper .wallet-container .points-item {\n  font-family: \"Source Sans Pro\", sans-serif;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 14px;\n  line-height: 150%;\n  display: flex;\n  align-items: center;\n  text-align: right;\n  color: #696D6F;\n  justify-self: right;\n}";
  styleInject(css_248z$s);

  function unwrapExports(x) {
    return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
  }

  function createCommonjsModule(fn, module) {
    return module = {
      exports: {}
    }, fn(module, module.exports), module.exports;
  }

  var utils = createCommonjsModule(function (module, exports) {
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.noop = noop;
    exports.returnTrue = returnTrue;
    exports.charIsNumber = charIsNumber;
    exports.escapeRegExp = escapeRegExp;
    exports.fixLeadingZero = fixLeadingZero;
    exports.splitString = splitString;
    exports.limitToScale = limitToScale;
    exports.roundToPrecision = roundToPrecision;
    exports.omit = omit;
    exports.setCaretPosition = setCaretPosition; // basic noop function

    function noop() {}

    function returnTrue() {
      return true;
    }

    function charIsNumber(char) {
      return !!(char || '').match(/\d/);
    }

    function escapeRegExp(str) {
      return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
    }

    function fixLeadingZero(numStr) {
      if (!numStr) return numStr;
      var isNegative = numStr[0] === '-';
      if (isNegative) numStr = numStr.substring(1, numStr.length);
      var parts = numStr.split('.');
      var beforeDecimal = parts[0].replace(/^0+/, '') || '0';
      var afterDecimal = parts[1] || '';
      return '' + (isNegative ? '-' : '') + beforeDecimal + (afterDecimal ? '.' + afterDecimal : '');
    }

    function splitString(str, index) {
      return [str.substring(0, index), str.substring(index)];
    }
    /**
     * limit decimal numbers to given scale
     * Not used .fixedTo because that will break with big numbers
     */


    function limitToScale(numStr, scale, fixedDecimalScale) {
      var str = '';
      var filler = fixedDecimalScale ? '0' : '';

      for (var i = 0; i <= scale - 1; i++) {
        str += numStr[i] || filler;
      }

      return str;
    }
    /**
     * This method is required to round prop value to given scale.
     * Not used .round or .fixedTo because that will break with big numbers
     */


    function roundToPrecision(numStr, scale, fixedDecimalScale) {
      var numberParts = numStr.split('.');
      var roundedDecimalParts = parseFloat('0.' + (numberParts[1] || '0')).toFixed(scale).split('.');
      var intPart = numberParts[0].split('').reverse().reduce(function (roundedStr, current, idx) {
        if (roundedStr.length > idx) {
          return (Number(roundedStr[0]) + Number(current)).toString() + roundedStr.substring(1, roundedStr.length);
        }

        return current + roundedStr;
      }, roundedDecimalParts[0]);
      var decimalPart = limitToScale(roundedDecimalParts[1] || '', (numberParts[1] || '').length, fixedDecimalScale);
      return intPart + (decimalPart ? '.' + decimalPart : '');
    }

    function omit(obj, keyMaps) {
      var filteredObj = {};
      Object.keys(obj).forEach(function (key) {
        if (!keyMaps[key]) filteredObj[key] = obj[key];
      });
      return filteredObj;
    }
    /** set the caret positon in an input field **/


    function setCaretPosition(el, caretPos) {
      el.value = el.value; // ^ this is used to not only get "focus", but
      // to make sure we don't have it everything -selected-
      // (it causes an issue in chrome, and having it doesn't hurt any other browser)

      if (el !== null) {
        if (el.createTextRange) {
          var range = el.createTextRange();
          range.move('character', caretPos);
          range.select();
          return true;
        } // (el.selectionStart === 0 added for Firefox bug)


        if (el.selectionStart || el.selectionStart === 0) {
          el.focus();
          el.setSelectionRange(caretPos, caretPos);
          return true;
        } // fail city, fortunately this never happens (as far as I've tested) :)


        el.focus();
        return false;
      }
    }

    var thousandGroupSpacing = exports.thousandGroupSpacing = {
      two: '2',
      twoScaled: '2s',
      three: '3',
      four: '4'
    };
  });
  unwrapExports(utils);
  var utils_1 = utils.noop;
  var utils_2 = utils.returnTrue;
  var utils_3 = utils.charIsNumber;
  var utils_4 = utils.escapeRegExp;
  var utils_5 = utils.fixLeadingZero;
  var utils_6 = utils.splitString;
  var utils_7 = utils.limitToScale;
  var utils_8 = utils.roundToPrecision;
  var utils_9 = utils.omit;
  var utils_10 = utils.setCaretPosition;
  var utils_11 = utils.thousandGroupSpacing;
  var currencyFormat = createCommonjsModule(function (module) {
    var _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    var _createClass = function () {
      function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }

      return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
      };
    }();

    var _propTypes2 = _interopRequireDefault(PropTypes__default);

    var _react2 = _interopRequireDefault(React__default);

    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }

    function _classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }

    function _possibleConstructorReturn(self, call) {
      if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }

      return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }

    function _inherits(subClass, superClass) {
      if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
      }

      subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
          value: subClass,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
      if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }

    var propTypes = {
      thousandSeparator: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.oneOf([true])]),
      thousandSpacing: _propTypes2.default.oneOf(['2', '2s', '3', '4']),
      decimalSeparator: _propTypes2.default.string,
      decimalScale: _propTypes2.default.number,
      fixedDecimalScale: _propTypes2.default.bool,
      displayType: _propTypes2.default.oneOf(['input', 'text']),
      prefix: _propTypes2.default.string,
      suffix: _propTypes2.default.string,
      format: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
      removeFormatting: _propTypes2.default.func,
      mask: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]),
      value: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
      isNumericString: _propTypes2.default.bool,
      customInput: _propTypes2.default.func,
      allowNegative: _propTypes2.default.bool,
      onValueChange: _propTypes2.default.func,
      onKeyDown: _propTypes2.default.func,
      onMouseUp: _propTypes2.default.func,
      onChange: _propTypes2.default.func,
      onFocus: _propTypes2.default.func,
      onBlur: _propTypes2.default.func,
      type: _propTypes2.default.oneOf(['text', 'tel']),
      isAllowed: _propTypes2.default.func,
      renderText: _propTypes2.default.func
    };
    var defaultProps = {
      displayType: 'input',
      decimalSeparator: '.',
      thousandSpacing: '3',
      fixedDecimalScale: false,
      prefix: '',
      suffix: '',
      allowNegative: true,
      isNumericString: false,
      type: 'text',
      onValueChange: utils.noop,
      onChange: utils.noop,
      onKeyDown: utils.noop,
      onMouseUp: utils.noop,
      onFocus: utils.noop,
      onBlur: utils.noop,
      isAllowed: utils.returnTrue
    };

    var CurrencyFormat = function (_React$Component) {
      _inherits(CurrencyFormat, _React$Component);

      function CurrencyFormat(props) {
        _classCallCheck(this, CurrencyFormat); //validate props


        var _this = _possibleConstructorReturn(this, (CurrencyFormat.__proto__ || Object.getPrototypeOf(CurrencyFormat)).call(this, props));

        _this.validateProps();

        var formattedValue = _this.formatValueProp();

        _this.state = {
          value: formattedValue,
          numAsString: _this.removeFormatting(formattedValue)
        };
        _this.onChange = _this.onChange.bind(_this);
        _this.onKeyDown = _this.onKeyDown.bind(_this);
        _this.onMouseUp = _this.onMouseUp.bind(_this);
        _this.onFocus = _this.onFocus.bind(_this);
        _this.onBlur = _this.onBlur.bind(_this);
        return _this;
      }

      _createClass(CurrencyFormat, [{
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
          this.updateValueIfRequired(prevProps);
        }
      }, {
        key: 'updateValueIfRequired',
        value: function updateValueIfRequired(prevProps) {
          var props = this.props,
              state = this.state;

          if (prevProps !== props) {
            //validate props
            this.validateProps();
            var stateValue = state.value;
            var lastNumStr = state.numAsString || '';
            var formattedValue = props.value === undefined ? this.formatNumString(lastNumStr) : this.formatValueProp();

            if (formattedValue !== stateValue) {
              this.setState({
                value: formattedValue,
                numAsString: this.removeFormatting(formattedValue)
              });
            }
          }
        }
        /** Misc methods **/

      }, {
        key: 'getFloatString',
        value: function getFloatString() {
          var num = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

          var _getSeparators = this.getSeparators(),
              decimalSeparator = _getSeparators.decimalSeparator;

          var numRegex = this.getNumberRegex(true); //remove negation for regex check

          var hasNegation = num[0] === '-';
          if (hasNegation) num = num.replace('-', '');
          num = (num.match(numRegex) || []).join('').replace(decimalSeparator, '.'); //remove extra decimals

          var firstDecimalIndex = num.indexOf('.');

          if (firstDecimalIndex !== -1) {
            num = num.substring(0, firstDecimalIndex) + '.' + num.substring(firstDecimalIndex + 1, num.length).replace(new RegExp((0, utils.escapeRegExp)(decimalSeparator), 'g'), '');
          } //add negation back


          if (hasNegation) num = '-' + num;
          return num;
        } //returned regex assumes decimalSeparator is as per prop

      }, {
        key: 'getNumberRegex',
        value: function getNumberRegex(g, ignoreDecimalSeparator) {
          var _props = this.props,
              format = _props.format,
              decimalScale = _props.decimalScale;

          var _getSeparators2 = this.getSeparators(),
              decimalSeparator = _getSeparators2.decimalSeparator;

          return new RegExp('\\d' + (decimalSeparator && decimalScale !== 0 && !ignoreDecimalSeparator && !format ? '|' + (0, utils.escapeRegExp)(decimalSeparator) : ''), g ? 'g' : undefined);
        }
      }, {
        key: 'getSeparators',
        value: function getSeparators() {
          var _props2 = this.props,
              decimalSeparator = _props2.decimalSeparator,
              thousandSpacing = _props2.thousandSpacing;
          var thousandSeparator = this.props.thousandSeparator;

          if (thousandSeparator === true) {
            thousandSeparator = ',';
          }

          return {
            decimalSeparator: decimalSeparator,
            thousandSeparator: thousandSeparator,
            thousandSpacing: thousandSpacing
          };
        }
      }, {
        key: 'getMaskAtIndex',
        value: function getMaskAtIndex(index) {
          var _props$mask = this.props.mask,
              mask = _props$mask === undefined ? ' ' : _props$mask;

          if (typeof mask === 'string') {
            return mask;
          }

          return mask[index] || ' ';
        }
      }, {
        key: 'validateProps',
        value: function validateProps() {
          var mask = this.props.mask; //validate decimalSeparator and thousandSeparator

          var _getSeparators3 = this.getSeparators(),
              decimalSeparator = _getSeparators3.decimalSeparator,
              thousandSeparator = _getSeparators3.thousandSeparator;

          if (decimalSeparator === thousandSeparator) {
            throw new Error('\n          Decimal separator can\'t be same as thousand separator.\n\n          thousandSeparator: ' + thousandSeparator + ' (thousandSeparator = {true} is same as thousandSeparator = ",")\n          decimalSeparator: ' + decimalSeparator + ' (default value for decimalSeparator is .)\n       ');
          } //validate mask


          if (mask) {
            var maskAsStr = mask === 'string' ? mask : mask.toString();

            if (maskAsStr.match(/\d/g)) {
              throw new Error('\n          Mask ' + mask + ' should not contain numeric character;\n        ');
            }
          }
        }
      }, {
        key: 'splitDecimal',
        value: function splitDecimal(numStr) {
          var allowNegative = this.props.allowNegative;
          var hasNagation = numStr[0] === '-';
          var addNegation = hasNagation && allowNegative;
          numStr = numStr.replace('-', '');
          var parts = numStr.split('.');
          var beforeDecimal = parts[0];
          var afterDecimal = parts[1] || '';
          return {
            beforeDecimal: beforeDecimal,
            afterDecimal: afterDecimal,
            hasNagation: hasNagation,
            addNegation: addNegation
          };
        }
        /** Misc methods end **/

        /** caret specific methods **/

      }, {
        key: 'setPatchedCaretPosition',
        value: function setPatchedCaretPosition(el, caretPos, currentValue) {
          /* setting caret position within timeout of 0ms is required for mobile chrome,
          otherwise browser resets the caret position after we set it
          We are also setting it without timeout so that in normal browser we don't see the flickering */
          (0, utils.setCaretPosition)(el, caretPos);
          setTimeout(function () {
            if (el.value === currentValue) (0, utils.setCaretPosition)(el, caretPos);
          }, 0);
        }
        /* This keeps the caret within typing area so people can't type in between prefix or suffix */

      }, {
        key: 'correctCaretPosition',
        value: function correctCaretPosition(value, caretPos, direction) {
          var _props3 = this.props,
              prefix = _props3.prefix,
              suffix = _props3.suffix,
              format = _props3.format; //in case of format as number limit between prefix and suffix

          if (!format) {
            var hasNegation = value[0] === '-';
            return Math.min(Math.max(caretPos, prefix.length + (hasNegation ? 1 : 0)), value.length - suffix.length);
          } //in case if custom format method don't do anything


          if (typeof format === 'function') return caretPos;
          /* in case format is string find the closest # position from the caret position */
          //in case the caretPos have input value on it don't do anything

          if (format[caretPos] === '#' && (0, utils.charIsNumber)(value[caretPos])) return caretPos; //if caretPos is just after input value don't do anything

          if (format[caretPos - 1] === '#' && (0, utils.charIsNumber)(value[caretPos - 1])) return caretPos; //find the nearest caret position

          var firstHashPosition = format.indexOf('#');
          var lastHashPosition = format.lastIndexOf('#'); //limit the cursor between the first # position and the last # position

          caretPos = Math.min(Math.max(caretPos, firstHashPosition), lastHashPosition + 1);
          var nextPos = format.substring(caretPos, format.length).indexOf('#');
          var caretLeftBound = caretPos;
          var caretRightBoud = caretPos + (nextPos === -1 ? 0 : nextPos); //get the position where the last number is present

          while (caretLeftBound > firstHashPosition && (format[caretLeftBound] !== '#' || !(0, utils.charIsNumber)(value[caretLeftBound]))) {
            caretLeftBound -= 1;
          }

          var goToLeft = !(0, utils.charIsNumber)(value[caretRightBoud]) || direction === 'left' && caretPos !== firstHashPosition || caretPos - caretLeftBound < caretRightBoud - caretPos;
          return goToLeft ? caretLeftBound + 1 : caretRightBoud;
        }
      }, {
        key: 'getCaretPosition',
        value: function getCaretPosition(inputValue, formattedValue, caretPos) {
          var format = this.props.format;
          var stateValue = this.state.value;
          var numRegex = this.getNumberRegex(true);
          var inputNumber = (inputValue.match(numRegex) || []).join('');
          var formattedNumber = (formattedValue.match(numRegex) || []).join('');
          var j = void 0,
              i = void 0;
          j = 0;

          for (i = 0; i < caretPos; i++) {
            var currentInputChar = inputValue[i] || '';
            var currentFormatChar = formattedValue[j] || ''; //no need to increase new cursor position if formatted value does not have those characters
            //case inputValue = 1a23 and formattedValue =  123

            if (!currentInputChar.match(numRegex) && currentInputChar !== currentFormatChar) continue; //When we are striping out leading zeros maintain the new cursor position
            //Case inputValue = 00023 and formattedValue = 23;

            if (currentInputChar === '0' && currentFormatChar.match(numRegex) && currentFormatChar !== '0' && inputNumber.length !== formattedNumber.length) continue; //we are not using currentFormatChar because j can change here

            while (currentInputChar !== formattedValue[j] && j < formattedValue.length) {
              j++;
            }

            j++;
          }

          if (typeof format === 'string' && !stateValue) {
            //set it to the maximum value so it goes after the last number
            j = formattedValue.length;
          } //correct caret position if its outside of editable area


          j = this.correctCaretPosition(formattedValue, j);
          return j;
        }
        /** caret specific methods ends **/

        /** methods to remove formattting **/

      }, {
        key: 'removePrefixAndSuffix',
        value: function removePrefixAndSuffix(val) {
          var _props4 = this.props,
              format = _props4.format,
              prefix = _props4.prefix,
              suffix = _props4.suffix; //remove prefix and suffix

          if (!format && val) {
            var isNegative = val[0] === '-'; //remove negation sign

            if (isNegative) val = val.substring(1, val.length); //remove prefix

            val = prefix && val.indexOf(prefix) === 0 ? val.substring(prefix.length, val.length) : val; //remove suffix

            var suffixLastIndex = val.lastIndexOf(suffix);
            val = suffix && suffixLastIndex !== -1 && suffixLastIndex === val.length - suffix.length ? val.substring(0, suffixLastIndex) : val; //add negation sign back

            if (isNegative) val = '-' + val;
          }

          return val;
        }
      }, {
        key: 'removePatternFormatting',
        value: function removePatternFormatting(val) {
          var format = this.props.format;
          var formatArray = format.split('#').filter(function (str) {
            return str !== '';
          });
          var start = 0;
          var numStr = '';

          for (var i = 0, ln = formatArray.length; i <= ln; i++) {
            var part = formatArray[i] || ''; //if i is the last fragment take the index of end of the value
            //For case like +1 (911) 911 91 91 having pattern +1 (###) ### ## ##

            var index = i === ln ? val.length : val.indexOf(part, start);
            /* in any case if we don't find the pattern part in the value assume the val as numeric string
            This will be also in case if user has started typing, in any other case it will not be -1
            unless wrong prop value is provided */

            if (index === -1) {
              numStr = val;
              break;
            } else {
              numStr += val.substring(start, index);
              start = index + part.length;
            }
          }

          return (numStr.match(/\d/g) || []).join('');
        }
      }, {
        key: 'removeFormatting',
        value: function removeFormatting(val) {
          var _props5 = this.props,
              format = _props5.format,
              removeFormatting = _props5.removeFormatting;
          if (!val) return val;

          if (!format) {
            val = this.removePrefixAndSuffix(val);
            val = this.getFloatString(val);
          } else if (typeof format === 'string') {
            val = this.removePatternFormatting(val);
          } else if (typeof removeFormatting === 'function') {
            //condition need to be handled if format method is provide,
            val = removeFormatting(val);
          } else {
            val = (val.match(/\d/g) || []).join('');
          }

          return val;
        }
        /** methods to remove formattting end **/

        /*** format specific methods start ***/

        /**
         * Format when # based string is provided
         * @param  {string} numStr Numeric String
         * @return {string}        formatted Value
         */

      }, {
        key: 'formatWithPattern',
        value: function formatWithPattern(numStr) {
          var format = this.props.format;
          var hashCount = 0;
          var formattedNumberAry = format.split('');

          for (var i = 0, ln = format.length; i < ln; i++) {
            if (format[i] === '#') {
              formattedNumberAry[i] = numStr[hashCount] || this.getMaskAtIndex(hashCount);
              hashCount += 1;
            }
          }

          return formattedNumberAry.join('');
        }
        /**
         * Format the given string according to thousand separator and thousand spacing
         * @param {*} beforeDecimal 
         * @param {*} thousandSeparator 
         * @param {*} thousandSpacing 
         */

      }, {
        key: 'formatThousand',
        value: function formatThousand(beforeDecimal, thousandSeparator, thousandSpacing) {
          var digitalGroup = void 0;

          switch (thousandSpacing) {
            case utils.thousandGroupSpacing.two:
              digitalGroup = /(\d)(?=(\d{2})+(?!\d))/g;
              break;

            case utils.thousandGroupSpacing.twoScaled:
              digitalGroup = /(\d)(?=(((\d{2})+)(\d{1})(?!\d)))/g;
              break;

            case utils.thousandGroupSpacing.four:
              digitalGroup = /(\d)(?=(\d{4})+(?!\d))/g;
              break;

            default:
              digitalGroup = /(\d)(?=(\d{3})+(?!\d))/g;
          }

          return beforeDecimal.replace(digitalGroup, '$1' + thousandSeparator);
        }
        /**
         * @param  {string} numStr Numeric string/floatString] It always have decimalSeparator as .
         * @return {string} formatted Value
         */

      }, {
        key: 'formatAsNumber',
        value: function formatAsNumber(numStr) {
          var _props6 = this.props,
              decimalScale = _props6.decimalScale,
              fixedDecimalScale = _props6.fixedDecimalScale,
              prefix = _props6.prefix,
              suffix = _props6.suffix;

          var _getSeparators4 = this.getSeparators(),
              thousandSeparator = _getSeparators4.thousandSeparator,
              decimalSeparator = _getSeparators4.decimalSeparator,
              thousandSpacing = _getSeparators4.thousandSpacing;

          var hasDecimalSeparator = numStr.indexOf('.') !== -1 || decimalScale && fixedDecimalScale;

          var _splitDecimal = this.splitDecimal(numStr),
              beforeDecimal = _splitDecimal.beforeDecimal,
              afterDecimal = _splitDecimal.afterDecimal,
              addNegation = _splitDecimal.addNegation; // eslint-disable-line prefer-const
          //apply decimal precision if its defined


          if (decimalScale !== undefined) afterDecimal = (0, utils.limitToScale)(afterDecimal, decimalScale, fixedDecimalScale);

          if (thousandSeparator) {
            beforeDecimal = this.formatThousand(beforeDecimal, thousandSeparator, thousandSpacing);
          } //add prefix and suffix


          if (prefix) beforeDecimal = prefix + beforeDecimal;
          if (suffix) afterDecimal = afterDecimal + suffix; //restore negation sign

          if (addNegation) beforeDecimal = '-' + beforeDecimal;
          numStr = beforeDecimal + (hasDecimalSeparator && decimalSeparator || '') + afterDecimal;
          return numStr;
        }
      }, {
        key: 'formatNumString',
        value: function formatNumString() {
          var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
          var format = this.props.format;
          var formattedValue = value;

          if (value === '') {
            formattedValue = '';
          } else if (value === '-' && !format) {
            formattedValue = '-';
            value = '';
          } else if (typeof format === 'string') {
            formattedValue = this.formatWithPattern(formattedValue);
          } else if (typeof format === 'function') {
            formattedValue = format(formattedValue);
          } else {
            formattedValue = this.formatAsNumber(formattedValue);
          }

          return formattedValue;
        }
      }, {
        key: 'formatValueProp',
        value: function formatValueProp() {
          var _props7 = this.props,
              format = _props7.format,
              decimalScale = _props7.decimalScale,
              fixedDecimalScale = _props7.fixedDecimalScale;
          var _props8 = this.props,
              value = _props8.value,
              isNumericString = _props8.isNumericString; // if value is not defined return empty string

          if (value === undefined) return '';

          if (typeof value === 'number') {
            value = value.toString();
            isNumericString = true;
          } //round the number based on decimalScale
          //format only if non formatted value is provided


          if (isNumericString && !format && typeof decimalScale === 'number') {
            value = (0, utils.roundToPrecision)(value, decimalScale, fixedDecimalScale);
          }

          var formattedValue = isNumericString ? this.formatNumString(value) : this.formatInput(value);
          return formattedValue;
        }
      }, {
        key: 'formatNegation',
        value: function formatNegation() {
          var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
          var allowNegative = this.props.allowNegative;
          var negationRegex = new RegExp('(-)');
          var doubleNegationRegex = new RegExp('(-)(.)*(-)'); // Check number has '-' value

          var hasNegation = negationRegex.test(value); // Check number has 2 or more '-' values

          var removeNegation = doubleNegationRegex.test(value); //remove negation

          value = value.replace(/-/g, '');

          if (hasNegation && !removeNegation && allowNegative) {
            value = '-' + value;
          }

          return value;
        }
      }, {
        key: 'formatInput',
        value: function formatInput() {
          var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
          var format = this.props.format; //format negation only if we are formatting as number

          if (!format) {
            value = this.formatNegation(value);
          } //remove formatting from number


          value = this.removeFormatting(value);
          return this.formatNumString(value);
        }
        /*** format specific methods end ***/

      }, {
        key: 'isCharacterAFormat',
        value: function isCharacterAFormat(caretPos, value) {
          var _props9 = this.props,
              format = _props9.format,
              prefix = _props9.prefix,
              suffix = _props9.suffix,
              decimalScale = _props9.decimalScale,
              fixedDecimalScale = _props9.fixedDecimalScale;

          var _getSeparators5 = this.getSeparators(),
              decimalSeparator = _getSeparators5.decimalSeparator; //check within format pattern


          if (typeof format === 'string' && format[caretPos] !== '#') return true; //check in number format

          if (!format && (caretPos < prefix.length || caretPos >= value.length - suffix.length || decimalScale && fixedDecimalScale && value[caretPos] === decimalSeparator)) {
            return true;
          }

          return false;
        }
      }, {
        key: 'checkIfFormatGotDeleted',
        value: function checkIfFormatGotDeleted(start, end, value) {
          for (var i = start; i < end; i++) {
            if (this.isCharacterAFormat(i, value)) return true;
          }

          return false;
        }
        /**
         * This will check if any formatting got removed by the delete or backspace and reset the value
         * It will also work as fallback if android chome keyDown handler does not work
         **/

      }, {
        key: 'correctInputValue',
        value: function correctInputValue(caretPos, lastValue, value) {
          var format = this.props.format;
          var lastNumStr = this.state.numAsString || ''; //don't do anyhting if something got added, or if value is empty string (when whole input is cleared)

          if (value.length >= lastValue.length || !value.length) {
            return value;
          }

          var start = caretPos;
          var lastValueParts = (0, utils.splitString)(lastValue, caretPos);
          var newValueParts = (0, utils.splitString)(value, caretPos);
          var deletedIndex = lastValueParts[1].lastIndexOf(newValueParts[1]);
          var diff = deletedIndex !== -1 ? lastValueParts[1].substring(0, deletedIndex) : '';
          var end = start + diff.length; //if format got deleted reset the value to last value

          if (this.checkIfFormatGotDeleted(start, end, lastValue)) {
            value = lastValue;
          } //for numbers check if beforeDecimal got deleted and there is nothing after decimal,
          //clear all numbers in such case while keeping the - sign


          if (!format) {
            var numericString = this.removeFormatting(value);

            var _splitDecimal2 = this.splitDecimal(numericString),
                beforeDecimal = _splitDecimal2.beforeDecimal,
                afterDecimal = _splitDecimal2.afterDecimal,
                addNegation = _splitDecimal2.addNegation; // eslint-disable-line prefer-const
            //clear only if something got deleted


            if (numericString.length < lastNumStr.length && beforeDecimal === '' && !parseFloat(afterDecimal)) {
              return addNegation ? '-' : '';
            }
          }

          return value;
        }
      }, {
        key: 'onChange',
        value: function onChange(e) {
          e.persist();
          var el = e.target;
          var inputValue = el.value;
          var state = this.state,
              props = this.props;
          var isAllowed = props.isAllowed;
          var lastValue = state.value || '';
          /*Max of selectionStart and selectionEnd is taken for the patch of pixel and other mobile device caret bug*/

          var currentCaretPosition = Math.max(el.selectionStart, el.selectionEnd);
          inputValue = this.correctInputValue(currentCaretPosition, lastValue, inputValue);
          var formattedValue = this.formatInput(inputValue) || '';
          var numAsString = this.removeFormatting(formattedValue);
          var valueObj = {
            formattedValue: formattedValue,
            value: numAsString,
            floatValue: parseFloat(numAsString)
          };

          if (!isAllowed(valueObj)) {
            formattedValue = lastValue;
          } //set the value imperatively, this is required for IE fix


          el.value = formattedValue; //get the caret position

          var caretPos = this.getCaretPosition(inputValue, formattedValue, currentCaretPosition); //set caret position

          this.setPatchedCaretPosition(el, caretPos, formattedValue); //change the state

          if (formattedValue !== lastValue) {
            this.setState({
              value: formattedValue,
              numAsString: numAsString
            }, function () {
              props.onValueChange(valueObj);
              props.onChange(e);
            });
          } else {
            props.onChange(e);
          }
        }
      }, {
        key: 'onBlur',
        value: function onBlur(e) {
          var props = this.props,
              state = this.state;
          var format = props.format,
              onBlur = props.onBlur;
          var numAsString = state.numAsString;
          var lastValue = state.value;

          if (!format) {
            numAsString = (0, utils.fixLeadingZero)(numAsString);
            var formattedValue = this.formatNumString(numAsString);
            var valueObj = {
              formattedValue: formattedValue,
              value: numAsString,
              floatValue: parseFloat(numAsString)
            }; //change the state

            if (formattedValue !== lastValue) {
              // the event needs to be persisted because its properties can be accessed in an asynchronous way
              e.persist();
              this.setState({
                value: formattedValue,
                numAsString: numAsString
              }, function () {
                props.onValueChange(valueObj);
                onBlur(e);
              });
              return;
            }
          }

          onBlur(e);
        }
      }, {
        key: 'onKeyDown',
        value: function onKeyDown(e) {
          var el = e.target;
          var key = e.key;
          var selectionEnd = el.selectionEnd,
              value = el.value;
          var selectionStart = el.selectionStart;
          var expectedCaretPosition = void 0;
          var _props10 = this.props,
              decimalScale = _props10.decimalScale,
              fixedDecimalScale = _props10.fixedDecimalScale,
              prefix = _props10.prefix,
              suffix = _props10.suffix,
              format = _props10.format,
              onKeyDown = _props10.onKeyDown;
          var ignoreDecimalSeparator = decimalScale !== undefined && fixedDecimalScale;
          var numRegex = this.getNumberRegex(false, ignoreDecimalSeparator);
          var negativeRegex = new RegExp('-');
          var isPatternFormat = typeof format === 'string'; //Handle backspace and delete against non numerical/decimal characters or arrow keys

          if (key === 'ArrowLeft' || key === 'Backspace') {
            expectedCaretPosition = selectionStart - 1;
          } else if (key === 'ArrowRight') {
            expectedCaretPosition = selectionStart + 1;
          } else if (key === 'Delete') {
            expectedCaretPosition = selectionStart;
          } //if expectedCaretPosition is not set it means we don't want to Handle keyDown
          //also if multiple characters are selected don't handle


          if (expectedCaretPosition === undefined || selectionStart !== selectionEnd) {
            onKeyDown(e);
            return;
          }

          var newCaretPosition = expectedCaretPosition;
          var leftBound = isPatternFormat ? format.indexOf('#') : prefix.length;
          var rightBound = isPatternFormat ? format.lastIndexOf('#') + 1 : value.length - suffix.length;

          if (key === 'ArrowLeft' || key === 'ArrowRight') {
            var direction = key === 'ArrowLeft' ? 'left' : 'right';
            newCaretPosition = this.correctCaretPosition(value, expectedCaretPosition, direction);
          } else if (key === 'Delete' && !numRegex.test(value[expectedCaretPosition]) && !negativeRegex.test(value[expectedCaretPosition])) {
            while (!numRegex.test(value[newCaretPosition]) && newCaretPosition < rightBound) {
              newCaretPosition++;
            }
          } else if (key === 'Backspace' && !numRegex.test(value[expectedCaretPosition]) && !negativeRegex.test(value[expectedCaretPosition])) {
            while (!numRegex.test(value[newCaretPosition - 1]) && newCaretPosition > leftBound) {
              newCaretPosition--;
            }

            newCaretPosition = this.correctCaretPosition(value, newCaretPosition, 'left');
          }

          if (newCaretPosition !== expectedCaretPosition || expectedCaretPosition < leftBound || expectedCaretPosition > rightBound) {
            e.preventDefault();
            this.setPatchedCaretPosition(el, newCaretPosition, value);
          }
          /* NOTE: this is just required for unit test as we need to get the newCaretPosition,
                  Remove this when you find different solution */


          if (e.isUnitTestRun) {
            this.setPatchedCaretPosition(el, newCaretPosition, value);
          }

          this.props.onKeyDown(e);
        }
        /** required to handle the caret position when click anywhere within the input **/

      }, {
        key: 'onMouseUp',
        value: function onMouseUp(e) {
          var el = e.target;
          var selectionStart = el.selectionStart,
              selectionEnd = el.selectionEnd,
              value = el.value;

          if (selectionStart === selectionEnd) {
            var caretPostion = this.correctCaretPosition(value, selectionStart);

            if (caretPostion !== selectionStart) {
              this.setPatchedCaretPosition(el, caretPostion, value);
            }
          }

          this.props.onMouseUp(e);
        }
      }, {
        key: 'onFocus',
        value: function onFocus(e) {
          var _this2 = this; // Workaround Chrome and Safari bug https://bugs.chromium.org/p/chromium/issues/detail?id=779328
          // (onFocus event target selectionStart is always 0 before setTimeout)


          e.persist();
          setTimeout(function () {
            var el = e.target;
            var selectionStart = el.selectionStart,
                value = el.value;

            var caretPosition = _this2.correctCaretPosition(value, selectionStart);

            if (caretPosition !== selectionStart) {
              _this2.setPatchedCaretPosition(el, caretPosition, value);
            }

            _this2.props.onFocus(e);
          });
        }
      }, {
        key: 'render',
        value: function render() {
          var _props11 = this.props,
              type = _props11.type,
              displayType = _props11.displayType,
              customInput = _props11.customInput,
              renderText = _props11.renderText;
          var value = this.state.value;
          var otherProps = (0, utils.omit)(this.props, propTypes);

          var inputProps = _extends({}, otherProps, {
            type: type,
            value: value,
            onChange: this.onChange,
            onKeyDown: this.onKeyDown,
            onMouseUp: this.onMouseUp,
            onFocus: this.onFocus,
            onBlur: this.onBlur
          });

          if (displayType === 'text') {
            return renderText ? renderText(value) || null : _react2.default.createElement('span', otherProps, value);
          } else if (customInput) {
            var CustomInput = customInput;
            return _react2.default.createElement(CustomInput, inputProps);
          }

          return _react2.default.createElement('input', inputProps);
        }
      }]);

      return CurrencyFormat;
    }(_react2.default.Component);

    CurrencyFormat.propTypes = propTypes;
    CurrencyFormat.defaultProps = defaultProps;
    module.exports = CurrencyFormat;
  });
  var CurrencyFormat = unwrapExports(currencyFormat);

  var LoyaltyProfile = function LoyaltyProfile(_ref) {
    var totalPoints = _ref.totalPoints;
    return /*#__PURE__*/React__default.createElement("div", {
      className: "loyaltyprofile-wrapper"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "wallet-container"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "wallet-item text-item"
    }, "Your Points"), /*#__PURE__*/React__default.createElement("div", {
      className: "wallet-item points-item"
    }, /*#__PURE__*/React__default.createElement(CurrencyFormat, {
      value: totalPoints,
      suffix: "pts",
      thousandSeparator: true,
      displayType: "text"
    }))));
  };

  LoyaltyProfile.propTypes = {
    totalPoints: PropTypes__default.number
  };
  LoyaltyProfile.defaultProps = {
    totalPoints: 0
  };
  var css_248z$t = "";
  styleInject(css_248z$t);

  var LuggageFilter = function LuggageFilter() {
    return /*#__PURE__*/React__default.createElement(CollapsibleButton, {
      title: /*#__PURE__*/React__default.createElement(FormatedTitle, {
        text: "Luggage"
      }),
      defaultOpenIcon: "chevron_down",
      defaultCloseIcon: "chevron_up"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "luggage-wrapper collapsible-wrapper"
    }, /*#__PURE__*/React__default.createElement(CheckBox, {
      value: /*#__PURE__*/React__default.createElement(FormatedTitle, {
        checkBox: true,
        text: "Included"
      })
    }), /*#__PURE__*/React__default.createElement(CheckBox, {
      value: /*#__PURE__*/React__default.createElement(FormatedTitle, {
        checkBox: true,
        text: "Not included"
      })
    })));
  };

  LuggageFilter.propTypes = {};
  LuggageFilter.defaultProps = {};
  var css_248z$u = ".notification-container-bottom-center,.notification-container-bottom-left,.notification-container-bottom-right,.notification-container-center,.notification-container-top-center,.notification-container-top-left,.notification-container-top-right{width:325px;position:absolute;pointer-events:all}.notification-container-bottom-center,.notification-container-center,.notification-container-top-center{display:flex;justify-content:center;align-items:center;flex-direction:column;left:calc(50% - 162.5px)}.notification-container-center{top:20px;height:100%;pointer-events:none}.notification-container-center .center-inner{width:325px;display:flex;justify-content:center;align-items:center;flex-direction:column;pointer-events:all}.notification-container-top-center{top:20px}.notification-container-bottom-center{bottom:20px}.notification-container-top-left{left:20px;top:20px}.notification-container-top-right{right:20px;top:20px}.notification-container-bottom-left{left:20px;bottom:20px}.notification-container-bottom-right{bottom:20px;right:20px}.notification-container-mobile-bottom,.notification-container-mobile-top{pointer-events:all;position:absolute}.notification-container-mobile-top{right:20px;left:20px;top:20px}.notification-container-mobile-bottom{right:20px;left:20px;bottom:20px;margin-bottom:-15px}.notification-default{border-left:8px solid #0562c7}.notification-default,.notification-default .timer{background-color:#007bff}.notification-default .timer-filler{background-color:#fff}.notification-default .notification-close{background-color:#007bff}.notification-success{border-left:8px solid #1f8838}.notification-success,.notification-success .timer{background-color:#28a745}.notification-success .timer-filler{background-color:#fff}.notification-success .notification-close{background-color:#28a745}.notification-danger{border-left:8px solid #bd1120}.notification-danger,.notification-danger .timer{background-color:#dc3545}.notification-danger .timer-filler{background-color:#fff}.notification-danger .notification-close{background-color:#dc3545}.notification-info{border-left:8px solid #138b9e}.notification-info,.notification-info .timer{background-color:#17a2b8}.notification-info .timer-filler{background-color:#fff}.notification-info .notification-close{background-color:#17a2b8}.notification-warning{border-left:8px solid #ce9c09}.notification-warning,.notification-warning .timer{background-color:#eab000}.notification-warning .timer-filler{background-color:#fff}.notification-warning .notification-close{background-color:#eab000}.notification-awesome{border-left:8px solid #4c3fb1}.notification-awesome,.notification-awesome .timer{background-color:#685dc3}.notification-awesome .timer-filler{background-color:#fff}.notification-awesome .notification-close{background-color:#685dc3}@keyframes timer{0%{width:100%}to{width:0}}.react-notification-root{position:fixed;z-index:9000;pointer-events:none;width:100%;height:100%}.notification-item{display:flex;position:relative;border-radius:3px;margin-bottom:15px;box-shadow:1px 3px 4px rgba(0,0,0,.2);cursor:pointer}.notification-item .timer{width:100%;margin-top:10px}.notification-item .timer,.notification-item .timer .timer-filler{height:3px;border-radius:5px}.notification-item .notification-title{color:#fff;font-weight:700;font-size:14px;margin-top:5px;margin-bottom:5px}.notification-item .notification-message{color:#fff;max-width:calc(100% - 15px);font-size:14px;line-height:150%;word-wrap:break-word;margin-bottom:0;margin-top:0}.notification-item .notification-content{padding:8px 15px;display:inline-block;width:100%}.notification-item .notification-close{width:18px;height:18px;border-radius:50%;display:inline-block;position:absolute;right:10px;top:10px}.notification-item .notification-close:after{content:\"\\D7\";position:absolute;transform:translate(-50%,-50%);color:#fff;font-size:12px;left:50%;top:50%}.notification-container-mobile-bottom .notification-item,.notification-container-mobile-bottom .notification-parent,.notification-container-mobile-top .notification-item,.notification-container-mobile-top .notification-parent{max-width:100%;width:100%}.notification-container-bottom-right .notification-parent,.notification-container-top-right .notification-parent{margin-left:auto}.notification-container-bottom-left .notification-parent,.notification-container-top-left .notification-parent{margin-right:auto}.notification-container-mobile-bottom .notification-parent,.notification-container-mobile-top .notification-parent{margin-left:auto;margin-right:auto}";
  styleInject(css_248z$u);
  var css_248z$v = ".notification-message {\n  white-space: pre-line;\n}\n\n.notification-container-bottom-center,\n.notification-container-bottom-left,\n.notification-container-bottom-right,\n.notification-container-mobile-bottom,\n.notification-container-mobile-top,\n.notification-container-top-center,\n.notification-container-top-left,\n.notification-container-top-right {\n  position: fixed;\n  z-index: 8000;\n}\n\n.notification-address .notification-message {\n  font-size: 22px;\n}\n\n@media only screen and (max-width: 365px) {\n  .notification-address .notification-message {\n    font-size: 16px;\n  }\n}";
  styleInject(css_248z$v);
  var NotificationContext = /*#__PURE__*/React__default.createContext();
  var NotificationConsumer = NotificationContext.Consumer;

  var Notification = function Notification(_ref) {
    var children = _ref.children;

    var show = function show(_ref2) {
      var inherintType = _ref2.type,
          message = _ref2.message,
          _ref2$title = _ref2.title,
          title = _ref2$title === void 0 ? "" : _ref2$title,
          _ref2$miliseconds = _ref2.miliseconds,
          miliseconds = _ref2$miliseconds === void 0 ? 3000 : _ref2$miliseconds;
      var INVALID_REFRESH_TOKEN = "Token is invalid or expired";

      if (typeof message === "object" || message === "" || message === INVALID_REFRESH_TOKEN) {
        return;
      }

      var type = "error";

      switch (inherintType) {
        case "is-success":
          type = "success";
          break;

        case "is-warning":
          type = "warning";
          break;

        case "is-danger":
          type = "danger";
          break;

        case "is-address":
          type = "address";
          break;

        default:
          type = "default";
          break;
      }

      ReactNotification.store.addNotification({
        title: title,
        message: message,
        type: type,
        insert: "right",
        container: "top-right",
        dismiss: {
          duration: miliseconds,
          onScreen: true
        }
      });
    };

    return /*#__PURE__*/React__default.createElement(NotificationContext.Provider, {
      value: {
        actions: {
          show: show
        }
      }
    }, /*#__PURE__*/React__default.createElement(React__default.Fragment, null, children, /*#__PURE__*/React__default.createElement(ReactNotification__default, {
      types: [{
        htmlClasses: ["notification-danger", "notification-address"],
        name: "address"
      }]
    })));
  };

  Notification.propTypes = {
    children: PropTypes__default.element
  };
  Notification.defaultProps = {
    children: null
  };
  var css_248z$w = ".pagetitle {\n  margin-top: 10px;\n  display: flex;\n  align-items: center;\n  height: 50px;\n  font-family: \"Source Sans Pro\", sans-serif;\n  font-size: 24px;\n  font-weight: 600;\n  line-height: 100%;\n  border-bottom: 1px solid #3c3835;\n  padding-bottom: 10px;\n  justify-content: space-between;\n}\n\n@media only screen and (max-width: 365px) {\n  .pagetitle {\n    max-width: 320px;\n  }\n}";
  styleInject(css_248z$w);

  var PageTitle = function PageTitle(_ref) {
    var title = _ref.title,
        margin = _ref.margin,
        style = _ref.style,
        fontSize = _ref.fontSize,
        rightContent = _ref.rightContent;
    return /*#__PURE__*/React__default.createElement("div", {
      className: "pagetitle",
      style: _objectSpread(_objectSpread({
        margin: margin
      }, style), {}, {
        fontSize: fontSize
      })
    }, title, rightContent && /*#__PURE__*/React__default.createElement("div", {
      className: "pagetitle-right-content"
    }, rightContent));
  };

  PageTitle.propTypes = {
    title: PropTypes__default.string,
    margin: PropTypes__default.string,
    style: PropTypes__default.instanceOf(Object),
    fontSize: PropTypes__default.number,
    rightContent: PropTypes__default.element
  };
  PageTitle.defaultProps = {
    title: "",
    margin: "",
    style: {},
    fontSize: 24,
    rightContent: null
  };
  var css_248z$x = ".reservation-header-container {\n  box-shadow: 0px 2px 6px 3px rgba(0, 0, 0, 0.25);\n  padding: 10px 15px;\n  background-color: #fff;\n}\n.reservation-header-container .connection-icon {\n  display: none;\n}\n.reservation-header-container .mobile-title {\n  display: none;\n}\n@media screen and (max-width: 1112px) {\n  .reservation-header-container {\n    background: #fff;\n    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);\n    flex-direction: column;\n    justify-content: baseline;\n  }\n  .reservation-header-container .title {\n    display: none !important;\n  }\n  .reservation-header-container .mobile-title {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    width: 100%;\n    padding-bottom: 10px;\n  }\n  .reservation-header-container .mobile-title .connection {\n    height: 1px;\n    margin: 0 10px;\n    flex: 1;\n    font-size: 0;\n    align-self: center;\n    justify-self: center;\n    border-bottom: 1px solid #d9d9d9;\n  }\n  .reservation-header-container .mobile-title .connection-icon {\n    display: flex;\n    position: absolute;\n    left: calc(50% - 15px);\n  }\n  .reservation-header-container .mobile-title .connection-icon svg {\n    opacity: 0.5;\n  }\n  .reservation-header-container .edit-search-button {\n    padding: 10px 0 !important;\n    width: 160px;\n    align-self: center;\n    background: #3c3835 !important;\n    color: #fff !important;\n    position: absolute;\n    bottom: -20px;\n  }\n}\n\n@media screen and (max-width: 1112px) {\n  .suncountry-banner-container {\n    display: none !important;\n  }\n}\n.date-selector-container {\n  position: relative;\n  color: #000;\n  display: flex;\n  justify-content: space-between;\n}\n.date-selector-container .title {\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n.date-selector-container .edit-search-button {\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 20px;\n  text-align: center;\n  padding: 7px 22px;\n  background: #fab500;\n  border-radius: 6px;\n  color: #000000;\n  border-style: none;\n}\n.date-selector-container .date-selection-container {\n  display: flex;\n  min-height: 40px;\n  font-size: 18px;\n  line-height: 23px;\n  justify-content: space-between;\n  align-items: center;\n}\n.date-selector-container .date-selection-container .arrow {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: #fab500;\n  width: 40px;\n  height: 40px;\n  cursor: pointer;\n}\n.date-selector-container .date-selection-container .arrow svg {\n  fill: #3c3835;\n}\n.date-selector-container .date-selection-container .arrow:hover {\n  background-color: #3c3835;\n  border: 1px solid #fab500;\n}\n.date-selector-container .date-selection-container .arrow:hover svg {\n  fill: #fab500;\n}\n.date-selector-container .date-selection-container .arrow-left {\n  border-top-left-radius: 6px;\n  border-bottom-left-radius: 6px;\n}\n.date-selector-container .date-selection-container .arrow-right {\n  border-top-right-radius: 6px;\n  border-bottom-right-radius: 6px;\n}\n.date-selector-container .date-selection-container .arrow-disabled {\n  background-color: #cdccc8;\n}\n.date-selector-container .date-selection-container .arrow-disabled:hover {\n  background-color: #cdccc8;\n  border: none;\n}\n.date-selector-container .date-selection-container .arrow-disabled:hover svg {\n  fill: #3c3835;\n}\n.date-selector-container .date-selection-container .date-content {\n  background-color: #fff;\n  height: 40px;\n  flex: 1;\n  color: #3c3835;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-width: 200px;\n}\n\n.edit-search-container {\n  position: relative;\n  padding-left: 35px;\n}\n.edit-search-container .cancel-edit-container {\n  display: none;\n}\n.edit-search-container .search-header {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n}\n.edit-search-container .search-header .search-header__title {\n  font-weight: 400;\n  font-size: 18px;\n  line-height: 24px;\n}\n.edit-search-container .search-header .cancel-edit {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #fab500;\n  border-style: none;\n  border-radius: 6px;\n  padding: 6px;\n}\n.edit-search-container .search-header .cancel-edit svg {\n  fill: #3c3835;\n  transform: translateX(1px);\n}\n.edit-search-container .search-container {\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n}\n.edit-search-container.search-padding .searchform-wrapper {\n  padding-top: 50px;\n}\n.edit-search-container .Search--Form {\n  padding: 0;\n  width: 100%;\n  margin-top: 0px;\n  z-index: 2;\n}\n.edit-search-container .searchform-wrapper {\n  box-shadow: none;\n  background-color: #3c3835;\n}\n@media screen and (max-width: 414px) {\n  .edit-search-container .searchform-wrapper {\n    background-color: #f5f5f5;\n    padding: 0;\n  }\n}\n.edit-search-container .selectitem-wrapper,\n.edit-search-container .dropdownmenu-wrapper {\n  border-radius: 8px;\n  background-color: #fff;\n}\n.edit-search-container .primary button {\n  background-color: #fab500;\n  color: #3c3835;\n}\n.edit-search-container .primary button svg {\n  fill: #3c3835;\n}\n.edit-search-container .primary button:hover {\n  background-color: #3c3835;\n  color: #fab500;\n  border: 1px solid #fab500;\n}\n.edit-search-container .primary button:hover svg {\n  fill: #fab500;\n}\n.edit-search-container .DateInput {\n  border-radius: 8px;\n}\n.edit-search-container .DateRangePickerInput {\n  border-radius: 8px !important;\n}\n.edit-search-container .switch-button-text {\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 14px;\n  color: #000;\n}\n\n.switch-button-label {\n  background-color: #fab500;\n  flex-shrink: 0;\n}";
  styleInject(css_248z$x);
  var css_248z$y = ".section-type-container {\n  z-index: 1;\n  height: 30px;\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 15px;\n  display: flex;\n  min-width: 140px;\n  justify-content: center;\n  padding: 5px 0px;\n  border-bottom-left-radius: 5px;\n  border-bottom-right-radius: 5px;\n}\n.section-type-container .section-type-wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 18px;\n}\n.section-type-container.edit-trip {\n  background-color: #fab500;\n}\n.section-type-container.dateSelector-type-button {\n  position: absolute;\n  bottom: -30px;\n  left: 20px;\n  background-color: #3c3835;\n  cursor: pointer;\n}\n.section-type-container.dateSelector-type-button svg {\n  margin-right: 10px;\n  fill: #fab500;\n}\n.section-type-container.dateSelector-type-button:hover {\n  background-color: #fab500;\n  color: #3c3835;\n}\n.section-type-container.dateSelector-type-button:hover svg {\n  fill: #3c3835;\n}\n.section-type-container.editSearch-type-button {\n  position: absolute;\n  bottom: -30px;\n  left: 20px;\n  background-color: #fab500;\n  color: #3c3835;\n  cursor: pointer;\n}\n.section-type-container.editSearch-type-button svg {\n  margin-right: 10px;\n  fill: #fff;\n}\n.section-type-container.editSearch-type-button:hover {\n  background-color: #3c3835;\n  color: #fab500;\n}\n.section-type-container.editSearch-type-button:hover svg {\n  fill: #fab500;\n}\n.section-type-container.loyalty {\n  background-color: #fab500;\n  color: #fff;\n}\n.section-type-container.cancel-trip {\n  background-color: #ff4040;\n  color: #fff;\n}";
  styleInject(css_248z$y);

  var SectionType = function SectionType(_ref) {
    var type = _ref.type,
        onClick = _ref.onClick,
        text = _ref.text;
    var sectionTypeClass = classNames("section-type-container", {
      "editSearch-type-button": type === "editSearch",
      "dateSelector-type-button": type === "dateSelector",
      "edit-trip": type === "edit-trip",
      loyalty: type === "loyalty",
      "cancel-trip": type === "cancel-trip"
    });

    var getIcon = function getIcon() {
      switch (type) {
        case "editSearch":
          return /*#__PURE__*/React__default.createElement(Icon, {
            name: "closeIcon",
            width: "20",
            height: "15",
            noAbsolute: true
          });

        case "dateSelector":
          return /*#__PURE__*/React__default.createElement(Icon, {
            name: "search",
            withoutProps: true,
            noAbsolute: true
          });

        default:
          return null;
      }
    };

    var getText = function getText() {
      switch (type) {
        case "editSearch":
          return "Cancel Editing";

        case "dateSelector":
          return "Edit Search";

        case "edit-trip":
          return "Editing Trip";

        case "cancel-trip":
          return "Cancelation";

        case "loyalty":
          return "Loyalty";

        default:
          return text;
      }
    };

    return /*#__PURE__*/React__default.createElement("div", {
      className: sectionTypeClass,
      onClick: onClick
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "section-type-wrapper"
    }, getIcon(), /*#__PURE__*/React__default.createElement("span", null, text || getText())));
  };

  SectionType.propTypes = {
    type: PropTypes__default.string.isRequired,
    onClick: PropTypes__default.func,
    text: PropTypes__default.string
  };
  SectionType.defaultProps = {
    onClick: undefined,
    text: null
  };
  var css_248z$z = "@media screen and (max-width: 625px) {\n  .suncountry-banner-wrapper {\n    max-width: 320px;\n  }\n}\n@media screen and (max-width: 510px) {\n  .suncountry-banner-wrapper {\n    max-width: 250px;\n    padding: 8px 32px !important;\n  }\n}\n@media screen and (max-width: 450px) {\n  .suncountry-banner-wrapper {\n    max-width: 155px;\n    padding: 8px 32px !important;\n  }\n}\n.suncountry-banner-container {\n  position: sticky;\n  top: 205px;\n  z-index: 997;\n  margin-right: 20px;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n}\n.suncountry-banner-container.sticky-edit-search-position {\n  top: 267px;\n}\n@media screen and (max-width: 1199px) {\n  .suncountry-banner-container.sticky-edit-search-position {\n    top: 278px;\n  }\n}\n@media screen and (max-width: 700px) {\n  .suncountry-banner-container.sticky-edit-search-position {\n    top: 400px !important;\n  }\n}\n@media screen and (max-width: 700px) {\n  .suncountry-banner-container {\n    top: 260px !important;\n  }\n}\n@media screen and (max-width: 1199px) {\n  .suncountry-banner-container {\n    top: 216px;\n  }\n}\n.suncountry-banner-container .suncountry-banner-wrapper {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: #fab500;\n  min-height: 30px;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 18px;\n  color: #3c3835;\n  padding: 0px 32px;\n  border-bottom-left-radius: 5px;\n  border-bottom-right-radius: 5px;\n}\n.suncountry-banner-container a:link {\n  text-decoration: none;\n  color: #fff;\n}\n.suncountry-banner-container a:visited {\n  text-decoration: none;\n  color: #fff;\n}\n.suncountry-banner-container a:hover {\n  text-decoration: none;\n  color: #fff;\n}\n.suncountry-banner-container a:active {\n  text-decoration: none;\n  color: #fff;\n}\n\n@media only screen and (max-width: 400px) {\n  .suncountry-banner-container {\n    margin-right: 0px;\n  }\n}";
  styleInject(css_248z$z);

  var SunCountryBanner = function SunCountryBanner(_ref) {
    var reservationHeaderState = _ref.reservationHeaderState,
        showSuncountryLink = _ref.showSuncountryLink;
    var sunCountryBannerClass = classNames("suncountry-banner-container", {
      "sticky-edit-search-position": reservationHeaderState.type === "editSearch"
    });

    var getCityString = function getCityString() {
      if (reservationHeaderState.from.code === "MSP") {
        return "to ".concat(reservationHeaderState.to.name);
      }

      if (reservationHeaderState.to.code === "MSP") {
        return "from ".concat(reservationHeaderState.from.name);
      }

      return null;
    };

    return /*#__PURE__*/React__default.createElement("div", {
      className: sunCountryBannerClass
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "suncountry-banner-wrapper"
    }, showSuncountryLink ? /*#__PURE__*/React__default.createElement("span", null, "Bundle & Save - Find our best fares ", getCityString(), " on \xA0", /*#__PURE__*/React__default.createElement("a", {
      target: "_blank",
      rel: "noopener noreferrer",
      href: "http://www.suncountry.com"
    }, "SunCountry")) : /*#__PURE__*/React__default.createElement("span", null, "Bundle & Save - Find our best fares ", getCityString())));
  };

  SunCountryBanner.propTypes = {
    reservationHeaderState: PropTypes__default.instanceOf(Object),
    showSuncountryLink: PropTypes__default.bool
  };
  SunCountryBanner.defaultProps = {
    reservationHeaderState: {},
    showSuncountryLink: false
  };

  var ReservationHeader = function ReservationHeader(_ref) {
    var date = _ref.date,
        from = _ref.from,
        to = _ref.to,
        onPrevClicked = _ref.onPrevClicked,
        onNextClicked = _ref.onNextClicked,
        search = _ref.search,
        searchPadding = _ref.searchPadding,
        isEditTripActive = _ref.isEditTripActive,
        getCityName = _ref.getCityName,
        getMobileCityName = _ref.getMobileCityName,
        prevDisabled = _ref.prevDisabled,
        nextDisabled = _ref.nextDisabled;
    var reservationHeaderClass = classNames("reservation-header-container date-selector-container");
    var editSearchClass = classNames("reservation-header-container edit-search-container", {
      "search-padding": searchPadding
    });

    var _React$useState11 = React.useState({
      type: isEditTripActive ? "editSearch" : "dateSelector",
      from: from,
      to: to
    }),
        _React$useState12 = _slicedToArray(_React$useState11, 2),
        state = _React$useState12[0],
        setState = _React$useState12[1];

    var shouldShowSuncountryLink = function shouldShowSuncountryLink() {
      if (from.code === MSP && to.code === MKT || from.code === MKT && to.code === MSP) {
        return false;
      }

      return true;
    };

    var shouldShowBundleBanner = React.useMemo(function () {
      return from.code === "DLH" || to.code === "DLH";
    }, [from.code, to.code]);

    var onEditSearchClick = function onEditSearchClick() {
      setState(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), {}, {
          type: "editSearch"
        });
      });
    };

    var onCancelEditClick = function onCancelEditClick() {
      setState(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), {}, {
          type: "dateSelector"
        });
      });
    };

    if (state.type === "dateSelector") {
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
        className: reservationHeaderClass
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "title"
      }, /*#__PURE__*/React__default.createElement("span", {
        className: "from"
      }, getCityName(state.from)), /*#__PURE__*/React__default.createElement("span", {
        className: "connection"
      }, ">"), /*#__PURE__*/React__default.createElement("span", {
        className: "to"
      }, getCityName(state.to))), /*#__PURE__*/React__default.createElement("div", {
        className: "mobile-title"
      }, /*#__PURE__*/React__default.createElement("span", {
        className: "from"
      }, getMobileCityName(state.from)), /*#__PURE__*/React__default.createElement("span", {
        className: "connection"
      }, ">"), /*#__PURE__*/React__default.createElement("span", {
        className: "connection-icon"
      }, /*#__PURE__*/React__default.createElement(BusIcon, null)), /*#__PURE__*/React__default.createElement("span", {
        className: "to"
      }, getMobileCityName(state.to))), /*#__PURE__*/React__default.createElement("button", {
        className: "edit-search-button",
        onClick: onEditSearchClick
      }, "Edit your Search")), shouldShowBundleBanner ? /*#__PURE__*/React__default.createElement(SunCountryBanner, {
        reservationHeaderState: state,
        showSuncountryLink: shouldShowSuncountryLink()
      }) : null);
    }

    if (state.type === "editSearch") {
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
        className: editSearchClass
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "search-header"
      }, /*#__PURE__*/React__default.createElement("span", {
        className: "search-header__title"
      }, "Edit your Search"), /*#__PURE__*/React__default.createElement("button", {
        className: "cancel-edit"
      }, /*#__PURE__*/React__default.createElement(Icon, {
        name: "closeIcon",
        width: "20",
        height: "15",
        noAbsolute: true,
        onClick: onCancelEditClick
      }))), /*#__PURE__*/React__default.createElement("div", {
        className: "search-container"
      }, search), /*#__PURE__*/React__default.createElement("div", {
        className: "cancel-edit-container"
      }, /*#__PURE__*/React__default.createElement("button", {
        className: "cancel-edit"
      }, /*#__PURE__*/React__default.createElement(Icon, {
        name: "closeIcon",
        width: "24",
        height: "24",
        viewBox: "0 0 20 20",
        noAbsolute: true,
        onClick: onCancelEditClick
      })))), shouldShowBundleBanner ? /*#__PURE__*/React__default.createElement(SunCountryBanner, {
        reservationHeaderState: state,
        showSuncountryLink: shouldShowSuncountryLink()
      }) : null);
    }

    return null;
  };

  ReservationHeader.propTypes = {
    date: PropTypes__default.string.isRequired,
    from: PropTypes__default.instanceOf(Object),
    to: PropTypes__default.instanceOf(Object),
    onPrevClicked: PropTypes__default.func,
    onNextClicked: PropTypes__default.func,
    search: PropTypes__default.element.isRequired,
    searchPadding: PropTypes__default.bool,
    isEditTripActive: PropTypes__default.bool,
    getCityName: PropTypes__default.func.isRequired,
    getMobileCityName: PropTypes__default.func.isRequired,
    prevDisabled: PropTypes__default.bool,
    nextDisabled: PropTypes__default.bool
  };
  ReservationHeader.defaultProps = {
    from: {},
    to: {},
    onPrevClicked: function onPrevClicked() {
      return null;
    },
    onNextClicked: function onNextClicked() {
      return null;
    },
    searchPadding: false,
    isEditTripActive: false,
    prevDisabled: false,
    nextDisabled: false
  };
  var css_248z$A = ".seatplace {\n  display: inline-flex;\n  align-items: center;\n  justify-content: space-evenly;\n  flex-direction: column;\n  width: 50px;\n  height: 50px;\n  border: 1px solid rgb(44, 44, 44);\n  border-radius: 6px;\n  background: white;\n  color: #3c3835;\n  position: relative;\n  font-family: \"Source Sans Pro\", sans-serif;\n  box-sizing: border-box;\n  line-height: 2rem;\n  margin-bottom: 10px;\n}\n.seatplace .seatNumber {\n  font-weight: 600;\n  text-align: center;\n  font-size: 18px;\n  line-height: 16px;\n}\n\n.seatplace .seatText {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n.seatplace .seatText .seatPrice {\n  font-size: 12px;\n  line-height: 15px;\n  text-align: center;\n}\n\n.seatplace.legend {\n  width: 20px;\n  height: 20px;\n  border-radius: 3px;\n  margin-right: 10px;\n  margin-bottom: 0px;\n}\n.seatplace.legend .seatNumber {\n  font-size: 10px;\n}\n\n.seatplace.tableSeat {\n  background: #e5e5e5;\n}\n\n.seatplace.tableSeat .border {\n  background-color: #3c3835;\n}\n\n.seatplace.premiumSeat {\n  background-color: #fab500;\n  border: 1px solid #3f3835;\n}\n.seatplace.premiumSeat .border {\n  background-color: #3f3835;\n}\n\n.seatplace.selectedSeat {\n  background-color: #696d6f;\n  border: 1px solid #696d6f;\n  color: #ffe6a6;\n}\n.seatplace.selectedSeat .border {\n  background-color: #ffe6a6;\n}\n\n.seatplace.selectedSeat.leadPassenger {\n  background-color: #3c3835;\n  border: 1px solid #3c3835;\n  color: #fab500;\n}\n.seatplace.selectedSeat.leadPassenger .border {\n  background-color: #fab500;\n}\n\n.seatplace.notAvailable {\n  opacity: 0.3;\n}\n\n.seatplace .border {\n  width: 40px;\n  background-color: #bebebe;\n  height: 1px;\n  margin: 0 auto;\n  position: absolute;\n}\n\n.seatplace.legend .border {\n  width: 14px;\n}\n\n.seatplace.legend .bottomBorder {\n  bottom: 3px;\n}\n\n.seatplace .bottomBorder {\n  bottom: 5px;\n}\n\n.seatplace .topBorder {\n  top: 5px;\n}\n\n.seatplace.isBlocked {\n  opacity: 0.3;\n  align-content: center;\n  justify-content: center;\n}\n\n.seatplace.isLast {\n  margin-bottom: 0;\n}\n\n.seatplace:not(.notAvailable):not(.legend):not(.isBlocked):hover {\n  cursor: pointer;\n  border: 1px solid #fab500;\n}\n\n.seatplace.deletable:after {\n  content: \"x\";\n  position: absolute;\n  bottom: -3px;\n  opacity: 0.4;\n  font-size: 14px;\n}";
  styleInject(css_248z$A);

  var SeatPlace = function SeatPlace(_ref) {
    var value = _ref.value,
        selected = _ref.selected,
        taken = _ref.taken,
        leadPassenger = _ref.leadPassenger,
        tableSeat = _ref.tableSeat,
        onClick = _ref.onClick,
        reversed = _ref.reversed,
        seat = _ref.seat,
        legend = _ref.legend,
        passengerId = _ref.passengerId,
        price = _ref.price,
        hidePrice = _ref.hidePrice,
        isBlocked = _ref.isBlocked,
        isLast = _ref.isLast;
    var isSelectedSeat = selected;
    var hasPrice = price !== "0.00" && price !== "0";
    var seatPlaceClass = classNames("seatplace", {
      selectedSeat: isSelectedSeat,
      notAvailable: taken,
      deletable: !legend && isSelectedSeat && passengerId === seat.passengerId && !hasPrice,
      premiumSeat: hasPrice,
      leadPassenger: leadPassenger,
      tableSeat: tableSeat,
      legend: legend,
      isBlocked: isBlocked,
      isLast: isLast
    });
    var borderClass = classNames("border", {
      topBorder: reversed,
      bottomBorder: !reversed
    });

    var onSeatClick = function onSeatClick() {
      if (!taken && !isBlocked) {
        onClick(_objectSpread(_objectSpread({}, seat), {}, {
          passengerId: passengerId
        }));
      }
    };

    return /*#__PURE__*/React__default.createElement("div", {
      className: seatPlaceClass,
      onClick: onSeatClick
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "seatText"
    }, isBlocked ? /*#__PURE__*/React__default.createElement(Icon, {
      width: legend ? 15 : 32,
      height: legend ? 15 : 32,
      name: "blocked-seat",
      noAbsolute: true
    }) : /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("span", {
      className: "seatNumber"
    }, value), hasPrice && !hidePrice ? /*#__PURE__*/React__default.createElement("span", {
      className: "seatPrice"
    }, /*#__PURE__*/React__default.createElement(Price, {
      presign: "+",
      amount: price,
      decimals: "0"
    })) : null)), !isBlocked && /*#__PURE__*/React__default.createElement("div", {
      className: borderClass
    }));
  };

  SeatPlace.propTypes = {
    seat: PropTypes__default.instanceOf(Object),
    selected: PropTypes__default.bool,
    onClick: PropTypes__default.func,
    value: PropTypes__default.string.isRequired,
    leadPassenger: PropTypes__default.bool,
    taken: PropTypes__default.bool,
    passengerId: PropTypes__default.number,
    reversed: PropTypes__default.string,
    tableSeat: PropTypes__default.bool,
    price: PropTypes__default.string,
    legend: PropTypes__default.bool,
    hidePrice: PropTypes__default.bool,
    isBlocked: PropTypes__default.bool,
    isLast: PropTypes__default.bool
  };
  SeatPlace.defaultProps = {
    seat: {},
    selected: false,
    onClick: function onClick() {},
    leadPassenger: false,
    taken: false,
    passengerId: undefined,
    reversed: false,
    tableSeat: false,
    price: "0.00",
    legend: false,
    hidePrice: false,
    isBlocked: false,
    isLast: false
  };
  var css_248z$B = ".singleIncrementer-wrapper {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  height: 50px;\n  border-bottom: 1px solid #cdccc8;\n}\n.singleIncrementer-wrapper .commands {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  position: relative;\n}\n.singleIncrementer-wrapper .decrease_container {\n  cursor: pointer;\n  padding-left: 20px;\n  display: flex;\n  align-items: center;\n  user-select: none; /* standard syntax */\n  -webkit-user-select: none; /* webkit (safari, chrome) browsers */\n  -moz-user-select: none; /* mozilla browsers */\n  -khtml-user-select: none; /* webkit (konqueror) browsers */\n  -ms-user-select: none;\n}\n.singleIncrementer-wrapper .increase_container {\n  user-select: none; /* standard syntax */\n  -webkit-user-select: none; /* webkit (safari, chrome) browsers */\n  -moz-user-select: none; /* mozilla browsers */\n  -khtml-user-select: none; /* webkit (konqueror) browsers */\n  -ms-user-select: none;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  padding-right: 20px;\n}\n.singleIncrementer-wrapper .number-to-increment {\n  width: 40px;\n  display: flex;\n  justify-content: center;\n}";
  styleInject(css_248z$B);

  var SingleIncrementer = function SingleIncrementer(_ref) {
    var text = _ref.text,
        incrementNumber = _ref.incrementNumber,
        incrementStep = _ref.incrementStep,
        onIncrementChange = _ref.onIncrementChange,
        counterMin = _ref.counterMin,
        counterLimit = _ref.counterLimit,
        disabled = _ref.disabled;

    var _React$useState13 = React.useState(incrementNumber),
        _React$useState14 = _slicedToArray(_React$useState13, 2),
        numberToIncrement = _React$useState14[0],
        setNumberToIncrement = _React$useState14[1];

    var updateCounter = function updateCounter(count) {
      if (!disabled && count >= counterMin && count <= counterLimit) {
        setNumberToIncrement(count);
        onIncrementChange(count);
      }
    };

    var singleIncrementerClass = classNames("singleIncrementer-wrapper");
    return /*#__PURE__*/React__default.createElement("div", {
      className: singleIncrementerClass
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "text"
    }, text), /*#__PURE__*/React__default.createElement("div", {
      className: "commands"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "increase_container",
      onClick: function onClick() {
        return updateCounter(numberToIncrement - incrementStep);
      }
    }, /*#__PURE__*/React__default.createElement(Icon, {
      name: "counter_decrease",
      noAbsolute: true
    })), /*#__PURE__*/React__default.createElement("div", {
      className: "number-to-increment"
    }, numberToIncrement), /*#__PURE__*/React__default.createElement("div", {
      className: "decrease_container",
      onClick: function onClick() {
        return updateCounter(numberToIncrement + incrementStep);
      }
    }, /*#__PURE__*/React__default.createElement(Icon, {
      name: "counter_increase",
      noAbsolute: true
    }))));
  };

  SingleIncrementer.propTypes = {
    text: PropTypes__default.string,
    incrementNumber: PropTypes__default.number,
    incrementStep: PropTypes__default.number,
    onIncrementChange: PropTypes__default.func,
    counterLimit: PropTypes__default.number,
    counterMin: PropTypes__default.number,
    disabled: PropTypes__default.bool
  };
  SingleIncrementer.defaultProps = {
    text: "",
    incrementNumber: 1,
    incrementStep: 1,
    onIncrementChange: function onIncrementChange() {},
    counterLimit: 10,
    counterMin: 0,
    disabled: false
  };
  var css_248z$C = "";
  styleInject(css_248z$C);

  var StopOverFilter = function StopOverFilter(_ref) {
    var maxStopovers = _ref.maxStopovers,
        onMaxStopoversChange = _ref.onMaxStopoversChange;
    var allStopovers = [{
      label: "Non-stop flights only",
      value: 1
    }, {
      label: "Up to 1 Stopover",
      value: 2
    }, {
      label: "2+ Stopovers",
      value: 3
    }];
    return /*#__PURE__*/React__default.createElement(CollapsibleButton, {
      title: /*#__PURE__*/React__default.createElement(FormatedTitle, {
        text: "Number of flight connections"
      }),
      defaultOpenIcon: "chevron_down",
      defaultCloseIcon: "chevron_up"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "collapsible-wrapper"
    }, /*#__PURE__*/React__default.createElement(RadioGroup, {
      selected: maxStopovers + 1,
      onChange: onMaxStopoversChange
    }, " ", allStopovers.map(function (stopover) {
      return /*#__PURE__*/React__default.createElement(RadioButton, {
        id: stopover.value
      }, stopover.label);
    }))));
  };

  StopOverFilter.propTypes = {
    maxStopovers: PropTypes__default.instanceOf(Array).isRequired,
    onMaxStopoversChange: PropTypes__default.func.isRequired
  };
  var css_248z$D = ".tabModal-container {\n  position: relative;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 40px;\n  border-radius: 24px;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 20px;\n  border: 1px solid #3c3835;\n  padding: 0px 24px;\n  cursor: pointer;\n}\n.tabModal-container:hover {\n  background-color: #e5e5e5;\n  border: 1px solid #e5e5e5;\n}\n.tabModal-container .inner-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.tabModal-container .inner-container .icon-container {\n  line-height: 0px;\n}\n.tabModal-container .inner-container span {\n  display: flex;\n  flex-shrink: 0;\n}\n.tabModal-container.active {\n  border: 1px solid #e5e5e5;\n  background-color: #e5e5e5;\n}";
  styleInject(css_248z$D);

  var TabModal = function TabModal(_ref) {
    var text = _ref.text,
        active = _ref.active,
        icon = _ref.icon,
        margin = _ref.margin,
        style = _ref.style,
        onClick = _ref.onClick;
    var tabModalClass = classNames("tabModal-container", {
      active: active
    });
    return /*#__PURE__*/React__default.createElement("div", {
      className: tabModalClass,
      style: _objectSpread({
        margin: margin
      }, style),
      onClick: onClick
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "inner-container"
    }, /*#__PURE__*/React__default.createElement("span", null, text), /*#__PURE__*/React__default.createElement("div", {
      className: "icon-container"
    }, icon)));
  };

  TabModal.propTypes = {
    text: PropTypes__default.string,
    active: PropTypes__default.bool,
    icon: PropTypes__default.element,
    margin: PropTypes__default.string,
    style: PropTypes__default.instanceOf(Object),
    onClick: PropTypes__default.func
  };
  TabModal.defaultProps = {
    text: "",
    active: false,
    icon: /*#__PURE__*/React__default.createElement(React__default.Fragment, null),
    margin: null,
    style: {},
    onClick: function onClick() {}
  };
  var css_248z$E = ".ticketClassband-container {\n  display: flex;\n}\n\n.ticketClassband-summary {\n  background-color: #e5e5e5;\n  border-radius: 3px;\n  display: flex;\n  color: #3c3835;\n  align-items: center;\n  justify-content: center;\n  font-size: 12px;\n  line-height: 15px;\n  height: 20px;\n  padding: 0px 10px;\n}\n.ticketClassband-summary .bus-icon {\n  margin-left: 10px;\n}\n.ticketClassband-summary.ticketClassband-summary-black-car {\n  background-color: #fff;\n}";
  styleInject(css_248z$E);

  var TicketClassband = function TicketClassband(_ref) {
    var classband = _ref.classband,
        isRefundable = _ref.isRefundable,
        segments = _ref.segments,
        summaryPreview = _ref.summaryPreview;
    var ticketClassbandClass = classNames("ticketClassband-container", {
      "ticketClassband-summary": summaryPreview,
      "ticketClassband-summary-black-car": isBlackCar(segments)
    });
    return /*#__PURE__*/React__default.createElement("div", {
      className: ticketClassbandClass
    }, "Book", isRefundable && /*#__PURE__*/React__default.createElement("div", {
      className: "bus-icon"
    }, isBlackCar(segments) ? /*#__PURE__*/React__default.createElement(Icon, {
      name: "blackCarNoPlaceholder",
      width: "30",
      height: "11",
      withoutProps: true,
      noAbsolute: true
    }) : /*#__PURE__*/React__default.createElement(Icon, {
      name: "smallBus",
      width: "13",
      height: "14",
      withoutProps: true,
      noAbsolute: true
    })));
  };

  TicketClassband.propTypes = {
    classband: PropTypes__default.string,
    isRefundable: PropTypes__default.bool,
    segments: PropTypes__default.instanceOf(Array).isRequired,
    summaryPreview: PropTypes__default.bool
  };
  TicketClassband.defaultProps = {
    isRefundable: false,
    classband: "",
    summaryPreview: false
  };
  var css_248z$F = ".timePicker-container {\n  font-family: \"Source Sans Pro\", sans-serif;\n  border: none;\n  position: relative;\n  display: inline-flex;\n  min-width: 140px;\n  min-height: 40px;\n  border: 1px solid #cdccc8;\n  color: #3c3835;\n  box-sizing: border-box;\n  border-radius: 6px;\n  padding: 0 15px;\n  font-family: \"Source Sans Pro\", sans-serif;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 18px;\n  line-height: 23px;\n  align-items: center;\n  position: relative;\n}\n.timePicker-container .react-time-picker__inputGroup__input {\n  outline: none;\n}\n.timePicker-container.timePicker-fullwidth {\n  width: 100%;\n}\n.timePicker-container .react-time-picker__wrapper {\n  border: 0;\n}\n.timePicker-container:disabled {\n  background-color: #fff;\n}\n.timePicker-container::placeholder {\n  /* Chrome, Firefox, Opera, Safari 10.1+ */\n  color: #cdccc8;\n  opacity: 1; /* Firefox */\n}\n.timePicker-container:-ms-input-placeholder {\n  /* Internet Explorer 10-11 */\n  color: #cdccc8;\n}\n.timePicker-container::-ms-input-placeholder {\n  /* Microsoft Edge */\n  color: #cdccc8;\n}\n.timePicker-container .react-time-picker {\n  width: 100%;\n}\n\n.timePicker-error {\n  border: 1px solid #ff4040;\n  color: #ff4040;\n}\n.timePicker-error::placeholder {\n  color: #ff4040;\n}\n.timePicker-error:-ms-input-placeholder {\n  /* Internet Explorer 10-11 */\n  color: #ff4040;\n}\n.timePicker-error::-ms-input-placeholder {\n  /* Microsoft Edge */\n  color: #ff4040;\n}";
  styleInject(css_248z$F);
  var css_248z$G = ".timePickerInput-container {\n  display: flex;\n}\n.timePickerInput-container select {\n  background-color: #fff;\n}\n.timePickerInput-container .timePickerInputs-wrapper {\n  flex: 2;\n  display: flex;\n}\n.timePickerInput-container .timePickerInput-hours,\n.timePickerInput-container .timePickerInput-minutes,\n.timePickerInput-container .timePickerInput-abbreviation {\n  display: flex;\n  flex: 1;\n}\n.timePickerInput-container .timePickerInput-hours input,\n.timePickerInput-container .timePickerInput-hours select,\n.timePickerInput-container .timePickerInput-minutes input,\n.timePickerInput-container .timePickerInput-minutes select,\n.timePickerInput-container .timePickerInput-abbreviation input,\n.timePickerInput-container .timePickerInput-abbreviation select {\n  width: 100%;\n  border: 0;\n  outline: none;\n  text-align: center;\n}\n\n@media only screen and (max-width: 860px) {\n  .timePickerInput-container .timePickerInput-hours,\n.timePickerInput-container .timePickerInput-minutes,\n.timePickerInput-container .timePickerInput-abbreviation {\n    flex: auto;\n  }\n}";
  styleInject(css_248z$G);

  var TimePickerInput = function TimePickerInput(_ref) {
    var onChange = _ref.onChange,
        value = _ref.value;
    var timePickerInputClass = classNames("timePickerInput-container");

    var _React$useState15 = React.useState({
      abbreviation: "AM",
      hours: undefined,
      minutes: undefined
    }),
        _React$useState16 = _slicedToArray(_React$useState15, 2),
        state = _React$useState16[0],
        setState = _React$useState16[1];

    React.useEffect(function () {
      if (value) {
        var splitedValue = value.split(":");
        var newHours = splitedValue[0];
        var splitedMinutes = splitedValue[1].split(" ");
        var newMinutes = splitedMinutes[0];
        var newAbbreviation = splitedMinutes[1];
        setState({
          hours: newHours,
          minutes: newMinutes,
          abbreviation: newAbbreviation
        });
      }
    }, []);

    var changeTime = function changeTime() {
      var hours = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      var minutes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
      var abbreviation = arguments.length > 2 ? arguments[2] : undefined;
      var newHours = hours[0] === "0" ? hours.substr(1) : hours;

      if (!state.hours || !newHours || newHours.match(/^(10|11|12|[1-9])$/)) {
        newHours = newHours.length === 1 ? "0".concat(newHours) : newHours;
      } else {
        newHours = state.hours;
      }

      var newMinutes = minutes[0] === "0" ? minutes.substr(-2) : minutes;

      if (!state.minutes || !newMinutes || newMinutes.match(/^[0-5][0-9]?$/)) {
        newMinutes = newMinutes.length === 1 ? "0".concat(newMinutes) : newMinutes;
      } else {
        newMinutes = state.minutes;
      }

      if (newHours && newMinutes) {
        onChange("".concat(newHours, ":").concat(newMinutes, " ").concat(abbreviation));
      } else {
        onChange(undefined);
      }

      setState({
        hours: newHours,
        minutes: newMinutes,
        abbreviation: abbreviation
      });
    };

    var changeHours = function changeHours(e) {
      var hours = e.target.value;
      changeTime(hours, state.minutes, state.abbreviation);
    };

    var changeMinutes = function changeMinutes(e) {
      var minutes = e.target.value;

      if (state.minutes === "00" && e.target.value === "0") {
        minutes = "";
      }

      changeTime(state.hours, minutes, state.abbreviation);
    };

    var selectAbbreviation = function selectAbbreviation(e) {
      var abbreviation = e.target.value;
      changeTime(state.hours, state.minutes, abbreviation);
    };

    var hourValue = state.hours && state.hours.length === 1 ? "0".concat(state.hours) : state.hours;
    var minutesValue = state.minutes && state.minutes.length === 1 ? "0".concat(state.minutes) : state.minutes;
    return /*#__PURE__*/React__default.createElement("div", {
      className: timePickerInputClass
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "timePickerInputs-wrapper"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "timePickerInput-hours"
    }, /*#__PURE__*/React__default.createElement("input", {
      placeholder: "--",
      value: hourValue,
      onChange: changeHours
    })), ":", /*#__PURE__*/React__default.createElement("div", {
      className: "timePickerInput-minutes"
    }, /*#__PURE__*/React__default.createElement("input", {
      placeholder: "--",
      value: minutesValue,
      onChange: changeMinutes
    }))), /*#__PURE__*/React__default.createElement("div", {
      className: "timePickerInput-abbreviation"
    }, /*#__PURE__*/React__default.createElement("select", {
      onChange: selectAbbreviation,
      value: state.abbreviation
    }, /*#__PURE__*/React__default.createElement("option", {
      value: "AM"
    }, "AM"), /*#__PURE__*/React__default.createElement("option", {
      value: "PM"
    }, "PM"))));
  };

  TimePickerInput.propTypes = {
    onChange: PropTypes__default.func.isRequired,
    value: PropTypes__default.string
  };
  TimePickerInput.defaultProps = {
    value: ""
  };

  var TimePicker = function TimePicker(_ref) {
    var onChange = _ref.onChange,
        value = _ref.value,
        fullWidth = _ref.fullWidth,
        margin = _ref.margin,
        mandatory = _ref.mandatory,
        error = _ref.error,
        labelText = _ref.labelText;
    var timePickerClass = classNames("timePicker-container", {
      "timePicker-fullwidth": fullWidth,
      "timePicker-error": error
    });
    return /*#__PURE__*/React__default.createElement("div", {
      className: timePickerClass,
      style: {
        margin: margin
      }
    }, /*#__PURE__*/React__default.createElement(FieldLabel, {
      mandatory: mandatory,
      error: error,
      labelText: labelText
    }), /*#__PURE__*/React__default.createElement(TimePickerInput, {
      onChange: onChange,
      value: value
    }));
  };

  TimePicker.propTypes = {
    onChange: PropTypes__default.func.isRequired,
    value: PropTypes__default.string,
    labelText: PropTypes__default.string,
    error: PropTypes__default.bool,
    fullWidth: PropTypes__default.bool,
    mandatory: PropTypes__default.bool,
    margin: PropTypes__default.string
  };
  TimePicker.defaultProps = {
    value: "",
    labelText: "",
    error: false,
    fullWidth: false,
    mandatory: false,
    margin: "0 0 20px 0"
  };
  var css_248z$H = "";
  styleInject(css_248z$H);
  var dotStyle$1 = {
    height: 20,
    width: 20,
    backgroundColor: "rgba(60, 56, 53, 1)",
    border: "none",
    marginTop: -8
  };

  var TimingFilter = function TimingFilter() {
    return /*#__PURE__*/React__default.createElement(CollapsibleButton, {
      title: /*#__PURE__*/React__default.createElement(FormatedTitle, {
        text: "Timing"
      }),
      defaultOpenIcon: "chevron_down",
      defaultCloseIcon: "chevron_up"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "timing-wrapper collapsible-wrapper"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "departure-time"
    }, "Departure Time"), /*#__PURE__*/React__default.createElement("div", {
      className: "slider-value-container"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "slider-value-start"
    }, "8:00 am"), /*#__PURE__*/React__default.createElement("div", {
      className: "slider-value=end"
    }, "11:55 am")), /*#__PURE__*/React__default.createElement(Slider.Range, {
      trackStyle: [{
        backgroundColor: "#FAB500"
      }],
      handleStyle: [dotStyle$1, dotStyle$1]
    }), /*#__PURE__*/React__default.createElement("div", {
      className: "landing-time"
    }, "Landing Time"), /*#__PURE__*/React__default.createElement("div", {
      className: "slider-value-container"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "slider-value-start"
    }, "2:00 pm"), /*#__PURE__*/React__default.createElement("div", {
      className: "slider-value=end"
    }, "10:55 pm")), /*#__PURE__*/React__default.createElement(Slider.Range, {
      trackStyle: [{
        backgroundColor: "#FAB500"
      }],
      handleStyle: [dotStyle$1, dotStyle$1]
    })));
  };

  TimingFilter.propTypes = {};
  TimingFilter.defaultProps = {};
  var css_248z$I = ".tripDurationFilter-container .tripDurationFilter-wrapper {\n  display: flex;\n  flex-direction: column;\n}\n.tripDurationFilter-container .tripDurationFilter-wrapper .text {\n  margin: 16px 0px;\n}\n.tripDurationFilter-container .tripDurationFilter-wrapper.collapsible-wrapper {\n  padding: 0px !important;\n}\n.tripDurationFilter-container .tripDurationFilter-wrapper .rc-slider-container {\n  margin-top: 50px;\n  padding: 0px 20px;\n}";
  styleInject(css_248z$I);

  var scrollToBottomUtil = function scrollToBottomUtil(refContainer, refToScroll, additionalHeightY) {
    if (refContainer && refContainer.current && refContainer.current.scrollTo) {
      refContainer.current.scrollTo(0, refToScroll.current.getBoundingClientRect().y + additionalHeightY);
    }
  };

  var createSliderWithTooltip$1 = Slider__default.createSliderWithTooltip;
  var SliderWithTooltip = createSliderWithTooltip$1(Slider__default);

  var TripDurationFilter = function TripDurationFilter(_ref) {
    var totalTripTime = _ref.totalTripTime,
        onTotalTripTimeChange = _ref.onTotalTripTimeChange,
        filterContainerRef = _ref.filterContainerRef;
    var tripDurationFilter = React.useRef();
    var tripDurationFilterClass = classNames("tripDurationFilter-container");
    return /*#__PURE__*/React__default.createElement("div", {
      className: tripDurationFilterClass,
      ref: tripDurationFilter
    }, /*#__PURE__*/React__default.createElement(CollapsibleButton, {
      onWork: function onWork() {
        scrollToBottomUtil(filterContainerRef, tripDurationFilter, 160);
      },
      title: /*#__PURE__*/React__default.createElement(FormatedTitle, {
        text: "Total travel time"
      }),
      defaultOpenIcon: "chevron_down",
      defaultCloseIcon: "chevron_up"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "collapsible-wrapper tripDurationFilter-wrapper"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "text"
    }, "Total travel time length"), /*#__PURE__*/React__default.createElement("div", {
      className: "rc-slider-container"
    }, /*#__PURE__*/React__default.createElement(SliderWithTooltip, {
      tipProps: {
        visible: true,
        placement: "top"
      },
      tipFormatter: getDurationTimeFromSeconds,
      min: 3600,
      max: 86359,
      step: 100,
      value: totalTripTime,
      onChange: onTotalTripTimeChange,
      trackStyle: [{
        backgroundColor: "#FAB500"
      }, {
        backgroundColor: "#FAB500"
      }],
      handleStyle: dotStyle
    })))));
  };

  TripDurationFilter.propTypes = {
    totalTripTime: PropTypes__default.number.isRequired,
    onTotalTripTimeChange: PropTypes__default.func.isRequired,
    filterContainerRef: PropTypes__default.oneOfType([// Either a function
    PropTypes__default.func, // Or the instance of a DOM native element (see the note about SSR)
    PropTypes__default.shape({
      current: PropTypes__default.elementType
    })])
  };
  TripDurationFilter.defaultProps = {
    filterContainerRef: undefined
  };
  var css_248z$J = "";
  styleInject(css_248z$J);

  var Zendesk = function Zendesk(_ref) {
    var history = _ref.history,
        principal = _ref.principal;
    React.useEffect(function () {
      if (!principal) {
        return;
      }

      var script = document.createElement("script");
      script.src = "https://static.zdassets.com/ekr/snippet.js?key=".concat(principal);
      script.id = "ze-snippet";
      document.head.appendChild(script);
    }, [history.location]);
    return null;
  };

  Zendesk.propTypes = {
    history: PropTypes__default.instanceOf(Object).isRequired,
    principal: PropTypes__default.bool
  };
  Zendesk.defaultProps = {
    principal: false
  };
  fontawesomeSvgCore.library.add(freeSolidSvgIcons.fas);
  var css_248z$K = ".editing-title {\n  font-family: \"Source Sans Pro\", sans-serif;\n  font-weight: 600;\n  font-size: 20px;\n  line-height: 100%;\n  display: inline-flex;\n}\n\n.editing-header {\n  border-bottom: 1px solid #3c3835;\n  padding: 10px 0;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 20px;\n}\n\n.editing-buttons {\n  display: inline-flex;\n}\n\n.editing-icon {\n  width: 40px;\n  height: 40px;\n  position: relative;\n  background-color: rgb(229, 229, 229);\n  border-radius: 6px;\n  cursor: pointer;\n}\n\n.editing-icon.check-icon {\n  background-color: #fab500;\n  margin-left: 10px;\n}\n\n.editing-span {\n  color: #cdccc8;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 170%;\n  display: flex;\n  align-items: center;\n  margin-right: 20px;\n}\n\n.editing-icon svg {\n  width: 20px;\n  height: 20px;\n  left: 0;\n  right: 0;\n  margin: auto;\n}";
  styleInject(css_248z$K);

  var birthDayMaxDate = function birthDayMaxDate() {
    var birthDayMax = new Date();
    birthDayMax.setDate(birthDayMax.getDate() - 1);
    return birthDayMax;
  };

  var EDITING_TYPES = {
    INPUT: "INPUT",
    DROP_DOWN: "DROP_DOWN",
    DATE_PICKER: "DATE_PICKER",
    PASSWORD: "password"
  };
  var css_248z$L = "";
  styleInject(css_248z$L);
  var css_248z$M = ".inputfield-container {\n  min-width: 100px;\n  min-height: 40px;\n  border: 1px solid #cdccc8;\n  color: #3c3835;\n  box-sizing: border-box;\n  border-radius: 6px;\n  padding: 0 10px;\n  font-family: \"Source Sans Pro\", sans-serif;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 18px;\n  line-height: 23px;\n  align-items: center;\n  position: relative;\n}\n.inputfield-container:disabled {\n  background-color: #fff;\n}\n.inputfield-container::placeholder {\n  /* Chrome, Firefox, Opera, Safari 10.1+ */\n  color: #cdccc8;\n  opacity: 1; /* Firefox */\n}\n.inputfield-container:-ms-input-placeholder {\n  /* Internet Explorer 10-11 */\n  color: #cdccc8;\n}\n.inputfield-container::-ms-input-placeholder {\n  /* Microsoft Edge */\n  color: #cdccc8;\n}\n\n.inputfield-hasIcon {\n  padding-right: 30px;\n}\n\n.inputfield-wrapper {\n  width: 100%;\n}\n\n.inputfield-container:focus {\n  border: 1px solid #3c3835;\n  outline: none;\n}\n\n.inputfield-fullWidth {\n  width: 100%;\n}\n\n.inputfield-referralColor {\n  border-color: #ff9800;\n}\n\n.inputfield-error {\n  border: 1px solid #ff4040;\n  color: #ff4040;\n}\n.inputfield-error::placeholder {\n  color: #ff4040;\n}\n.inputfield-error:-ms-input-placeholder {\n  /* Internet Explorer 10-11 */\n  color: #ff4040;\n}\n.inputfield-error::-ms-input-placeholder {\n  /* Microsoft Edge */\n  color: #ff4040;\n}\n\n.inputfield-suggestion {\n  margin-top: 10px;\n  font-size: 16px;\n  line-height: 20px;\n  box-sizing: border-box;\n  position: absolute;\n  width: 100%;\n  background-color: #f9f9f9;\n  min-width: 160px;\n  z-index: 2;\n  background: #ffffff;\n  box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.15);\n  border-radius: 6px;\n  max-height: 300px;\n  overflow: auto;\n}\n\n.inputfield-suggestion-content {\n  display: block;\n  padding: 10px 20px;\n}\n\n.AutoComplete--suggestions-wrapper {\n  width: 100%;\n  margin: auto;\n  position: relative;\n  padding: 0;\n  margin: 0;\n}\n.AutoComplete--suggestions-wrapper .AutoComplete--suggestions {\n  width: 100%;\n  max-height: 143px;\n  overflow-y: auto;\n}\n.AutoComplete--suggestions-wrapper .AutoComplete--suggestions div {\n  position: absolute;\n  z-index: 9000;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n}\n.AutoComplete--suggestions-wrapper .AutoComplete--suggestions div ul {\n  max-height: 200px;\n  overflow: auto;\n  padding: 0;\n  margin: 0;\n  background: white;\n  width: 100%;\n  border: 2px solid #f0f0f0;\n  list-style: none;\n}\n.AutoComplete--suggestions-wrapper .AutoComplete--suggestions div ul li:hover {\n  background: #f5f5f5;\n}\n.AutoComplete--suggestions-wrapper .AutoComplete--suggestions div ul li {\n  padding: 0.5rem;\n  border-bottom: 1px solid #f0f0f0;\n  cursor: pointer;\n}\n.AutoComplete--suggestions-wrapper .AutoComplete--suggestions div ul li :last-child {\n  border: 0;\n}\n\n@media only screen and (max-width: 380px) {\n  .inputfield-container {\n    font-size: 14px;\n    padding: 0 6px;\n  }\n}";
  styleInject(css_248z$M);

  function setNativeValue(element, value) {
    var valueSetter = Object.getOwnPropertyDescriptor(element, "value").set;
    var prototype = Object.getPrototypeOf(element);
    var prototypeValueSetter = Object.getOwnPropertyDescriptor(prototype, "value").set;

    if (valueSetter && valueSetter !== prototypeValueSetter) {
      prototypeValueSetter.call(element, value);
    } else {
      valueSetter.call(element, value);
    }
  }

  var InputField = function InputField(_ref) {
    var placeholder = _ref.placeholder,
        type = _ref.type,
        value = _ref.value,
        inputProps = _ref.inputProps,
        inputStyle = _ref.inputStyle,
        onChange = _ref.onChange,
        onBlur = _ref.onBlur,
        onClick = _ref.onClick,
        fullWidth = _ref.fullWidth,
        error = _ref.error,
        autocomplete = _ref.autocomplete,
        referralColor = _ref.referralColor,
        suggestions = _ref.suggestions,
        inputRef = _ref.inputRef,
        hasIcon = _ref.hasIcon,
        onCopy = _ref.onCopy,
        onFocus = _ref.onFocus,
        disabled = _ref.disabled,
        showPassword = _ref.showPassword,
        mask = _ref.mask,
        maskType = _ref.maskType,
        tabIndex = _ref.tabIndex;

    var _React$useState17 = React.useState({
      inputValue: "",
      activeSuggestion: -1,
      filteredSuggestions: [],
      showSuggestions: false
    }),
        _React$useState18 = _slicedToArray(_React$useState17, 2),
        state = _React$useState18[0],
        setState = _React$useState18[1];

    var innerRef = /*#__PURE__*/React__default.createRef();

    var changeState = function changeState(params) {
      setState(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), params);
      });
    };

    var handleChange = function handleChange(newValue, maskObject) {
      var handleValue = newValue;

      if (maskType === "time") {
        handleValue = {
          value: newValue,
          // eslint-disable-next-line no-underscore-dangle
          maskedValue: maskObject._value
        };
      }

      if (autocomplete) {
        var filteredSuggestions = suggestions.filter(function (suggestion) {
          return suggestion.toLowerCase().includes(handleValue.toLowerCase());
        });
        changeState({
          inputValue: handleValue,
          activeSuggestion: 0,
          filteredSuggestions: filteredSuggestions,
          showSuggestions: handleValue.length > 0
        });
      }

      if (onChange) {
        onChange({
          target: {
            value: handleValue
          }
        });
      } else {
        changeState({
          inputValue: handleValue
        });
      }
    };

    var inputFieldClass = classNames("inputfield-container", {
      "inputfield-error": error,
      "inputfield-suggestions-content": state.showSuggestions,
      "inputfield-fullWidth": fullWidth,
      "inputfield-referralColor": referralColor,
      "inputfield-hasIcon": hasIcon
    });

    var onKeyDown = function onKeyDown(e) {
      if (autocomplete) {
        var activeSuggestion = state.activeSuggestion,
            filteredSuggestions = state.filteredSuggestions;

        if (e.keyCode === 13) {
          changeState({
            activeSuggestion: 0,
            showSuggestions: false,
            value: filteredSuggestions[activeSuggestion]
          });
        } else if (e.keyCode === 38) {
          if (activeSuggestion === 0) {
            return;
          }

          changeState({
            activeSuggestion: activeSuggestion - 1
          });
        }
      }
    };

    var onSuggestionClicked = function onSuggestionClicked(e) {
      setNativeValue(innerRef.current, e.currentTarget.innerText);
      innerRef.current.dispatchEvent(new Event("input", {
        bubbles: true
      }));
      changeState({
        activeSuggestion: 0,
        showSuggestions: false,
        filteredSuggestions: []
      });
    };

    var getValue = function getValue() {
      var tempValue = state.inputValue;

      if (value) {
        tempValue = value;
      }

      return tempValue ? tempValue.toString() : "";
    };

    var getMask = function getMask() {
      switch (maskType) {
        case "phone":
          return "(000) 000-0000";

        default:
          return mask;
      }
    };

    return /*#__PURE__*/React__default.createElement("div", {
      className: "inputfield-wrapper"
    }, /*#__PURE__*/React__default.createElement(reactImask.IMaskInput, _extends({
      tabindex: tabIndex,
      mask: getMask(),
      unmask: true
    }, dateMask(maskType), {
      onAccept: handleChange,
      readOnly: disabled,
      ref: inputRef || innerRef,
      className: inputFieldClass,
      fullWidth: fullWidth,
      onCopy: onCopy,
      value: getValue(),
      onBlur: onBlur,
      onClick: onClick,
      onFocus: onFocus,
      onKeyDown: onKeyDown,
      style: inputStyle,
      type: type === "password" && showPassword ? "text" : type,
      placeholder: placeholder,
      error: error
    }, inputProps)), state.showSuggestions && /*#__PURE__*/React__default.createElement("div", {
      className: "AutoComplete--suggestions-wrapper"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "AutoComplete--suggestions"
    }, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("ul", null, state.filteredSuggestions.length > 0 ? state.filteredSuggestions.map(function (suggestion, index) {
      var className;

      if (index === state.activeSuggestion) {
        className = "suggestion-active";
      }

      return /*#__PURE__*/React__default.createElement("li", {
        key: suggestion,
        className: className,
        onClick: onSuggestionClicked
      }, suggestion);
    }) : /*#__PURE__*/React__default.createElement("li", null, "No options"))))));
  };

  InputField.propTypes = {
    onChange: PropTypes__default.func,
    placeholder: PropTypes__default.string,
    type: PropTypes__default.string,
    error: PropTypes__default.bool,
    fullWidth: PropTypes__default.bool,
    suggestions: PropTypes__default.instanceOf(Array),
    autocomplete: PropTypes__default.bool,
    onBlur: PropTypes__default.func,
    onClick: PropTypes__default.func,
    value: PropTypes__default.string,
    inputProps: PropTypes__default.instanceOf(Object),
    inputStyle: PropTypes__default.instanceOf(Object),
    referralColor: PropTypes__default.bool,
    inputRef: PropTypes__default.oneOfType([// Either a function
    PropTypes__default.func, // Or the instance of a DOM native element (see the note about SSR)
    PropTypes__default.shape({
      current: PropTypes__default.elementType
    })]),
    hasIcon: PropTypes__default.bool,
    onCopy: PropTypes__default.func,
    onFocus: PropTypes__default.func,
    disabled: PropTypes__default.bool,
    showPassword: PropTypes__default.bool,
    mask: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.bool]),
    maskType: PropTypes__default.oneOf(["phone"]),
    tabIndex: PropTypes__default.number
  };
  InputField.defaultProps = {
    onChange: function onChange() {
      return null;
    },
    onBlur: function onBlur() {
      return null;
    },
    onClick: function onClick() {
      return null;
    },
    placeholder: "",
    type: "text",
    error: false,
    value: "",
    fullWidth: false,
    suggestions: [],
    autocomplete: false,
    inputProps: {},
    inputStyle: {},
    referralColor: false,
    inputRef: undefined,
    hasIcon: false,
    onCopy: function onCopy() {},
    disabled: false,
    onFocus: function onFocus() {},
    showPassword: false,
    mask: true,
    maskType: "",
    tabIndex: undefined
  };

  var InputFieldSet = function InputFieldSet(_ref) {
    var inputPlaceholder = _ref.inputPlaceholder,
        inputType = _ref.inputType,
        inputValue = _ref.inputValue,
        inputProps = _ref.inputProps,
        onChange = _ref.onChange,
        onBlur = _ref.onBlur,
        onClick = _ref.onClick,
        fullWidth = _ref.fullWidth,
        inputStyle = _ref.inputStyle,
        labelText = _ref.labelText,
        icon = _ref.icon,
        inputRef = _ref.inputRef,
        error = _ref.error,
        mandatory = _ref.mandatory,
        referralColor = _ref.referralColor,
        margin = _ref.margin,
        suggestions = _ref.suggestions,
        autocomplete = _ref.autocomplete,
        disabled = _ref.disabled,
        onCopy = _ref.onCopy,
        onFocus = _ref.onFocus,
        mask = _ref.mask,
        maskType = _ref.maskType,
        tabIndex = _ref.tabIndex;

    var _React$useState19 = React.useState({
      isPasswordHidden: false
    }),
        _React$useState20 = _slicedToArray(_React$useState19, 2),
        state = _React$useState20[0],
        setState = _React$useState20[1];

    var toggleHiddenPassword = function toggleHiddenPassword() {
      setState(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), {}, {
          isPasswordHidden: !prevState.isPasswordHidden
        });
      });
    };

    return /*#__PURE__*/React__default.createElement(Fieldset, {
      fullWidth: fullWidth,
      margin: margin
    }, /*#__PURE__*/React__default.createElement(FieldLabel, {
      mandatory: mandatory,
      error: error,
      labelText: labelText
    }), /*#__PURE__*/React__default.createElement(InputField, {
      tabIndex: tabIndex,
      referralColor: referralColor,
      inputRef: inputRef,
      fullWidth: fullWidth,
      value: inputValue,
      onChange: onChange,
      onBlur: onBlur,
      onCopy: onCopy,
      onClick: onClick,
      style: inputStyle,
      type: inputType,
      error: error,
      showPassword: state.isPasswordHidden,
      placeholder: inputPlaceholder,
      disabled: disabled,
      suggestions: suggestions,
      autocomplete: autocomplete,
      hasIcon: !!icon,
      inputProps: inputProps,
      onFocus: onFocus,
      mask: mask,
      maskType: maskType
    }), inputType === "password" ? /*#__PURE__*/React__default.createElement(Icon, {
      name: state.isPasswordHidden ? "openEye" : "closedEye",
      viewBox: state.isPasswordHidden ? "0 0 20 14" : "0 0 20 18",
      width: "20",
      height: state.isPasswordHidden ? "14" : "19",
      onClick: toggleHiddenPassword,
      style: {
        marginRight: 10
      }
    }) : icon);
  };

  var Fieldset = styled.div(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  font-family: \"Source Sans Pro\", sans-serif;\n  border: none;\n  position: relative;\n  display: inline-flex;\n  ", ";\n  ", ";\n  svg {\n    filter: invert(18%) sepia(1%) saturate(3126%) hue-rotate(343deg) brightness(92%) contrast(83%);\n    position: absolute;\n    right: 5px;\n    top: 50%;\n    transform: translateY(-50%);\n  }\n"])), function (props) {
    return props.fullWidth ? "width: 100%" : "";
  }, function (props) {
    return "margin: ".concat(props.margin);
  });
  InputFieldSet.propTypes = {
    inputPlaceholder: PropTypes__default.string,
    inputType: PropTypes__default.oneOf(["text", "password", "email"]),
    inputValue: PropTypes__default.string.isRequired,
    onChange: PropTypes__default.func.isRequired,
    onBlur: PropTypes__default.func,
    onClick: PropTypes__default.func,
    inputStyle: PropTypes__default.instanceOf(Object),
    labelText: PropTypes__default.string,
    error: PropTypes__default.bool,
    fullWidth: PropTypes__default.bool,
    mandatory: PropTypes__default.bool,
    margin: PropTypes__default.string,
    inputProps: PropTypes__default.instanceOf(Object),
    icon: PropTypes__default.element,
    inputRef: PropTypes__default.oneOfType([// Either a function
    PropTypes__default.func, // Or the instance of a DOM native element (see the note about SSR)
    PropTypes__default.shape({
      current: PropTypes__default.elementType
    })]),
    referralColor: PropTypes__default.bool,
    suggestions: PropTypes__default.instanceOf(Array),
    autocomplete: PropTypes__default.bool,
    disabled: PropTypes__default.bool,
    onCopy: PropTypes__default.func,
    onFocus: PropTypes__default.func,
    mask: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.bool]),
    maskType: PropTypes__default.oneOf(["phone"]),
    tabIndex: PropTypes__default.number
  };
  InputFieldSet.defaultProps = {
    inputType: "text",
    error: false,
    labelText: "",
    inputPlaceholder: "",
    inputProps: {},
    onBlur: function onBlur() {},
    onClick: function onClick() {},
    inputStyle: {},
    fullWidth: false,
    mandatory: false,
    margin: "0 0 20px 0",
    inputRef: undefined,
    icon: null,
    referralColor: false,
    suggestions: [],
    autocomplete: false,
    disabled: false,
    onCopy: function onCopy() {},
    onFocus: function onFocus() {},
    mask: true,
    maskType: "",
    tabIndex: undefined
  };

  var EditingContainer = function EditingContainer(_ref) {
    var title = _ref.title,
        margin = _ref.margin,
        items = _ref.items,
        onSave = _ref.onSave;

    var _React$useState21 = React.useState(false),
        _React$useState22 = _slicedToArray(_React$useState21, 2),
        editing = _React$useState22[0],
        setEditing = _React$useState22[1];

    var _React$useState23 = React.useState([]),
        _React$useState24 = _slicedToArray(_React$useState23, 2),
        oldItems = _React$useState24[0],
        setOldItems = _React$useState24[1];

    React.useEffect(function () {
      setOldItems(items);
    }, []);

    var cancelEditing = function cancelEditing() {
      oldItems.forEach(function (_ref2) {
        var type = _ref2.type,
            value = _ref2.value,
            onChange = _ref2.onChange;

        if (type === EDITING_TYPES.INPUT || type === EDITING_TYPES.PASSWORD) {
          onChange({
            target: {
              value: value
            }
          });
        } else {
          onChange(value);
        }
      });
      setEditing(false);
    };

    var saveEdit = /*#__PURE__*/function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
        var isSaved;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return onSave(e, title);

              case 2:
                isSaved = _context.sent;

                if (isSaved) {
                  setEditing(false);
                }

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function saveEdit(_x) {
        return _ref7.apply(this, arguments);
      };
    }();

    var getFieldByType = function getFieldByType(_ref3) {
      var type = _ref3.type,
          value = _ref3.value,
          error = _ref3.error,
          onChange = _ref3.onChange,
          mandatory = _ref3.mandatory,
          labelText = _ref3.labelText,
          content = _ref3.content,
          autocomplete = _ref3.autocomplete,
          suggestions = _ref3.suggestions,
          maskType = _ref3.maskType;

      switch (type) {
        case EDITING_TYPES.INPUT:
          return /*#__PURE__*/React__default.createElement(InputFieldSet, {
            fullWidth: true,
            inputValue: value,
            error: error,
            onChange: onChange,
            mandatory: mandatory,
            maskType: maskType,
            labelText: labelText,
            autocomplete: autocomplete,
            suggestions: suggestions
          });

        case EDITING_TYPES.PASSWORD:
          return /*#__PURE__*/React__default.createElement(InputFieldSet, {
            fullWidth: true,
            inputValue: value,
            inputType: "password",
            error: error,
            onChange: onChange,
            mandatory: mandatory,
            maskType: maskType,
            labelText: labelText,
            autocomplete: autocomplete,
            suggestions: suggestions
          });

        case EDITING_TYPES.DROP_DOWN:
          return /*#__PURE__*/React__default.createElement(DropdownMenu, {
            fullWidth: true,
            labelText: labelText,
            mandatory: mandatory,
            error: error,
            value: value,
            content: content,
            onSelect: onChange
          });

        case EDITING_TYPES.DATE_PICKER:
          return /*#__PURE__*/React__default.createElement(DropDownDatePicker, {
            fullWidth: true,
            labelText: labelText,
            mandatory: mandatory,
            maxDate: birthDayMaxDate(),
            error: error,
            value: value,
            onDateChange: onChange
          });

        default:
          return null;
      }
    };

    getFieldByType.propTypes = {
      type: PropTypes__default.oneOf(Object.values(EDITING_TYPES)),
      value: PropTypes__default.string,
      error: PropTypes__default.bool,
      onChange: PropTypes__default.func,
      mandatory: PropTypes__default.bool,
      labelText: PropTypes__default.string,
      content: PropTypes__default.element.isRequired,
      autocomplete: PropTypes__default.bool,
      suggestions: PropTypes__default.instanceOf(Array),
      maskType: PropTypes__default.oneOf(["phone"])
    };
    getFieldByType.defaultProps = {
      type: "",
      value: "",
      error: false,
      onChange: function onChange() {},
      mandatory: false,
      labelText: "",
      autocomplete: false,
      suggestions: [],
      maskType: ""
    };

    var InputPreviewValue = function InputPreviewValue(_ref4) {
      var type = _ref4.type,
          value = _ref4.value;

      if (type === EDITING_TYPES.DATE_PICKER) {
        if (value) {
          return moment(value).format("DD MMM YYYY");
        }

        return "Not Set";
      }

      return value || "Not Set";
    };

    return /*#__PURE__*/React__default.createElement("div", {
      className: "editingcontainer-wrapper",
      style: {
        margin: margin
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "editing-header"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "editing-title"
    }, title), /*#__PURE__*/React__default.createElement("div", {
      className: "editing-buttons"
    }, editing ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("span", {
      className: "editing-span"
    }, "(Editing)"), /*#__PURE__*/React__default.createElement("div", {
      className: "editing-icon",
      onClick: cancelEditing
    }, /*#__PURE__*/React__default.createElement(Icon, {
      name: "closeIcon",
      viewBox: "0 0 20 20"
    })), /*#__PURE__*/React__default.createElement("div", {
      className: "editing-icon check-icon",
      onClick: saveEdit
    }, /*#__PURE__*/React__default.createElement(Icon, {
      name: "checkIcon",
      viewBox: "0 0 20 15"
    }))) : /*#__PURE__*/React__default.createElement("div", {
      className: "editing-icon",
      onClick: function onClick() {
        setEditing(true);
      }
    }, /*#__PURE__*/React__default.createElement(Icon, {
      name: "editing",
      viewBox: "0 0 20 20"
    })))), items.map(function (item) {
      return editing ? getFieldByType(item) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, item.type !== EDITING_TYPES.PASSWORD && /*#__PURE__*/React__default.createElement(InputPreview, {
        title: item.labelText,
        value: /*#__PURE__*/React__default.createElement(InputPreviewValue, {
          value: item.value,
          type: item.type
        })
      }));
    }));
  };

  EditingContainer.propTypes = {
    title: PropTypes__default.string,
    margin: PropTypes__default.string,
    items: PropTypes__default.shape([{
      value: PropTypes__default.string
    }]),
    onSave: PropTypes__default.func.isRequired
  };
  EditingContainer.defaultProps = {
    title: "",
    margin: "0",
    items: []
  };
  var css_248z$N = ".incrementerGroup-wrapper {\n  padding: 0px 20px;\n}";
  styleInject(css_248z$N);

  var IncrementerGroup = function IncrementerGroup(_ref) {
    var items = _ref.items,
        disabled = _ref.disabled;
    var incrementerGroupClass = classNames("incrementerGroup-wrapper");
    return /*#__PURE__*/React__default.createElement("div", {
      className: incrementerGroupClass
    }, items.map(function (item) {
      return /*#__PURE__*/React__default.createElement(SingleIncrementer, {
        disabled: disabled,
        key: item.text,
        text: item.text,
        incrementNumber: item.incrementNumber,
        incrementStep: item.incrementStep,
        onIncrementChange: item.onIncrementChange,
        counterMin: item.counterMin,
        counterLimit: item.counterLimit
      });
    }));
  };

  IncrementerGroup.propTypes = {
    items: PropTypes__default.instanceOf(Array),
    disabled: PropTypes__default.bool
  };
  IncrementerGroup.defaultProps = {
    items: [],
    disabled: false
  };
  var css_248z$O = ".loyaltyBuyPoints-wrapper {\n  font-family: \"Source Sans Pro\", sans-serif;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 14px;\n  line-height: 150%;\n}\nu .loyaltyBuyPoints-wrapper ul {\n  line-height: 150%;\n}\nu .loyaltyBuyPoints-wrapper ul li {\n  margin-bottom: 20px;\n}\n.loyaltyBuyPoints-wrapper ul.incrementer-legend li:before {\n  /* the custom styled bullets */\n  background-color: #ff9800;\n  border-radius: 50%;\n  content: \"\";\n  display: inline-block;\n  margin-right: 10px;\n  height: 10px;\n  width: 10px;\n}\n.loyaltyBuyPoints-wrapper ul {\n  padding-left: 0px;\n  list-style: none;\n}\n\n.loyaltyBuyPoints-wrapper-title {\n  font-weight: 600;\n  font-size: 24px;\n  line-height: 100%;\n  color: #3c3835;\n  border-bottom: 1px solid #3c3835;\n  padding-bottom: 15px;\n  margin-bottom: 20px;\n}\n\n.incrementer-legend {\n  padding-top: 20px;\n  padding-bottom: 40px;\n}\n.incrementer-legend li {\n  display: flex;\n  align-items: center;\n}\n\n.loyaltyBuyPoints-input-button {\n  display: flex;\n}\n.loyaltyBuyPoints-input-button div:first-child {\n  margin: 0px 20px 0px 0px;\n}\n\n@media screen and (max-width: 420px) {\n  .loyaltyBuyPoints-input-button {\n    flex-direction: column;\n  }\n  .loyaltyBuyPoints-input-button div:first-child {\n    margin: 0px 0px 20px 0px;\n  }\n}";
  styleInject(css_248z$O);

  var LoyaltyBuyPoints = function LoyaltyBuyPoints(_ref) {
    var onChange = _ref.onChange,
        value = _ref.value,
        onCalculateButtonClick = _ref.onCalculateButtonClick,
        minimum = _ref.minimum,
        maximum = _ref.maximum,
        mask = _ref.mask;
    var loyaltyBuyPointsClass = classNames("loyaltyBuyPoints-wrapper");
    return /*#__PURE__*/React__default.createElement("div", {
      className: loyaltyBuyPointsClass
    }, /*#__PURE__*/React__default.createElement("h1", {
      className: "loyaltyBuyPoints-wrapper-title"
    }, "Buy Miles"), /*#__PURE__*/React__default.createElement("div", {
      className: "loyaltyBuyPoints-input-button"
    }, /*#__PURE__*/React__default.createElement(InputFieldSet, {
      mask: mask,
      mandatory: true,
      fullWidth: true,
      labelText: "MILEAGE TO BE PURCHASED",
      onChange: onChange,
      inputValue: value > 0 ? value : undefined
    }), /*#__PURE__*/React__default.createElement(Button, {
      type: "secondary",
      onClick: onCalculateButtonClick
    }, "Calculate")), /*#__PURE__*/React__default.createElement("ul", {
      className: "incrementer-legend"
    }, /*#__PURE__*/React__default.createElement("li", null, minimum, " mile minimum"), /*#__PURE__*/React__default.createElement("li", null, maximum, " mile maximum")));
  };

  LoyaltyBuyPoints.propTypes = {
    onChange: PropTypes__default.func,
    value: PropTypes__default.string,
    onCalculateButtonClick: PropTypes__default.func,
    maximum: PropTypes__default.string.isRequired,
    minimum: PropTypes__default.string.isRequired,
    mask: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.bool])
  };
  LoyaltyBuyPoints.defaultProps = {
    onChange: function onChange() {},
    value: "",
    onCalculateButtonClick: function onCalculateButtonClick() {},
    mask: true
  };
  var css_248z$P = ".luggageIcon-container {\n  margin-right: 10px;\n}\n.luggageIcon-container .tagLabel-isContainer {\n  padding: 0 !important;\n}\n.luggageIcon-container .luggageIcon-wrapper {\n  display: flex;\n  align-items: center;\n}\n.luggageIcon-container .luggageIcon-wrapper svg {\n  margin: 0 5px;\n}\n.luggageIcon-container .luggageIcon-wrapper .tagLabel-container {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}";
  styleInject(css_248z$P);
  var LUGGAGE_HAND_BAG = "hand_bag";
  var LUGGAGE_HOLD_BAG = "hold_bag";
  var LUGGAGE_CATEGORY = {
    hold_bag: {
      property: "hold_bag",
      text: "Checked Luggage"
    },
    cabin_bag: {
      property: "cabin_bag",
      text: "Cabin Luggage"
    },
    personal_item: {
      property: "personal_item",
      text: "Personal Item"
    }
  };

  var LuggageIcon$1 = function LuggageIcon$1(_ref) {
    var price = _ref.price,
        category = _ref.category;
    var luggageIconClass = classNames("luggageIcon-container");
    return /*#__PURE__*/React__default.createElement("div", {
      className: luggageIconClass
    }, /*#__PURE__*/React__default.createElement(TagLabel, {
      type: "inf",
      container: true,
      content: /*#__PURE__*/React__default.createElement("div", {
        className: "luggageIcon-wrapper"
      }, /*#__PURE__*/React__default.createElement(SuitCaseIcon, {
        category: category
      }), /*#__PURE__*/React__default.createElement(LuggageLabel, {
        price: price
      }))
    }));
  };

  LuggageIcon$1.propTypes = {
    price: PropTypes__default.number,
    category: PropTypes__default.string
  };
  LuggageIcon$1.defaultProps = {
    price: undefined,
    category: undefined
  };

  var SuitCaseIcon = function SuitCaseIcon(_ref2) {
    var category = _ref2.category;

    switch (category) {
      case LUGGAGE_CATEGORY.hold_bag.property:
        return /*#__PURE__*/React__default.createElement(Icon, {
          name: "checked_luggage",
          width: "16",
          height: "20",
          withoutProps: true,
          noAbsolute: true
        });

      case LUGGAGE_CATEGORY.cabin_bag.property:
        return /*#__PURE__*/React__default.createElement(Icon, {
          name: "cabin_luggage",
          width: "16",
          height: "20",
          withoutProps: true,
          noAbsolute: true
        });

      case LUGGAGE_CATEGORY.personal_item.property:
        return /*#__PURE__*/React__default.createElement(Icon, {
          name: "personal_item",
          width: "16",
          height: "20",
          withoutProps: true,
          noAbsolute: true
        });

      default:
        return null;
    }
  };

  SuitCaseIcon.propTypes = {
    category: PropTypes__default.string
  };
  SuitCaseIcon.defaultProps = {
    category: undefined
  };

  var LuggageLabel = function LuggageLabel(_ref3) {
    var price = _ref3.price,
        noLuggage = _ref3.noLuggage;

    if (noLuggage) {
      return /*#__PURE__*/React__default.createElement(TagLabel, {
        center: true,
        type: "RED",
        content: "NO",
        width: 35
      });
    }

    if (price === 0) {
      return /*#__PURE__*/React__default.createElement(TagLabel, {
        center: true,
        type: "GREEN",
        content: "FREE",
        width: 35
      });
    }

    if (price > 0) {
      return /*#__PURE__*/React__default.createElement(TagLabel, {
        center: true,
        type: "LL",
        content: "$",
        width: 35
      });
    }

    return null;
  };

  LuggageLabel.propTypes = {
    price: PropTypes__default.number,
    noLuggage: PropTypes__default.bool
  };
  LuggageLabel.defaultProps = {
    price: undefined,
    noLuggage: false
  };
  var css_248z$Q = ".luggageItem-container {\n  display: flex;\n  align-items: center;\n}\n.luggageItem-container p {\n  font-size: 12px;\n  line-height: 24px;\n}";
  styleInject(css_248z$Q);

  var LuggageItem = function LuggageItem(_ref) {
    var category = _ref.category,
        price = _ref.price,
        weight = _ref.weight;
    var luggageItemClass = classNames("luggageItem-container");
    return /*#__PURE__*/React__default.createElement("div", {
      className: luggageItemClass
    }, /*#__PURE__*/React__default.createElement(LuggageIcon$1, {
      price: price,
      category: category
    }), /*#__PURE__*/React__default.createElement("p", null, LUGGAGE_CATEGORY[category].text, " - ", weight, " kg"));
  };

  LuggageItem.propTypes = {
    category: PropTypes__default.string,
    price: PropTypes__default.string,
    weight: PropTypes__default.string
  };
  LuggageItem.defaultProps = {
    category: undefined,
    price: undefined,
    weight: ""
  };
  var css_248z$R = ".referralCodeInput-wrapper {\n  padding-top: 20px;\n}";
  styleInject(css_248z$R);

  var ReferralCodeInput = function ReferralCodeInput(_ref) {
    var onReferralCodeChange = _ref.onReferralCodeChange,
        hideText = _ref.hideText,
        referralCode = _ref.referralCode,
        publicUrl = _ref.publicUrl,
        copiedSuccesfully = _ref.copiedSuccesfully;
    var referralCodeInputClass = classNames("referralCodeInput-wrapper");
    var inputRef = React.useRef(null);

    var copyToClipboard = function copyToClipboard() {
      var el = inputRef;
      el.current.select();
      document.execCommand("copy");
      copiedSuccesfully();
    };

    var _React$useState25 = React.useState({
      referralCode: referralCode
    }),
        _React$useState26 = _slicedToArray(_React$useState25, 2),
        state = _React$useState26[0],
        setState = _React$useState26[1];

    var onReferalCodeChange = function onReferalCodeChange(referalCode) {
      setState(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), {}, {
          referralCode: referalCode.target.value
        });
      });
      onReferralCodeChange(referalCode);
    };

    return /*#__PURE__*/React__default.createElement("div", {
      className: referralCodeInputClass
    }, /*#__PURE__*/React__default.createElement(InputFieldSet, {
      disabled: true,
      labelText: "YOUR REFERRAL CODE",
      fullWidth: true,
      inputValue: state.referralCode,
      referralColor: true,
      onCopy: copyToClipboard,
      onChange: function onChange(e) {
        return onReferalCodeChange(e);
      },
      icon: /*#__PURE__*/React__default.createElement(Icon, {
        name: "copyIcon",
        onClick: function onClick() {
          return copyToClipboard();
        },
        viewBox: "0 0 19 22",
        width: "19",
        height: "22"
      })
    }), /*#__PURE__*/React__default.createElement("input", {
      ref: inputRef,
      style: {
        position: "absolute",
        left: "-1000px",
        top: "-1000px"
      },
      value: "".concat(publicUrl, "/account/register?referalcode=").concat(state.referralCode)
    }), !hideText && /*#__PURE__*/React__default.createElement("p", {
      style: {
        lineHeight: "150%"
      }
    }, "Refer your friends to give them $10 off - and get $10 off your next Landline when they complete a trip."));
  };

  ReferralCodeInput.propTypes = {
    onReferralCodeChange: PropTypes__default.func,
    copiedSuccesfully: PropTypes__default.func,
    referralCode: PropTypes__default.string,
    publicUrl: PropTypes__default.string,
    hideText: PropTypes__default.bool
  };
  ReferralCodeInput.defaultProps = {
    onReferralCodeChange: function onReferralCodeChange() {},
    referralCode: "",
    publicUrl: "",
    copiedSuccesfully: function copiedSuccesfully() {},
    hideText: false
  };
  var css_248z$S = ".tab-modal-group-container {\n  width: 100%;\n  min-height: 44px;\n  display: flex;\n  background-color: #f5f5f5;\n  border-radius: 24px;\n  font-weight: 600;\n  font-size: 14px;\n  transition: all 0.3s ease;\n}\n.tab-modal-group-container .icon-container {\n  line-height: 0px;\n}\n.tab-modal-group-container span {\n  display: flex;\n  flex-shrink: 0;\n}\n.tab-modal-group-container .first-container {\n  flex: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  line-height: 20px;\n  cursor: pointer;\n}\n.tab-modal-group-container .first-container.active-container {\n  background-color: #fff;\n  border: 2px solid #f5f5f5;\n  border-radius: 24px;\n  box-shadow: 0px 2px 8px 2px rgba(0, 0, 0, 0.1);\n}\n.tab-modal-group-container .second-container {\n  flex: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  line-height: 20px;\n  cursor: pointer;\n}\n.tab-modal-group-container .second-container.active-container {\n  background-color: #fff;\n  border: 2px solid #f5f5f5;\n  border-radius: 24px;\n  box-shadow: 0px 2px 8px 2px rgba(0, 0, 0, 0.1);\n}";
  styleInject(css_248z$S);

  var TabModalGroup = function TabModalGroup(_ref) {
    var firstItemTitle = _ref.firstItemTitle,
        secondItemTitle = _ref.secondItemTitle,
        firstItemIcon = _ref.firstItemIcon,
        secondItemIcon = _ref.secondItemIcon,
        firstActive = _ref.firstActive,
        secondActive = _ref.secondActive,
        onFirstItemClick = _ref.onFirstItemClick,
        onSecondItemClick = _ref.onSecondItemClick,
        margin = _ref.margin,
        style = _ref.style;
    var tabModalGroupClass = classNames("tab-modal-group-container");
    var firstContainer = classNames("first-container", {
      "active-container": firstActive
    });
    var secondContainer = classNames("second-container", {
      "active-container": secondActive
    });
    return /*#__PURE__*/React__default.createElement("div", {
      className: tabModalGroupClass,
      style: _objectSpread({
        margin: margin
      }, style)
    }, /*#__PURE__*/React__default.createElement("div", {
      className: firstContainer,
      onClick: onFirstItemClick
    }, /*#__PURE__*/React__default.createElement("span", null, firstItemTitle), /*#__PURE__*/React__default.createElement("div", {
      className: "icon-container"
    }, firstItemIcon)), /*#__PURE__*/React__default.createElement("div", {
      className: secondContainer,
      onClick: onSecondItemClick
    }, /*#__PURE__*/React__default.createElement("span", null, secondItemTitle), /*#__PURE__*/React__default.createElement("div", {
      className: "icon-container"
    }, secondItemIcon)));
  };

  TabModalGroup.propTypes = {
    firstItemTitle: PropTypes__default.string,
    firstActive: PropTypes__default.bool,
    firstItemIcon: PropTypes__default.element,
    margin: PropTypes__default.string,
    style: PropTypes__default.instanceOf(Object),
    onFirstItemClick: PropTypes__default.func,
    secondItemTitle: PropTypes__default.string,
    secondActive: PropTypes__default.bool,
    secondItemIcon: PropTypes__default.element,
    onSecondItemClick: PropTypes__default.func
  };
  TabModalGroup.defaultProps = {
    firstItemTitle: "",
    firstActive: false,
    firstItemIcon: /*#__PURE__*/React__default.createElement(React__default.Fragment, null),
    margin: null,
    style: {},
    onFirstItemClick: function onFirstItemClick() {},
    secondItemTitle: "",
    secondActive: false,
    secondItemIcon: /*#__PURE__*/React__default.createElement(React__default.Fragment, null),
    onSecondItemClick: function onSecondItemClick() {}
  };
  var css_248z$T = ".itinerarySingleRow-container {\n  transition: background 0.5s ease;\n  border: 1px solid #f5f5f5;\n  border-radius: 6px;\n  filter: drop-shadow(2px 2px 6px rgba(0, 0, 0, 0.2));\n  margin-bottom: 20px;\n  width: calc(100% - 20px);\n  background-color: #ffffff;\n  box-sizing: border-box;\n}\n.itinerarySingleRow-container.summary-preview {\n  width: calc(100% - 40px);\n  margin-left: 20px;\n  margin-right: 20px;\n}\n\n.container-black-car-background {\n  background-color: #dcdcdb;\n}\n\n.itinerarySingleRow-leg-connection-container {\n  display: flex;\n  flex: 3;\n  flex-direction: column;\n}\n\n.itinerarySingleRow-ticket-button-container-wrapper {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  margin-left: 20px;\n  position: relative;\n  max-width: 150px;\n  align-self: center;\n}\n.itinerarySingleRow-ticket-button-container-wrapper .ticket-button-container {\n  min-height: 128px;\n}\n.itinerarySingleRow-ticket-button-container-wrapper .ticket-button-container .ticket-price-container .currency-style,\n.itinerarySingleRow-ticket-button-container-wrapper .ticket-button-container .ticket-price-container .defaultPrice {\n  font-family: \"Source Sans Pro\" !important;\n}\n@media screen and (max-width: 1112px) {\n  .itinerarySingleRow-ticket-button-container-wrapper {\n    margin-left: 10px;\n  }\n}\n@media screen and (max-width: 896px) {\n  .itinerarySingleRow-ticket-button-container-wrapper .ticket-button-container {\n    min-height: 128px;\n  }\n}\n\n.itinerarySingleRow-seats-left {\n  padding: 0px 10px;\n  line-height: 20px;\n  font-family: \"Source Sans Pro\", sans-serif;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 10px;\n  background: #fab500;\n  color: #3c3835;\n  text-align: center;\n  border-radius: 3px;\n}\n\n.itinerarySingleRow-preview-button {\n  position: absolute;\n  right: 20px;\n  top: 5px !important;\n}\n.itinerarySingleRow-preview-button .ticket-button-container {\n  flex-direction: row !important;\n}\n.itinerarySingleRow-preview-button .number-of-passengers {\n  position: absolute;\n  left: -80px;\n}\n\n.itinerarySingleRow-seats-left-container {\n  padding-right: 10px;\n  position: relative;\n  display: flex;\n  justify-content: center;\n}\n\n.number-of-passengers {\n  margin-right: 10px;\n  font-size: 12px;\n  line-height: 15px;\n  padding: 0px 2px;\n  height: 20px;\n  width: 60px;\n  background: #e5e5e5;\n  border-radius: 3px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.number-of-passengers-black-car {\n  background-color: #fff;\n}\n\n.itinerarySingleRow-passenger-left-container {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  flex-shrink: 0;\n}\n.itinerarySingleRow-passenger-left-container .tagLabel-wrapper {\n  display: block;\n}\n\n.ItinerarySingleRow-is-classband-open .ticket-button-refundable {\n  background-color: #dcdcdb;\n}\n\n.ItinerarySingleRow-flex-container {\n  padding: 0px 0 0 20px;\n  display: flex;\n}\n.ItinerarySingleRow-flex-container.hide-ticket-price {\n  padding-right: 20px;\n}\n\n.map-modal-container {\n  max-width: 520px;\n  position: relative;\n}\n.map-modal-container .map-modal-text {\n  font-size: 16px;\n  letter-spacing: 0.01em;\n  line-height: 18px;\n  margin-bottom: 24px;\n}\n.map-modal-container .map-modal-buttons-container {\n  display: flex;\n  flex-direction: row;\n}\n.map-modal-container img {\n  display: block;\n  margin: auto;\n  margin-bottom: 19px;\n}\n\n@media only screen and (max-width: 400px) {\n  .map-modal-container {\n    max-width: 320px;\n  }\n  .map-modal-container .map-modal-buttons-container {\n    flex-direction: row;\n    padding-bottom: 15px;\n  }\n  .map-modal-container img {\n    width: 100%;\n    height: auto;\n  }\n}\n@media only screen and (max-width: 450px) {\n  .map-modal-container {\n    max-width: 370px;\n  }\n  .map-modal-container .map-modal-buttons-container {\n    flex-direction: row;\n    padding-bottom: 15px;\n  }\n  .map-modal-container img {\n    width: 100%;\n    height: auto;\n  }\n}\n@media only screen and (max-width: 520px) {\n  .map-modal-container {\n    max-width: 400px;\n  }\n  .map-modal-container .map-modal-buttons-container {\n    flex-direction: row;\n    padding-bottom: 15px;\n  }\n  .map-modal-container img {\n    width: 100%;\n    height: auto;\n  }\n}\n@media only screen and (max-width: 380px) {\n  .map-modal-container {\n    max-width: 280px;\n  }\n  .map-modal-container .map-modal-buttons-container {\n    flex-direction: column;\n    padding-bottom: 10px;\n  }\n  img {\n    width: 100%;\n    height: auto;\n  }\n}\n@media only screen and (max-width: 320px) {\n  .map-modal-container {\n    max-width: 260px;\n  }\n  .map-modal-container .map-modal-buttons-container {\n    flex-direction: column;\n  }\n  img {\n    width: 100%;\n    height: auto;\n  }\n}\n.ItinerarySingleRow_footer {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  padding-bottom: 10px;\n}\n.ItinerarySingleRow_footer .mobile-travel-time {\n  display: none;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 15px;\n  /* identical to box height */\n  color: #858484;\n}\n.ItinerarySingleRow_footer .ItinerarySingleRow_amenities-container .transport-icon {\n  display: none;\n}\n.ItinerarySingleRow_footer .ItinerarySingleRow_amenities-container .icon-motorcoach {\n  height: 8px;\n  transform: scale(3);\n}\n@media screen and (max-width: 1112px) {\n  .ItinerarySingleRow_footer {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 10px;\n  }\n  .ItinerarySingleRow_footer .mobile-travel-time {\n    display: flex;\n  }\n  .ItinerarySingleRow_footer .ItinerarySingleRow_amenities-container .transport-icon {\n    display: flex;\n    align-self: center;\n  }\n}\n\n.ItinerarySingleRow_amenities-container {\n  display: flex;\n  flex-direction: row;\n  gap: 5px;\n}\n\n.ItinerarySingleRow_price-per-pax-container {\n  display: flex;\n  flex-direction: column;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 18px;\n}\n\n.mobile-travel-vehicle-row {\n  display: none;\n  flex-direction: row;\n  justify-content: space-between;\n  width: 100%;\n}\n@media screen and (max-width: 414px) {\n  .mobile-travel-vehicle-row {\n    display: flex;\n  }\n}\n\n.mobile-vehicle-label {\n  display: none;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 15px;\n  color: #858484;\n}\n@media screen and (max-width: 414px) {\n  .mobile-vehicle-label {\n    display: flex;\n  }\n}";
  styleInject(css_248z$T);
  var EXPRESS_AT_HOME_CLASSBAND = "Home Service";
  var REFUNDABLE_CLASSBAND = "Refundable";
  var expressMap = "/media/5d66451426363c77.png";
  var css_248z$U = ".classbandsdescription-wrapper {\n  display: block;\n}\n.classbandsdescription-wrapper .classband-wrapper {\n  padding: 10px 0;\n}\n.classbandsdescription-wrapper .classband-wrapper .classband-item {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n.classbandsdescription-wrapper .classband-wrapper .classband-item svg {\n  width: 30px;\n  margin-right: 5px;\n}\n.classbandsdescription-wrapper .classband-wrapper .classband-item p {\n  padding: 0;\n  margin: 0;\n  font-family: \"Source Sans Pro\", sans-serif;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 12px;\n  line-height: 24px;\n  color: #3c3835;\n}\n.classbandsdescription-wrapper .classband-wrapper .classband-item .svgLeft {\n  left: 0;\n}\n\n.amenitis-wrapper {\n  display: flex;\n  border-bottom: 1px solid rgba(60, 56, 53, 0.15);\n}\n@media screen and (max-width: 600px) {\n  .amenitis-wrapper {\n    flex-direction: column;\n  }\n}\n.amenitis-wrapper .landline-amenitis {\n  flex: 1;\n}\n.amenitis-wrapper .title {\n  height: 40px;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 100%;\n  border-bottom: 1px solid #e5e5e5;\n  margin-bottom: 15px;\n  display: flex;\n  align-items: center;\n}\n\n.bus-terms-conditions {\n  width: 100%;\n  display: block;\n}\n.bus-terms-conditions .comment-item {\n  font-family: \"Source Sans Pro\", sans-serif;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 10px;\n  text-align: center;\n  color: #3c3835;\n  line-height: 40px;\n}\n.bus-terms-conditions .comment-item a {\n  font-weight: bold;\n  color: #3c3835;\n}";
  styleInject(css_248z$U);
  var css_248z$V = ".luggage-container {\n  flex: 1;\n}\n.luggage-container .title {\n  height: 40px;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 100%;\n  border-bottom: 1px solid #e5e5e5;\n  margin-bottom: 15px;\n}\n.luggage-container .flight-amenitis-all-items {\n  padding: 10px 0;\n}";
  styleInject(css_248z$V);

  var Luggage = function Luggage(_ref) {
    var luggage = _ref.luggage,
        loading = _ref.loading;
    if (loading) return /*#__PURE__*/React__default.createElement(Loading, {
      small: true
    });
    var luggageClass = classNames("luggage-container");
    var definitions = luggage.baggage.definitions;
    return /*#__PURE__*/React__default.createElement("div", {
      className: luggageClass
    }, /*#__PURE__*/React__default.createElement("h4", {
      className: "title"
    }, "Flight luggage specification"), /*#__PURE__*/React__default.createElement("div", {
      className: "flight-amenitis-all-items"
    }, definitions[LUGGAGE_HAND_BAG].map(function (item) {
      return /*#__PURE__*/React__default.createElement(LuggageItem, {
        weight: item.restrictions.weight,
        price: item.price.amount,
        category: item.category
      });
    }), definitions[LUGGAGE_HOLD_BAG].map(function (item) {
      return /*#__PURE__*/React__default.createElement(LuggageItem, {
        weight: item.restrictions.weight,
        price: item.price.amount,
        category: item.category
      });
    })));
  };

  Luggage.propTypes = {
    luggage: PropTypes__default.shape({
      baggage: PropTypes__default.shape({
        definitions: PropTypes__default.shape((_PropTypes__default$s = {}, _defineProperty(_PropTypes__default$s, LUGGAGE_HAND_BAG, PropTypes__default.instanceOf(Array)), _defineProperty(_PropTypes__default$s, LUGGAGE_HOLD_BAG, PropTypes__default.instanceOf(Array)), _PropTypes__default$s))
      })
    }),
    loading: PropTypes__default.bool
  };
  Luggage.defaultProps = {
    luggage: {
      baggage: {
        definitions: (_definitions = {}, _defineProperty(_definitions, LUGGAGE_HAND_BAG, []), _defineProperty(_definitions, LUGGAGE_HOLD_BAG, []), _definitions)
      }
    },
    loading: false
  };

  var ReactMarkdown = require("react-markdown");

  var ClassbandsDescription = function ClassbandsDescription(_ref) {
    var classband = _ref.classband,
        luggage = _ref.luggage,
        loading = _ref.loading,
        flightSearchActive = _ref.flightSearchActive;
    var classbandsdescriptionClass = classNames("classbandsdescription-wrapper");

    if (loading) {
      return /*#__PURE__*/React__default.createElement(Loading, {
        small: true
      });
    }

    return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("div", {
      className: "amenitis-wrapper"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "landline-amenitis"
    }, /*#__PURE__*/React__default.createElement("h4", {
      className: "title"
    }, "Landline Amenities"), /*#__PURE__*/React__default.createElement("div", {
      className: classbandsdescriptionClass
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "classband-wrapper"
    }, classband.description.filter(function (item) {
      return item.texttype === "";
    }).map(function (item) {
      return /*#__PURE__*/React__default.createElement("div", {
        className: "classband-item",
        key: item.Text
      }, /*#__PURE__*/React__default.createElement(reactFontawesome.FontAwesomeIcon, {
        icon: item.icon.toString().substring(3)
      }), /*#__PURE__*/React__default.createElement(ReactMarkdown, {
        source: item.Text,
        escapeHtml: false
      }));
    })))), flightSearchActive && /*#__PURE__*/React__default.createElement(Luggage, {
      luggage: luggage
    })), /*#__PURE__*/React__default.createElement("div", {
      className: "bus-terms-conditions"
    }, classband.description.filter(function (item) {
      return item.texttype === "comment";
    }).map(function (item) {
      return /*#__PURE__*/React__default.createElement("div", {
        className: "comment-item",
        key: item.Text,
        dangerouslySetInnerHTML: {
          __html: item.Text
        }
      });
    })));
  };

  ClassbandsDescription.propTypes = {
    classband: PropTypes__default.instanceOf(Object),
    luggage: PropTypes__default.instanceOf(Object),
    loading: PropTypes__default.bool,
    flightSearchActive: PropTypes__default.bool
  };
  ClassbandsDescription.defaultProps = {
    classband: {},
    luggage: undefined,
    loading: false,
    flightSearchActive: false
  };
  var css_248z$W = ".sold-out-button-container {\n  border-radius: 6px;\n  border: 1px solid #d9d9d9;\n  padding: 20px 12px;\n  position: relative;\n  right: -20px;\n  background-color: #ffffff;\n}\n.sold-out-button-container .sold-out-button-wrapper {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  cursor: not-allowed;\n  transition: background 0.2s ease;\n  background-color: #98908a;\n  color: white;\n  border-radius: 6px;\n  font-family: \"Source Sans Pro\", sans-serif;\n  font-style: normal;\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 20px;\n  padding: 12px 12px;\n}";
  styleInject(css_248z$W);

  var SoldOutButton = function SoldOutButton() {
    return /*#__PURE__*/React__default.createElement("div", {
      className: "sold-out-button-container"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "sold-out-button-wrapper"
    }, "Sold out"));
  };

  SoldOutButton.propTypes = {};
  SoldOutButton.defaultProps = {};
  var css_248z$X = ".ticket-button-container {\n  border: 1px solid #d9d9d9;\n  border-radius: 6px;\n  position: relative;\n  width: 100%;\n  padding: 20px 12px;\n  right: -20px;\n  background: #fff;\n}\n.ticket-button-container .ticket-button-wrapper {\n  transition: background 0.2s ease;\n  border-radius: 6px;\n  font-family: \"Source Sans Pro\", sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 20px;\n  background-color: #fab500;\n  color: #3c3835;\n  padding: 10px 12px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  cursor: pointer;\n}\n@media (max-width: 415px) {\n  .ticket-button-container .ticket-button-wrapper {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n  .ticket-button-container .ticket-button-wrapper .ticket-button-type {\n    margin-top: 0px;\n  }\n  .ticket-button-container .ticket-button-wrapper .ticket-button-price {\n    margin-left: 8px;\n  }\n}\n.ticket-button-container .loyalty-style {\n  line-height: 15px;\n  display: flex;\n  align-items: flex-end;\n}\n.ticket-button-container .ticket-button-white {\n  display: flex;\n  flex-direction: row;\n  background-color: #ffffff;\n  border: 1px solid #3c3835;\n  color: #3c3835;\n}\n.ticket-button-container .ticket-button-express-home {\n  display: flex;\n  flex-direction: row;\n  background-color: #4d4d4d;\n  color: #fab500;\n}\n@media screen and (max-width: 450px) {\n  .ticket-button-container .ticket-button-white {\n    flex-wrap: wrap;\n  }\n}\n.ticket-button-container .ticket-button-white:hover,\n.ticket-button-container .ticket-button-white-hovered {\n  border-color: #fab500;\n  background-color: transparent;\n}\n.ticket-button-container .ticket-button-express-home:hover,\n.ticket-button-container .ticket-button-express-home-hovered {\n  background-color: #fab500;\n  color: #4d4d4d;\n}\n.ticket-button-container .ticket-button-loyalty {\n  background-color: #fab500;\n  color: #3c3835;\n}\n.ticket-button-container .ticket-button-loyalty:hover {\n  background-color: #3c3835;\n  color: #fab500;\n}\n.ticket-button-container .ticket-button-type {\n  margin-top: 0px;\n}\n@media (max-width: 405px) {\n  .ticket-button-container .ticket-button-type {\n    margin-top: 5px;\n  }\n}\n.ticket-button-container .ticket-button-price {\n  text-align: right;\n}\n.ticket-button-container .icon-wrapper {\n  display: flex;\n  flex-direction: row;\n}\n.ticket-button-container .bus-icon {\n  padding-top: 1.5px;\n  padding-left: 5px;\n}\n.ticket-button-container .bus-icon-preview {\n  fill: #fab500;\n}\n.ticket-button-container .ticket-button-summary-preview {\n  background-color: transparent;\n  color: #fab500;\n  border-radius: 0px;\n  border: none;\n  border-top: 1px solid #3c3835;\n  min-width: 170px;\n  padding: 5px 0px !important;\n  justify-content: space-between;\n}\n.ticket-button-container .ticket-button-summary-preview .ticket-button-price {\n  color: #3c3835;\n}\n.ticket-button-container .ticket-button-summary-preview .bus-icon {\n  fill: #fab500;\n}\n.ticket-button-container .ticket-button-summary-preview:hover {\n  background-color: transparent;\n  color: #fab500;\n  cursor: auto;\n}\n.ticket-button-container .ticket-button-price-starts-at {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 14px;\n}\n.ticket-button-container .price-big {\n  font-weight: bold;\n  font-size: 24px;\n  line-height: 32px;\n}\n.ticket-button-container .round-trip-text {\n  font-size: 16px;\n  line-height: 24px;\n}\n.ticket-button-container .ticket-button-starts-at {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n}\n.ticket-button-container .ticket-button-starts-at-look {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.ticket-button-container .ticket-button-starts-at-look .icon-wrapper {\n  align-items: center;\n}\n.ticket-button-container .ticket-button-starts-at-look .icon-wrapper .bus-icon {\n  padding-left: 0px;\n  margin-left: 8px;\n}\n.ticket-button-container .passenger-types-price-wrapper {\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 7px;\n}\n.ticket-button-container .passenger-types-price-wrapper.oneWay {\n  margin-bottom: 0px;\n}\n@media screen and (max-width: 960px) {\n  .ticket-button-container .passenger-types-price-wrapper {\n    flex-direction: row;\n    margin-top: 8px;\n  }\n}\n.ticket-button-container .seats-left-container {\n  font-weight: 400;\n  font-size: 11px;\n  line-height: 12px;\n  text-align: center;\n  text-transform: uppercase;\n  padding: 0 12px;\n  margin-top: 10px;\n}\n\n.ticket-sale {\n  background: url(https://content.landline.com/wp-content/uploads/2024/02/sale-background.png);\n  background-size: 40%;\n  background-repeat: no-repeat;\n  background-color: white;\n}";
  styleInject(css_248z$X);
  var css_248z$Y = ".price-per-passenger-type-container {\n  display: flex;\n  flex-direction: row;\n  height: 22px;\n}\n.price-per-passenger-type-container.adult {\n  margin-top: 18px;\n}\n.price-per-passenger-type-container.child {\n  margin-top: 11px;\n}\n.price-per-passenger-type-container .passenger-type-price {\n  font-size: 22px;\n  font-weight: 600;\n}\n.price-per-passenger-type-container .passenger-type-text {\n  font-size: 14px;\n  margin-left: 6px;\n}\n@media screen and (max-width: 960px) {\n  .price-per-passenger-type-container.adult {\n    margin-top: 0px;\n  }\n  .price-per-passenger-type-container.child {\n    margin-top: 0px;\n    margin-left: 8px;\n  }\n  .price-per-passenger-type-container .passenger-type-price {\n    font-size: 16px;\n  }\n}";
  styleInject(css_248z$Y);

  var PricePerPassengerType = function PricePerPassengerType(_ref) {
    var price = _ref.price,
        passengerType = _ref.passengerType;
    var containerClass = classNames("price-per-passenger-type-container", [passengerType]);
    return /*#__PURE__*/React__default.createElement("div", {
      className: containerClass
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "passenger-type-price"
    }, priceFormat(price, "USD")), /*#__PURE__*/React__default.createElement("div", {
      className: "passenger-type-text"
    }, "(per ".concat(passengerType, ")")));
  };

  PricePerPassengerType.propTypes = {
    price: PropTypes__default.number.isRequired,
    passengerType: PropTypes__default.string.isRequired
  };
  PricePerPassengerType.defaultProps = {};

  var TicketButton = function TicketButton(_ref) {
    var priceDollars = _ref.priceDollars,
        selectedItinerary = _ref.selectedItinerary,
        pricePoints = _ref.pricePoints,
        onClick = _ref.onClick,
        classband = _ref.classband,
        isRefundable = _ref.isRefundable,
        useLoyalty = _ref.useLoyalty,
        currency = _ref.currency,
        priceCeil = _ref.priceCeil,
        summaryPreview = _ref.summaryPreview,
        passengersAdults = _ref.passengersAdults,
        passengersChildrens = _ref.passengersChildrens,
        segments = _ref.segments,
        passengersInfants = _ref.passengersInfants,
        startsAt = _ref.startsAt,
        oneWay = _ref.oneWay,
        isExpressHome = _ref.isExpressHome,
        summaryPrice = _ref.summaryPrice,
        seatsLeft = _ref.seatsLeft;
    var passegersCount = passengersAdults + passengersChildrens + passengersInfants;
    var ticketButtonWrapper = classNames("ticket-button-wrapper", {
      "ticket-button-white": isRefundable,
      "ticket-button-summary-preview": summaryPreview,
      "ticket-button-container-hovered": selectedItinerary && !isRefundable && !isExpressHome,
      "ticket-button-white-hovered": selectedItinerary && isRefundable,
      "ticket-button-loyalty": useLoyalty && !isRefundable && !isExpressHome,
      "ticket-button-loyalty-hovered": useLoyalty && !isRefundable && !isExpressHome,
      "ticket-button-starts-at-look": !summaryPreview,
      "ticket-button-express-home": isExpressHome,
      "ticket-button-express-home-hovered": selectedItinerary && isExpressHome
    });
    var containerClass = "";

    if (classband === "Sale") {
      containerClass = "ticket-button-container ticket-sale";
    } else {
      containerClass = "ticket-button-container";
    }

    return /*#__PURE__*/React__default.createElement("div", {
      className: containerClass
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "ticket-button-price-starts-at"
    }, /*#__PURE__*/React__default.createElement("span", {
      className: "price-big"
    }, /*#__PURE__*/React__default.createElement(Price, {
      ceil: priceCeil,
      currency: currency,
      useLoyalty: useLoyalty,
      showDecimals: false,
      amount: useLoyalty ? pricePoints / passegersCount : priceDollars
    })), "\xA0"), /*#__PURE__*/React__default.createElement("div", {
      className: ticketButtonWrapper,
      onClick: onClick
    }, /*#__PURE__*/React__default.createElement(TicketClassband, {
      classband: classband,
      isRefundable: isRefundable,
      segments: segments,
      summaryPreview: summaryPreview
    })), seatsLeft <= 3 ? /*#__PURE__*/React__default.createElement("div", {
      className: "seats-left-container"
    }, "".concat(seatsLeft, " left at ").concat(useLoyalty ? "" : "$").concat(priceFormat(useLoyalty ? pricePoints / passegersCount : priceDollars, currency, undefined, priceCeil, undefined, "hide")).concat(useLoyalty ? "m" : "")) : null);
  };

  TicketButton.propTypes = {
    segments: PropTypes__default.instanceOf(Array).isRequired,
    priceDollars: PropTypes__default.string,
    isRefundable: PropTypes__default.bool,
    useLoyalty: PropTypes__default.bool,
    selectedItinerary: PropTypes__default.bool,
    pricePoints: PropTypes__default.string,
    onClick: PropTypes__default.func,
    classband: PropTypes__default.string,
    currency: PropTypes__default.string,
    priceCeil: PropTypes__default.string,
    summaryPreview: PropTypes__default.bool,
    passengersAdults: PropTypes__default.number,
    passengersChildrens: PropTypes__default.number,
    passengersInfants: PropTypes__default.number,
    startsAt: PropTypes__default.bool,
    oneWay: PropTypes__default.bool,
    isExpressHome: PropTypes__default.bool,
    summaryPrice: PropTypes__default.instanceOf(Object),
    seatsLeft: PropTypes__default.number
  };
  TicketButton.defaultProps = {
    priceDollars: "",
    isRefundable: false,
    useLoyalty: false,
    selectedItinerary: false,
    pricePoints: "",
    onClick: function onClick() {},
    classband: "",
    currency: "USD",
    priceCeil: "",
    summaryPreview: false,
    passengersAdults: 1,
    passengersChildrens: 0,
    passengersInfants: 0,
    startsAt: false,
    oneWay: false,
    isExpressHome: false,
    summaryPrice: {},
    seatsLeft: 3
  };
  var css_248z$Z = ".React-modal {\n  font-family: \"Source Sans Pro\", sans-serif;\n}\n.React-modal .React-modal-header-border {\n  border-bottom: 1px solid #3c3835;\n  padding-bottom: 10px;\n}\n.React-modal .React-modal-header-border .React-modal--dialog-content {\n  padding-top: 20px;\n}\n.React-modal .React-modal-header {\n  position: relative;\n  display: flex;\n  align-items: center;\n  font-style: normal;\n  font-weight: 600;\n  font-size: 24px;\n  line-height: 100%;\n  height: 50px;\n}\n.React-modal .modal-absolute-icon svg {\n  right: 16px;\n  top: 16px;\n  transform: none;\n  fill: #999999;\n}\n.React-modal .React-modal--dialog-content {\n  font-style: normal;\n  font-weight: normal;\n  font-size: 16px;\n  line-height: 150%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n.React-modal .React-modal--dialog-buttons {\n  padding-top: 20px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n.React-modal .React-modal--dialog-buttons .React-modal--dialog-cancel-button {\n  padding-top: 10px;\n}";
  styleInject(css_248z$Z);
  var dialogStyle = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      backgroundColor: "rgba(0, 0, 0, 0.3)",
      zIndex: 7000,
      overflow: "auto"
    },
    content: {
      width: 375,
      maxWidth: "100%",
      position: "static",
      top: "unset",
      left: "unset",
      right: "unset",
      bottom: "unset",
      margin: "0 20px",
      overflow: "auto",
      maxHeight: "calc(100vh - 100px)"
    }
  };

  var Modal = function Modal(_ref) {
    var isOpen = _ref.isOpen,
        style = _ref.style,
        message = _ref.message,
        onSuccess = _ref.onSuccess,
        onCancel = _ref.onCancel,
        showFooterButtons = _ref.showFooterButtons,
        render = _ref.render,
        title = _ref.title,
        successButtonText = _ref.successButtonText,
        cancelButtonText = _ref.cancelButtonText,
        shouldCloseOnEsc = _ref.shouldCloseOnEsc,
        shouldCloseOnOverlayClick = _ref.shouldCloseOnOverlayClick;
    var ReactModalHeader = classNames("React-modal-header", {
      "React-modal-header-border": !!title
    });
    return /*#__PURE__*/React__default.createElement(ReactModal, {
      isOpen: isOpen,
      shouldCloseOnEsc: shouldCloseOnEsc,
      shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
      overlayClassName: "React-modal",
      style: {
        content: _objectSpread(_objectSpread({}, dialogStyle.content), style.content),
        overlay: _objectSpread(_objectSpread({}, dialogStyle.overlay), style.overlay)
      }
    }, title && /*#__PURE__*/React__default.createElement("div", {
      className: ReactModalHeader
    }, title, /*#__PURE__*/React__default.createElement(Icon, {
      name: "closeButtonIcon",
      width: "15",
      height: "15",
      onClick: onCancel
    })), !title && /*#__PURE__*/React__default.createElement("div", {
      className: "modal-absolute-icon"
    }, /*#__PURE__*/React__default.createElement(Icon, {
      name: "closeButtonIcon",
      width: "15",
      height: "15",
      onClick: onCancel
    })), /*#__PURE__*/React__default.createElement("div", {
      className: "React-modal--dialog-content"
    }, render ? render() : message), showFooterButtons && /*#__PURE__*/React__default.createElement("div", {
      className: "React-modal--dialog-buttons"
    }, /*#__PURE__*/React__default.createElement(Button, {
      fullWidth: true,
      type: "primary",
      onClick: onSuccess
    }, successButtonText), /*#__PURE__*/React__default.createElement(Button, {
      className: "React-modal--dialog-cancel-button",
      fullWidth: true,
      type: "destructive",
      onClick: onCancel
    }, cancelButtonText)));
  };

  Modal.propTypes = {
    render: PropTypes__default.element,
    message: PropTypes__default.string,
    showFooterButtons: PropTypes__default.bool,
    title: PropTypes__default.string,
    successButtonText: PropTypes__default.string,
    cancelButtonText: PropTypes__default.string,
    isOpen: PropTypes__default.bool,
    style: PropTypes__default.shape({
      overlay: PropTypes__default.instanceOf(Object),
      content: PropTypes__default.instanceOf(Object)
    }),
    onSuccess: PropTypes__default.func,
    onCancel: PropTypes__default.func,
    shouldCloseOnEsc: PropTypes__default.bool,
    shouldCloseOnOverlayClick: PropTypes__default.bool
  };
  Modal.defaultProps = {
    render: undefined,
    message: "",
    showFooterButtons: true,
    title: "",
    successButtonText: "OK",
    cancelButtonText: "Cancel",
    onSuccess: function onSuccess() {},
    isOpen: false,
    style: {
      overlay: {},
      content: {}
    },
    onCancel: function onCancel() {},
    shouldCloseOnEsc: false,
    shouldCloseOnOverlayClick: false
  };
  var icons$1 = {
    "fa-suitcase": LuggageIcon,
    "fa-wifi": WifiIcon
  };

  function Amenities(_ref) {
    var classband = _ref.classband,
        transportIcon = _ref.transportIcon,
        motorcoach = _ref.motorcoach;

    if (!classband) {
      return null;
    }

    var title = classband.description.filter(function (_ref2) {
      var icon = _ref2.icon;
      return icons$1[icon];
    }).map(function (_ref3) {
      var Text = _ref3.Text;
      return Text;
    }).join(", ");
    return /*#__PURE__*/React__default.createElement("div", {
      className: "ItinerarySingleRow_amenities-container",
      title: "Onboard amenities include: ".concat(title)
    }, classband.description.map(function (_ref4) {
      var text = _ref4.text,
          icon = _ref4.icon;
      var Icon = icons$1[icon];

      if (!Icon) {
        return null;
      }

      return /*#__PURE__*/React__default.createElement(Icon, {
        key: "".concat(icon, "-").concat(text)
      });
    }), motorcoach ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(BathroomIcon, null), /*#__PURE__*/React__default.createElement(WheelchairIcon, null)) : '', /*#__PURE__*/React__default.createElement("span", {
      className: "transport-icon"
    }, transportIcon));
  }

  var ItinerarySingleRow = function ItinerarySingleRow(_ref) {
    var departureCode = _ref.departureCode,
        arrivalCode = _ref.arrivalCode,
        segments = _ref.segments,
        tickets = _ref.tickets,
        itineraryIndex = _ref.itineraryIndex,
        selectedItineraryIndex = _ref.selectedItineraryIndex,
        selectedTicketIndex = _ref.selectedTicketIndex,
        classbands = _ref.classbands,
        currencySymbol = _ref.currencySymbol,
        onTicketClicked = _ref.onTicketClicked,
        seatsLeft = _ref.seatsLeft,
        segmentIndex = _ref.segmentIndex,
        summaryPrice = _ref.summaryPrice,
        useLoyalty = _ref.useLoyalty,
        priceCeil = _ref.priceCeil,
        passengersAdults = _ref.passengersAdults,
        passengersChildrens = _ref.passengersChildrens,
        passengersInfants = _ref.passengersInfants,
        summaryPreview = _ref.summaryPreview,
        showLegConnectionDate = _ref.showLegConnectionDate,
        flightSearchActive = _ref.flightSearchActive,
        layoverTimes = _ref.layoverTimes,
        collapsibleLeft = _ref.collapsibleLeft,
        getFlightDetails = _ref.getFlightDetails,
        luggage = _ref.luggage,
        loading = _ref.loading,
        onCollapse = _ref.onCollapse,
        isCollapsableOpen = _ref.isCollapsableOpen,
        totalTripTime = _ref.totalTripTime,
        returnFlights = _ref.returnFlights,
        bookingToken = _ref.bookingToken,
        startsAt = _ref.startsAt,
        excludeFlight = _ref.excludeFlight,
        reservationDepart = _ref.reservationDepart,
        oneWay = _ref.oneWay,
        showMapOnReturnScreen = _ref.showMapOnReturnScreen;
    var selectedItinerary = selectedItineraryIndex === itineraryIndex;

    var _React$useState27 = React.useState(false),
        _React$useState28 = _slicedToArray(_React$useState27, 2),
        showMapModal = _React$useState28[0],
        setShowMapModal = _React$useState28[1];

    var _React$useState29 = React.useState(undefined),
        _React$useState30 = _slicedToArray(_React$useState29, 2),
        selectedIndex = _React$useState30[0],
        setSelectedIndex = _React$useState30[1];

    var itinerarySingleRowClass = classNames("itinerarySingleRow-container", {
      "ItinerarySingleRow-selected": selectedItinerary,
      "container-black-car-background": isBlackCar(segments),
      "summary-preview": summaryPreview
    });
    var ItineraryFlexContainer = classNames("ItinerarySingleRow-flex-container", {
      "hide-ticket-price": summaryPreview
    });
    var numberOfPassengersClass = classNames("number-of-passengers", {
      "number-of-passengers-black-car": isBlackCar(segments)
    });

    var onTicketButtonClick = function onTicketButtonClick(ticketId) {
      onTicketClicked(tickets[ticketId], ticketId, itineraryIndex, segmentIndex, segments, summaryPrice, layoverTimes, totalTripTime, returnFlights, bookingToken);
    };

    var itinerarySingleRowContainer = classNames("itinerarySingleRow-ticket-button-container", {
      "itinerarySingleRow-ticket-button-container-starts-at": startsAt
    });
    preloadImage(expressMap);
    var visiblePrice = summaryPreview ? [summaryPrice] : summaryPrice;
    var firstSummaryPrice = visiblePrice && visiblePrice.length && visiblePrice[0];

    if (!firstSummaryPrice) {
      firstSummaryPrice = {};
    }

    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
      className: itinerarySingleRowClass
    }, /*#__PURE__*/React__default.createElement("div", {
      className: ItineraryFlexContainer
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "itinerarySingleRow-leg-connection-container"
    }, /*#__PURE__*/React__default.createElement(LegConnection, {
      departureCode: departureCode,
      arrivalCode: arrivalCode,
      segments: segments,
      layoverTimes: layoverTimes,
      showLegConnectionDate: showLegConnectionDate,
      ticketSelect: !summaryPreview,
      totalTripTime: totalTripTime
    }), /*#__PURE__*/React__default.createElement("div", {
      className: "ItinerarySingleRow_footer"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "mobile-travel-vehicle-row"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "mobile-travel-time"
    }, "Trip Duration: ", getDurationTime(segments[0].duration)), /*#__PURE__*/React__default.createElement("div", {
      className: "mobile-vehicle-label"
    }, "Vehicle: ", containsBus([segments[0]]) ? "Motorcoach" : "Express")), /*#__PURE__*/React__default.createElement(Amenities, {
      classband: classbands.find(function (band) {
        return band.name === firstSummaryPrice.classband;
      }),
      transportIcon: getTransportIcon(segments[0]),
      motorcoach: containsBus([segments[0]]) ? true : false
    }), !firstSummaryPrice.classband ? /*#__PURE__*/React__default.createElement("div", null) : null)), !summaryPreview ? /*#__PURE__*/React__default.createElement("div", {
      className: "itinerarySingleRow-ticket-button-container-wrapper"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: itinerarySingleRowContainer
    }, seatsLeft === 0 ? /*#__PURE__*/React__default.createElement(SoldOutButton, null) : visiblePrice.map(function (summary, index) {
      var price = summary.landline_price + (!excludeFlight ? summary.flight_price || 0 : 0);
      return /*#__PURE__*/React__default.createElement(TicketButton, {
        segments: segments,
        oneWay: oneWay,
        startsAt: startsAt,
        reservationDepart: reservationDepart,
        hasReturnFlight: returnFlights.length > 0,
        selectedItinerary: !selectedTicketIndex && selectedItinerary,
        priceDollars: price,
        pricePoints: summary.price_in_miles,
        priceCeil: priceCeil,
        currency: currencySymbol,
        onClick: summary.classband === EXPRESS_AT_HOME_CLASSBAND && (reservationDepart || showMapOnReturnScreen) ? function () {
          setShowMapModal(true);
          setSelectedIndex(index);
        } : function () {
          onTicketButtonClick(index);
        },
        classband: summary.classband,
        isRefundable: summary.classband === REFUNDABLE_CLASSBAND,
        isExpressHome: summary.classband === EXPRESS_AT_HOME_CLASSBAND,
        useLoyalty: useLoyalty,
        passengersAdults: passengersAdults,
        passengersChildrens: passengersChildrens,
        passengersInfants: passengersInfants,
        summaryPrice: visiblePrice[0],
        seatsLeft: seatsLeft
      });
    }))) : null), /*#__PURE__*/React__default.createElement(Modal, {
      style: {
        content: {
          position: "relative",
          width: 480,
          height: 528,
          padding: "48px 20px 28px 20px"
        }
      },
      showFooterButtons: false,
      isOpen: showMapModal,
      onCancel: function onCancel() {
        setShowMapModal(false);
      },
      render: function render() {
        return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
          className: "map-modal-container"
        }, /*#__PURE__*/React__default.createElement("div", {
          className: "map-modal-text"
        }, "This service option operates in a limited radius within St. Cloud. Check out the map below to see if home pick-up/drop-off is available in your area."), /*#__PURE__*/React__default.createElement("img", {
          src: expressMap,
          alt: "",
          width: "440",
          height: "310"
        }), /*#__PURE__*/React__default.createElement("div", {
          className: "map-modal-buttons-container"
        }, /*#__PURE__*/React__default.createElement(Button, {
          fullWidth: true,
          type: "primary",
          margin: "0 12px 0 0",
          onClick: function onClick() {
            return setShowMapModal(false);
          }
        }, "Close"), /*#__PURE__*/React__default.createElement(Button, {
          fullWidth: true,
          type: "primary",
          margin: "0 0 0 0",
          onClick: function onClick() {
            return onTicketButtonClick(selectedIndex);
          }
        }, "Continue"))));
      }
    })));
  };

  ItinerarySingleRow.propTypes = {
    onCollapse: PropTypes__default.func.isRequired,
    isCollapsableOpen: PropTypes__default.bool,
    priceCeil: PropTypes__default.bool,
    departureCode: PropTypes__default.string.isRequired,
    arrivalCode: PropTypes__default.string.isRequired,
    segments: PropTypes__default.instanceOf(Array).isRequired,
    tickets: PropTypes__default.instanceOf(Array),
    itineraryIndex: PropTypes__default.string.isRequired,
    selectedItineraryIndex: PropTypes__default.string.isRequired,
    selectedTicketIndex: PropTypes__default.string.isRequired,
    classbands: PropTypes__default.instanceOf(Object).isRequired,
    currencySymbol: PropTypes__default.string.isRequired,
    onTicketClicked: PropTypes__default.func.isRequired,
    seatsLeft: PropTypes__default.string.isRequired,
    segmentIndex: PropTypes__default.string.isRequired,
    useLoyalty: PropTypes__default.bool,
    passengersAdults: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.number]).isRequired,
    passengersChildrens: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.number]).isRequired,
    passengersInfants: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.number]).isRequired,
    summaryPreview: PropTypes__default.bool,
    flightSearchActive: PropTypes__default.bool,
    summaryPrice: PropTypes__default.instanceOf(Array),
    layoverTimes: PropTypes__default.instanceOf(Array),
    collapsibleLeft: PropTypes__default.bool,
    getFlightDetails: PropTypes__default.func,
    luggage: PropTypes__default.instanceOf(Object),
    loading: PropTypes__default.bool,
    showLegConnectionDate: PropTypes__default.bool,
    totalTripTime: PropTypes__default.string,
    returnFlights: PropTypes__default.instanceOf(Array),
    bookingToken: PropTypes__default.string,
    startsAt: PropTypes__default.bool,
    excludeFlight: PropTypes__default.bool,
    reservationDepart: PropTypes__default.bool,
    oneWay: PropTypes__default.bool,
    showMapOnReturnScreen: PropTypes__default.bool
  };
  ItinerarySingleRow.defaultProps = {
    isCollapsableOpen: false,
    useLoyalty: false,
    priceCeil: false,
    summaryPreview: false,
    flightSearchActive: false,
    summaryPrice: [],
    layoverTimes: [],
    collapsibleLeft: false,
    getFlightDetails: function getFlightDetails() {},
    luggage: undefined,
    loading: false,
    showLegConnectionDate: false,
    tickets: [{
      classband: {}
    }],
    totalTripTime: undefined,
    returnFlights: [],
    bookingToken: "",
    startsAt: false,
    excludeFlight: false,
    reservationDepart: false,
    oneWay: false,
    showMapOnReturnScreen: false
  };
  var css_248z$_ = ".locationForm-container {\n  position: relative;\n}\n.locationForm-container .inputFieldSets-container {\n  display: flex;\n}\n.locationForm-container .inputFieldSets-container .inputfield-hasIcon {\n  padding-right: 50px;\n}\n.locationForm-container .inputFieldSets-container .close-icon {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 40px;\n  height: 40px;\n  position: absolute;\n  cursor: pointer;\n  right: 0px;\n  top: 53%;\n  opacity: 0.5;\n  transform: translateY(-50%);\n}\n.locationForm-container .inputFieldSets-container .close-icon .close-hover {\n  width: 25px;\n  height: 24px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-right: 0px;\n}\n.locationForm-container .inputFieldSets-container .close-icon .close-hover:hover {\n  background: #dbdbdb;\n  border-radius: 50%;\n}\n.locationForm-container .inputFieldSets-container .close-icon svg {\n  top: unset;\n  right: unset;\n  transform: unset;\n  -webkit-transform: unset;\n  position: relative;\n}\n.locationForm-container .inputFieldSets-container .toogle-icon {\n  width: 40px;\n  height: 40px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  right: 0px;\n  top: 50%;\n  transform: translateY(-50%);\n}\n.locationForm-container .inputFieldSets-container .toogle-icon svg {\n  top: unset;\n  right: unset;\n  transform: unset;\n  -webkit-transform: unset;\n  position: relative;\n}\n.locationForm-container .inputFieldSets-container div:nth-child(1) {\n  margin-right: 10px;\n}\n.locationForm-container .inputFieldSets-container div:nth-child(3) {\n  margin-left: 10px;\n}\n.locationForm-container .locationListPicker {\n  position: absolute;\n  background-color: #fff;\n  z-index: 2;\n  width: calc(100% - 10px);\n  display: none;\n  /* Desktop default */\n  top: 50px;\n}\n.locationForm-container .locationListPicker.isListOpened {\n  display: block;\n}\n\n@media only screen and (max-width: 400px) {\n  .locationForm-container .inputFieldSets-container div:nth-child(1) {\n    margin-right: 4px;\n  }\n  .locationForm-container .inputFieldSets-container div:nth-child(3) {\n    margin-left: 4px;\n  }\n}\n.full-screen-panel {\n  position: fixed;\n  top: 96px;\n  left: 0;\n  min-height: 100%;\n  height: -webkit-fill-available;\n  min-height: -webkit-fill-available;\n  max-height: -webkit-fill-available;\n  width: 100%;\n  background-color: white;\n  z-index: 1050;\n  padding-left: 6px;\n  padding-right: 6px;\n  padding-top: 40px;\n  overflow: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n@media (max-width: 768px) {\n  .locationListPicker {\n    position: fixed !important;\n    top: 180px !important;\n    padding-bottom: env(safe-area-inset-bottom);\n    height: calc(100% - 180px);\n    overflow-y: auto;\n  }\n}\n\n.close-fullscreen-button {\n  position: fixed;\n  top: 100px;\n  right: 16px;\n  background: none;\n  border: none;\n  padding: 6px;\n  font-size: 12px;\n  font-weight: bold;\n  cursor: pointer;\n  z-index: 1002;\n}\n\n@media (max-width: 768px) {\n  .ReactModal__Body--open {\n    overflow: hidden;\n  }\n  .modal-content {\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    padding: 16px;\n  }\n  .modal-content .inputFieldSets-container {\n    position: sticky;\n    top: 96px !important;\n    z-index: 1002;\n    padding-bottom: 16px;\n    border-bottom: 1px solid #eee;\n  }\n  .modal-content .modal-location-list {\n    flex: 1;\n    overflow-y: auto;\n    -webkit-overflow-scrolling: touch;\n    padding-bottom: env(safe-area-inset-bottom);\n  }\n  .close-fullscreen-button {\n    position: absolute;\n    top: 4px;\n    right: 16px;\n    z-index: 3;\n    background-color: transparent;\n    border: none;\n    font-size: 1rem;\n    padding: 0.5rem;\n    cursor: pointer;\n    color: #000; /* ensures it's not rendered as a link color on iOS */\n    appearance: none;\n    -webkit-appearance: none;\n    text-decoration: none;\n    outline: none;\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0.1); /* bring back the light gray iOS tap highlight */\n  }\n}";
  styleInject(css_248z$_);
  var css_248z$$ = ".route-switcher {\n  width: 40px;\n  height: 40px;\n  flex-shrink: 0;\n  border: 0px solid #cdccc8;\n  box-sizing: border-box;\n  border-radius: 8px;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  background-color: #ffffff;\n}";
  styleInject(css_248z$$);

  var RouteSwitcher = function RouteSwitcher(_ref) {
    var onClick = _ref.onClick;
    return /*#__PURE__*/React__default.createElement("div", {
      className: "route-switcher",
      role: "button",
      onClick: onClick,
      tabIndex: 0
    }, /*#__PURE__*/React__default.createElement(Icon, {
      name: "route-switcher",
      noAbsolute: true,
      margin: "7px 0px 0px 7px"
    }));
  };

  RouteSwitcher.propTypes = {
    onClick: PropTypes__default.func.isRequired
  };
  RouteSwitcher.defaultProps = {};
  var css_248z$10 = ".locationListPicker-container {\n  box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.15);\n  max-height: 450px;\n  cursor: pointer;\n  /* Mobile-specific styles */\n}\n.locationListPicker-container .locationRows-container {\n  display: flex;\n  flex-direction: column;\n}\n@media (max-width: 768px) {\n  .locationListPicker-container {\n    box-shadow: none;\n    max-height: calc(100vh - 180px) !important;\n    height: calc(100vh - 180px) !important;\n  }\n}";
  styleInject(css_248z$10);
  var css_248z$11 = "/* Collection default theme */\n\n.ReactVirtualized__Collection {\n}\n\n.ReactVirtualized__Collection__innerScrollContainer {\n}\n\n/* Grid default theme */\n\n.ReactVirtualized__Grid {\n}\n\n.ReactVirtualized__Grid__innerScrollContainer {\n}\n\n/* Table default theme */\n\n.ReactVirtualized__Table {\n}\n\n.ReactVirtualized__Table__Grid {\n}\n\n.ReactVirtualized__Table__headerRow {\n  font-weight: 700;\n  text-transform: uppercase;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n.ReactVirtualized__Table__row {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n\n.ReactVirtualized__Table__headerTruncatedText {\n  display: inline-block;\n  max-width: 100%;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n\n.ReactVirtualized__Table__headerColumn,\n.ReactVirtualized__Table__rowColumn {\n  margin-right: 10px;\n  min-width: 0px;\n}\n.ReactVirtualized__Table__rowColumn {\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.ReactVirtualized__Table__headerColumn:first-of-type,\n.ReactVirtualized__Table__rowColumn:first-of-type {\n  margin-left: 10px;\n}\n.ReactVirtualized__Table__sortableHeaderColumn {\n  cursor: pointer;\n}\n\n.ReactVirtualized__Table__sortableHeaderIconContainer {\n  display: flex;\n  align-items: center;\n}\n.ReactVirtualized__Table__sortableHeaderIcon {\n  flex: 0 0 24px;\n  height: 1em;\n  width: 1em;\n  fill: currentColor;\n}\n\n/* List default theme */\n\n.ReactVirtualized__List {\n}";
  styleInject(css_248z$11);

  var LocationListPicker = function LocationListPicker(_ref) {
    var locationList = _ref.locationList,
        way = _ref.way,
        onPlaceSelect = _ref.onPlaceSelect,
        toggleLocationListOpen = _ref.toggleLocationListOpen,
        setInputFieldSet = _ref.setInputFieldSet,
        focusState = _ref.focusState,
        setFocusState = _ref.setFocusState,
        toInputRef = _ref.toInputRef,
        stringToBold = _ref.stringToBold;
    var locationListPickerClass = classNames("locationListPicker-container");

    var _React$useState31 = React.useState(900),
        _React$useState32 = _slicedToArray(_React$useState31, 2),
        listHeight = _React$useState32[0],
        setListHeight = _React$useState32[1]; // Initialize with mobile height


    var cache = new reactVirtualized.CellMeasurerCache({
      fixedWidth: true,
      defaultHeight: 61
    });
    var listRef = React.useRef();
    var listContainerRef = React.useRef(); // Add resize handler effect

    React.useEffect(function () {
      var handleResize = function handleResize() {
        setListHeight(window.innerWidth < 768 ? 900 : 400);
      }; // Set initial height


      handleResize(); // Add event listener

      window.addEventListener('resize', handleResize); // Cleanup

      return function () {
        return window.removeEventListener('resize', handleResize);
      };
    }, []);
    React.useEffect(function () {
      if (listRef.current) {
        listRef.current.recomputeRowHeights();
      }

      cache.clearAll();
    }, []);
    var RowRenderer = React.useCallback(function (_ref2) {
      var key = _ref2.key,
          index = _ref2.index,
          style = _ref2.style,
          parent = _ref2.parent;
      return /*#__PURE__*/React__default.createElement(LocationPickerRowRenderer$1, {
        key: key,
        index: index,
        style: style,
        focusState: focusState,
        setFocusState: setFocusState,
        toInputRef: toInputRef,
        parent: parent,
        locationList: locationList,
        way: way,
        cache: cache,
        onPlaceSelect: onPlaceSelect,
        setInputFieldSet: setInputFieldSet,
        toggleLocationListOpen: toggleLocationListOpen,
        stringToBold: stringToBold
      });
    }, [locationList, way, cache, onPlaceSelect, setInputFieldSet, toggleLocationListOpen, focusState, setFocusState, toInputRef.current]);

    if (locationList.length > 0) {
      return /*#__PURE__*/React__default.createElement("div", {
        className: locationListPickerClass,
        ref: listContainerRef
      }, /*#__PURE__*/React__default.createElement(reactVirtualized.AutoSizer, {
        disableHeight: true
      }, function (_ref3) {
        var width = _ref3.width;
        return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("button", {
          className: "close-fullscreen-button",
          onClick: function onClick() {
            return toggleLocationListOpen(false);
          }
        }), /*#__PURE__*/React__default.createElement(reactVirtualized.List, {
          scrollToIndex: focusState.cityIndex,
          height: listHeight // Use dynamic height
          ,
          rowRenderer: RowRenderer,
          rowCount: locationList.length,
          width: width,
          rowHeight: cache.rowHeight,
          ref: listRef,
          deferredMeasurementCache: cache
        }));
      }));
    }

    return /*#__PURE__*/React__default.createElement("div", {
      className: locationListPickerClass
    }, /*#__PURE__*/React__default.createElement(EmptyState, {
      type: "search"
    }));
  };

  LocationListPicker.propTypes = {
    locationList: PropTypes__default.instanceOf(Array).isRequired,
    way: PropTypes__default.string.isRequired,
    onPlaceSelect: PropTypes__default.func.isRequired,
    toggleLocationListOpen: PropTypes__default.func.isRequired,
    setInputFieldSet: PropTypes__default.func.isRequired,
    focusState: PropTypes__default.shape({
      cityIndex: PropTypes__default.number,
      airportIndex: PropTypes__default.number
    }).isRequired,
    setFocusState: PropTypes__default.func.isRequired,
    toInputRef: PropTypes__default.instanceOf(Object),
    stringToBold: PropTypes__default.string
  };
  LocationListPicker.defaultProps = {
    toInputRef: {},
    stringToBold: ""
  };
  var LocationListPicker$1 = /*#__PURE__*/React__default.memo(LocationListPicker); // LocationForm.jsx

  var globalObj = typeof window !== "undefined" ? window : {
    matchMedia: function matchMedia() {
      return {
        matches: false
      };
    }
  };

  var LocationForm = function LocationForm(_ref) {
    var fromList = _ref.fromList,
        toList = _ref.toList,
        onPlaceSelect = _ref.onPlaceSelect,
        onLocationStringChange = _ref.onLocationStringChange,
        errors = _ref.errors,
        setReservationProperty = _ref.setReservationProperty,
        departureTo = _ref.departureTo,
        departureFrom = _ref.departureFrom,
        disabled = _ref.disabled,
        isLocationListOpened = _ref.isLocationListOpened,
        setIsLocationListOpened = _ref.setIsLocationListOpened,
        forceOneWay = _ref.forceOneWay; // 2) Use matchMedia instead of innerWidth

    var isMobile = globalObj.matchMedia("(max-width: 768px)").matches;
    var locationFormClass = classNames("locationForm-container");
    var toTimeRef = React.useRef();
    var fromTimeRef = React.useRef();
    var canadaCodes = ["YYZ", "YHM", "YKF"];
    React.useEffect(function () {
      if (isLocationListOpened && isMobile) {
        document.body.style.overflow = "hidden";
      }

      return function () {
        document.body.style.overflow = "auto";
      };
    }, [isLocationListOpened, isMobile]);

    var _React$useState33 = React.useState({
      cityIndex: -1,
      airportIndex: -1
    }),
        _React$useState34 = _slicedToArray(_React$useState33, 2),
        focusState = _React$useState34[0],
        setFocusState = _React$useState34[1];

    var changeFocusState = function changeFocusState(param) {
      setFocusState(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), param);
      });
    };

    var _React$useState35 = React.useState({
      way: "dep_from",
      fromInputFieldValue: departureFrom,
      toInputFieldValue: departureTo,
      showToClearButton: false,
      showFromClearButton: false
    }),
        _React$useState36 = _slicedToArray(_React$useState35, 2),
        state = _React$useState36[0],
        setState = _React$useState36[1];

    var changeState = function changeState(params) {
      setState(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), params);
      });
    };

    var locationList = React.useMemo(function () {
      return {
        dep_from: fromList,
        dep_to: toList
      }[state.way];
    }, [fromList, toList, state.way]);
    var getCityName = React.useCallback(function (city) {
      if (!city) {
        return "";
      }

      var cityName = city.name;
      var cityCode = city.code;

      if (city.city_from || city.city_to) {
        if (!hiddenCityCodes.includes(cityCode)) {
          cityName += " (All airports, ".concat(cityCode, ")");
        } else {
          cityName += " (All airports)";
        }
      } else if (cityCode) {
        return "".concat(cityName, " - ").concat(cityCode);
      }

      return cityName;
    }, []);
    var toInputFormat = getCityName(state.toInputFieldValue);
    var fromInputFormat = getCityName(state.fromInputFieldValue);
    var locationListPickerClass = classNames("locationListPicker", {
      isListOpened: isLocationListOpened
    });
    var inputFieldRef = React.useRef();
    useOnClickOutside(inputFieldRef, function () {
      return setIsLocationListOpened(false);
    });
    var clearInputFields = React.useCallback(function (direction) {
      if (direction === "dep_from") {
        changeState({
          showFromClearButton: false,
          fromInputFieldValue: {}
        });
        return;
      }

      changeState({
        showToClearButton: false,
        toInputFieldValue: {}
      });
    }, []);
    var inputIcon = React.useCallback(function (isDisabled, showClearButton, inputWay) {
      return !isDisabled && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, showClearButton ? /*#__PURE__*/React__default.createElement("div", {
        className: "close-icon",
        onClick: function onClick() {
          return clearInputFields(inputWay);
        }
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "close-hover"
      }, /*#__PURE__*/React__default.createElement(Icon, {
        name: "closeIcon",
        width: 15,
        height: 12,
        noAbsolute: true
      }))) : /*#__PURE__*/React__default.createElement("div", {
        className: "toogle-icon"
      }, /*#__PURE__*/React__default.createElement(Icon, {
        onClick: function onClick() {
          setIsLocationListOpened(!isLocationListOpened);
          changeState({
            way: inputWay
          });
        },
        name: isLocationListOpened && state.way === inputWay ? "chevron_up" : "chevron_down",
        noAbsolute: true
      })));
    }, [isLocationListOpened, state.way]);
    var FromIcon = React.useCallback(function () {
      return inputIcon(disabled.disableFrom, state.showFromClearButton, "dep_from");
    }, [disabled.disableFrom, state.showFromClearButton]);
    var ToIcon = React.useCallback(function () {
      return inputIcon(disabled.disableTo, state.showToClearButton, "dep_to");
    }, [disabled.disableTo, state.showToClearButton]);
    var onInputFocus = React.useCallback(function (isDisabled, inputWay) {
      if (!isDisabled) {
        setIsLocationListOpened(true);
        changeState({
          way: inputWay
        });
      }
    }, []);
    var onFromFocus = React.useCallback(function () {
      onInputFocus(disabled.disableFrom, "dep_from");
    }, [onInputFocus, disabled.disableFrom]);
    var onToFocus = React.useCallback(function () {
      onInputFocus(disabled.disableTo, "dep_to");
    }, [onInputFocus, disabled.disableTo]);
    var onInputChange = React.useCallback(function (currentValue, inputFormatValue, clearButtonName, inputWay, mainDepart, otherDepart, inputRef, locationString, inputFieldValue) {
      var newStateData = _defineProperty({}, clearButtonName, currentValue);

      if (!currentValue && !inputFormatValue) {
        onPlaceSelect(inputWay, {});
      }

      if (currentValue !== inputFormatValue) {
        if (mainDepart.code) {
          setReservationProperty(inputWay, {});
        }

        clearTimeout(inputRef.current);
        inputRef.current = setTimeout(function () {
          onLocationStringChange(currentValue, locationString, otherDepart);
        }, 300);
        newStateData[inputFieldValue] = {
          name: currentValue
        };
      }

      changeState(newStateData);
    }, []);
    var onFromChange = React.useCallback(function (e) {
      onInputChange(e.target.value, fromInputFormat || "", "showFromClearButton", "dep_from", departureFrom, departureTo, fromTimeRef, "froms", "fromInputFieldValue");
      changeFocusState({
        cityIndex: -1,
        airportIndex: -1
      });

      if (canadaCodes.includes(departureFrom.code)) {
        console.log("Forcing one way");
        forceOneWay();
      }
    }, [fromInputFormat, departureFrom, departureTo, fromTimeRef]);
    var onToChange = React.useCallback(function (e) {
      onInputChange(e.target.value, toInputFormat || "", "showToClearButton", "dep_to", departureTo, departureFrom, toTimeRef, "tos", "toInputFieldValue");
      changeFocusState({
        cityIndex: -1,
        airportIndex: -1
      });
    }, [toInputFormat, departureTo, departureFrom, toTimeRef]);
    var setInputFieldSet = React.useCallback(function (way, string) {
      if (way === "dep_to") {
        changeState({
          toInputFieldValue: string,
          showToClearButton: false
        });
      } else {
        changeState({
          fromInputFieldValue: string,
          showFromClearButton: false
        });
      }
    }, []);

    var onRouteSwitch = function onRouteSwitch() {
      if (state.fromInputFieldValue || state.toInputFieldValue) {
        setInputFieldSet("dep_from", state.toInputFieldValue);
        onPlaceSelect("dep_from", state.toInputFieldValue);
        setInputFieldSet("dep_to", state.fromInputFieldValue);
        onPlaceSelect("dep_to", state.fromInputFieldValue);

        if (!state.toInputFieldValue) {
          setFocusState();
        }
      }
    };

    var toggleLocationListOpen = React.useCallback(function (toggle) {
      return setIsLocationListOpened(toggle);
    }, []);
    var toInputRef = React.useRef(); // 3) Wrap your return JSX in a variable

    var content = /*#__PURE__*/React__default.createElement("div", {
      className: classNames(locationFormClass, {
        "full-screen-panel": isLocationListOpened && isMobile
      }),
      ref: inputFieldRef
    }, isLocationListOpened && isMobile && /*#__PURE__*/React__default.createElement("button", {
      className: "close-fullscreen-button",
      onClick: function onClick() {
        setIsLocationListOpened(false);
        document.body.style.overflow = "auto";
      }
    }, "\u2715"), /*#__PURE__*/React__default.createElement("div", {
      className: "inputFieldSets-container"
    }, /*#__PURE__*/React__default.createElement(InputFieldSet, {
      disabled: disabled.disableFrom,
      fullWidth: true,
      inputPlaceholder: "Airport/City",
      icon: /*#__PURE__*/React__default.createElement(FromIcon, null),
      error: errors.dep_from,
      labelText: "from",
      onFocus: onFromFocus,
      inputValue: fromInputFormat,
      onChange: onFromChange,
      tabIndex: "0"
    }), /*#__PURE__*/React__default.createElement(RouteSwitcher, {
      onClick: onRouteSwitch
    }), /*#__PURE__*/React__default.createElement(InputFieldSet, {
      disabled: disabled.disableTo,
      fullWidth: true,
      labelText: "to",
      inputPlaceholder: "Airport/City",
      error: errors.dep_to,
      icon: /*#__PURE__*/React__default.createElement(ToIcon, null),
      onFocus: onToFocus,
      inputValue: toInputFormat,
      onChange: onToChange,
      tabIndex: "0",
      inputRef: toInputRef
    })), isLocationListOpened && /*#__PURE__*/React__default.createElement("div", {
      className: locationListPickerClass
    }, /*#__PURE__*/React__default.createElement(LocationListPicker$1, {
      focusState: focusState,
      setFocusState: changeFocusState,
      locationList: locationList,
      way: state.way,
      setInputFieldSet: setInputFieldSet,
      onPlaceSelect: onPlaceSelect,
      toggleLocationListOpen: toggleLocationListOpen,
      toInputRef: toInputRef,
      stringToBold: state.way === "dep_from" ? fromInputFormat : toInputFormat
    }))); // 4) For mobile + open, portal; otherwise render normally

    if (isMobile && isLocationListOpened) {
      return /*#__PURE__*/ReactDOM.createPortal(content, document.getElementById("mobile-portal-root") // Make sure you have this element in your HTML
      );
    }

    return content;
  };

  LocationForm.propTypes = {
    fromList: PropTypes__default.instanceOf(Array).isRequired,
    toList: PropTypes__default.instanceOf(Array).isRequired,
    onPlaceSelect: PropTypes__default.func.isRequired,
    onLocationStringChange: PropTypes__default.func.isRequired,
    errors: PropTypes__default.instanceOf(Object),
    setReservationProperty: PropTypes__default.func.isRequired,
    departureTo: PropTypes__default.string,
    departureFrom: PropTypes__default.string,
    disabled: PropTypes__default.instanceOf(Object),
    isLocationListOpened: PropTypes__default.bool.isRequired,
    setIsLocationListOpened: PropTypes__default.func.isRequired,
    forceOneWay: PropTypes__default.func
  };
  LocationForm.defaultProps = {
    errors: {},
    departureTo: undefined,
    departureFrom: undefined,
    disabled: {},
    forceOneWay: function forceOneWay() {}
  };
  var LocationForm$1 = /*#__PURE__*/React__default.memo(LocationForm);
  var css_248z$12 = ".passengerseatmap-wrapper {\n  font-family: \"Source Sans Pro\", sans-serif;\n  line-height: 2rem;\n  margin-top: 10px;\n}\n\n.passengerseatmap-toggle-seat {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 60px;\n  border-radius: 6px;\n  margin-right: 10px;\n  color: #ffe6a6;\n  font-size: 14px;\n  background-color: #696d6f;\n  height: 24px;\n  align-self: center;\n}\n\n.passengerseatmap-toggle-seat.lead {\n  background-color: #3c3835;\n  color: #fab500;\n}\n\n.passengerseatmap-toggle-seat.noSeat {\n  display: none;\n}";
  styleInject(css_248z$12);
  var css_248z$13 = ".seatmap-wrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}";
  styleInject(css_248z$13);
  var css_248z$14 = ".bus-seatmap-container {\n  display: flex;\n  flex: 1;\n  flex-direction: row;\n  justify-content: center;\n  margin-bottom: 40px;\n}\n\n.bus-seat-column {\n  display: flex;\n  flex-direction: column;\n  margin-right: 10px;\n}\n\n.last-bus-seat-column {\n  margin-right: 0px;\n}\n\n@media only screen and (max-width: 365px) {\n  .bus-seatmap-container {\n    min-width: 280px;\n  }\n  .bus-seat-column {\n    margin-right: 5px;\n  }\n  .last-bus-seat-column {\n    margin-right: 0px;\n  }\n}";
  styleInject(css_248z$14);
  var css_248z$15 = ".aisleContainer {\n  display: flex;\n  border: 1px solid #3c3835;\n  border-radius: 6px;\n  opacity: 0.3;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.legendContainer {\n  display: flex;\n  opacity: 0.3;\n  align-items: center;\n  justify-content: space-between;\n  border: 1px solid #3c3835;\n  width: 20px;\n  height: 20px;\n  flex-direction: row;\n  padding-left: 5px;\n  padding-right: 5px;\n  border-radius: 3px;\n}\n\n.aisleLine {\n  width: 35px;\n  border-bottom: 1px solid #3c3835;\n  align-self: center;\n  transform: rotate(-30deg);\n}\n\n.horizontalAisleLine {\n  height: 35px;\n  border-left: 1px solid #3c3835;\n  align-self: center;\n  transform: rotate(30deg);\n}\n\n.legendAisleLine {\n  border-left: 1px solid #3c3835;\n  height: 12px;\n  transform: rotate(30deg);\n}";
  styleInject(css_248z$15);

  var SeatMapAisle = function SeatMapAisle(_ref) {
    var lengthInSeats = _ref.lengthInSeats,
        isHorizontal = _ref.isHorizontal,
        customStyle = _ref.customStyle,
        legend = _ref.legend;
    var length = lengthInSeats * 50 + (lengthInSeats - 1) * 10;
    var containerStyle = classNames({
      legendContainer: legend
    }, {
      aisleContainer: !legend
    });
    var aisleLineStyle = classNames({
      legendAisleLine: legend
    }, {
      horizontalAisleLine: isHorizontal
    }, {
      aisleLine: !legend && !isHorizontal
    });
    var containerDimensions = isHorizontal ? {
      width: length,
      height: 50,
      paddingLeft: 20,
      paddingRight: 20,
      flexDirection: "row"
    } : {
      width: 50,
      height: length,
      paddingTop: 20,
      paddingBottom: 20,
      flexDirection: "column"
    };

    var getAisleLines = function getAisleLines(numberOfLines) {
      var aisleLines = [];

      for (var i = 0; i < numberOfLines; i++) {
        aisleLines.push( /*#__PURE__*/React__default.createElement("div", {
          className: aisleLineStyle
        }));
      }

      return aisleLines;
    };

    return /*#__PURE__*/React__default.createElement("div", {
      className: containerStyle,
      style: _objectSpread(_objectSpread({}, !legend ? containerDimensions : {}), customStyle || {})
    }, getAisleLines(legend ? 2 : lengthInSeats * 2 + 1));
  };

  SeatMapAisle.propTypes = {
    lengthInSeats: PropTypes__default.number.isRequired,
    isHorizontal: PropTypes__default.bool,
    customStyle: PropTypes__default.instanceOf(Object),
    legend: PropTypes__default.bool
  };
  SeatMapAisle.defaultProps = {
    isHorizontal: false,
    customStyle: {},
    legend: false
  };

  var BusSeatMap = function BusSeatMap(_ref) {
    var allSelectedSeats = _ref.allSelectedSeats,
        seats = _ref.seats,
        passenger = _ref.passenger,
        onSeatClicked = _ref.onSeatClicked;
    var lastReversedRow = 0;

    var _React$useState37 = React.useState([]),
        _React$useState38 = _slicedToArray(_React$useState37, 2),
        selectedSeats = _React$useState38[0],
        setSelectedSeats = _React$useState38[1];

    var getBusColumns = function getBusColumns() {
      var columnA = [];
      var columnB = [];
      var columnC = [];
      var columnD = [];
      var busColumns = [];
      seats.forEach(function (row) {
        row.forEach(function (seat) {
          var code = seat.code;

          if (code.includes("A")) {
            columnA.push(seat);
          } else if (code.includes("B")) {
            columnB.push(seat);
          } else if (code.includes("C")) {
            columnC.push(seat);
          } else if (code.includes("D")) {
            columnD.push(seat);
          }
        });
      });
      busColumns.push(columnA, columnB, ["aisle"], columnC, columnD);
      return busColumns;
    };

    var busColumns = getBusColumns();
    React.useEffect(function () {
      setSelectedSeats(allSelectedSeats);
    }, [allSelectedSeats]);
    return /*#__PURE__*/React__default.createElement("div", {
      className: "bus-seatmap-container"
    }, busColumns.map(function (seatColumn, columnIndex) {
      var isLastColumn = columnIndex === busColumns.length - 1;
      var busSeatColumnStyle = classNames("bus-seat-column", {
        "last-bus-seat-column": isLastColumn
      });
      return /*#__PURE__*/React__default.createElement("div", {
        className: busSeatColumnStyle
      }, seatColumn.map(function (seat, seatIndex) {
        if (seat === "aisle") {
          return /*#__PURE__*/React__default.createElement(SeatMapAisle, {
            lengthInSeats: 7
          });
        }

        var available = seat.available,
            code = seat.code,
            description = seat.description,
            row = seat.row,
            price = seat.price;

        if (lastReversedRow < row - 2 && description === "EmergencySeat") {
          lastReversedRow = row;
        }

        var isBlocked = description === "Block Seat";
        var isLast = seatIndex === seatColumn.length - 1;
        var selectedSeat = selectedSeats.find(function (currentSeat) {
          return currentSeat.code === code;
        }) || {};
        return /*#__PURE__*/React__default.createElement(SeatPlace, {
          seat: _objectSpread(_objectSpread({}, seat), {}, {
            passengerId: selectedSeat.passengerId
          }),
          selected: !!selectedSeat.code,
          onClick: onSeatClicked,
          value: code,
          leadPassenger: selectedSeat.passengerId === 0,
          taken: !available,
          passengerId: passenger.index,
          reversed: lastReversedRow === row,
          tableSeat: description === "EmergencySeat",
          price: price,
          isBlocked: isBlocked,
          isLast: isLast
        });
      }));
    }));
  };

  BusSeatMap.propTypes = {
    allSelectedSeats: PropTypes__default.instanceOf(Array),
    seats: PropTypes__default.instanceOf(Array),
    passenger: PropTypes__default.instanceOf(Object),
    onSeatClicked: PropTypes__default.func
  };
  BusSeatMap.defaultProps = {
    allSelectedSeats: [],
    seats: [],
    passenger: {},
    onSeatClicked: function onSeatClicked() {}
  };
  var css_248z$16 = ".express-seatmap-container {\n  display: flex;\n  flex: 1;\n  flex-direction: row;\n  justify-content: center;\n  margin-bottom: 40px;\n}\n\n.express-seat-column {\n  margin-right: 10px;\n}\n\n.express-last-seat-column {\n  margin-right: 0px;\n}\n\n.express-seatmap-row {\n  display: flex;\n  flex-direction: row;\n}";
  styleInject(css_248z$16);

  var BusSeatMap$1 = function BusSeatMap$1(_ref) {
    var allSelectedSeats = _ref.allSelectedSeats,
        seats = _ref.seats,
        passenger = _ref.passenger,
        onSeatClicked = _ref.onSeatClicked;
    var lastReversedRow = 0;

    var _React$useState39 = React.useState([]),
        _React$useState40 = _slicedToArray(_React$useState39, 2),
        selectedSeats = _React$useState40[0],
        setSelectedSeats = _React$useState40[1];

    var getExpressColumns = function getExpressColumns() {
      var columnA = [];
      var columnB = [];
      var columnC = [];
      var columnD = [];
      var expressColumns = [];
      seats.forEach(function (row) {
        row.forEach(function (seat) {
          var code = seat.code;

          if (code.includes("A")) {
            columnA.push(seat);
          } else if (code.includes("B")) {
            columnB.push(seat);
          } else if (code.includes("C")) {
            columnC.push(seat);
          } else if (code.includes("D")) {
            columnD.push(seat);
          }
        });
      });
      expressColumns.push(columnA, columnB, columnC, columnD);
      return expressColumns;
    };

    var expressColumns = getExpressColumns();
    var firstThreeColumns = [expressColumns[0], expressColumns[1], expressColumns[2]];
    var lastColumn = expressColumns[expressColumns.length - 1];
    React.useEffect(function () {
      setSelectedSeats(allSelectedSeats);
    }, [allSelectedSeats]);
    return /*#__PURE__*/React__default.createElement("div", {
      className: "express-seatmap-container"
    }, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(SeatMapAisle, {
      lengthInSeats: 3,
      isHorizontal: true,
      customStyle: {
        marginBottom: 10
      }
    }), /*#__PURE__*/React__default.createElement("div", {
      className: "express-seatmap-row"
    }, firstThreeColumns.map(function (seatColumn) {
      return /*#__PURE__*/React__default.createElement("div", {
        className: "express-seat-column"
      }, seatColumn.map(function (seat, seatIndex) {
        var available = seat.available,
            code = seat.code,
            description = seat.description,
            row = seat.row,
            price = seat.price;

        if (lastReversedRow < row - 2 && description === "EmergencySeat") {
          lastReversedRow = row;
        }

        var isBlocked = description === "Block Seat";
        var isLast = seatIndex === seatColumn.length - 1;
        var selectedSeat = selectedSeats.find(function (currentSeat) {
          return currentSeat.code === code;
        }) || {};
        return /*#__PURE__*/React__default.createElement("div", null, code === "5D" && /*#__PURE__*/React__default.createElement(SeatMapAisle, {
          lengthInSeats: 3,
          customStyle: {
            marginBottom: 10
          }
        }), /*#__PURE__*/React__default.createElement(SeatPlace, {
          seat: _objectSpread(_objectSpread({}, seat), {}, {
            passengerId: selectedSeat.passengerId
          }),
          selected: !!selectedSeat.code,
          onClick: onSeatClicked,
          value: code,
          leadPassenger: selectedSeat.passengerId === 0,
          taken: !available,
          passengerId: passenger.index,
          reversed: lastReversedRow === row,
          tableSeat: description === "EmergencySeat",
          price: price,
          isLast: isLast,
          isBlocked: isBlocked
        }));
      }));
    }))), /*#__PURE__*/React__default.createElement("div", {
      className: "express-last-seat-column"
    }, lastColumn.map(function (seat, seatIndex) {
      var available = seat.available,
          code = seat.code,
          description = seat.description,
          row = seat.row,
          price = seat.price;

      if (lastReversedRow < row - 2 && description === "EmergencySeat") {
        lastReversedRow = row;
      }

      var isBlocked = description === "Block Seat";
      var isLast = seatIndex === lastColumn.length - 1;
      var selectedSeat = selectedSeats.find(function (currentSeat) {
        return currentSeat.code === code;
      }) || {};
      return /*#__PURE__*/React__default.createElement("div", null, code === "5D" && /*#__PURE__*/React__default.createElement(SeatMapAisle, {
        lengthInSeats: 3,
        customStyle: {
          marginBottom: 10
        }
      }), /*#__PURE__*/React__default.createElement(SeatPlace, {
        seat: _objectSpread(_objectSpread({}, seat), {}, {
          passengerId: selectedSeat.passengerId
        }),
        selected: !!selectedSeat.code,
        onClick: onSeatClicked,
        value: code,
        leadPassenger: selectedSeat.passengerId === 0,
        taken: !available,
        passengerId: passenger.index,
        reversed: lastReversedRow === row,
        tableSeat: description === "EmergencySeat",
        price: price,
        isLast: isLast,
        isBlocked: isBlocked
      }));
    })));
  };

  BusSeatMap$1.propTypes = {
    allSelectedSeats: PropTypes__default.instanceOf(Array),
    seats: PropTypes__default.instanceOf(Array),
    passenger: PropTypes__default.instanceOf(Object),
    onSeatClicked: PropTypes__default.func
  };
  BusSeatMap$1.defaultProps = {
    allSelectedSeats: [],
    seats: [],
    passenger: {},
    onSeatClicked: function onSeatClicked() {}
  };
  var css_248z$17 = ".seatlegend-wrapper {\n  display: inline-block;\n  margin: auto auto 30px auto;\n  font-family: \"Source Sans Pro\", sans-serif;\n  line-height: 2rem;\n}\n\n.seatlegend-row {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-around;\n}\n\n.seatlegend-item {\n  display: inline-flex;\n  align-items: center;\n  font-size: 12px;\n  flex-basis: 120px;\n}\n\n.seatlegend-title {\n  margin: 8px 0px;\n  min-width: 280px;\n  width: 100%;\n  font-weight: 600;\n  font-size: 14px;\n  color: #696d6f;\n  border-bottom: 1px solid #e5e5e5;\n  height: 40px;\n  text-align: center;\n}";
  styleInject(css_248z$17);

  var SeatLegend = function SeatLegend() {
    return /*#__PURE__*/React__default.createElement("div", {
      className: "seatlegend-wrapper"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "seatlegend-title"
    }, "Legend"), /*#__PURE__*/React__default.createElement("div", {
      className: "seatlegend-row"
    }, /*#__PURE__*/React__default.createElement("span", {
      className: "seatlegend-item"
    }, /*#__PURE__*/React__default.createElement(SeatPlace, {
      value: "\u25CF",
      legend: true
    }), " Available Seat"), /*#__PURE__*/React__default.createElement("span", {
      className: "seatlegend-item"
    }, /*#__PURE__*/React__default.createElement(SeatPlace, {
      value: "\u25CF",
      legend: true,
      leadPassenger: true,
      selected: true
    }), " Lead Passenger")), /*#__PURE__*/React__default.createElement("div", {
      className: "seatlegend-row"
    }, /*#__PURE__*/React__default.createElement("span", {
      className: "seatlegend-item"
    }, /*#__PURE__*/React__default.createElement(SeatPlace, {
      value: "\u25CF",
      legend: true,
      taken: true
    }), " Taken Seat"), /*#__PURE__*/React__default.createElement("span", {
      className: "seatlegend-item"
    }, /*#__PURE__*/React__default.createElement(SeatPlace, {
      value: "\u25CF",
      legend: true,
      selected: true
    }), " Companion(s)")), /*#__PURE__*/React__default.createElement("div", {
      className: "seatlegend-row"
    }, /*#__PURE__*/React__default.createElement("span", {
      className: "seatlegend-item"
    }, /*#__PURE__*/React__default.createElement(SeatPlace, {
      legend: true,
      isBlocked: true
    }), "Blocked Seat"), /*#__PURE__*/React__default.createElement("span", {
      className: "seatlegend-item"
    }, /*#__PURE__*/React__default.createElement(SeatMapAisle, {
      legend: true,
      customStyle: {
        marginRight: 10
      }
    }), " Aisle")));
  };

  SeatLegend.propTypes = {};
  SeatLegend.defaultProps = {};

  var SeatMap = function SeatMap(_ref) {
    var allSelectedSeats = _ref.allSelectedSeats,
        seats = _ref.seats,
        passenger = _ref.passenger,
        onSeatClicked = _ref.onSeatClicked,
        isExpress = _ref.isExpress;
    return /*#__PURE__*/React__default.createElement("div", {
      className: "seatmap-wrapper"
    }, /*#__PURE__*/React__default.createElement(SeatLegend, null), isExpress ? /*#__PURE__*/React__default.createElement(BusSeatMap$1, {
      allSelectedSeats: allSelectedSeats,
      seats: seats,
      passenger: passenger,
      onSeatClicked: onSeatClicked
    }) : /*#__PURE__*/React__default.createElement(BusSeatMap, {
      allSelectedSeats: allSelectedSeats,
      seats: seats,
      passenger: passenger,
      onSeatClicked: onSeatClicked
    }));
  };

  SeatMap.propTypes = {
    allSelectedSeats: PropTypes__default.instanceOf(Array),
    seats: PropTypes__default.instanceOf(Array),
    passenger: PropTypes__default.instanceOf(Object),
    onSeatClicked: PropTypes__default.func,
    isExpress: PropTypes__default.bool
  };
  SeatMap.defaultProps = {
    allSelectedSeats: [],
    seats: [],
    passenger: {},
    onSeatClicked: function onSeatClicked() {},
    isExpress: false
  };

  var PassengerSeatMap = function PassengerSeatMap(_ref) {
    var passenger = _ref.passenger,
        allSelectedSeats = _ref.allSelectedSeats,
        seats = _ref.seats,
        onSeatClicked = _ref.onSeatClicked,
        allPassengers = _ref.allPassengers,
        openPassengerSeatMap = _ref.openPassengerSeatMap,
        setOpenPassengerSeatMap = _ref.setOpenPassengerSeatMap,
        clearPassengerSeat = _ref.clearPassengerSeat,
        isExpress = _ref.isExpress;
    var openSeatMap = openPassengerSeatMap === passenger.index;

    var _ref8 = passenger || {},
        title = _ref8.title,
        firstName = _ref8.first_name,
        lastName = _ref8.last_name;

    var selectedSeat = allSelectedSeats.find(function (seat) {
      return seat.passengerId === passenger.index;
    }) || {};
    var modalInitialData = {
      open: false,
      seat: {}
    };

    var _React$useState41 = React.useState(modalInitialData),
        _React$useState42 = _slicedToArray(_React$useState41, 2),
        modalData = _React$useState42[0],
        changeShowModal = _React$useState42[1];

    var passengerSeatClass = classNames("passengerseatmap-toggle-seat", {
      lead: passenger.index === 0,
      noSeat: !selectedSeat.code
    });

    var tooglePassengerSeatMap = function tooglePassengerSeatMap() {
      setOpenPassengerSeatMap(openPassengerSeatMap === passenger.index ? -1 : passenger.index);
    };

    var selectSeat = function selectSeat(seat) {
      if (seat.code) {
        var shouldCloseSeatMap = !selectedSeat.code && allSelectedSeats.length === allPassengers.length - 1 || allSelectedSeats.length === allPassengers.length;

        if (passenger.index < allPassengers.length - 1) {
          setOpenPassengerSeatMap(passenger.index + 1);
        } else if (shouldCloseSeatMap) {
          setOpenPassengerSeatMap(-1);
        }
      }

      onSeatClicked(seat);
    };

    var onSeatClickedWrapper = function onSeatClickedWrapper(seat) {
      var currentSeatWithCode = allSelectedSeats.find(function (_ref2) {
        var code = _ref2.code;
        return code === seat.code;
      });

      if (currentSeatWithCode && currentSeatWithCode.passengerId === passenger.index) {
        clearPassengerSeat(seat);
      } else if (!currentSeatWithCode) {
        if (seat.description === "EmergencySeat") {
          changeShowModal({
            open: true,
            seat: seat
          });
        } else {
          selectSeat(seat);
        }
      }
    };

    return /*#__PURE__*/React__default.createElement("div", {
      className: "passengerseatmap-wrapper"
    }, /*#__PURE__*/React__default.createElement(Modal, {
      isOpen: modalData.open,
      onCancel: function onCancel() {
        changeShowModal(modalInitialData);
      },
      onSuccess: function onSuccess() {
        selectSeat(modalData.seat);
        changeShowModal(modalInitialData);
      },
      title: "Table seats",
      message: "You have chosen a table seat. These seats have a little extra legroom and face each other around a table"
    }), /*#__PURE__*/React__default.createElement(CollapsibleButton, {
      className: "right-information-wrapper",
      toggle: tooglePassengerSeatMap,
      open: openSeatMap,
      title: /*#__PURE__*/React__default.createElement(React__default.Fragment, null, "Select a seat for passenger: ".concat(title, ". ").concat(firstName, " ").concat(lastName)),
      rightContent: /*#__PURE__*/React__default.createElement("span", {
        className: passengerSeatClass
      }, selectedSeat.code)
    }, /*#__PURE__*/React__default.createElement(SeatMap, {
      allSelectedSeats: allSelectedSeats,
      seats: seats,
      passenger: passenger,
      onSeatClicked: onSeatClickedWrapper,
      isExpress: isExpress
    })));
  };

  PassengerSeatMap.propTypes = {
    passenger: PropTypes__default.instanceOf(Object),
    allSelectedSeats: PropTypes__default.instanceOf(Array),
    seats: PropTypes__default.instanceOf(Array),
    onSeatClicked: PropTypes__default.func,
    allPassengers: PropTypes__default.instanceOf(Array),
    openPassengerSeatMap: PropTypes__default.string.isRequired,
    setOpenPassengerSeatMap: PropTypes__default.func.isRequired,
    clearPassengerSeat: PropTypes__default.func,
    isExpress: PropTypes__default.bool
  };
  PassengerSeatMap.defaultProps = {
    passenger: {},
    allSelectedSeats: [],
    seats: [],
    onSeatClicked: function onSeatClicked() {},
    allPassengers: [],
    clearPassengerSeat: function clearPassengerSeat() {},
    isExpress: false
  };
  var css_248z$18 = ".passengerseats-wrapper {\n  font-family: \"Source Sans Pro\", sans-serif;\n  margin: 0 20px;\n}\n\n.passengerseats-wrapper * {\n  box-sizing: border-box;\n}\n\n.leg-connection-wrapper .itinerarySingleRow-container {\n  margin: 0;\n  width: 100%;\n}";
  styleInject(css_248z$18);

  var PassengerSeats = function PassengerSeats(props) {
    var passengers = props.passengers,
        allSelectedSeats = props.allSelectedSeats,
        seats = props.seats,
        onSeatClicked = props.onSeatClicked,
        totalTripTime = props.totalTripTime,
        title = props.title,
        leg = props.leg,
        segments = props.segments,
        clearPassengerSeat = props.clearPassengerSeat,
        layoverTimes = props.layoverTimes;

    var _React$useState43 = React.useState(0),
        _React$useState44 = _slicedToArray(_React$useState43, 2),
        openPassengerSeatMap = _React$useState44[0],
        setOpenPassengerSeatMap = _React$useState44[1];

    var isExpressSegment = isExpress(segments) || isExpressHome(segments);
    return /*#__PURE__*/React__default.createElement("div", {
      className: "passengerseats-wrapper"
    }, /*#__PURE__*/React__default.createElement(PageTitle, {
      title: title
    }), /*#__PURE__*/React__default.createElement("div", {
      className: "leg-connection-wrapper"
    }, /*#__PURE__*/React__default.createElement(ItinerarySingleRow, {
      segments: segments,
      tickets: [],
      summaryPrice: [],
      layoverTimes: layoverTimes,
      seatsLeft: 4,
      itineraryIndex: 0,
      classbands: [],
      departureCode: leg.departure_info.code,
      arrivalCode: null,
      selectedItineraryIndex: 0,
      summaryPreview: true,
      passengersAdults: 1,
      passengersChildrens: 0,
      passengersInfants: 0
    })), passengers.map(function (passenger, index) {
      return /*#__PURE__*/React__default.createElement(PassengerSeatMap, {
        clearPassengerSeat: clearPassengerSeat,
        openPassengerSeatMap: openPassengerSeatMap,
        setOpenPassengerSeatMap: setOpenPassengerSeatMap,
        allPassengers: passengers,
        passenger: _objectSpread(_objectSpread({}, passenger), {}, {
          index: index
        }),
        allSelectedSeats: allSelectedSeats,
        seats: seats,
        onSeatClicked: onSeatClicked,
        isExpress: isExpressSegment
      });
    }));
  };

  PassengerSeats.propTypes = {
    passengers: PropTypes__default.instanceOf(Array),
    allSelectedSeats: PropTypes__default.instanceOf(Array),
    seats: PropTypes__default.instanceOf(Array),
    onSeatClicked: PropTypes__default.func,
    title: PropTypes__default.string,
    leg: PropTypes__default.instanceOf(Object).isRequired,
    segments: PropTypes__default.instanceOf(Array).isRequired,
    clearPassengerSeat: PropTypes__default.func,
    layoverTimes: PropTypes__default.instanceOf(Array),
    totalTripTime: PropTypes__default.string
  };
  PassengerSeats.defaultProps = {
    passengers: [],
    allSelectedSeats: [],
    seats: [],
    onSeatClicked: function onSeatClicked() {},
    title: "",
    clearPassengerSeat: function clearPassengerSeat() {},
    layoverTimes: [],
    totalTripTime: undefined
  };
  var css_248z$19 = ".search-filters-wrapper {\n  z-index: 1;\n  margin-top: 40px;\n  display: flex;\n  flex-direction: column;\n  padding-bottom: 20px;\n}\n.search-filters-wrapper .search-filter-content {\n  background: #fff;\n  padding: 0px 20px 20px 20px;\n  max-height: calc(100vh - 335px);\n  border-radius: 6px 6px 0px 0px;\n  overflow: auto;\n}\n.search-filters-wrapper.search-filter-wrapper-modal {\n  margin-top: 0;\n  padding-bottom: 0;\n}\n.search-filters-wrapper.search-filter-wrapper-modal .search-filter-content {\n  padding: 0;\n}\n.search-filters-wrapper.search-filter-wrapper-modal .button-containers {\n  margin: 20px -20px -20px -20px;\n}\n.search-filters-wrapper .formated-title {\n  font-style: normal;\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 100%;\n}\n.search-filters-wrapper .checkbox-title {\n  font-weight: 600;\n  font-size: 18px;\n  line-height: 23px;\n}\n.search-filters-wrapper .title {\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 15px;\n  padding-top: 20px;\n}\n.search-filters-wrapper .clear-filter {\n  display: flex;\n  flex: 1;\n  justify-content: space-between;\n}\n.search-filters-wrapper .clear-filter .text {\n  font-style: normal;\n  font-weight: normal;\n  font-size: 14px;\n  line-height: 18px;\n}\n.search-filters-wrapper .collapsible-wrapper {\n  padding: 20px 10px;\n}\n.search-filters-wrapper .luggage-wrapper div {\n  padding-bottom: 10px;\n}\n.search-filters-wrapper .tripDuration-wrapper .slider-value {\n  font-style: normal;\n  font-weight: 600;\n  font-size: 18px;\n  line-height: 23px;\n}\n.search-filters-wrapper .timing-wrapper .slider-value-container {\n  display: flex;\n  justify-content: space-between;\n  font-style: normal;\n  font-weight: 600;\n  font-size: 18px;\n  line-height: 23px;\n}\n.search-filters-wrapper .timing-wrapper .departure-time {\n  padding-bottom: 10px;\n}\n.search-filters-wrapper .timing-wrapper .landing-time {\n  padding: 20px 0px 10px 0px;\n}\n.search-filters-wrapper .button-containers {\n  background-color: #3c3835;\n  display: flex;\n  align-items: center;\n  margin-top: 10px;\n  position: sticky;\n  justify-content: space-around;\n}\n.search-filters-wrapper .filter-button button {\n  padding: 0px;\n  margin: 20px;\n  min-width: 115px;\n}\n.search-filters-wrapper .filter-button.reset-filter button {\n  margin-right: 5px;\n}\n.search-filters-wrapper .filter-button.apply-filter button {\n  color: #fff;\n  margin-left: 5px;\n}";
  styleInject(css_248z$19);
  var css_248z$1a = ".rc-slider {\n  position: relative;\n  height: 14px;\n  padding: 5px 0;\n  width: 100%;\n  border-radius: 6px;\n  touch-action: none;\n  box-sizing: border-box;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n.rc-slider * {\n  box-sizing: border-box;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n.rc-slider-rail {\n  position: absolute;\n  width: 100%;\n  background-color: #e9e9e9;\n  height: 4px;\n  border-radius: 6px;\n}\n.rc-slider-track {\n  position: absolute;\n  left: 0;\n  height: 4px;\n  border-radius: 6px;\n  background-color: #abe2fb;\n}\n.rc-slider-handle {\n  position: absolute;\n  width: 14px;\n  height: 14px;\n  cursor: pointer;\n  cursor: -webkit-grab;\n  margin-top: -5px;\n  cursor: grab;\n  border-radius: 50%;\n  border: solid 2px #96dbfa;\n  background-color: #fff;\n  touch-action: pan-x;\n}\n.rc-slider-handle-dragging.rc-slider-handle-dragging.rc-slider-handle-dragging {\n  border-color: #57c5f7;\n  box-shadow: 0 0 0 5px #96dbfa;\n}\n.rc-slider-handle:focus {\n  outline: none;\n}\n.rc-slider-handle-click-focused:focus {\n  border-color: #96dbfa;\n  box-shadow: unset;\n}\n.rc-slider-handle:hover {\n  border-color: #57c5f7;\n}\n.rc-slider-handle:active {\n  border-color: #57c5f7;\n  box-shadow: 0 0 5px #57c5f7;\n  cursor: grabbing;\n}\n.rc-slider-mark {\n  position: absolute;\n  top: 18px;\n  left: 0;\n  width: 100%;\n  font-size: 12px;\n}\n.rc-slider-mark-text {\n  position: absolute;\n  display: inline-block;\n  vertical-align: middle;\n  text-align: center;\n  cursor: pointer;\n  color: #999;\n}\n.rc-slider-mark-text-active {\n  color: #666;\n}\n.rc-slider-step {\n  position: absolute;\n  width: 100%;\n  height: 4px;\n  background: transparent;\n}\n.rc-slider-dot {\n  position: absolute;\n  bottom: -2px;\n  margin-left: -4px;\n  width: 8px;\n  height: 8px;\n  border: 2px solid #e9e9e9;\n  background-color: #fff;\n  cursor: pointer;\n  border-radius: 50%;\n  vertical-align: middle;\n}\n.rc-slider-dot-active {\n  border-color: #96dbfa;\n}\n.rc-slider-dot-reverse {\n  margin-right: -4px;\n}\n.rc-slider-disabled {\n  background-color: #e9e9e9;\n}\n.rc-slider-disabled .rc-slider-track {\n  background-color: #ccc;\n}\n.rc-slider-disabled .rc-slider-handle,\n.rc-slider-disabled .rc-slider-dot {\n  border-color: #ccc;\n  box-shadow: none;\n  background-color: #fff;\n  cursor: not-allowed;\n}\n.rc-slider-disabled .rc-slider-mark-text,\n.rc-slider-disabled .rc-slider-dot {\n  cursor: not-allowed !important;\n}\n.rc-slider-vertical {\n  width: 14px;\n  height: 100%;\n  padding: 0 5px;\n}\n.rc-slider-vertical .rc-slider-rail {\n  height: 100%;\n  width: 4px;\n}\n.rc-slider-vertical .rc-slider-track {\n  left: 5px;\n  bottom: 0;\n  width: 4px;\n}\n.rc-slider-vertical .rc-slider-handle {\n  margin-left: -5px;\n  touch-action: pan-y;\n}\n.rc-slider-vertical .rc-slider-mark {\n  top: 0;\n  left: 18px;\n  height: 100%;\n}\n.rc-slider-vertical .rc-slider-step {\n  height: 100%;\n  width: 4px;\n}\n.rc-slider-vertical .rc-slider-dot {\n  left: 2px;\n  margin-bottom: -4px;\n}\n.rc-slider-vertical .rc-slider-dot:first-child {\n  margin-bottom: -4px;\n}\n.rc-slider-vertical .rc-slider-dot:last-child {\n  margin-bottom: -4px;\n}\n.rc-slider-tooltip-zoom-down-enter,\n.rc-slider-tooltip-zoom-down-appear {\n  animation-duration: 0.3s;\n  animation-fill-mode: both;\n  display: block !important;\n  animation-play-state: paused;\n}\n.rc-slider-tooltip-zoom-down-leave {\n  animation-duration: 0.3s;\n  animation-fill-mode: both;\n  display: block !important;\n  animation-play-state: paused;\n}\n.rc-slider-tooltip-zoom-down-enter.rc-slider-tooltip-zoom-down-enter-active,\n.rc-slider-tooltip-zoom-down-appear.rc-slider-tooltip-zoom-down-appear-active {\n  animation-name: rcSliderTooltipZoomDownIn;\n  animation-play-state: running;\n}\n.rc-slider-tooltip-zoom-down-leave.rc-slider-tooltip-zoom-down-leave-active {\n  animation-name: rcSliderTooltipZoomDownOut;\n  animation-play-state: running;\n}\n.rc-slider-tooltip-zoom-down-enter,\n.rc-slider-tooltip-zoom-down-appear {\n  transform: scale(0, 0);\n  animation-timing-function: cubic-bezier(0.23, 1, 0.32, 1);\n}\n.rc-slider-tooltip-zoom-down-leave {\n  animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);\n}\n@keyframes rcSliderTooltipZoomDownIn {\n  0% {\n    opacity: 0;\n    transform-origin: 50% 100%;\n    transform: scale(0, 0);\n  }\n  100% {\n    transform-origin: 50% 100%;\n    transform: scale(1, 1);\n  }\n}\n@keyframes rcSliderTooltipZoomDownOut {\n  0% {\n    transform-origin: 50% 100%;\n    transform: scale(1, 1);\n  }\n  100% {\n    opacity: 0;\n    transform-origin: 50% 100%;\n    transform: scale(0, 0);\n  }\n}\n.rc-slider-tooltip {\n  position: absolute;\n  left: -9999px;\n  top: -9999px;\n  visibility: visible;\n  box-sizing: border-box;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n.rc-slider-tooltip * {\n  box-sizing: border-box;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n.rc-slider-tooltip-hidden {\n  display: none;\n}\n.rc-slider-tooltip-placement-top {\n  padding: 4px 0 8px 0;\n}\n.rc-slider-tooltip-inner {\n  padding: 6px 2px;\n  min-width: 24px;\n  height: 24px;\n  font-size: 12px;\n  line-height: 1;\n  color: #fff;\n  text-align: center;\n  text-decoration: none;\n  background-color: #6c6c6c;\n  border-radius: 6px;\n  box-shadow: 0 0 4px #d9d9d9;\n}\n.rc-slider-tooltip-arrow {\n  position: absolute;\n  width: 0;\n  height: 0;\n  border-color: transparent;\n  border-style: solid;\n}\n.rc-slider-tooltip-placement-top .rc-slider-tooltip-arrow {\n  bottom: 4px;\n  left: 50%;\n  margin-left: -4px;\n  border-width: 4px 4px 0;\n  border-top-color: #6c6c6c;\n}\n";
  styleInject(css_248z$1a);

  var SearchFilters = function SearchFilters(_ref) {
    var maxStopovers = _ref.maxStopovers,
        onMaxStopoversChange = _ref.onMaxStopoversChange,
        maxBusLayover = _ref.maxBusLayover,
        maxFlightLayover = _ref.maxFlightLayover,
        onBusLayoverChange = _ref.onBusLayoverChange,
        onFlightLayoverTimeChange = _ref.onFlightLayoverTimeChange,
        onCabinTypeChange = _ref.onCabinTypeChange,
        cabinTypes = _ref.cabinTypes,
        airlineFilter = _ref.airlineFilter,
        onAirlineFilterChange = _ref.onAirlineFilterChange,
        connectingAirports = _ref.connectingAirports,
        onConnectingAirportsChange = _ref.onConnectingAirportsChange,
        onApplyFilters = _ref.onApplyFilters,
        onResetFilters = _ref.onResetFilters,
        totalTripTime = _ref.totalTripTime,
        onTotalTripTimeChange = _ref.onTotalTripTimeChange,
        modal = _ref.modal;
    var SearchFiltersClass = classNames("search-filters-wrapper", {
      "search-filter-wrapper-modal": modal
    });
    var filterContainerRef = React.useRef();
    return /*#__PURE__*/React__default.createElement("div", {
      className: SearchFiltersClass
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "search-filter-content",
      ref: filterContainerRef
    }, /*#__PURE__*/React__default.createElement(CabinTypeFilter, {
      cabinTypes: cabinTypes,
      onCabinTypeChange: onCabinTypeChange
    }), airlineFilter.length > 0 && /*#__PURE__*/React__default.createElement(CarrierFilter, {
      airlineFilter: airlineFilter,
      onAirlineFilterChange: onAirlineFilterChange
    }), /*#__PURE__*/React__default.createElement(LayoverFilter, {
      maxLayover: maxBusLayover,
      onLayoverTimeChange: onBusLayoverChange,
      transportType: "bus"
    }), /*#__PURE__*/React__default.createElement(LayoverFilter, {
      maxLayover: maxFlightLayover,
      onLayoverTimeChange: onFlightLayoverTimeChange,
      transportType: "flight"
    }), /*#__PURE__*/React__default.createElement(StopOverFilter, {
      maxStopovers: maxStopovers,
      onMaxStopoversChange: onMaxStopoversChange
    }), connectingAirports.length > 0 && /*#__PURE__*/React__default.createElement(ConnectingAirportFilter, {
      connectingAirports: connectingAirports,
      onConnectingAirportsChange: onConnectingAirportsChange
    }), /*#__PURE__*/React__default.createElement(TripDurationFilter, {
      filterContainerRef: filterContainerRef,
      totalTripTime: totalTripTime,
      onTotalTripTimeChange: onTotalTripTimeChange
    })), /*#__PURE__*/React__default.createElement("div", {
      className: "button-containers"
    }, /*#__PURE__*/React__default.createElement(Button, {
      type: "regular",
      className: "filter-button reset-filter",
      onClick: onResetFilters
    }, "Reset All"), /*#__PURE__*/React__default.createElement(Button, {
      type: "secondary",
      className: "filter-button apply-filter",
      onClick: onApplyFilters
    }, "Apply")));
  };

  SearchFilters.propTypes = {
    airlineFilter: PropTypes__default.instanceOf(Array),
    onAirlineFilterChange: PropTypes__default.func,
    maxStopovers: PropTypes__default.instanceOf(Array),
    onMaxStopoversChange: PropTypes__default.func,
    cabinTypes: PropTypes__default.string,
    onCabinTypeChange: PropTypes__default.func,
    maxBusLayover: PropTypes__default.instanceOf(Array),
    maxFlightLayover: PropTypes__default.instanceOf(Array),
    onFlightLayoverTimeChange: PropTypes__default.func,
    onBusLayoverChange: PropTypes__default.func,
    connectingAirports: PropTypes__default.instanceOf(Array),
    onConnectingAirportsChange: PropTypes__default.func,
    onApplyFilters: PropTypes__default.func,
    onResetFilters: PropTypes__default.func,
    modal: PropTypes__default.bool,
    totalTripTime: PropTypes__default.number,
    onTotalTripTimeChange: PropTypes__default.number
  };
  SearchFilters.defaultProps = {
    airlineFilter: [],
    onAirlineFilterChange: function onAirlineFilterChange() {},
    maxStopovers: [],
    onMaxStopoversChange: function onMaxStopoversChange() {},
    cabinTypes: "M",
    onCabinTypeChange: function onCabinTypeChange() {},
    maxBusLayover: [],
    maxFlightLayover: [],
    onFlightLayoverTimeChange: function onFlightLayoverTimeChange() {},
    onBusLayoverChange: function onBusLayoverChange() {},
    connectingAirports: [],
    onConnectingAirportsChange: function onConnectingAirportsChange() {},
    onApplyFilters: function onApplyFilters() {},
    onResetFilters: function onResetFilters() {},
    modal: false,
    totalTripTime: 0,
    onTotalTripTimeChange: function onTotalTripTimeChange() {}
  };
  var css_248z$1b = ".searchform-wrapper {\n  background: #ffffff;\n  box-shadow: 0px 20px 20px rgba(0, 0, 0, 0.15);\n  padding: 22px 20px 20px 20px;\n}\n.searchform-wrapper .first-column-container {\n  display: flex;\n}\n.searchform-wrapper .first-column-container .locationForm-container {\n  flex: 2;\n  padding-right: 10px;\n}\n.searchform-wrapper .first-column-container .counter-wrapper {\n  flex: 1;\n}\n.searchform-wrapper .second-column-container {\n  display: flex;\n  align-items: center;\n}\n.searchform-wrapper .second-column-container .for-date-wrapper {\n  flex: 3;\n}\n.searchform-wrapper .second-column-container .search-buttons {\n  display: flex;\n  flex: 3;\n  align-items: center;\n}\n.searchform-wrapper .second-column-container .search-buttons .points-button {\n  flex: 1;\n  padding-left: 10px;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 20px;\n}\n.searchform-wrapper .counter-wrapper-responsive {\n  width: 70%;\n}\n.searchform-wrapper .switch-milemarkers {\n  font-weight: 600;\n  font-size: 18px;\n  line-height: 23px;\n  align-items: center;\n}\n.searchform-wrapper .switch-milemarkers .switch-button-text {\n  margin-left: 10px;\n}\n@media screen and (orientation: landscape) {\n  .searchform-wrapper .switch-milemarkers {\n    display: none;\n  }\n}\n@media screen and (max-width: 1120px) {\n  .searchform-wrapper {\n    padding: 20px;\n  }\n}\n@media screen and (max-width: 700px) {\n  .searchform-wrapper .inputFieldSets-container div {\n    margin: 0;\n  }\n  .searchform-wrapper .locationForm-container {\n    padding-right: 0px !important;\n  }\n  .searchform-wrapper .second-column-container {\n    flex-direction: column;\n  }\n  .searchform-wrapper .counter-wrapper-responsive {\n    display: block;\n  }\n  .searchform-wrapper .counter-wrapper {\n    display: none;\n  }\n  .searchform-wrapper .for-date-wrapper {\n    margin-right: 0px !important;\n    width: 100%;\n    padding: 10px 0px;\n  }\n  .searchform-wrapper .for-date-wrapper .DateRangePickerContainer {\n    height: 44px;\n  }\n  .searchform-wrapper .search-buttons {\n    display: flex;\n    justify-content: space-between;\n    width: 100%;\n  }\n  .searchform-wrapper .search-buttons .search-button {\n    flex: 1;\n    margin-left: 0px;\n  }\n  .searchform-wrapper .search-buttons .points-button {\n    flex: 1;\n  }\n  .searchform-wrapper .first-column-container .to-wrapper {\n    margin-right: 0px;\n  }\n}\n\n.switch-button-label {\n  flex-shrink: 0;\n}\n\n.switch-milemarkers {\n  font-weight: 600;\n  font-size: 18px;\n  line-height: 23px;\n  display: none;\n  align-items: center;\n}\n.switch-milemarkers .switch-button-text {\n  margin-left: 10px;\n}\n\n@media only screen and (max-width: 400px) {\n  .searchform-wrapper .switch-milemarkers {\n    font-size: 16px;\n  }\n}\n.mobile-only {\n  display: none;\n}\n\n@media only screen and (max-width: 520px) {\n  .desktop-only {\n    display: none;\n  }\n  .mobile-only {\n    display: flex;\n    width: 100%;\n    flex-direction: column;\n  }\n  .incrementerGroup-wrapper {\n    padding: 0 10px;\n  }\n  .singleIncrementer-wrapper .increase_container,\n.singleIncrementer-wrapper .decrease_container {\n    padding: 0;\n  }\n  .singleIncrementer-wrapper .number-to-increment {\n    width: auto;\n  }\n  .singleIncrementer-wrapper .text {\n    font-size: 14px;\n  }\n  .singleIncrementer-wrapper .commands {\n    width: 55px;\n  }\n  .singleIncrementer-wrapper .commands svg {\n    width: 18px;\n    height: 18px;\n  }\n  .row {\n    width: 100%;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: 10px;\n  }\n  .row .dropdownmenu-wrapper {\n    margin: 0 !important;\n  }\n  .row .switch-button-label {\n    background: #ccc;\n    width: 34px;\n    height: 20px;\n  }\n  .row .switch-button-label::after {\n    width: 14px;\n    height: 14px;\n  }\n  .row .switch-button-text {\n    font-weight: 400;\n    font-size: 12px;\n    line-height: 14px;\n    white-space: nowrap;\n  }\n  .search-buttons {\n    display: none !important;\n  }\n  .counter-wrapper-responsive .dropdownmenu-wrapper {\n    background-color: transparent !important;\n  }\n  .counter-wrapper-responsive .counter-value.mobile-only {\n    display: flex;\n    flex-direction: row;\n    gap: 10px;\n    align-items: center;\n  }\n  .counter-wrapper-responsive .counter-value.mobile-only div {\n    background: #fff;\n    border-radius: 6px;\n    padding: 10px;\n    border: 1px solid #cdccc8;\n  }\n}";
  styleInject(css_248z$1b);
  var CHILD_MIN_AGE = 0;
  var CHILD_MAX_AGE = 12;
  var ADULT_MIN_AGE = 13;
  var css_248z$1c = ".PresetDateRangePicker_panel {\n  padding: 0 22px 11px\n}\n.PresetDateRangePicker_button {\n  position: relative;\n  height: 100%;\n  text-align: center;\n  background: 0 0;\n  border: 2px solid #00a699;\n  color: #00a699;\n  padding: 4px 12px;\n  margin-right: 8px;\n  font: inherit;\n  font-weight: 700;\n  line-height: normal;\n  overflow: visible;\n  box-sizing: border-box;\n  cursor: pointer\n}\n.PresetDateRangePicker_button:active {\n  outline: 0\n}\n.PresetDateRangePicker_button__selected {\n  color: #fff;\n  background: #00a699\n}\n.SingleDatePickerInput {\n  display: inline-block;\n  background-color: #fff\n}\n.SingleDatePickerInput__withBorder {\n  border-radius: 2px;\n  border: 1px solid #dbdbdb\n}\n.SingleDatePickerInput__rtl {\n  direction: rtl\n}\n.SingleDatePickerInput__disabled {\n  background-color: #f2f2f2\n}\n.SingleDatePickerInput__block {\n  display: block\n}\n.SingleDatePickerInput__showClearDate {\n  padding-right: 30px\n}\n.SingleDatePickerInput_clearDate {\n  background: 0 0;\n  border: 0;\n  color: inherit;\n  font: inherit;\n  line-height: normal;\n  overflow: visible;\n  cursor: pointer;\n  padding: 10px;\n  margin: 0 10px 0 5px;\n  position: absolute;\n  right: 0;\n  top: 50%;\n  transform: translateY(-50%)\n}\n.SingleDatePickerInput_clearDate__default:focus,\n.SingleDatePickerInput_clearDate__default:hover {\n  background: #dbdbdb;\n  border-radius: 50%\n}\n.SingleDatePickerInput_clearDate__small {\n  padding: 6px\n}\n.SingleDatePickerInput_clearDate__hide {\n  visibility: hidden\n}\n.SingleDatePickerInput_clearDate_svg {\n  fill: #82888a;\n  height: 12px;\n  width: 15px;\n  vertical-align: middle\n}\n.SingleDatePickerInput_clearDate_svg__small {\n  height: 9px\n}\n.SingleDatePickerInput_calendarIcon {\n  background: 0 0;\n  border: 0;\n  color: inherit;\n  font: inherit;\n  line-height: normal;\n  overflow: visible;\n  cursor: pointer;\n  display: inline-block;\n  vertical-align: middle;\n  padding: 10px;\n  margin: 0 5px 0 10px\n}\n.SingleDatePickerInput_calendarIcon_svg {\n  fill: #82888a;\n  height: 15px;\n  width: 14px;\n  vertical-align: middle\n}\n.SingleDatePicker {\n  position: relative;\n  display: inline-block\n}\n.SingleDatePicker__block {\n  display: block\n}\n.SingleDatePicker_picker {\n  z-index: 1;\n  background-color: #fff;\n  position: absolute\n}\n.SingleDatePicker_picker__rtl {\n  direction: rtl\n}\n.SingleDatePicker_picker__directionLeft {\n  left: 0\n}\n.SingleDatePicker_picker__directionRight {\n  right: 0\n}\n.SingleDatePicker_picker__portal {\n  background-color: rgba(0,0,0,.3);\n  position: fixed;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 100%\n}\n.SingleDatePicker_picker__fullScreenPortal {\n  background-color: #fff\n}\n.SingleDatePicker_closeButton {\n  background: 0 0;\n  border: 0;\n  color: inherit;\n  font: inherit;\n  line-height: normal;\n  overflow: visible;\n  cursor: pointer;\n  position: absolute;\n  top: 0;\n  right: 0;\n  padding: 15px;\n  z-index: 2\n}\n.SingleDatePicker_closeButton:focus,\n.SingleDatePicker_closeButton:hover {\n  color: darken(#cacccd,10%);\n  text-decoration: none\n}\n.SingleDatePicker_closeButton_svg {\n  height: 15px;\n  width: 15px;\n  fill: #cacccd\n}\n.DayPickerKeyboardShortcuts_buttonReset {\n  background: 0 0;\n  border: 0;\n  border-radius: 0;\n  color: inherit;\n  font: inherit;\n  line-height: normal;\n  overflow: visible;\n  padding: 0;\n  cursor: pointer;\n  font-size: 14px\n}\n.DayPickerKeyboardShortcuts_buttonReset:active {\n  outline: 0\n}\n.DayPickerKeyboardShortcuts_show {\n  width: 33px;\n  height: 26px;\n  position: absolute;\n  z-index: 2\n}\n.DayPickerKeyboardShortcuts_show::before {\n  content: \"\";\n  display: block;\n  position: absolute\n}\n.DayPickerKeyboardShortcuts_show__bottomRight {\n  bottom: 0;\n  right: 0\n}\n.DayPickerKeyboardShortcuts_show__bottomRight::before {\n  border-top: 26px solid transparent;\n  border-right: 33px solid #00a699;\n  bottom: 0;\n  right: 0\n}\n.DayPickerKeyboardShortcuts_show__bottomRight:hover::before {\n  border-right: 33px solid #008489\n}\n.DayPickerKeyboardShortcuts_show__topRight {\n  top: 0;\n  right: 0\n}\n.DayPickerKeyboardShortcuts_show__topRight::before {\n  border-bottom: 26px solid transparent;\n  border-right: 33px solid #00a699;\n  top: 0;\n  right: 0\n}\n.DayPickerKeyboardShortcuts_show__topRight:hover::before {\n  border-right: 33px solid #008489\n}\n.DayPickerKeyboardShortcuts_show__topLeft {\n  top: 0;\n  left: 0\n}\n.DayPickerKeyboardShortcuts_show__topLeft::before {\n  border-bottom: 26px solid transparent;\n  border-left: 33px solid #00a699;\n  top: 0;\n  left: 0\n}\n.DayPickerKeyboardShortcuts_show__topLeft:hover::before {\n  border-left: 33px solid #008489\n}\n.DayPickerKeyboardShortcuts_showSpan {\n  color: #fff;\n  position: absolute\n}\n.DayPickerKeyboardShortcuts_showSpan__bottomRight {\n  bottom: 0;\n  right: 5px\n}\n.DayPickerKeyboardShortcuts_showSpan__topRight {\n  top: 1px;\n  right: 5px\n}\n.DayPickerKeyboardShortcuts_showSpan__topLeft {\n  top: 1px;\n  left: 5px\n}\n.DayPickerKeyboardShortcuts_panel {\n  overflow: auto;\n  background: #fff;\n  border: 1px solid #dbdbdb;\n  border-radius: 2px;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  left: 0;\n  z-index: 2;\n  padding: 22px;\n  margin: 33px;\n  text-align: left\n}\n.DayPickerKeyboardShortcuts_title {\n  font-size: 16px;\n  font-weight: 700;\n  margin: 0\n}\n.DayPickerKeyboardShortcuts_list {\n  list-style: none;\n  padding: 0;\n  font-size: 14px\n}\n.DayPickerKeyboardShortcuts_close {\n  position: absolute;\n  right: 22px;\n  top: 22px;\n  z-index: 2\n}\n.DayPickerKeyboardShortcuts_close:active {\n  outline: 0\n}\n.DayPickerKeyboardShortcuts_closeSvg {\n  height: 15px;\n  width: 15px;\n  fill: #cacccd\n}\n.DayPickerKeyboardShortcuts_closeSvg:focus,\n.DayPickerKeyboardShortcuts_closeSvg:hover {\n  fill: #82888a\n}\n.CalendarDay {\n  box-sizing: border-box;\n  cursor: pointer;\n  font-size: 14px;\n  text-align: center\n}\n.CalendarDay:active {\n  outline: 0\n}\n.CalendarDay__defaultCursor {\n  cursor: default\n}\n.CalendarDay__default {\n  border: 1px solid #e4e7e7;\n  color: #484848;\n  background: #fff\n}\n.CalendarDay__default:hover {\n  background: #e4e7e7;\n  border: 1px solid #e4e7e7;\n  color: inherit\n}\n.CalendarDay__hovered_offset {\n  background: #f4f5f5;\n  border: 1px double #e4e7e7;\n  color: inherit\n}\n.CalendarDay__outside {\n  border: 0;\n  background: #fff;\n  color: #484848\n}\n.CalendarDay__outside:hover {\n  border: 0\n}\n.CalendarDay__blocked_minimum_nights {\n  background: #fff;\n  border: 1px solid #eceeee;\n  color: #cacccd\n}\n.CalendarDay__blocked_minimum_nights:active,\n.CalendarDay__blocked_minimum_nights:hover {\n  background: #fff;\n  color: #cacccd\n}\n.CalendarDay__highlighted_calendar {\n  background: #ffe8bc;\n  color: #484848\n}\n.CalendarDay__highlighted_calendar:active,\n.CalendarDay__highlighted_calendar:hover {\n  background: #ffce71;\n  color: #484848\n}\n.CalendarDay__selected_span {\n  background: #66e2da;\n  border: 1px double #33dacd;\n  color: #fff\n}\n.CalendarDay__selected_span:active,\n.CalendarDay__selected_span:hover {\n  background: #33dacd;\n  border: 1px double #33dacd;\n  color: #fff\n}\n.CalendarDay__selected,\n.CalendarDay__selected:active,\n.CalendarDay__selected:hover {\n  background: #00a699;\n  border: 1px double #00a699;\n  color: #fff\n}\n.CalendarDay__hovered_span,\n.CalendarDay__hovered_span:hover {\n  background: #b2f1ec;\n  border: 1px double #80e8e0;\n  color: #007a87\n}\n.CalendarDay__hovered_span:active {\n  background: #80e8e0;\n  border: 1px double #80e8e0;\n  color: #007a87\n}\n.CalendarDay__blocked_calendar,\n.CalendarDay__blocked_calendar:active,\n.CalendarDay__blocked_calendar:hover {\n  background: #cacccd;\n  border: 1px solid #cacccd;\n  color: #82888a\n}\n.CalendarDay__blocked_out_of_range,\n.CalendarDay__blocked_out_of_range:active,\n.CalendarDay__blocked_out_of_range:hover {\n  background: #fff;\n  border: 1px solid #e4e7e7;\n  color: #cacccd\n}\n.CalendarDay__hovered_start_first_possible_end {\n  background: #eceeee;\n  border: 1px double #eceeee\n}\n.CalendarDay__hovered_start_blocked_min_nights {\n  background: #eceeee;\n  border: 1px double #e4e7e7\n}\n.CalendarMonth {\n  background: #fff;\n  text-align: center;\n  vertical-align: top;\n  -webkit-user-select: none;\n  user-select: none\n}\n.CalendarMonth_table {\n  border-collapse: collapse;\n  border-spacing: 0\n}\n.CalendarMonth_verticalSpacing {\n  border-collapse: separate\n}\n.CalendarMonth_caption {\n  color: #484848;\n  font-size: 18px;\n  text-align: center;\n  padding-top: 22px;\n  padding-bottom: 37px;\n  caption-side: initial\n}\n.CalendarMonth_caption__verticalScrollable {\n  padding-top: 12px;\n  padding-bottom: 7px\n}\n.CalendarMonthGrid {\n  background: #fff;\n  text-align: left;\n  z-index: 0\n}\n.CalendarMonthGrid__animating {\n  z-index: 1\n}\n.CalendarMonthGrid__horizontal {\n  position: absolute;\n  left: 9px\n}\n.CalendarMonthGrid__vertical,\n.CalendarMonthGrid__vertical_scrollable {\n  margin: 0 auto\n}\n.CalendarMonthGrid_month__horizontal {\n  display: inline-block;\n  vertical-align: top;\n  min-height: 100%\n}\n.CalendarMonthGrid_month__hideForAnimation {\n  position: absolute;\n  z-index: -1;\n  opacity: 0;\n  pointer-events: none\n}\n.CalendarMonthGrid_month__hidden {\n  visibility: hidden\n}\n.DayPickerNavigation {\n  position: relative;\n  z-index: 2\n}\n.DayPickerNavigation__horizontal {\n  height: 0\n}\n.DayPickerNavigation__verticalScrollable_prevNav {\n  z-index: 1\n}\n.DayPickerNavigation__verticalDefault {\n  position: absolute;\n  width: 100%;\n  height: 52px;\n  bottom: 0;\n  left: 0\n}\n.DayPickerNavigation__verticalScrollableDefault {\n  position: relative\n}\n.DayPickerNavigation__bottom {\n  height: auto\n}\n.DayPickerNavigation__bottomDefault {\n  -webkit-box-pack: justify;\n  -ms-flex-pack: justify;\n  display: flex;\n  justify-content: space-between\n}\n.DayPickerNavigation_button {\n  cursor: pointer;\n  -webkit-user-select: none;\n  user-select: none;\n  border: 0;\n  padding: 0;\n  margin: 0\n}\n.DayPickerNavigation_button__default {\n  border: 1px solid #e4e7e7;\n  background-color: #fff;\n  color: #757575\n}\n.DayPickerNavigation_button__default:focus,\n.DayPickerNavigation_button__default:hover {\n  border: 1px solid #c4c4c4\n}\n.DayPickerNavigation_button__default:active {\n  background: #f2f2f2\n}\n.DayPickerNavigation_button__disabled {\n  cursor: default;\n  border: 1px solid #f2f2f2\n}\n.DayPickerNavigation_button__disabled:focus,\n.DayPickerNavigation_button__disabled:hover {\n  border: 1px solid #f2f2f2\n}\n.DayPickerNavigation_button__disabled:active {\n  background: 0 0\n}\n.DayPickerNavigation_button__horizontalDefault {\n  position: absolute;\n  top: 18px;\n  line-height: .78;\n  border-radius: 3px;\n  padding: 6px 9px\n}\n.DayPickerNavigation_bottomButton__horizontalDefault {\n  position: static;\n  margin: -10px 22px 30px\n}\n.DayPickerNavigation_leftButton__horizontalDefault {\n  left: 22px\n}\n.DayPickerNavigation_rightButton__horizontalDefault {\n  right: 22px\n}\n.DayPickerNavigation_button__verticalDefault {\n  padding: 5px;\n  background: #fff;\n  box-shadow: 0 0 5px 2px rgba(0,0,0,.1);\n  position: relative;\n  display: inline-block;\n  text-align: center;\n  height: 100%;\n  width: 50%\n}\n.DayPickerNavigation_nextButton__verticalDefault {\n  border-left: 0\n}\n.DayPickerNavigation_nextButton__verticalScrollableDefault,\n.DayPickerNavigation_prevButton__verticalScrollableDefault {\n  width: 100%\n}\n.DayPickerNavigation_svg__horizontal {\n  height: 19px;\n  width: 19px;\n  fill: #82888a;\n  display: block\n}\n.DayPickerNavigation_svg__vertical {\n  height: 42px;\n  width: 42px;\n  fill: #484848\n}\n.DayPickerNavigation_svg__disabled {\n  fill: #f2f2f2\n}\n.DayPicker {\n  background: #fff;\n  position: relative;\n  text-align: left\n}\n.DayPicker__horizontal {\n  background: #fff\n}\n.DayPicker__verticalScrollable {\n  height: 100%\n}\n.DayPicker__hidden {\n  visibility: hidden\n}\n.DayPicker__withBorder {\n  box-shadow: 0 2px 6px rgba(0,0,0,.05),0 0 0 1px rgba(0,0,0,.07);\n  border-radius: 3px\n}\n.DayPicker_portal__horizontal {\n  box-shadow: none;\n  position: absolute;\n  left: 50%;\n  top: 50%\n}\n.DayPicker_portal__vertical {\n  position: initial\n}\n.DayPicker_focusRegion {\n  outline: 0\n}\n.DayPicker_calendarInfo__horizontal,\n.DayPicker_wrapper__horizontal {\n  display: inline-block;\n  vertical-align: top\n}\n.DayPicker_weekHeaders {\n  position: relative\n}\n.DayPicker_weekHeaders__horizontal {\n  margin-left: 9px\n}\n.DayPicker_weekHeader {\n  color: #757575;\n  position: absolute;\n  top: 62px;\n  z-index: 2;\n  text-align: left\n}\n.DayPicker_weekHeader__vertical {\n  left: 50%\n}\n.DayPicker_weekHeader__verticalScrollable {\n  top: 0;\n  display: table-row;\n  border-bottom: 1px solid #dbdbdb;\n  background: #fff;\n  margin-left: 0;\n  left: 0;\n  width: 100%;\n  text-align: center\n}\n.DayPicker_weekHeader_ul {\n  list-style: none;\n  margin: 1px 0;\n  padding-left: 0;\n  padding-right: 0;\n  font-size: 14px\n}\n.DayPicker_weekHeader_li {\n  display: inline-block;\n  text-align: center\n}\n.DayPicker_transitionContainer {\n  position: relative;\n  overflow: hidden;\n  border-radius: 3px\n}\n.DayPicker_transitionContainer__horizontal {\n  transition: height .2s ease-in-out\n}\n.DayPicker_transitionContainer__vertical {\n  width: 100%\n}\n.DayPicker_transitionContainer__verticalScrollable {\n  padding-top: 20px;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  left: 0;\n  overflow-y: scroll\n}\n.DateInput {\n  margin: 0;\n  padding: 0;\n  background: #fff;\n  position: relative;\n  display: inline-block;\n  width: 130px;\n  vertical-align: middle\n}\n.DateInput__small {\n  width: 97px\n}\n.DateInput__block {\n  width: 100%\n}\n.DateInput__disabled {\n  background: #f2f2f2;\n  color: #dbdbdb\n}\n.DateInput_input {\n  font-weight: 200;\n  font-size: 19px;\n  line-height: 24px;\n  color: #484848;\n  background-color: #fff;\n  width: 100%;\n  padding: 11px 11px 9px;\n  border: 0;\n  border-top: 0;\n  border-right: 0;\n  border-bottom: 2px solid transparent;\n  border-left: 0;\n  border-radius: 0\n}\n.DateInput_input__small {\n  font-size: 15px;\n  line-height: 18px;\n  letter-spacing: .2px;\n  padding: 7px 7px 5px\n}\n.DateInput_input__regular {\n  font-weight: auto\n}\n.DateInput_input__readOnly {\n  -webkit-user-select: none;\n  user-select: none\n}\n.DateInput_input__focused {\n  outline: 0;\n  background: #fff;\n  border: 0;\n  border-top: 0;\n  border-right: 0;\n  border-bottom: 2px solid #008489;\n  border-left: 0\n}\n.DateInput_input__disabled {\n  background: #f2f2f2;\n  font-style: italic\n}\n.DateInput_screenReaderMessage {\n  border: 0;\n  clip: rect(0,0,0,0);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px\n}\n.DateInput_fang {\n  position: absolute;\n  width: 20px;\n  height: 10px;\n  left: 22px;\n  z-index: 2\n}\n.DateInput_fangShape {\n  fill: #fff\n}\n.DateInput_fangStroke {\n  stroke: #dbdbdb;\n  fill: transparent\n}\n.DateRangePickerInput {\n  background-color: #fff;\n  display: inline-block\n}\n.DateRangePickerInput__disabled {\n  background: #f2f2f2\n}\n.DateRangePickerInput__withBorder {\n  border-radius: 2px;\n  border: 1px solid #dbdbdb\n}\n.DateRangePickerInput__rtl {\n  direction: rtl\n}\n.DateRangePickerInput__block {\n  display: block\n}\n.DateRangePickerInput__showClearDates {\n  padding-right: 30px\n}\n.DateRangePickerInput_arrow {\n  display: inline-block;\n  vertical-align: middle;\n  color: #484848\n}\n.DateRangePickerInput_arrow_svg {\n  vertical-align: middle;\n  fill: #484848;\n  height: 24px;\n  width: 24px\n}\n.DateRangePickerInput_clearDates {\n  background: 0 0;\n  border: 0;\n  color: inherit;\n  font: inherit;\n  line-height: normal;\n  overflow: visible;\n  cursor: pointer;\n  padding: 10px;\n  margin: 0 10px 0 5px;\n  position: absolute;\n  right: 0;\n  top: 50%;\n  transform: translateY(-50%)\n}\n.DateRangePickerInput_clearDates__small {\n  padding: 6px\n}\n.DateRangePickerInput_clearDates_default:focus,\n.DateRangePickerInput_clearDates_default:hover {\n  background: #dbdbdb;\n  border-radius: 50%\n}\n.DateRangePickerInput_clearDates__hide {\n  visibility: hidden\n}\n.DateRangePickerInput_clearDates_svg {\n  fill: #82888a;\n  height: 12px;\n  width: 15px;\n  vertical-align: middle\n}\n.DateRangePickerInput_clearDates_svg__small {\n  height: 9px\n}\n.DateRangePickerInput_calendarIcon {\n  background: 0 0;\n  border: 0;\n  color: inherit;\n  font: inherit;\n  line-height: normal;\n  overflow: visible;\n  cursor: pointer;\n  display: inline-block;\n  vertical-align: middle;\n  padding: 10px;\n  margin: 0 5px 0 10px\n}\n.DateRangePickerInput_calendarIcon_svg {\n  fill: #82888a;\n  height: 15px;\n  width: 14px;\n  vertical-align: middle\n}\n.DateRangePicker {\n  position: relative;\n  display: inline-block\n}\n.DateRangePicker__block {\n  display: block\n}\n.DateRangePicker_picker {\n  z-index: 1;\n  background-color: #fff;\n  position: absolute\n}\n.DateRangePicker_picker__rtl {\n  direction: rtl\n}\n.DateRangePicker_picker__directionLeft {\n  left: 0\n}\n.DateRangePicker_picker__directionRight {\n  right: 0\n}\n.DateRangePicker_picker__portal {\n  background-color: rgba(0,0,0,.3);\n  position: fixed;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 100%\n}\n.DateRangePicker_picker__fullScreenPortal {\n  background-color: #fff\n}\n.DateRangePicker_closeButton {\n  background: 0 0;\n  border: 0;\n  color: inherit;\n  font: inherit;\n  line-height: normal;\n  overflow: visible;\n  cursor: pointer;\n  position: absolute;\n  top: 0;\n  right: 0;\n  padding: 15px;\n  z-index: 2\n}\n.DateRangePicker_closeButton:focus,\n.DateRangePicker_closeButton:hover {\n  color: darken(#cacccd,10%);\n  text-decoration: none\n}\n.DateRangePicker_closeButton_svg {\n  height: 15px;\n  width: 15px;\n  fill: #cacccd\n}";
  styleInject(css_248z$1c);
  var css_248z$1d = ".DateRangePickerContainer {\n  position: relative;\n}\n.DateRangePickerContainer.fromError .labelwrapper {\n  color: #ff4040;\n}\n.DateRangePickerContainer.fromError .DateInput:nth-child(1) input {\n  color: #ff4040 !important;\n  border-color: #ff4040 !important;\n}\n.DateRangePickerContainer .labelwrapper {\n  position: absolute;\n  left: 10px;\n  z-index: 1;\n  top: -5px;\n  padding: 0px 5px;\n  font-family: \"Source Sans Pro\", sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 8.5px;\n  line-height: 10px;\n  text-transform: uppercase;\n  background: #fff;\n  color: #3c3835;\n}\n@media only screen and (max-width: 400px) {\n  .DateRangePickerContainer .labelwrapper .labelwrapper {\n    padding: 0px;\n    font-size: 10px;\n    left: 15px;\n  }\n}\n.DateRangePickerContainer .DateRangePicker {\n  width: 100%;\n  height: 40px;\n}\n.DateRangePickerContainer .DateRangePicker .DateRangePickerInput {\n  padding: 0;\n  border-radius: 0;\n  border: none;\n  width: 100%;\n  height: 40px;\n}\n.DateRangePickerContainer .DateRangePicker .DateRangePickerInput .DateRangePickerInput_calendarIcon {\n  margin: 0 !important;\n  padding: 0 !important;\n}\n.DateRangePickerContainer .DateRangePicker .DateRangePickerInput .DateInput {\n  width: 50%;\n}\n.DateRangePickerContainer .DateRangePicker .DateRangePickerInput .DateInput .DateInput_input.DateInput_input_1 {\n  font-family: \"Source Sans Pro\", sans-serif;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 18px;\n  line-height: 23px;\n  align-items: center;\n  color: #3c3835;\n  height: 40px;\n  box-sizing: border-box;\n  border-top: 1px solid #cdccc8;\n  border-bottom: 1px solid #cdccc8;\n  padding: 0 40px 0 10px;\n}\n.DateRangePickerContainer .DateRangePicker .DateRangePickerInput .DateInput .DateInput_input.DateInput_input_1::-webkit-input-placeholder {\n  color: #cdccc8;\n}\n.DateRangePickerContainer .DateRangePicker .DateRangePickerInput .DateInput .DateInput_input.DateInput_input_1::-moz-placeholder {\n  color: #cdccc8;\n}\n.DateRangePickerContainer .DateRangePicker .DateRangePickerInput .DateInput .DateInput_input.DateInput_input_1:-ms-input-placeholder {\n  color: #cdccc8;\n}\n.DateRangePickerContainer .DateRangePicker .DateRangePickerInput .DateInput .DateInput_input.DateInput_input_1:-moz-placeholder {\n  color: #cdccc8;\n}\n.DateRangePickerContainer .DateRangePicker .DateRangePickerInput .DateInput .DateInput_input.DateInput_input_1#start_date {\n  border-left: 1px solid #cdccc8;\n  border-radius: 6px 0 0px 6px;\n}\n.DateRangePickerContainer .DateRangePicker .DateRangePickerInput .DateInput .DateInput_input.DateInput_input_1#end_date {\n  border-right: 1px solid #cdccc8;\n  border-radius: 0 6px 6px 0;\n}\n.DateRangePickerContainer .DateRangePicker .DateRangePickerInput .DateInput .DateInput_input.DateInput_input_1.DateInput_input__focused {\n  font-weight: 600;\n  color: #3c3835;\n  border-top: 1px solid #3c3835;\n  border-bottom: 1px solid #3c3835;\n}\n.DateRangePickerContainer .DateRangePicker .DateRangePickerInput .DateInput .DateInput_input.DateInput_input_1.DateInput_input__focused#start_date {\n  border-left: 1px solid #3c3835;\n  border-radius: 6px 0 0px 6px;\n}\n.DateRangePickerContainer .DateRangePicker .DateRangePickerInput .DateInput .DateInput_input.DateInput_input_1.DateInput_input__focused#end_date {\n  border-right: 1px solid #3c3835;\n  border-radius: 0 6px 6px 0;\n}\n.DateRangePickerContainer .DateRangePicker .DateRangePickerInput .DateRangePickerInput_arrow {\n  display: block;\n  vertical-align: middle;\n  color: #484848;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translateY(-50%);\n}\n\n.DateRangePicker_picker {\n  background: #ffffff;\n  box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.15);\n  border-radius: 6px;\n  z-index: 1000;\n}\n.DateRangePicker_picker .DayPickerNavigation__verticalDefault {\n  display: inline-flex;\n}\n.DateRangePicker_picker .DayPickerKeyboardShortcuts_show {\n  display: none;\n}\n.DateRangePicker_picker .DayPicker .CalendarMonth_caption {\n  font-family: \"Source Sans Pro\", sans-serif;\n  font-style: normal;\n  font-weight: 600;\n  font-size: 20px;\n  line-height: 100%;\n  text-align: center;\n  color: #000000;\n}\n.DateRangePicker_picker .DayPicker .DayPicker_weekHeader_ul .DayPicker_weekHeader_li {\n  font-family: \"Source Sans Pro\", sans-serif;\n  font-style: normal;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 18px;\n  text-align: center;\n  color: #000000;\n}\n.DateRangePicker_picker .DayPicker .DayPickerNavigation_button__horizontalDefault {\n  border: 1px solid #cdccc8;\n  box-sizing: border-box;\n  border-radius: 6px;\n}\n.DateRangePicker_picker .DayPicker .CalendarMonth_table {\n  margin-top: 10px;\n}\n.DateRangePicker_picker .DayPicker .CalendarMonth_table .CalendarDay__default {\n  font-family: \"Source Sans Pro\", sans-serif;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 18px;\n  line-height: 23px;\n  text-align: center;\n  color: #000000;\n  border: none;\n}\n.DateRangePicker_picker .DayPicker .CalendarMonth_table .CalendarDay__blocked_out_of_range {\n  font-family: \"Source Sans Pro\", sans-serif;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 18px;\n  line-height: 23px;\n  text-align: center;\n  color: #cdccc8;\n}\n.DateRangePicker_picker .DayPicker .CalendarMonth_table .CalendarDay__selected_span {\n  background: #fab500;\n  font-family: \"Source Sans Pro\", sans-serif;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 18px;\n  line-height: 23px;\n  text-align: center;\n  color: #3c3835;\n}\n.DateRangePicker_picker .DayPicker .CalendarMonth_table .CalendarDay__selected {\n  font-family: \"Source Sans Pro\", sans-serif;\n  font-style: normal;\n  font-weight: 600;\n  font-size: 18px;\n  line-height: 23px;\n  text-align: center;\n  background: #3c3835;\n  color: #fab500;\n}\n.DateRangePicker_picker .DayPicker .CalendarMonth_table .CalendarDay__default:hover,\n.DateRangePicker_picker .DayPicker .CalendarMonth_table .CalendarDay__selected:hover {\n  background: #fab500;\n  font-family: \"Source Sans Pro\", sans-serif;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 18px;\n  line-height: 23px;\n  text-align: center;\n  color: #3c3835;\n}\n.DateRangePicker_picker .DayPicker .CalendarMonth_table .CalendarDay__hovered_span:hover,\n.DateRangePicker_picker .DayPicker .CalendarMonth_table .CalendarDay__hovered_span {\n  background: rgba(250, 181, 0, 0.8);\n  font-family: \"Source Sans Pro\", sans-serif;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 18px;\n  line-height: 23px;\n  text-align: center;\n}\n.DateRangePicker_picker .one-way-button-calendar {\n  padding: 20px;\n}\n.DateRangePicker_picker .one-way-button-calendar.mobile {\n  position: fixed;\n  bottom: 62px;\n  left: 20px;\n}\n.DateRangePicker_picker .one-way-button-calendar .one-way-button-calendar-wrapper {\n  display: flex;\n}\n.DateRangePicker_picker .one-way-button-calendar span {\n  margin-left: 10px;\n}\n\n.DateRangePickerInput_clearDates {\n  right: 25px;\n  width: 25px;\n  padding: 0 1px 4px 0px !important;\n}\n\n@media only screen and (max-width: 600px) {\n  .DateRangePickerContainer .DateRangePicker .DateRangePickerInput .DateInput .DateInput_input.DateInput_input_1 {\n    font-size: 16px;\n    padding: 0 0 0 20px;\n  }\n  .DateRangePicker_picker .one-way-button-calendar {\n    padding: 0;\n  }\n  .DayPicker .CalendarMonth_caption {\n    padding-bottom: 15px;\n  }\n  .DayPicker_weekHeader_ul {\n    margin: -20px 0;\n  }\n}\n.single-date-picker .DateInput {\n  width: 100%;\n}\n\n.single-date-picker .DateRangePickerInput_arrow {\n  display: none;\n}\n\n.single-date-picker .DateInput_input {\n  border-radius: 6px;\n}\n\n.single-date-picker .DateInput_input_1 {\n  padding-right: 10px;\n}";
  styleInject(css_248z$1d);
  var global = typeof window !== "undefined" ? window : {
    matchMedia: function matchMedia() {
      return false;
    }
  };

  var DatePicker = function DatePicker(_ref) {
    var startDateParam = _ref.startDate,
        endDateParam = _ref.endDate,
        handleDayClick = _ref.handleDayClick,
        error = _ref.error,
        oneWay = _ref.oneWay,
        disabled = _ref.disabled,
        fromMaxDate = _ref.fromMaxDate,
        fromMinDate = _ref.fromMinDate,
        setIsLocationListOpened = _ref.setIsLocationListOpened;

    var _React$useState45 = React.useState({
      startDate: startDateParam,
      endDate: endDateParam,
      focusedInput: null
    }),
        _React$useState46 = _slicedToArray(_React$useState45, 2),
        state = _React$useState46[0],
        setState = _React$useState46[1];

    var setFocusedInput = function setFocusedInput(focusedInput) {
      setState(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), {}, {
          focusedInput: focusedInput
        });
      });
    };

    var getDisabledDate = function getDisabledDate() {
      if (disabled.disableEndDate && disabled.disableStartDate) return true;
      if (oneWay || disabled.disableEndDate) return "endDate";
      if (disabled.disableStartDate) return "startDate";
      return undefined;
    };

    var onDatesChange = function onDatesChange(_ref2) {
      var startDate = _ref2.startDate,
          endDate = _ref2.endDate;
      var changedInput = "startDate";
      var hasEndDateSet = !state.endDate && endDate;
      var hadEndDateChanged = state.endDate && endDate && state.endDate.format("LL") !== endDate.format("LL");

      if (hasEndDateSet || hadEndDateChanged) {
        changedInput = "endDate";
      }

      handleDayClick({
        startDate: startDate,
        endDate: endDate,
        focusedInput: changedInput
      });
      setState(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), {}, {
          startDate: startDate,
          endDate: endDate
        });
      });
    };

    var dateContainer = classNames("DateRangePickerContainer", {
      fromError: error
    });

    var isOutsideRange = function isOutsideRange(day) {
      if (fromMinDate) {
        if (fromMaxDate) {
          return day.isBefore(fromMinDate) || day.isAfter(moment(fromMaxDate).add(1, "days"));
        }

        return day.isBefore(fromMinDate);
      }

      return undefined;
    };

    return /*#__PURE__*/React__default.createElement("div", {
      className: dateContainer
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "labelwrapper"
    }, "choose date"), /*#__PURE__*/React__default.createElement(reactDates.DateRangePicker, {
      anchorDirection: "left",
      startDate: startDateParam // momentPropTypes.momentObj or null,
      ,
      startDateId: "start_date" // PropTypes.string.isRequired,
      ,
      endDate: endDateParam // momentPropTypes.momentObj or null,
      ,
      endDateId: "end_date" // PropTypes.string.isRequired,
      ,
      onDatesChange: onDatesChange // PropTypes.func.isRequired,
      ,
      focusedInput: state.focusedInput // PropTypes.oneOf([START_DATE, END_DATE]) or null,
      ,
      onFocusChange: function onFocusChange(focusedInput) {
        setIsLocationListOpened(false);

        if (global.matchMedia("(max-width: 480px)").matches) {
          if (state.focusedInput !== "startDate") {
            setFocusedInput(focusedInput);
          } else {
            setFocusedInput(null);
          }
        } else {
          setFocusedInput(focusedInput);
        }
      } // PropTypes.func.isRequired,
      ,
      displayFormat: "ddd D, MMM",
      minimumNights: 0,
      disabled: getDisabledDate(),
      startDatePlaceholderText: "Depart",
      endDatePlaceholderText: "Return",
      showDefaultInputIcon: true,
      inputIconPosition: "after",
      readOnly: true,
      customInputIcon: /*#__PURE__*/React__default.createElement(Icon, {
        name: "datepicker"
      }),
      customArrowIcon: /*#__PURE__*/React__default.createElement(Icon, {
        name: "date_arrow",
        style: {
          marginTop: 3
        }
      }),
      orientation: global.matchMedia("(max-width: 480px)").matches ? "vertical" : "horizontal",
      withFullScreenPortal: global.matchMedia("(max-width: 480px)").matches,
      showClearDates: true // renderCalendarInfo={calendarBottomContent}  // Hiding the bottom content as we won't be using it anymore
      ,
      isOutsideRange: fromMinDate || fromMaxDate ? isOutsideRange : undefined
    }));
  };

  DatePicker.propTypes = {
    startDate: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.instanceOf(Object)]),
    endDate: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.instanceOf(Object)]),
    handleDayClick: PropTypes__default.func,
    error: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.bool]),
    oneWay: PropTypes__default.bool,
    fromMaxDate: PropTypes__default.instanceOf(Object),
    fromMinDate: PropTypes__default.instanceOf(Object),
    disabled: PropTypes__default.instanceOf(Object),
    setIsLocationListOpened: PropTypes__default.func.isRequired
  };
  DatePicker.defaultProps = {
    startDate: "",
    endDate: "",
    handleDayClick: function handleDayClick() {},
    error: false,
    oneWay: false,
    fromMaxDate: undefined,
    fromMinDate: undefined,
    disabled: {}
  };
  var css_248z$1e = ".switch-button-input {\n  display: none;\n}\n\n.switch-button-label {\n  position: relative;\n  cursor: pointer;\n  display: inline-block;\n  width: 51px;\n  height: 30px;\n  background-color: #cdccc8;\n  border-radius: 20px;\n}\n.switch-button-label::after {\n  content: \"\";\n  position: absolute;\n  width: 20px;\n  height: 20px;\n  border-radius: 15px;\n  background-color: #ffffff;\n  left: 10%;\n  right: 50.82%;\n  top: 18%;\n  bottom: 25%;\n  transition: all 0.3s;\n}\n\n.switch-button-checked {\n  background-color: #fab500;\n}\n.switch-button-checked::after {\n  left: 50.82%;\n  right: 16.39%;\n  top: 18%;\n  bottom: 25%;\n}";
  styleInject(css_248z$1e);

  var SwitchButton = function SwitchButton(_ref) {
    var checked = _ref.checked,
        onChange = _ref.onChange,
        id = _ref.id,
        disabled = _ref.disabled;

    var _React$useState47 = React.useState({
      checked: checked
    }),
        _React$useState48 = _slicedToArray(_React$useState47, 2),
        state = _React$useState48[0],
        setState = _React$useState48[1];

    var changeState = function changeState(params) {
      setState(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), params);
      });
    };

    var handleChange = function handleChange(e) {
      if (!disabled) {
        changeState({
          checked: e.currentTarget.checked
        });
        onChange(e);
      }
    };

    var labelClassname = classNames("switch-button-label", {
      "switch-button-checked": state.checked
    });
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("input", {
      className: "switch-button-input",
      type: "checkbox",
      checked: state.checked,
      onChange: handleChange,
      id: id
    }), /*#__PURE__*/React__default.createElement("label", {
      className: labelClassname,
      htmlFor: id
    }));
  };

  SwitchButton.propTypes = {
    checked: PropTypes__default.bool,
    onChange: PropTypes__default.func,
    id: PropTypes__default.string.isRequired,
    disabled: PropTypes__default.bool
  };
  SwitchButton.defaultProps = {
    checked: false,
    onChange: function onChange() {
      return null;
    },
    disabled: false
  };
  var css_248z$1f = ".one-way-switch-button-container {\n  background-color: #e5e5e5;\n  border-radius: 8px;\n  padding: 3px;\n  margin: 3px;\n  display: flex;\n  justify-content: center;\n}\n@media only screen and (max-width: 700px) {\n  .one-way-switch-button-container {\n    width: 100%;\n  }\n}\n\n.one-way-switch-button-button {\n  border-radius: 6px;\n  font-size: 12px;\n  background: none;\n  border: none;\n  margin: 2px;\n  padding: 5px;\n  color: #82888a;\n  transition: all 0.5s ease;\n}\n@media only screen and (max-width: 700px) {\n  .one-way-switch-button-button {\n    width: 50%;\n    padding: 10px;\n  }\n}\n\n@media only screen and (max-width: 700px) {\n  .one-way-button-calendar-wrapper {\n    margin-top: 10px;\n    width: 100%;\n  }\n}\n@media only screen and (min-width: 700px) {\n  .one-way-button-calendar-wrapper {\n    margin-right: 10px;\n    width: 150px;\n  }\n}\n\n/* Animations */\n@keyframes revealBG {\n  from {\n    background-color: #e5e5e5;\n  }\n  to {\n    background-color: white;\n  }\n}\n#one-way-switch-button-selected {\n  animation-name: revealBG;\n  animation-duration: 0.3s;\n  animation-fill-mode: forwards;\n  animation-timing-function: ease-in;\n}";
  styleInject(css_248z$1f);

  var OneWaySwitchButton = function OneWaySwitchButton(_ref) {
    var onChange = _ref.onChange,
        id = _ref.id,
        checked = _ref.checked;

    var handleChange = function handleChange() {
      if (!checked) {
        onChange(true);
      } else {
        onChange(false);
      }
    };

    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
      className: "one-way-switch-button-container",
      id: id
    }, /*#__PURE__*/React__default.createElement("button", {
      type: "button",
      className: "one-way-switch-button-button",
      onClick: handleChange,
      id: !checked ? 'one-way-switch-button-selected' : ''
    }, "Round Trip"), /*#__PURE__*/React__default.createElement("button", {
      type: "button",
      className: "one-way-switch-button-button",
      onClick: handleChange,
      id: checked ? 'one-way-switch-button-selected' : ''
    }, "One Way")));
  };

  OneWaySwitchButton.propTypes = {
    checked: PropTypes__default.bool,
    onChange: PropTypes__default.func,
    id: PropTypes__default.string.isRequired,
    disabled: PropTypes__default.bool
  };
  OneWaySwitchButton.defaultProps = {
    checked: false,
    onChange: function onChange() {
      return null;
    },
    disabled: false
  };

  var SearchForm = function SearchForm(_ref) {
    var fromList = _ref.fromList,
        toList = _ref.toList,
        onDepartureDayChanged = _ref.onDepartureDayChanged,
        onReturnDayChanged = _ref.onReturnDayChanged,
        onSubmit = _ref.onSubmit,
        onAdultCountChange = _ref.onAdultCountChange,
        onChildrenCountChange = _ref.onChildrenCountChange,
        onInfantsCountChange = _ref.onInfantsCountChange,
        onPlaceSelect = _ref.onPlaceSelect,
        onLoyaltySubmit = _ref.onLoyaltySubmit,
        loyaltyActive = _ref.loyaltyActive,
        setReservationProperty = _ref.setReservationProperty,
        onLocationStringChange = _ref.onLocationStringChange,
        errors = _ref.errors,
        departureFrom = _ref.departureFrom,
        departureTo = _ref.departureTo,
        returnDate = _ref.returnDate,
        departureDate = _ref.departureDate,
        passengersAdults = _ref.passengersAdults,
        passengersChildrens = _ref.passengersChildrens,
        passengersInfants = _ref.passengersInfants,
        showFlightSearch = _ref.showFlightSearch,
        editTrip = _ref.editTrip,
        dateFromError = _ref.dateFromError,
        disabled = _ref.disabled,
        fromMaxDate = _ref.fromMaxDate,
        fromMinDate = _ref.fromMinDate;
    var searchformClass = classNames("searchform-wrapper", {
      "flight-search-enabled": showFlightSearch
    });

    var _React$useState49 = React.useState(false),
        _React$useState50 = _slicedToArray(_React$useState49, 2),
        isLocationListOpened = _React$useState50[0],
        setIsLocationListOpened = _React$useState50[1];

    var _React$useState51 = React.useState(true),
        _React$useState52 = _slicedToArray(_React$useState51, 2),
        enableTripSwitch = _React$useState52[0],
        setTripSwitch = _React$useState52[1];

    var _React$useState53 = React.useState(moment(departureDate)),
        _React$useState54 = _slicedToArray(_React$useState53, 2),
        startDate = _React$useState54[0],
        setStartDate = _React$useState54[1];

    var _React$useState55 = React.useState({
      adults: +passengersAdults,
      children: +passengersChildrens,
      infant: +passengersInfants,
      oneWay: false,
      endDate: returnDate ? moment(returnDate) : undefined
    }),
        _React$useState56 = _slicedToArray(_React$useState55, 2),
        state = _React$useState56[0],
        setState = _React$useState56[1];

    var _React$useState57 = React.useState(loyaltyActive),
        _React$useState58 = _slicedToArray(_React$useState57, 2),
        useLoyaltyActive = _React$useState58[0],
        setUseLoyaltyActive = _React$useState58[1];

    var getCounterLimit = function getCounterLimit(field) {
      switch (field) {
        case "adult":
          return state.children + state.infant;

        case "child":
          return state.adults + state.infant;

        case "infant":
          return state.children + state.adults;

        default:
          return 0;
      }
    };

    var getPassengersSum = function getPassengersSum() {
      return state.adults + state.children + state.infant;
    };

    var handleDayClick = function handleDayClick(range) {
      var rangeStartDate = range.startDate,
          rangeEndDate = range.endDate,
          focusedInput = range.focusedInput;
      setStartDate(rangeStartDate);
      setState(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), {}, {
          endDate: rangeEndDate
        });
      });

      if (!rangeStartDate && !rangeEndDate) {
        onDepartureDayChanged(moment(null));
        onReturnDayChanged(null);
      }

      if (focusedInput === "startDate" && rangeStartDate) {
        onDepartureDayChanged(rangeStartDate.toString());
      } else if (rangeEndDate) {
        onReturnDayChanged(rangeEndDate.toString());
      }
    };

    var onSearchClick = function onSearchClick() {
      if (useLoyaltyActive) {
        onLoyaltySubmit();
      } else {
        onSubmit();
      }
    }; // New State Change function for the new one way switch button
    // that will replace the old one


    var onOneWaySwitchChange = function onOneWaySwitchChange(value) {
      setState(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), {}, {
          endDate: undefined,
          oneWay: value
        });
      });
    };

    var forceOneWay = function forceOneWay() {
      onOneWaySwitchChange(true);
      setTripSwitch(false);
    };

    return /*#__PURE__*/React__default.createElement("div", {
      className: searchformClass
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "first-column-container"
    }, /*#__PURE__*/React__default.createElement(LocationForm$1, {
      isLocationListOpened: isLocationListOpened,
      fromList: fromList,
      toList: toList,
      onPlaceSelect: onPlaceSelect,
      onLocationStringChange: onLocationStringChange,
      departureTo: departureTo,
      departureFrom: departureFrom,
      errors: errors,
      setReservationProperty: setReservationProperty,
      disabled: disabled,
      setIsLocationListOpened: setIsLocationListOpened,
      forceOneWay: forceOneWay
    }), /*#__PURE__*/React__default.createElement(Counter, {
      disabled: editTrip,
      getPassengersSum: getPassengersSum,
      getCounterLimit: getCounterLimit,
      onAdultCountChange: onAdultCountChange,
      onInfantsCountChange: onInfantsCountChange,
      onChildrenCountChange: onChildrenCountChange,
      searchFormsetState: setState,
      searchFormState: state,
      className: "counter-wrapper"
    })), /*#__PURE__*/React__default.createElement("div", {
      className: "second-column-container"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "one-way-button-calendar-wrapper"
    }, enableTripSwitch && /*#__PURE__*/React__default.createElement(OneWaySwitchButton, {
      id: "one-way-switch-button",
      onChange: onOneWaySwitchChange,
      checked: state.oneWay
    })), /*#__PURE__*/React__default.createElement("div", {
      className: "for-date-wrapper"
    }, /*#__PURE__*/React__default.createElement(DatePicker, {
      error: dateFromError,
      startDate: startDate,
      endDate: state.endDate,
      handleDayClick: handleDayClick,
      oneWay: state.oneWay,
      onReturnDayChanged: onReturnDayChanged,
      disabled: disabled,
      fromMaxDate: fromMaxDate,
      fromMinDate: fromMinDate,
      setIsLocationListOpened: setIsLocationListOpened
    })), /*#__PURE__*/React__default.createElement("div", {
      className: "mobile-only"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "row"
    }, /*#__PURE__*/React__default.createElement(Counter, {
      disabled: editTrip,
      getCounterLimit: getCounterLimit,
      getPassengersSum: getPassengersSum,
      onAdultCountChange: onAdultCountChange,
      onInfantsCountChange: onInfantsCountChange,
      onChildrenCountChange: onChildrenCountChange,
      searchFormsetState: setState,
      searchFormState: state,
      className: "counter-wrapper-responsive"
    })), /*#__PURE__*/React__default.createElement("div", {
      className: "row mobile-search-button"
    }, /*#__PURE__*/React__default.createElement(Button, {
      type: "primary",
      onClick: onSearchClick
    }, "Search Trips"))), /*#__PURE__*/React__default.createElement("div", {
      className: "search-buttons"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "points-button"
    }, /*#__PURE__*/React__default.createElement(Button, {
      type: "primary",
      onClick: onSearchClick,
      fullWidth: true
    }, "Search Trips")))));
  };

  SearchForm.propTypes = {
    loyaltyActive: PropTypes__default.bool.isRequired,
    fromList: PropTypes__default.instanceOf(Array),
    toList: PropTypes__default.instanceOf(Array),
    onDepartureDayChanged: PropTypes__default.func,
    onReturnDayChanged: PropTypes__default.func,
    onSubmit: PropTypes__default.func,
    onAdultCountChange: PropTypes__default.func.isRequired,
    onChildrenCountChange: PropTypes__default.func.isRequired,
    onInfantsCountChange: PropTypes__default.func.isRequired,
    onPlaceSelect: PropTypes__default.func,
    onLoyaltySubmit: PropTypes__default.func,
    errors: PropTypes__default.instanceOf(Object),
    departureFrom: PropTypes__default.instanceOf(Object),
    departureTo: PropTypes__default.instanceOf(Object),
    returnDate: PropTypes__default.string,
    departureDate: PropTypes__default.string,
    passengersAdults: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.number]),
    passengersChildrens: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.number]),
    passengersInfants: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.number]),
    showFlightSearch: PropTypes__default.bool,
    onLocationStringChange: PropTypes__default.func.isRequired,
    setReservationProperty: PropTypes__default.func.isRequired,
    editTrip: PropTypes__default.bool,
    dateFromError: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.bool]),
    disabled: PropTypes__default.instanceOf(Object),
    fromMaxDate: PropTypes__default.string,
    fromMinDate: PropTypes__default.string
  };
  SearchForm.defaultProps = {
    departureFrom: undefined,
    departureTo: undefined,
    departureDate: undefined,
    returnDate: undefined,
    fromList: [],
    toList: [],
    onDepartureDayChanged: function onDepartureDayChanged() {},
    onReturnDayChanged: function onReturnDayChanged() {},
    onSubmit: function onSubmit() {},
    onPlaceSelect: function onPlaceSelect() {},
    onLoyaltySubmit: function onLoyaltySubmit() {},
    errors: {},
    passengersAdults: 1,
    passengersChildrens: 0,
    passengersInfants: 0,
    showFlightSearch: false,
    editTrip: false,
    dateFromError: false,
    disabled: {},
    fromMaxDate: undefined,
    fromMinDate: undefined
  };

  var Counter = function Counter(_ref2) {
    var disabled = _ref2.disabled,
        getPassengersSum = _ref2.getPassengersSum,
        getCounterLimit = _ref2.getCounterLimit,
        onAdultCountChange = _ref2.onAdultCountChange,
        onInfantsCountChange = _ref2.onInfantsCountChange,
        searchFormsetState = _ref2.searchFormsetState,
        searchFormState = _ref2.searchFormState,
        onChildrenCountChange = _ref2.onChildrenCountChange,
        className = _ref2.className;
    return /*#__PURE__*/React__default.createElement("div", {
      className: className
    }, /*#__PURE__*/React__default.createElement(DropdownMenu, {
      labelText: "PASSENGERS",
      value: /*#__PURE__*/React__default.createElement("div", {
        className: "passengers-counter-container"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "counter-value"
      }, getPassengersSum() > 0 && "".concat(getPassengersSum(), " ").concat(getPassengersSum() === 1 ? 'Passenger' : 'Passengers')))
    }, /*#__PURE__*/React__default.createElement(IncrementerGroup, {
      disabled: disabled,
      items: [{
        text: "Adult  ".concat(ADULT_MIN_AGE, "+"),
        incrementNumber: searchFormState.adults,
        incrementStep: 1,
        onIncrementChange: function onIncrementChange(count) {
          searchFormsetState(function (prevState) {
            return _objectSpread(_objectSpread({}, prevState), {}, {
              adults: count
            });
          });
          onAdultCountChange(count);
        },
        counterMin: 1,
        counterLimit: 9 - Number(getCounterLimit("adult"))
      }, {
        text: "Child  ".concat(CHILD_MIN_AGE, " - ").concat(CHILD_MAX_AGE),
        incrementNumber: searchFormState.children,
        incrementStep: 1,
        onIncrementChange: function onIncrementChange(count) {
          searchFormsetState(function (prevState) {
            return _objectSpread(_objectSpread({}, prevState), {}, {
              children: count
            });
          });
          onChildrenCountChange(count);
        },
        counterMin: 0,
        counterLimit: 9 - Number(getCounterLimit("child"))
      } // {
      //   text: "Infant  0 - 2",
      //   incrementNumber: searchFormState.infant,
      //   incrementStep: 1,
      //   onIncrementChange: count => {
      //     searchFormsetState(prevState => ({ ...prevState, infant: count }))
      //     onInfantsCountChange(count)
      //   },
      //   counterMin: 0,
      //   counterLimit: 9 - Number(getCounterLimit("infant")),
      // },
      ]
    })));
  };

  Counter.propTypes = {
    getPassengersSum: PropTypes__default.func,
    onAdultCountChange: PropTypes__default.func,
    onInfantsCountChange: PropTypes__default.func,
    searchFormsetState: PropTypes__default.func,
    searchFormState: PropTypes__default.instanceOf(Object),
    onChildrenCountChange: PropTypes__default.func,
    className: PropTypes__default.string,
    disabled: PropTypes__default.bool,
    getCounterLimit: PropTypes__default.func
  };
  Counter.defaultProps = {
    getPassengersSum: function getPassengersSum() {},
    onAdultCountChange: function onAdultCountChange() {},
    onInfantsCountChange: function onInfantsCountChange() {},
    searchFormsetState: function searchFormsetState() {},
    searchFormState: {},
    onChildrenCountChange: function onChildrenCountChange() {},
    className: "",
    disabled: {},
    getCounterLimit: function getCounterLimit() {},
    onReturnDayChanged: function onReturnDayChanged() {}
  };
  Counter.defaultProps = {};
  var css_248z$1g = ".Section-container {\n  display: flex;\n  flex-direction: column;\n}\n.Section-container .Section {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  height: 40px;\n  position: relative;\n  background-color: #28221e;\n}\n.Section-container .Section .Section-back {\n  position: relative;\n}\n.Section-container .Section .Section-title {\n  flex: 1;\n  display: flex;\n  justify-content: center;\n  color: #ffffff;\n  font-weight: 600;\n  font-size: 18px;\n  line-height: 23px;\n}\n.Section-container .section-type-absolute {\n  position: absolute;\n  top: 40px;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 999;\n}\n\n.Section-right-content {\n  display: flex;\n  align-items: center;\n  position: absolute;\n  right: 0;\n  height: 30px;\n  width: 75px;\n}\n\n@media only screen and (max-width: 365px) {\n  .Section-container .Section .Section-title {\n    max-width: 280px;\n    padding-left: 40px;\n  }\n}";
  styleInject(css_248z$1g);

  var Section = function Section(_ref) {
    var title = _ref.title,
        canGoBack = _ref.canGoBack,
        onGoBackClicked = _ref.onGoBackClicked,
        type = _ref.type,
        rightContent = _ref.rightContent,
        leftIconName = _ref.leftIconName,
        margin = _ref.margin;
    var sectionClassName = classNames("Section");

    var getMargin = function getMargin() {
      if (margin !== "") {
        return {
          margin: margin
        };
      }

      if (type !== "") {
        return {
          margin: "0px 0px 40px 0px"
        };
      }

      return {
        margin: margin
      };
    };

    return /*#__PURE__*/React__default.createElement("div", {
      className: "Section-container",
      style: getMargin()
    }, /*#__PURE__*/React__default.createElement("div", {
      className: sectionClassName
    }, canGoBack && /*#__PURE__*/React__default.createElement("div", {
      className: "Section-back",
      onClick: onGoBackClicked
    }, /*#__PURE__*/React__default.createElement(Icon, {
      name: leftIconName,
      align: "left",
      fill: type === "loyalty" ? "#28221e" : "#fff"
    })), /*#__PURE__*/React__default.createElement("div", {
      className: "Section-title"
    }, title), /*#__PURE__*/React__default.createElement("div", {
      className: "Section-right-content"
    }, rightContent), /*#__PURE__*/React__default.createElement("div", {
      className: "section-type-absolute"
    }, /*#__PURE__*/React__default.createElement(SectionType, {
      type: type
    }))));
  };

  Section.propTypes = {
    title: PropTypes__default.string,
    canGoBack: PropTypes__default.bool,
    onGoBackClicked: PropTypes__default.func,
    type: PropTypes__default.oneOf(["loyalty", "edit-trip", "cancel-trip"]),
    rightContent: PropTypes__default.element,
    leftIconName: PropTypes__default.string,
    margin: PropTypes__default.string
  };
  Section.defaultProps = {
    title: "Passenger Details",
    canGoBack: true,
    onGoBackClicked: function onGoBackClicked() {},
    type: "",
    rightContent: null,
    leftIconName: "arrowLeft",
    margin: ""
  };
  exports.AccrualLogList = AccrualLogList;
  exports.Button = Button;
  exports.CabinTypeFilter = CabinTypeFilter;
  exports.CarrierFilter = CarrierFilter;
  exports.CheckBox = CheckBox;
  exports.ClearFilter = ClearFilter;
  exports.CollapsibleButton = CollapsibleButton;
  exports.ConnectingAirportFilter = ConnectingAirportFilter;
  exports.DropDownDatePicker = DropDownDatePicker;
  exports.DropdownMenu = DropdownMenu;
  exports.EditingContainer = EditingContainer;
  exports.EmptyState = EmptyState;
  exports.FieldLabel = FieldLabel;
  exports.FormatedTitle = FormatedTitle;
  exports.Icon = Icon;
  exports.IncrementerGroup = IncrementerGroup;
  exports.IncrementerInput = IncrementerInput;
  exports.InputFieldSet = InputFieldSet;
  exports.InputPreview = InputPreview;
  exports.ItinerarySingleRow = ItinerarySingleRow;
  exports.LayoverFilter = LayoverFilter;
  exports.LegConnection = LegConnection;
  exports.LegConnectionVertical = LegConnectionVertical;
  exports.ListOfSuccessReferrals = ListOfSuccessReferrals;
  exports.Loading = Loading;
  exports.LocationForm = LocationForm$1;
  exports.LocationListPicker = LocationListPicker$1;
  exports.LocationPickerRowRenderer = LocationPickerRowRenderer$1;
  exports.LocationRow = LocationRow;
  exports.LoyaltyBuyPoints = LoyaltyBuyPoints;
  exports.LoyaltyPointsBalance = LoyaltyPointsBalance;
  exports.LoyaltyProfile = LoyaltyProfile;
  exports.Luggage = Luggage;
  exports.LuggageFilter = LuggageFilter;
  exports.LuggageIcon = LuggageIcon$1;
  exports.LuggageItem = LuggageItem;
  exports.Modal = Modal;
  exports.NotificationConsumer = NotificationConsumer;
  exports.NotificationProvider = Notification;
  exports.PageTitle = PageTitle;
  exports.PassengerSeatMap = PassengerSeatMap;
  exports.PassengerSeats = PassengerSeats;
  exports.Price = Price;
  exports.RadioButton = RadioButton;
  exports.RadioGroup = RadioGroup;
  exports.ReferralCodeInput = ReferralCodeInput;
  exports.ReservationHeader = ReservationHeader;
  exports.SearchFilters = SearchFilters;
  exports.SearchForm = SearchForm;
  exports.SeatLegend = SeatLegend;
  exports.SeatMap = SeatMap;
  exports.SeatPlace = SeatPlace;
  exports.Section = Section;
  exports.SectionType = SectionType;
  exports.SingleIncrementer = SingleIncrementer;
  exports.StopOverFilter = StopOverFilter;
  exports.SunCountryBanner = SunCountryBanner;
  exports.TabModal = TabModal;
  exports.TabModalGroup = TabModalGroup;
  exports.TagLabel = TagLabel;
  exports.TagLabelGroup = TagLabelGroup;
  exports.TicketClassband = TicketClassband;
  exports.TimePicker = TimePicker;
  exports.TimePickerInput = TimePickerInput;
  exports.TimingFilter = TimingFilter;
  exports.TripDurationFilter = TripDurationFilter;
  exports.Zendesk = Zendesk;
  exports.fontawesome = fontawesomeSvgCore.library;
  Object.defineProperty(exports, '__esModule', {
    value: true
  });
});